import styled, { keyframes, css, ThemeContext, createGlobalStyle, useTheme, withTheme } from 'styled-components';
import { flipInX as flipInX$1, bounceIn, rubberBand, shake as shake$1, pulse as pulse$1, headShake } from 'react-animations';
import { getThemeProp, ZINDEX, media, isMatchedMinWidth, MatchMedia, GreyPalette, lighten, darken, isMatchedMaxWidth } from '@amtrav/themes';
import { getTokenValue, THEME_TOKENS, SPACE, getConfigValue, THEME_CONFIG } from '@amtrav/theme-system';
import React, { useState, useContext, forwardRef, createContext, useMemo, memo, useRef, useImperativeHandle, useEffect, useCallback } from 'react';
import PropTypes, { PropTypes as PropTypes$1 } from 'prop-types';
import { IconNext, IconHalfCircle, IconLine, IconClose, IconCaretDown, IconCheck, IconStarSolid, IconHotelLine, IconCarLine, IconTrainLine, IconPlaneLine, IconRemove, IconAdd, IconInfoLine, IconSvgStyled, IconInfo, IconCheckCircle, IconWarning, IconAngleLeft, IconAngleRight, IconCaretUp, IconSearch, IconEdit, IconPrevious, IconChevron, IconAngleDown, IconCar, IconHotel, IconWarningTriangle, IconLocation, IconCalendarLine } from '@amtrav/icons';
import { Flex, Box } from '@rebass/grid';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import ReactModal from 'react-modal';
import { useSpring, animated, useTransition } from 'react-spring';
import * as RadixScrollArea from '@radix-ui/react-scroll-area';
import tinycolor from 'tinycolor2';
import { isNilOrEmpty, formatDate, randomString } from '@amtrav/utils';
import { BOOKING_ATTACHMENT_TYPES } from '@amtrav/webservice';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { Multiselect as Multiselect$1 } from 'multiselect-react-dropdown';
import { Slider, Rail as Rail$1, Handles, Tracks, Ticks } from 'react-compound-slider';
import { parse, format, startOfWeek, startOfMonth, endOfWeek, endOfMonth, eachDayOfInterval, addMonths, compareAsc, monthYearFormatter, getWeek, dayOfMonthFormatter, isSameDay, isSameMonth, isBefore, isoExtendedFormat, useDay, useMonth, useDatepicker, dayOfWeekShortFormatter, parseDate, monthShortFormatter, differenceInCalendarDays } from '@amtrav/dates';
import ReactDOM, { createPortal } from 'react-dom';
import { ToastContainer as ToastContainer$1, toast } from 'react-toastify';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import useEmblaCarousel from 'embla-carousel-react';
import Downshift, { useCombobox } from 'downshift';
import AnotherReactLightBox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import DayPicker from 'react-day-picker';
import PhoneInput, { formatPhoneNumberIntl, formatPhoneNumber, isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
export { formatPhoneNumber, formatPhoneNumberIntl, getCountryCallingCode, isPossiblePhoneNumber, isSupportedCountry, isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

const loadingAnimationStyles = keyframes`
  0% {
    background-position: -490px 0;
  }
  40%, 100% {
    background-position: 490px 0;
  }
`;
const skeletonLoadingStyles = function (isLoading) {
  let highContrast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return isLoading ? css`
        --skeleton-loading-color-dim1: ${getTokenValue(THEME_TOKENS.base.color.loaderStart)};
        --skeleton-loading-color-dim2: ${getTokenValue(THEME_TOKENS.base.color.loaderEnd)};
        --skeleton-loading-color-dim3: ${getTokenValue(THEME_TOKENS.base.color.loaderEnd)};

        background-image: ${highContrast ?
  // eslint-disable-next-line max-len
  'linear-gradient(to right, var(--skeleton-loading-color-dim1) 0%, var(--skeleton-loading-color-dim2) 20%, var(--skeleton-loading-color-dim1) 40%, var(--skeleton-loading-color-dim1) 100%)' :
  // eslint-disable-next-line max-len
  'linear-gradient(to right, var(--skeleton-loading-color-dim1) 0%, var(--skeleton-loading-color-dim3) 20%, var(--skeleton-loading-color-dim1) 40%, var(--skeleton-loading-color-dim1) 100%)'};
        background-size: 980px 898px;
        animation: ${loadingAnimationStyles} 1.7s infinite linear;

        & > * {
          visibility: hidden;
        }

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          background: ${getThemeProp('global.border--color')};
        }
      ` : null;
};
keyframes`
  100% { transform: rotate(360deg) }
`;
keyframes`
  0% { transform: rotate(0deg) }
  25% { transform: rotate(180deg) }
  50% { transform: rotate(180deg) }
  75% { transform: rotate(360deg) }
  100% { transform: rotate(360deg) }
`;
keyframes`
  0% ,100% { transform: scale(0) }
  50% { transform: scale(1) }
`;
keyframes`
  from { 
    transform: translateX(100vw);
  }
  to {
    transform: translateX(0vw);
  }
`;
keyframes`
  from { 
    transform: scale(.85);
  }
  to {
    transform: scale(1);
  }
`;
keyframes`
  from { 
    transform: scale(1);
  }
  to {
    transform: scale(.95);
  }
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;
const flipInX = keyframes`${flipInX$1}`;
keyframes`${bounceIn}`;
keyframes`${rubberBand}`;
const shake = keyframes`${shake$1}`;
const pulse = keyframes`${pulse$1}`;
keyframes`${headShake}`;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const IconContainer$3 = styled.div`
  transition: transform 0.3s ease;
  padding-left: 2px;
  display: flex;
  align-items: center;
`;
const ActionLinkContainer = styled.div`
  color: ${getThemeProp('global.link--color')};
  display: inline-flex;
  &:hover ${IconContainer$3} {
    transform: translate3d(5px, 0, 0);
  }
  cursor: pointer;
  font-weight: ${_ref => {
  let {
    weight
  } = _ref;
  return weight;
}};
  text-decoration: none;
`;
const ActionLink = _ref2 => {
  let {
    onClickHandler,
    children,
    showArrow = false,
    weight = '700',
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(ActionLinkContainer, _extends({
    onClick: onClickHandler,
    weight: weight
  }, rest), children, showArrow && /*#__PURE__*/React.createElement(IconContainer$3, null, /*#__PURE__*/React.createElement(IconNext, null)));
};
ActionLink.propTypes = {
  /**
   * String to pass in to be anchor
   */
  children: PropTypes.string,
  /**
   * function that gets called when anchor is clicked
   */
  onClickHandler: PropTypes.func,
  /**
   * adds an animated arrow to the right of the text
   */
  showArrow: PropTypes.bool,
  weight: PropTypes.oneOf(['normal', 'bold', 'lighter', 'bolder', '100', '200', '300', '400', '500', '600', '700', '800', '900', 'inherit', 'unset'])
};

const getKindColor$5 = props => {
  switch (props.kind) {
    case 'warning':
      return getTokenValue(THEME_TOKENS.base.color.warning);
    case 'danger':
      return getTokenValue(THEME_TOKENS.base.color.danger);
    case 'success':
      return getTokenValue(THEME_TOKENS.base.color.success);
    case 'vellum':
      return 'rgba(255, 255, 255, 0.3)';
    default:
      return getTokenValue(THEME_TOKENS.base.color.action);
  }
};

const getButtonBackgroundColor = () => props => {
  const {
    bordered,
    borderedLight,
    disabled,
    minimal,
    transparent
  } = props;
  if (transparent) {
    return 'transparent';
  }
  if (disabled) {
    return getTokenValue(THEME_TOKENS.button.color.disabledBackground);
  }
  if (bordered || borderedLight || minimal) {
    return 'white';
  }
  return getKindColor$5(props);
};

const getButtonPadding = () => props => {
  const {
    text,
    size,
    iconPrefix,
    iconSuffix,
    hasLineIconPrefix,
    hasLineIconSuffix
  } = props;
  if (text) {
    if (hasLineIconPrefix || iconPrefix) {
      switch (size) {
        case 'large':
          return `
            ${SPACE.size12} 
            ${SPACE.size32} 
            ${SPACE.size12} 
            0`;
        case 'small':
          return `
            ${SPACE.size4} 
            ${SPACE.size12}
            ${SPACE.size4}
            0`;
        case 'inlineForm':
          return `
            0
            ${SPACE.size16}
            0
            0`;
        default:
          return `
            ${SPACE.size8}
            ${SPACE.size16}
            ${SPACE.size8}
            0`;
      }
    }
    if (hasLineIconSuffix || iconSuffix) {
      switch (size) {
        case 'large':
          return `
            ${SPACE.size12} 
            0
            ${SPACE.size12} 
            ${SPACE.size32}`;
        case 'small':
          return `
            ${SPACE.size4} 
            0
            ${SPACE.size4}
            ${SPACE.size12}`;
        case 'inlineForm':
          return `
            0
            0
            0
            ${SPACE.size16}`;
        default:
          return `
            ${SPACE.size8}
            0
            ${SPACE.size8}
            ${SPACE.size16}`;
      }
    }
    switch (size) {
      case 'large':
        return `${SPACE.size12} ${SPACE.size32}`;
      case 'small':
        return `${SPACE.size2} ${SPACE.size8}`;
      case 'inlineForm':
        return `0 ${SPACE.size12}`;
      default:
        return `${SPACE.size8} ${SPACE.size16}`;
    }
  } else {
    // icon only since props.text does not exist

    switch (size) {
      case 'large':
        return `${SPACE.size16}`;
      case 'small':
        return `${SPACE.size2}`;
      case 'inlineForm':
        return `0 ${SPACE.size8}`;
      default:
        return `${SPACE.size8}`;
    }
  }
};

const getButtonBorderColor = () => props => {
  const {
    kind,
    bordered,
    borderedLight,
    minimal,
    disabled
  } = props;
  if (disabled) {
    return getTokenValue(THEME_TOKENS.button.color.disabledBorder);
  }
  if (minimal) {
    return 'transparent';
  }

  // borderedLight only applies to primary
  if (borderedLight && kind === 'primary') {
    return getTokenValue(THEME_TOKENS.base.color.infoBorder);
  }
  if (bordered || borderedLight) {
    return getKindColor$5(props);
  }
  return getButtonBackgroundColor()(props);
};

const getButtonBorderRadius = () => props => {
  const {
    size,
    round
  } = props;
  if (round) {
    return '50%';
  }
  if (size === 'small') {
    return '4px';
  }
  return '8px';
};

const getButtonFontSize = () => _ref => {
  let {
    size
  } = _ref;
  switch (size) {
    case 'small':
      return '14px';
    case 'large':
      return getTokenValue(THEME_TOKENS.base.size.header3);
    default:
      return '16px';
  }
};

const getButtonTextColor = () => props => {
  const {
    bordered,
    borderedLight,
    disabled,
    minimal,
    transparent
  } = props;
  if (disabled) {
    return getTokenValue(THEME_TOKENS.button.color.disabledText);
  }
  if (bordered || borderedLight || minimal || transparent) {
    return getKindColor$5(props);
  }
  return getTokenValue(THEME_TOKENS.base.color.neutral0);
};

const getButtonHoverBackgroundColor = () => props => {
  const {
    kind,
    bordered,
    borderedLight,
    minimal,
    disabled
  } = props;
  if (kind === 'primary') {
    if (bordered || borderedLight || minimal) {
      return `color-mix(in srgb, rgb(25, 25, 15) 5%, white 95%)`;
    }
    return `color-mix(in srgb, ${getButtonBackgroundColor()(props)} 90%, white 10%)`;
  }
  if (bordered || borderedLight || minimal) {
    return `color-mix(in srgb, ${getButtonTextColor()(props)} 5%, white 95%)`;
  }
  if (disabled) {
    return getButtonBackgroundColor()(props);
  }
  return `color-mix(in srgb, ${getButtonBackgroundColor()(props)} 90%, rgb(25, 25, 15) 10%)`;
};

const getButtonHoverTextColor = () => props => {
  const {
    bordered,
    borderedLight,
    minimal,
    disabled,
    transparent
  } = props;
  if (bordered || borderedLight || minimal) {
    return getButtonTextColor()(props);
  }
  if (disabled) {
    return getTokenValue(THEME_TOKENS.button.color.disabledText);
  }
  if (transparent) {
    return getKindColor$5(props);
  }
  return getTokenValue(THEME_TOKENS.base.color.neutral0);
};

const getButtonHoverBorderColor = () => props => {
  const {
    minimal,
    disabled
  } = props;
  if (disabled) {
    return getTokenValue(THEME_TOKENS.button.color.disabledBorder);
  }
  if (minimal) {
    return 'transparent';
  }
  return getButtonBorderColor()(props);
};

const getAffixPadding = props => {
  const {
    size,
    iconPrefix,
    iconSuffix,
    hasLineIconSuffix,
    hasLineIconPrefix,
    isIconOnly
  } = props;
  if (isIconOnly) {
    return '0';
  }
  if (iconPrefix || hasLineIconPrefix) {
    switch (size) {
      case 'large':
        return `0 ${SPACE.size4} 0 ${SPACE.size32}`;
      default:
        return `0 ${SPACE.size4} 0 ${SPACE.size12}`;
    }
  }
  if (iconSuffix || hasLineIconSuffix) {
    switch (size) {
      case 'large':
        return `0 ${SPACE.size32} 0 ${SPACE.size4}`;
      default:
        return `0 ${SPACE.size12} 0 ${SPACE.size4}`;
    }
  }
  switch (size) {
    case 'large':
      return `0 ${SPACE.size16}`;
    case 'small':
      return `0 ${SPACE.size2} ${SPACE.size8}`;
    case 'inlineForm':
      return `0 ${SPACE.size8}`;
    default:
      return `0 ${SPACE.size8}`;
  }
};
const IconAffixStyled$1 = styled.div`
  height: 100%;
  padding: ${getAffixPadding};
  display: inline-flex;
  align-items: center;
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: background-color;
`;
const IconAffix$2 = props => {
  const {
    icon
  } = props;
  return /*#__PURE__*/React.createElement(IconAffixStyled$1, props, icon);
};
IconAffix$2.propTypes = {
  icon: PropTypes.element.isRequired,
  suffix: PropTypes.bool
};
IconAffix$2.defaultProps = {
  suffix: false
};

const mediumStyles = _ref => {
  let {
    medium
  } = _ref;
  return medium && css`
    font-size: 14px;
    font-weight: 700;
  `;
};
const lightStyles = _ref2 => {
  let {
    light
  } = _ref2;
  return light && css`
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 1.3px;
  `;
};
const TitleCase = styled.span`
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;

  ${mediumStyles}
  ${lightStyles}
`;

const getHeight = _ref => {
  let {
    size
  } = _ref;
  const formControlHeight = `calc(${getTokenValue(THEME_TOKENS.textInput.size.minHeight)} + ${getTokenValue(THEME_TOKENS.textInput.size.border)} * 2)`;
  return size === 'inlineForm' ? formControlHeight : 'auto';
};
const ButtonStyled = styled.button`
  height: ${getHeight};
  background: ${getButtonBackgroundColor};
  border-color: ${getButtonBorderColor};
  border-radius: ${getButtonBorderRadius};
  border-width: ${getThemeProp('button.borderWidth--standard')};
  padding: 0;
  font-size: ${getButtonFontSize};
  width: ${_ref2 => {
  let {
    fullWidth
  } = _ref2;
  return fullWidth ? '100%' : 'auto';
}};
  cursor: ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? 'not-allowed' : 'pointer';
}};
  min-height: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'small' ? '24px' : 'unset';
}};
  min-width: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'small' ? '24px' : 'unset';
}};
  font-family: ${getThemeProp('button.text--fontFamily')};
  border-style: solid;
  color: ${getButtonTextColor};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  outline: 0;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  transition-duration: 0.15s;
  transition-property: border-color, background-color;
  position: relative;
  appearance: initial;
  -webkit-appearance: initial;

  @media (hover: hover) {
    &:hover {
      background: ${getButtonHoverBackgroundColor};
      color: ${getButtonHoverTextColor};
      border-color: ${getButtonHoverBorderColor};
    }
  }

  &:focus-visible {
    outline: 2px solid ${getKindColor$5};
    outline-offset: 2px;
  }
`;
const ButtonTextStyled = styled.div`
  display: inline-flex;
  flex: 1 0 auto;
  justify-content: center;
  padding: ${getButtonPadding};
  visibility: ${_ref6 => {
  let {
    isLoading
  } = _ref6;
  return isLoading ? 'hidden' : 'unset';
}};
  font-weight: 600;
`;
const ButtonLoading = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  bottom: 0;
  align-items: center;
  justify-content: center;
`;
const generateLineIcon = _ref7 => {
  let {
    iconLineName,
    size,
    isPrefix = false,
    isSuffix = false
  } = _ref7;
  const iconSize = () => {
    if (size === 'large') {
      return 24;
    }
    if (size === 'small') {
      return 16;
    }
    return 20;
  };
  return /*#__PURE__*/React.createElement(IconAffix$2, {
    hasLineIconSuffix: isSuffix,
    hasLineIconPrefix: isPrefix,
    isIconOnly: iconLineName && !isPrefix && !isSuffix,
    size: size,
    icon: /*#__PURE__*/React.createElement(IconLine, {
      icon: iconLineName,
      size: iconSize()
    })
  });
};
const Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    onClick,
    className,
    size,
    renderAs,
    iconLineName,
    prefixIconLineName,
    suffixIconLineName,
    ...rest
  } = props;
  const [hover, setHover] = useState(false);
  const handleMouseOver = () => setHover(true);
  const handleMouseOut = () => setHover(false);
  const renderAsProp = renderAs ? {
    as: renderAs
  } : null;
  return /*#__PURE__*/React.createElement(ButtonStyled, _extends({
    ref: ref
  }, rest, {
    size: size,
    disabled: props.isLoading || props.disabled,
    onClick: onClick,
    className: className,
    onMouseEnter: handleMouseOver,
    onMouseLeave: handleMouseOut
  }, renderAsProp), props.iconPrefix ? /*#__PURE__*/React.createElement(IconAffix$2, _extends({}, rest, {
    size: size,
    icon: props.iconPrefix,
    hover: hover
  })) : null, prefixIconLineName && generateLineIcon({
    size,
    iconLineName: prefixIconLineName,
    isPrefix: true
  }), /*#__PURE__*/React.createElement(ButtonTextStyled, _extends({}, rest, {
    size: size,
    hasLineIconSuffix: !!suffixIconLineName,
    hasLineIconPrefix: !!prefixIconLineName
  }), props.icon, iconLineName && generateLineIcon({
    size,
    iconLineName
  }), props.titleCase ? /*#__PURE__*/React.createElement(TitleCase, null, props.text) : props.text), props.isLoading && props.text && /*#__PURE__*/React.createElement(ButtonLoading, null, /*#__PURE__*/React.createElement(IconHalfCircle, {
    isRotating: true
  })), props.iconSuffix ? /*#__PURE__*/React.createElement(IconAffix$2, _extends({
    suffix: true
  }, rest, {
    size: size,
    icon: props.iconSuffix,
    hover: hover
  })) : null, suffixIconLineName && generateLineIcon({
    size,
    iconLineName: suffixIconLineName,
    isSuffix: true
  }));
});
Button.propTypes = {
  /** Button text. */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Function to call on button click.
   */
  onClick: PropTypes.func,
  kind: PropTypes.oneOf(['primary', 'warning', 'danger', 'success', 'vellum']),
  size: PropTypes.oneOf(['small', 'inlineForm', 'medium', 'large']),
  bordered: PropTypes.bool,
  /**
   * Similar to bordered but with lighter borders
   */
  borderedLight: PropTypes.bool,
  minimal: PropTypes.bool,
  disabled: PropTypes.bool,
  /**
   * Span the button width at 100% of available space.
   */
  fullWidth: PropTypes.bool,
  /** **Deprecated:** use `iconLineName` */
  icon: PropTypes.element,
  /** **Deprecated:** use `prefixIconLineName` */
  iconPrefix: PropTypes.element,
  /** **Deprecated:** use `suffixIconLineName` */
  iconSuffix: PropTypes.element,
  /**
   * Typically used for an icon-only button.
   */
  round: PropTypes.bool,
  transparent: PropTypes.bool,
  className: PropTypes.string,
  titleCase: PropTypes.bool,
  /**
   * Show loading animation and disable button.
   */
  isLoading: PropTypes.bool,
  /**
   * Allows the outputted DOM element to be different than a `button` (ex. `div`)
   */
  renderAs: PropTypes.string,
  /**
   * To be used alone, when the button does not have text but only an icon
   */
  iconLineName: PropTypes.string,
  /**
   * To be used in conjunction with text
   */
  prefixIconLineName: PropTypes.string,
  /**
   * To be used in conjunction with text
   */
  suffixIconLineName: PropTypes.string
};
Button.defaultProps = {
  text: '',
  onClick: () => {},
  kind: 'primary',
  size: 'medium',
  bordered: false,
  borderedLight: false,
  minimal: false,
  disabled: false,
  fullWidth: false,
  transparent: false,
  icon: null,
  iconPrefix: null,
  iconSuffix: null,
  round: false,
  className: '',
  titleCase: false,
  isLoading: false,
  renderAs: null,
  iconLineName: '',
  prefixIconLineName: '',
  suffixIconLineName: ''
};

const slideRightAndFade = keyframes`
  0% { opacity: 0; transform: translateX(-3px); },
  100% { opacity: 1; transform: translateX(0); },
`;
const slideLeftAndFade = keyframes`
  0% { opacity: 0; transform: translateX(3px); },
  100% { opacity: 1; transform: translateX(0); },
`;
const slideTopAndFade = keyframes`
  0% { opacity: 0; transform: translateY(3px); },
  100% { opacity: 1; transform: translateY(0); },
`;
const slideBottomAndFade = keyframes`
  0% { opacity: 0; transform: translateY(-3px); },
  100% { opacity: 1; transform: translateY(0); },
`;
const TooltipContent = styled(TooltipPrimitive.Content)`
  max-width: ${_ref => {
  let {
    $maxWidth
  } = _ref;
  return $maxWidth;
}};
  animation-timing-function: ease-out;
  animation-duration: 0.2s;
  z-index: ${ZINDEX.TOOLTIP};

  &[data-side='right'] {
    animation-name: ${slideRightAndFade};
  }
  &[data-side='left'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-side='top'] {
    animation-name: ${slideTopAndFade};
  }
  &[data-side='bottom'] {
    animation-name: ${slideBottomAndFade};
  }
`;

const getBackgroundColor$3 = props => () => {
  const {
    kind
  } = props;
  switch (kind) {
    case 'info':
    case 'success':
    case 'warning':
    case 'danger':
      return getThemeProp(`global.${kind}--color`)(props);
    case 'light':
      return '#fff';
    default:
      return '#333';
  }
};

const TooltipBox = styled.div`
  border-radius: ${_ref => {
  let {
    isPopover
  } = _ref;
  return isPopover ? getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge) : getTokenValue(THEME_TOKENS.card.size.borderRadiusSmall);
}};
  font-size: ${_ref2 => {
  let {
    contentFontSize
  } = _ref2;
  return contentFontSize || '14px';
}};
  line-height: 1.4;
  outline: 0;
  background-color: ${getBackgroundColor$3};
  color: ${props => props.kind === 'light' ? getThemeProp('global.textBody--color')(props) : 'white'};
  max-width: ${_ref3 => {
  let {
    maxwidth
  } = _ref3;
  return maxwidth;
}};
  padding: ${_ref4 => {
  let {
    padding
  } = _ref4;
  return padding;
}};
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 16px 0px, rgba(0, 0, 0, 0.1) 0px 2px 16px 0px,
    rgba(0, 0, 0, 0.12) 0px 0px 2px 0px;
`;

const TooltipArrow = styled(TooltipPrimitive.Arrow)`
  fill: ${getBackgroundColor$3};
`;

const Trigger$2 = styled.div`
  display: ${_ref => {
  let {
    triggerDisplayProperty
  } = _ref;
  return triggerDisplayProperty;
}};
  flex: 1 0 auto;
`;
const CloseButton$1 = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 16px;

  ${_ref2 => {
  let {
    $kind
  } = _ref2;
  return $kind !== 'light' && css`
      color: white;
    `;
}};

  &:focus-visible {
    outline-offset: -4px;
  }
`;
const Popover = /*#__PURE__*/React.forwardRef((_ref3, forwardedRef) => {
  let {
    children,
    content,
    contentFontSize = null,
    maxWidth = '350px',
    placement = 'bottom',
    align = 'center',
    kind = 'light',
    open,
    defaultOpen = false,
    onOpenChange,
    showCloseButton = false,
    withPadding = true,
    onClickOutside,
    triggerDisplayProperty = 'inline-block'
  } = _ref3;
  const tooltipPadding = () => {
    if (showCloseButton) {
      return '20px';
    }
    if (withPadding) {
      return '8px 12px';
    }
    return '0px';
  };
  return /*#__PURE__*/React.createElement(PopoverPrimitive.Root, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(PopoverPrimitive.Trigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Trigger$2, {
    triggerDisplayProperty: triggerDisplayProperty
  }, children)), /*#__PURE__*/React.createElement(PopoverPrimitive.Portal, null, /*#__PURE__*/React.createElement(TooltipContent, {
    as: PopoverPrimitive.Content,
    ref: forwardedRef,
    onOpenAutoFocus: event => event.preventDefault(),
    $maxWidth: maxWidth,
    collisionPadding: 5,
    side: placement,
    align: align,
    sideOffset: 3,
    "data-within": "popover",
    onInteractOutside: onClickOutside
  }, /*#__PURE__*/React.createElement(TooltipBox, {
    isPopover: true,
    kind: kind,
    padding: tooltipPadding(),
    contentFontSize: contentFontSize
  }, content), showCloseButton ? /*#__PURE__*/React.createElement(PopoverPrimitive.Close, {
    asChild: true
  }, /*#__PURE__*/React.createElement(CloseButton$1, {
    $kind: kind,
    icon: /*#__PURE__*/React.createElement(IconClose, null),
    transparent: true,
    size: "small",
    round: true
  })) : null, /*#__PURE__*/React.createElement(TooltipArrow, {
    as: PopoverPrimitive.Arrow,
    kind: kind
  }))));
});
Popover.propTypes = {
  /**
   * The trigger for the Popover.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * The content of the Popover.
   */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * The font-size of the content will default to 14px if no value is provided. This happens downstream in TooltipBox.
   */
  contentFontSize: PropTypes.string,
  /**
   * Show a button that closes an open popover. Automatically adds padding.
   */
  showCloseButton: PropTypes.bool,
  /**
   * Add padding around the Popover content.
   */
  withPadding: PropTypes.bool,
  /**
   * Event handler called when clicking outside the Popover content.
   */
  onClickOutside: PropTypes.func,
  /**
   * A CSS display property to control the layout of the trigger. The trigger is rendered as 'display-block' by default.
   */
  triggerDisplayProperty: PropTypes.string,
  /**
   * The allowed maximum width of the Popover content.
   */
  maxWidth: PropTypes.string,
  /**
   * The side of the trigger to render the Popover against. Will be reversed when collisions occur.
   */
  placement: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),
  /**
   * Controls the color of the popover.
   */
  kind: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'light', 'dark']),
  /**
   * The controlled open state of the Popover. Must be used in conjunction with onOpenChange.
   */
  open: PropTypes.bool,
  /**
   * The open state of the Popover when it is initially rendered.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Event handler called when the open state of the Popover changes.
   * @param {bool} open
   */
  onOpenChange: PropTypes.func,
  /**
   * Alignment of the Popover to the trigger.
   */
  align: PropTypes.oneOf(['start', 'center', 'end'])
};

const getModalTextColor = props => {
  switch (props.kind) {
    case 'success':
      return getTokenValue(THEME_TOKENS.base.color.success);
    case 'warning':
      return getTokenValue(THEME_TOKENS.base.color.warning);
    case 'danger':
      return getTokenValue(THEME_TOKENS.base.color.danger);
    default:
      return getTokenValue(THEME_TOKENS.base.color.primaryText);
  }
};

const HeaderStyled = styled(Flex)`
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header2)};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  color: ${getModalTextColor};
  width: 100%;
  flex-shrink: 0;
  border-bottom: 1px solid ${getTokenValue(THEME_TOKENS.card.color.border)};

  & ${ButtonStyled}:hover {
    border-color: rgba(0, 0, 0, 0.25);
  }
`;
const ModalHeader = _ref => {
  let {
    children,
    kind,
    fullscreen,
    drawer,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement(HeaderStyled, {
    kind: kind,
    px: SPACE.size16,
    py: SPACE.size12,
    fullscreen: fullscreen,
    drawer: drawer,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, children), /*#__PURE__*/React.createElement(Button, {
    kind: kind === 'dark' ? 'primary' : kind,
    onClick: onClose,
    round: true,
    minimal: true,
    icon: /*#__PURE__*/React.createElement(IconClose, null)
  }));
};
ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  kind: PropTypes.string,
  fullscreen: PropTypes.bool,
  drawer: PropTypes.bool
};
ModalHeader.defaultProps = {
  onClose: () => {},
  kind: 'dark'
};

const getMinWidth = props => () => {
  const {
    fullscreen,
    drawer
  } = props;
  if (drawer && fullscreen) {
    return css`
      min-width: 100vw;
    `;
  }
  if (drawer) {
    return css`
      min-width: 100vw;

      ${media.Medium`
        min-width: 480px;
      `}
    `;
  }
  if (fullscreen) {
    return css`
      min-width: 100vw;

      ${media.Small`
        min-width: calc(100vw - 16px);
      `}
    `;
  }
  return css`
    min-width: 100%;

    ${media.Small`
        min-width: 420px;
      `}

    ${media.Medium`
        min-width: 520px;
      `}
  `;
};
const getMinHeight = props => () => {
  const {
    fullscreen,
    drawer
  } = props;
  if (drawer) {
    return css`
      min-height: ${window.innerHeight}px;

      @supports (min-height: 100dvh) {
        min-height: 100dvh;
      }
    `;
  }
  if (fullscreen) {
    return css`
      min-height: ${window.innerHeight}px;

      @supports (min-height: 100dvh) {
        min-height: 100dvh;
      }

      ${media.Small`
        min-height: calc(90vh - 16px);

        @supports (min-height: 100dvh) {
          min-height: calc(100dvh - 16px);
        }
      `}
    `;
  }
  return css`
    min-height: unset;
  `;
};
const ModalPositioner = styled(Flex)`
  align-items: center;
  min-height: 100%;
`;
const Wrapper$1 = styled.div`
  background: ${_ref => {
  let {
    modalBackgroundColor
  } = _ref;
  return modalBackgroundColor || 'white';
}};
  ${getMinWidth};
  ${getMinHeight};
  box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
  display: flex;
  flex-direction: column;

  ${_ref2 => {
  let {
    fullscreen,
    drawer
  } = _ref2;
  return !fullscreen && !drawer && css`
      border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
    `;
}};

  ${_ref3 => {
  let {
    fullscreen,
    drawer
  } = _ref3;
  return !fullscreen && !drawer && css`
      max-height: calc(80vh - 16px);

      ${media.Large`
        max-height: calc(100vh - 16px);      
      `}
    `;
}};
`;
const ModalWrapper = _ref4 => {
  let {
    children,
    fullscreen = false,
    closeOnOverlayClick,
    drawer = false,
    onClose,
    modalBackgroundColor
  } = _ref4;
  const themeContext = useContext(ThemeContext);
  const isMediumViewportOrLarger = isMatchedMinWidth(`${themeContext.global['breakpointSM--size']}px`);
  const baseStyle = useSpring({
    from: {
      opacity: 0,
      transform: 'scale(0.95)'
    },
    to: {
      opacity: 1,
      transform: 'scale(1)'
    }
  });
  const drawerStyle = useSpring({
    from: {
      transform: 'translateX(100%)'
    },
    to: {
      transform: 'translateX(0px)'
    }
  });
  const modalPadding = () => {
    if (drawer) {
      return 0;
    }
    if (fullscreen) {
      return [0, 2];
    }
    return 2;
  };
  return /*#__PURE__*/React.createElement(ModalPositioner, {
    onClick: e => {
      var _e$target;
      if (e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.dataset.isModalPositioner && closeOnOverlayClick) {
        onClose();
      }
    },
    "data-is-modal-positioner": "true",
    p: modalPadding,
    justifyContent: drawer ? 'flex-end' : 'center'
  }, /*#__PURE__*/React.createElement(animated.div, {
    style: drawer && isMediumViewportOrLarger ? drawerStyle : baseStyle
  }, /*#__PURE__*/React.createElement(Wrapper$1, {
    modalBackgroundColor: modalBackgroundColor,
    drawer: drawer,
    fullscreen: fullscreen
  }, children)));
};
ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  fullscreen: PropTypes.bool,
  drawer: PropTypes.bool,
  onClose: PropTypes.func,
  modalBackgroundColor: PropTypes.string,
  closeOnOverlayClick: PropTypes.bool
};

const BodyStyled = styled(Box)`
  width: 100%;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  overflow-x: auto;
  min-width: 300px;
  flex: ${_ref => {
  let {
    fullscreen,
    drawer
  } = _ref;
  return fullscreen || drawer ? '1 1 0px' : '0 1 auto';
}};

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    flex-basis: 80vh;
  }

  ${_ref2 => {
  let {
    fullscreen,
    drawer
  } = _ref2;
  return fullscreen || drawer && css`
        @media only screen and (min-device-width: 320px) and (max-device-width: 767px) {
          padding-bottom: 180px;
        }
      `;
}}
`;
const ModalBody = _ref3 => {
  let {
    children,
    fullscreen,
    drawer,
    noPadding
  } = _ref3;
  return /*#__PURE__*/React.createElement(BodyStyled, {
    drawer: drawer,
    fullscreen: fullscreen,
    p: noPadding ? 0 : 3
  }, children);
};
ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  fullscreen: PropTypes.bool,
  drawer: PropTypes.bool,
  noPadding: PropTypes.bool
};
ModalBody.defaultProps = {
  fullscreen: false,
  drawer: false,
  noPadding: false
};

const ModalOverlayStyled = styled(Box)`
  background-color: ${_ref => {
  let {
    overlayColor
  } = _ref;
  return overlayColor || getTokenValue(THEME_TOKENS.base.color.overlayBackdrop);
}};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${ZINDEX.OVERLAY};
`;
const ModalOverlay = _ref2 => {
  let {
    children,
    overlayColor
  } = _ref2;
  return /*#__PURE__*/React.createElement(ModalOverlayStyled, {
    overlayColor: overlayColor
  }, children);
};
ModalOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  overlayColor: PropTypes.string
};

const FlexFooter = styled(Flex)`
  flex-shrink: 0;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-style: solid;
  border-width: 1px 0 0;
`;
const ModalFooter = _ref => {
  let {
    children,
    drawer,
    fullscreen,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(FlexFooter, _extends({
    justifyContent: "flex-end",
    p: 3,
    drawer: drawer,
    fullscreen: fullscreen
  }, rest), children);
};
ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
  drawer: PropTypes.bool,
  fullscreen: PropTypes.bool
};

const ScrollAreaRoot = styled(RadixScrollArea.Root)`
  overflow: hidden;
  --scrollbar-size: 10px;
`;
const ScrollAreaViewport = styled(RadixScrollArea.Viewport)`
  width: 100%;
  height: 100%;
  border-radius: inherit;
`;
const ScrollAreaScrollbar = styled(RadixScrollArea.Scrollbar)`
  display: flex;
  /* ensures no selection */
  user-select: none;
  /* disable browser handling of all panning and zooming gestures on touch devices */
  touch-action: none;
  padding: 2px;
  background: rgba(0, 0, 0, 0.11);
  transition: background 160ms ease-out;

  &:hover {
    background: rgba(0, 0, 0, 0.22);
  }

  &[data-orientation='vertical'] {
    width: var(--scrollbar-size);
  }
  &[data-orientation='horizontal'] {
    flex-direction: column;
    height: var(--scrollbar-size);
  }
`;
const ScrollAreaThumb = styled(RadixScrollArea.Thumb)`
  flex: 1;
  background: rgba(0, 0, 0, 0.3);
  border-radius: var(--scrollbar-size);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 14px;
    min-height: 14px;
  }
`;
const ScrollAreaCorner = styled(RadixScrollArea.Corner)`
  background: rgba(0, 0, 0, 0.22);
`;
const ScrollArea = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(ScrollAreaRoot, _extends({
    scrollHideDelay: 300
  }, rest), /*#__PURE__*/React.createElement(ScrollAreaViewport, {
    ref: ref
  }, children), /*#__PURE__*/React.createElement(ScrollAreaScrollbar, {
    orientation: "vertical"
  }, /*#__PURE__*/React.createElement(ScrollAreaThumb, null)), /*#__PURE__*/React.createElement(ScrollAreaScrollbar, {
    orientation: "horizontal"
  }, /*#__PURE__*/React.createElement(ScrollAreaThumb, null)), /*#__PURE__*/React.createElement(ScrollAreaCorner, null));
});
ScrollArea.propTypes = {
  children: PropTypes.node
};

const BodyScroll = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(ScrollArea, rest, children);
};
BodyScroll.propTypes = {
  children: PropTypes.node
};

// https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/

const $html = document.querySelector('html');
const $thebody = document.querySelector('body');
let scrollPosition = 0;
const hkLockScroll = 'hk-lock-scroll';
const ua = window.navigator.userAgent;
const iPhoneSafari = !!ua.match(/iPhone/i) && !!ua.match(/WebKit/i);
const lockScroll = () => {
  if (!$html.classList.contains(hkLockScroll)) {
    /*    
    mobile Safari has a dynamically resizing viewport so it needs a different
    solution to lock the viewport. The solution below works well with one drawback; the viewport 
    behind the modal will jump to the top of the page when the modal is opened. We are saving the scroll 
    position when the modal is opened so it can be restored when the modal id closed.
    */

    scrollPosition = window.pageYOffset;
    if (iPhoneSafari) {
      /*
       1px is subtracted from the height due to a Safari bug that
       reveals the footer if the makes a vertical pan when the
       Safari footer is hidden
      */
      $html.style.height = `${window.innerHeight - 1}px`;
      $html.style.overflow = 'hidden';
      $thebody.style.height = `${window.innerHeight - 1}px`;
      $thebody.style.overflow = 'hidden';
    } else {
      $html.style.overflow = 'initial';
      $html.style.position = 'fixed';
      $html.style.maxWidth = '100vw';
      $html.style.left = '0';
      $html.style.right = '0';
      $html.style.top = `-${scrollPosition}px`;
    }
    $html.classList.add(hkLockScroll);
    $thebody.style.touchAction = 'manipulation';
  }
};
const unlockScroll = () => {
  $html.style.removeProperty('overflow');
  $html.style.removeProperty('height');
  $html.style.removeProperty('position');
  $html.style.removeProperty('maxWidth');
  $html.style.removeProperty('left');
  $html.style.removeProperty('right');
  $html.style.removeProperty('top');
  $thebody.style.removeProperty('overflow');
  $thebody.style.removeProperty('height');
  $thebody.style.removeProperty('touchAction');
  $html.classList.remove(hkLockScroll);
  window.scrollTo(0, scrollPosition);
};

ReactModal.defaultStyles = {};
const ModalContext$1 = /*#__PURE__*/createContext({});
const ModalStyles = createGlobalStyle`
  .ReactModal__Body--open {
    overflow: hidden;

    .ReactModalPortal {
      position: fixed;
      // height and width is needed to ensure form elements within modal are tabbable 
      // https://github.com/reactjs/react-modal/issues/782#issuecomment-796844745
      height: 1px;
      width: 1px;
      z-index: ${ZINDEX.MODAL};
    }
  }
`;
const Modal = _ref => {
  let {
    children,
    fullscreen,
    drawer,
    closeOnOverlayClick = !fullscreen && !drawer,
    closeOnEsc = !fullscreen && !drawer,
    kind,
    onClose,
    fixPageBackground,
    noPadding,
    modalBackgroundColor,
    overlayColor
  } = _ref;
  if (fixPageBackground) {
    lockScroll();
  }
  const providerProps = useMemo(() => ({
    kind,
    onClose,
    fullscreen,
    drawer,
    noPadding
  }), [kind, onClose, fullscreen, drawer, noPadding]);
  return /*#__PURE__*/React.createElement(ModalContext$1.Provider, {
    value: providerProps
  }, /*#__PURE__*/React.createElement(ModalStyles, null), /*#__PURE__*/React.createElement(ReactModal, {
    shouldCloseOnOverlayClick: closeOnOverlayClick,
    shouldCloseOnEsc: closeOnEsc,
    ariaHideApp: false,
    isOpen: true,
    onAfterClose: () => {
      if (fixPageBackground) {
        unlockScroll();
      }
    },
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(ModalOverlay, {
    overlayColor: overlayColor
  }, /*#__PURE__*/React.createElement(ModalWrapper, {
    closeOnOverlayClick: closeOnOverlayClick,
    modalBackgroundColor: modalBackgroundColor,
    onClose: onClose,
    drawer: drawer,
    fullscreen: fullscreen
  }, children))));
};
Modal.Header = _ref2 => {
  let {
    children
  } = _ref2;
  const settings = useContext(ModalContext$1);
  return /*#__PURE__*/React.createElement(ModalHeader, {
    kind: settings.kind,
    drawer: settings.drawer,
    fullscreen: settings.fullscreen,
    onClose: settings.onClose
  }, children);
};
Modal.Header.propTypes = {
  children: PropTypes.node.isRequired
};
Modal.Body = _ref3 => {
  let {
    children
  } = _ref3;
  const settings = useContext(ModalContext$1);
  return /*#__PURE__*/React.createElement(ModalBody, {
    noPadding: settings.noPadding,
    drawer: settings.drawer,
    fullscreen: settings.fullscreen
  }, children);
};
Modal.Body.propTypes = {
  children: PropTypes.node.isRequired
};
Modal.Footer = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  const settings = useContext(ModalContext$1);
  return /*#__PURE__*/React.createElement(ModalFooter, _extends({
    drawer: settings.drawer,
    fullscreen: settings.fullscreen
  }, rest), children);
};
Modal.Footer.propTypes = {
  children: PropTypes.node.isRequired
};
Modal.BodyScroll = BodyScroll;
Modal.propTypes = {
  /**
   * The content of the modal.
   */
  children: PropTypes.node.isRequired,
  /**
   * Callback invoked to close the modal.
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Used for the header background color.
   */
  kind: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'dark']),
  /**
   * Force modal to use all available screen real estate.
   */
  fullscreen: PropTypes.bool,
  /**
   * Slide the modal from the right side of the viewport.
   */
  drawer: PropTypes.bool,
  /**
   * Fix the background page behind the modal from scrolling.
   */
  fixPageBackground: PropTypes.bool,
  /**
   * Remove padding from around modal body.
   */
  noPadding: PropTypes.bool,
  /**
   * Provide a custom color for the modal background.
   */
  modalBackgroundColor: PropTypes.string,
  /**
   * If clicking the overlay should close the modal. Defaults to false for drawers and full screen modals.
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * If pressing the esc key should close the modal. Defaults to false for drawers and full screen modals.
   */
  closeOnEsc: PropTypes.bool,
  /**
   * Provide a custom color for the modal overlay.
   */
  overlayColor: PropTypes.string
};
Modal.defaultProps = {
  kind: 'dark',
  fullscreen: false,
  drawer: false,
  fixPageBackground: true,
  noPadding: false
};

/* eslint-disable react/jsx-no-useless-fragment */
const ActionButtonRegion$2 = styled(Flex)`
  ${media.Medium`
    box-shadow: 0 1px 0 0 ${getTokenValue(THEME_TOKENS.card.color.border)} inset;
  `};
`;
const ScrollRegion$2 = styled(Box)`
  max-height: 50vh;
  overflow-y: auto;
`;
const MulfilterButtonContainer = styled.div`
  min-width: max-content;
`;
const BadgeContainer$1 = styled.div`
  position: relative;
  display: inline-block;
  ${media.Medium`
    padding-right: 8px;
  `};
`;
const BadgeDot = styled.div`
  position: absolute;
  top: -10px;
  right: -1px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  border-color: ${getTokenValue(THEME_TOKENS.base.color.infoBorder)};
  border-style: solid;
  border-width: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getThemeProp('global.link--color')};
  font-weight: 700;
  font-size: 12px;

  ${media.Medium`
    width: 22px;
    height: 22px;
  `};
`;
const MultifilterBadge = _ref => {
  let {
    children,
    number
  } = _ref;
  if (number === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(BadgeContainer$1, null, children, /*#__PURE__*/React.createElement(BadgeDot, null, number));
};
const MultifilterTrigger = _ref2 => {
  let {
    size,
    numActiveFilters,
    label,
    clickHandler
  } = _ref2;
  return /*#__PURE__*/React.createElement(MulfilterButtonContainer, null, /*#__PURE__*/React.createElement(MultifilterBadge, {
    number: numActiveFilters
  }, /*#__PURE__*/React.createElement(Button, {
    size: size,
    prefixIconLineName: "AdjustmentsHorizontal",
    kind: "primary",
    text: label,
    onClick: clickHandler,
    renderAs: "div"
  })));
};
MultifilterTrigger.propTypes = {
  size: PropTypes.string,
  label: PropTypes.string,
  numActiveFilters: PropTypes.number,
  clickHandler: PropTypes.func.isRequired
};
const Multifilter = _ref3 => {
  let {
    onReset,
    onApply,
    onCancel,
    label = 'All Filters',
    children,
    showResetApplyButtons = false,
    numActiveFilters = 0,
    size = 'inlineForm'
  } = _ref3;
  const [isOpen, setIsOpen] = useState(false);
  const clickHandler = () => setIsOpen(!isOpen);
  const closePopover = () => setIsOpen(false);
  const resetHandler = e => {
    e.stopPropagation();
    closePopover();
    onReset();
  };
  const applyHandler = () => {
    if (onApply) {
      onApply();
    }
    /* 
      A timeout is necessary to allow state changes in the <Modal /> content to finish updating. Otherwise, state 
      changes and accompanying useEffect code will not execute on the Modal's child components. We should reexamine 
      this approach to avoid using setTimeout().
     */
    setTimeout(() => {
      closePopover();
    }, 100);
  };
  const cancelHandler = () => {
    onCancel();
    closePopover();
  };
  const resetButtonText = 'Reset';
  const applyButtonText = 'Apply';
  const makeActionButtons = padding => onApply ? /*#__PURE__*/React.createElement(ActionButtonRegion$2, {
    width: "100%",
    justifyContent: "center",
    p: padding
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    bordered: true,
    text: resetButtonText,
    kind: "danger",
    onClick: cancelHandler
  })), /*#__PURE__*/React.createElement(Box, {
    px: 2,
    flex: "1 0 auto"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    text: applyButtonText,
    onClick: applyHandler
  }))) : /*#__PURE__*/React.createElement(MatchMedia.LargeAndLess, null, /*#__PURE__*/React.createElement(ActionButtonRegion$2, {
    width: "100%",
    justifyContent: "center",
    p: padding
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    kind: "danger",
    bordered: true,
    text: "Clear Filters",
    onClick: resetHandler
  })), /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    text: "Apply Filters",
    onClick: applyHandler
  }))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollRegion$2, null, children), showResetApplyButtons ? makeActionButtons(3) : null),
    open: isOpen,
    onOpenChange: open => {
      if (!open) closePopover();
    },
    onClickOutside: closePopover,
    align: "start",
    withPadding: false
  }, /*#__PURE__*/React.createElement(MultifilterTrigger, {
    size: size,
    numActiveFilters: numActiveFilters,
    label: label,
    clickHandler: clickHandler
  }))), /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(Modal, {
    drawer: true,
    onClose: closePopover
  }, /*#__PURE__*/React.createElement(Modal.Header, null, label), /*#__PURE__*/React.createElement(Modal.Body, null, children), showResetApplyButtons ? /*#__PURE__*/React.createElement(Modal.Footer, null, makeActionButtons(0)) : null), /*#__PURE__*/React.createElement(MultifilterTrigger, {
    size: size,
    numActiveFilters: numActiveFilters,
    label: label,
    clickHandler: clickHandler
  }))));
};
MultifilterBadge.propTypes = {
  children: PropTypes.node,
  number: PropTypes.number
};
Multifilter.propTypes = {
  /**
   * Button text name
   */
  label: PropTypes.string,
  /**
   * filterText will override text.
   */
  showResetApplyButtons: PropTypes.bool,
  children: PropTypes.node,
  onReset: PropTypes.func,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  numActiveFilters: PropTypes.number,
  size: PropTypes.string
};

const ActionButtonRegion$1 = styled(Flex)`
  ${media.Medium`
    box-shadow: 0 1px 0 0 ${getTokenValue(THEME_TOKENS.card.color.border)} inset;
  `};
`;
const ScrollRegion$1 = styled(Box)`
  max-height: 50vh;
  padding: 16px;
  overflow-y: auto;
`;
const FilterButton$2 = styled(Button)`
  min-width: max-content;
  ${_ref => {
  let {
    isFiltered
  } = _ref;
  return isFiltered && css`
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
      box-shadow: ${getTokenValue(THEME_TOKENS.textInput.shadow.focus)};
    `;
}};
`;
const Solofilter = _ref2 => {
  let {
    label,
    onReset,
    onApply,
    onCancel,
    showResetApplyButtons = false,
    isFiltered = false,
    children
  } = _ref2;
  const [isOpen, setIsOpen] = useState(false);
  const clickHandler = () => setIsOpen(!isOpen);
  const closePopover = () => setIsOpen(false);
  const resetHandler = e => {
    e.stopPropagation();
    closePopover();
    onReset();
  };
  const applyHandler = () => {
    onApply();
    closePopover();
  };
  const cancelHandler = () => {
    onCancel();
    closePopover();
  };
  const makeActionButtons = () => onApply ? /*#__PURE__*/React.createElement(ActionButtonRegion$1, {
    width: "100%",
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    bordered: true,
    text: "Clear Filters",
    kind: "danger",
    onClick: resetHandler
  })), /*#__PURE__*/React.createElement(Box, {
    px: 2,
    flex: "1 0 auto"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    text: "Apply",
    onClick: applyHandler
  }))) : /*#__PURE__*/React.createElement(ActionButtonRegion$1, {
    width: "100%",
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    bordered: true,
    text: "Clear Filters",
    onClick: cancelHandler
  })));
  return /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollRegion$1, null, children), showResetApplyButtons ? makeActionButtons() : null),
    open: isOpen,
    onOpenChange: open => {
      if (!open) closePopover();
    },
    align: "start",
    onClickOutside: closePopover,
    withPadding: false
  }, /*#__PURE__*/React.createElement(FilterButton$2, {
    size: "inlineForm",
    text: label,
    isFiltered: isFiltered,
    onClick: clickHandler,
    bordered: isFiltered,
    borderedLight: !isFiltered,
    renderAs: "div",
    iconSuffix: isFiltered && onReset ? /*#__PURE__*/React.createElement(IconClose, {
      onClick: resetHandler
    }) : /*#__PURE__*/React.createElement(IconCaretDown, null)
  }));
};
Solofilter.propTypes = {
  /**
   * Button text name
   */
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  /**
   * If passed in, function will be called when user clicks X on active filter
   */
  onReset: PropTypes.func,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  /**
   * Controls whether the reset and apply buttons are visible
   */
  showResetApplyButtons: PropTypes.bool,
  /**
   * Should be set to true when a filter is applied to control styling
   */
  isFiltered: PropTypes.bool
};
Solofilter.defaultProps = {
  onApply: () => {},
  onCancel: () => {}
};

const CheckboxWithLabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  align-items: center;
`;
const FilterButton$1 = styled(Button)`
  min-width: max-content;

  ${_ref => {
  let {
    isChecked
  } = _ref;
  return isChecked && css`
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
      box-shadow: ${getTokenValue(THEME_TOKENS.textInput.shadow.focus)};
    `;
}};

  ${ButtonTextStyled} {
    padding-left: 12px;
    padding-right: 12px;
  }
`;
const CheckboxStyled$1 = styled.span`
  background: white;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
  box-shadow: inset 0 0 0 ${props => props.checked ? 0 : '1em'} white;
  border-color: inherit;
  background-color: ${getThemeProp('global.link--color')};
  content: '';
  height: 0.8em;
  width: 0.8em;
  transition: 0.3s;
  display: inline-block;
  justify-content: center;

  /* '&&' is added to increase specificity */
  && {
    span {
      display: flex;
      color: #fff;
      justify-content: center;

      svg {
        width: 1em;
        height: 0.65em;
        top: 0em;
      }
    }
  }
`;
const Count$2 = styled.span`
  opacity: 0.5;
  min-width: 16px;
  border-radius: 16px;
`;
const SolofilterCheckbox = _ref2 => {
  let {
    label,
    checked,
    onChange,
    icon,
    count
  } = _ref2;
  return /*#__PURE__*/React.createElement(FilterButton$1, {
    size: "inlineForm",
    text: /*#__PURE__*/React.createElement(CheckboxWithLabelWrapper, null, /*#__PURE__*/React.createElement(CheckboxStyled$1, {
      checked: checked
    }, /*#__PURE__*/React.createElement(IconCheck, null)), label, count ? /*#__PURE__*/React.createElement(Count$2, null, count) : null),
    onClick: onChange,
    isChecked: checked,
    bordered: checked,
    borderedLight: !checked,
    renderAs: "div",
    iconPrefix: icon
  });
};
SolofilterCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const KINDS = {
  PRIMARY: 'primary',
  // deprecated
  SECONDARY: 'secondary',
  // deprecated
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
  INFO: 'info',
  NEUTRAL: 'neutral',
  DARK: 'dark',
  // deprecated
  VELLUM: 'vellum',
  // deprecated
  DISABLED: 'disabled'
};
const getBadgeKindColorObj$1 = (kind, strong, transparent) => {
  const whiteToken = getTokenValue(THEME_TOKENS.base.color.neutral0);
  const offBlackToken = getTokenValue(THEME_TOKENS.base.color.neutral950);
  switch (kind) {
    case KINDS.NEUTRAL:
      return transparent ? {
        icon: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        text: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        background: 'transparent'
      } : {
        icon: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        text: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        background: getTokenValue(THEME_TOKENS.badge.color.neutralBackground)
      };
    case KINDS.SUCCESS:
      return transparent ? {
        icon: getTokenValue(THEME_TOKENS.badge.color.success),
        text: offBlackToken,
        background: 'transparent'
      } : {
        icon: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.successText),
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.successText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.success) : getTokenValue(THEME_TOKENS.badge.color.successBackground)
      };
    case KINDS.WARNING:
      return transparent ? {
        icon: getTokenValue(THEME_TOKENS.badge.color.warning),
        text: offBlackToken,
        background: 'transparent'
      } : {
        icon: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.warningText),
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.warningText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.warning) : getTokenValue(THEME_TOKENS.badge.color.warningBackground)
      };
    case KINDS.DANGER:
      return transparent ? {
        icon: getTokenValue(THEME_TOKENS.badge.color.danger),
        text: offBlackToken,
        background: 'transparent'
      } : {
        icon: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.dangerText),
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.dangerText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.danger) : getTokenValue(THEME_TOKENS.badge.color.dangerBackground)
      };
    case KINDS.INFO:
      return transparent ? {
        icon: offBlackToken,
        text: offBlackToken,
        background: 'transparent'
      } : {
        icon: getTokenValue(THEME_TOKENS.badge.color.infoText),
        text: getTokenValue(THEME_TOKENS.badge.color.infoText),
        background: getTokenValue(THEME_TOKENS.badge.color.infoBackground)
      };
    default:
      return {
        icon: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        text: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        background: getTokenValue(THEME_TOKENS.badge.color.neutral)
      };
  }
};
const getNoticeKindColorObj = kind => {
  switch (kind) {
    case KINDS.NEUTRAL:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.neutralText),
        background: getTokenValue(THEME_TOKENS.notice.color.neutralBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.neutralBorder)
      };
    case KINDS.SUCCESS:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.successText),
        background: getTokenValue(THEME_TOKENS.notice.color.successBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.successBorder)
      };
    case KINDS.WARNING:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.warningText),
        background: getTokenValue(THEME_TOKENS.notice.color.warningBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.warningBorder)
      };
    case KINDS.DANGER:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.dangerText),
        background: getTokenValue(THEME_TOKENS.notice.color.dangerBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.dangerBorder)
      };
    case KINDS.INFO:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.infoText),
        background: getTokenValue(THEME_TOKENS.notice.color.infoBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.infoBorder)
      };
    default:
      return {
        text: getTokenValue(THEME_TOKENS.notice.color.neutralText),
        background: getTokenValue(THEME_TOKENS.notice.color.neutralBackground),
        border: getTokenValue(THEME_TOKENS.notice.color.neutralBorder)
      };
  }
};
const getKindColorFromProps = props => {
  switch (props.kind) {
    case KINDS.SECONDARY:
      return getThemeProp('button.secondary--color')(props);
    case KINDS.WARNING:
      return getThemeProp('global.warning--color')(props);
    case KINDS.DANGER:
      return getThemeProp('global.danger--color')(props);
    case KINDS.SUCCESS:
      return getThemeProp('global.success--color')(props);
    case KINDS.INFO:
      return getThemeProp('global.info--color')(props);
    case KINDS.VELLUM:
      return 'rgba(255,255,255,0.3)';
    case KINDS.DISABLED:
      return getThemeProp('global.disabled--color')(props);
    default:
      return getThemeProp('button.primary--color')(props);
  }
};
const getKindBorderColor = props => {
  switch (props.kind) {
    case KINDS.SECONDARY:
      return getThemeProp('button.secondary--color')(props);
    case KINDS.WARNING:
      return getThemeProp('global.warning--color')(props);
    case KINDS.DANGER:
      return getThemeProp('global.danger--color')(props);
    case KINDS.SUCCESS:
      return getThemeProp('global.success--color')(props);
    case KINDS.INFO:
      return getThemeProp('global.info--color')(props);
    case KINDS.VELLUM:
      return 'rgba(255,255,255,0.3)';
    case KINDS.DISABLED:
      return getThemeProp('global.disabled--color')(props);
    // this was causing an issue with the
    // border color on TextInput
    // in getKindColorFromProps
    default:
      return getTokenValue(THEME_TOKENS.textInput.color.border);
  }
};
const getButtonKindToken = function (kind) {
  let defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  switch (kind) {
    case KINDS.PRIMARY:
      return 'global.primary--color';
    case KINDS.SECONDARY:
      return 'global.secondary--color';
    case KINDS.WARNING:
      return 'global.warning--color';
    case KINDS.DANGER:
      return 'global.danger--color';
    case KINDS.SUCCESS:
      return 'global.success--color';
    case KINDS.INFO:
      return 'global.info--color';
    case KINDS.DARK:
      return 'global.dark--color';
    case KINDS.VELLUM:
      return 'rgba(255,255,255,0.3)';
    default:
      return `global.${defaultColor}--color`;
  }
};
// kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'dark', 'vellum']),

const getTextColor = () => props => {
  if (props.kind === KINDS.DISABLED || props.disabled) {
    return getTokenValue(THEME_TOKENS.textInput.color.disabledText);
  }
  if (props.kind === KINDS.SUCCESS) {
    return getThemeProp('global.success--color')(props);
  }
  return getThemeProp('textfield.text--color')(props);
};
const textInputPaddingY = 4;
const textInputPaddingX = 12;
const iconAffixPadding = 6;
const LOCATION_KEY_TYPES = {
  AIRPORT: 'A',
  TOWN: 'T',
  CITY: 'C',
  HOTEL: 'H',
  ATTRACTION: 'P',
  RENTAL_AGENCY: 'V',
  RAIL_STATION: 'R',
  ADDRESS: 'G',
  CUSTOM_ACCOUNT: 'G',
  CUSTOM_PERSONAL: 'G'
};
const LOCATION_TYPES = [{
  displayType: 'A',
  label: 'Airport',
  keyType: LOCATION_KEY_TYPES.AIRPORT
}, {
  displayType: 'T',
  label: 'City/Town',
  keyType: LOCATION_KEY_TYPES.TOWN
}, {
  displayType: 'C',
  label: 'City/Town',
  keyType: LOCATION_KEY_TYPES.CITY
}, {
  displayType: 'H',
  label: 'Hotel',
  keyType: LOCATION_KEY_TYPES.HOTEL
}, {
  displayType: 'P',
  label: 'Attraction',
  keyType: LOCATION_KEY_TYPES.ATTRACTION
}, {
  displayType: 'V',
  label: 'Rental Agency',
  keyType: LOCATION_KEY_TYPES.RENTAL_AGENCY
}, {
  displayType: 'R',
  label: 'Rail station',
  keyType: LOCATION_KEY_TYPES.RAIL_STATION
}, {
  displayType: 'G',
  label: 'Address',
  keyType: LOCATION_KEY_TYPES.ADDRESS
}, {
  displayType: 'CUSTOM_ACCOUNT',
  label: 'Account Address',
  keyType: LOCATION_KEY_TYPES.CUSTOM_ACCOUNT
}, {
  displayType: 'CUSTOM_PERSONAL',
  label: 'Personal Address',
  keyType: LOCATION_KEY_TYPES.CUSTOM_PERSONAL
}];
const getLocationByKeyTypeValue = keyType => {
  const foundKeyType = LOCATION_TYPES.filter(type => type.keyType === keyType);
  return foundKeyType.length ? foundKeyType[0].label : '';
};
const scrollToElement = function () {
  let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';
  document.querySelector(`${el}`).scrollIntoView({
    behavior: 'smooth'
  });
};
const colorKindDefs = ['textBody', 'primary', 'secondary', 'info', 'dark', 'link', 'success', 'warning', 'danger'];
// This is not the same as getting a kind color to use in a Badge or Button
const getKindColorOrString = str => {
  if (colorKindDefs.includes(str)) {
    return getThemeProp(`global.${str}--color`);
  }
  return str;
};

const getIconColor = _ref => {
  let {
    defaultColor,
    inheritColor,
    linkColor,
    white
  } = _ref;
  if (defaultColor) {
    return getThemeProp('global.textBody--color');
  }
  if (inheritColor) {
    return 'inherit';
  }
  if (linkColor) {
    return getThemeProp('global.link--color');
  }
  if (white) {
    return '#FFFFFF';
  }
  return GreyPalette['500'];
};
const IconFlexStyled = styled(Flex)`
  justify-content: center;
  align-items: center;
  color: ${getIconColor};
  font-size: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size;
}};

  svg {
    position: relative;

    ${_ref3 => {
  let {
    heightOffset
  } = _ref3;
  return heightOffset && css`
        top: ${heightOffset};
      `;
}}

    ${_ref4 => {
  let {
    widthOffset
  } = _ref4;
  return widthOffset && css`
        left: ${widthOffset};
      `;
}}
  }
`;
const IconFlex = _ref5 => {
  let {
    size = 25,
    heightOffset,
    widthOffset,
    defaultColor,
    inheritColor,
    linkColor,
    white,
    children,
    ...rest
  } = _ref5;
  const heightOffsetVal = heightOffset ? `${heightOffset}px` : null;
  const widthOffsetVal = widthOffset ? `${widthOffset}px` : null;
  const sizeVal = typeof size === 'number' ? `${size}px` : size;
  return /*#__PURE__*/React.createElement(IconFlexStyled, _extends({
    size: sizeVal,
    heightOffset: heightOffsetVal,
    widthOffset: widthOffsetVal,
    defaultColor: defaultColor,
    inheritColor: inheritColor,
    linkColor: linkColor,
    white: white
  }, rest), children);
};
IconFlex.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  heightOffset: PropTypes.number,
  widthOffset: PropTypes.number,
  defaultColor: PropTypes.bool,
  inheritColor: PropTypes.bool,
  linkColor: PropTypes.bool,
  white: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired
};

const CheckboxContainer = styled.div`
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  color: ${getTextColor};
  border-color: ${getThemeProp('textfield.border--color')};
  display: flex;
  line-height: 1.1;
`;
const CheckboxStyled = styled.span`
  background: white;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
  border-radius: 4px;
  box-shadow: inset 0 0 0 ${props => props.checked ? 0 : '1em'} white;
  border-color: ${props => props.checked ? getKindColorFromProps(props) : getTokenValue(THEME_TOKENS.textInput.color.border)};
  background-color: ${props => props.checked ? getKindColorFromProps(props) : 'transparent'};
  content: '';
  height: 1.125em;
  width: 1.125em;
  transition: 0.3s;
  display: inline-block;
  justify-content: center;

  /* '&&' is added to increase specificity */
  && {
    span {
      display: flex;
      color: #fff;
      justify-content: center;

      svg {
        width: 1em;
        height: 1em;
        top: 0em;
      }
    }

    ${props => !props.disabled && !props.checked && props.hover && css`
        box-shadow: inset 0 0 0 1em white,
          0 0 0 0.25em ${tinycolor(getThemeProp('textfield.border--color')(props)).lighten(12).toString()};
      `};

    ${props => props.disabled && css`
        box-shadow: inset 0 0 0 1em ${getTokenValue(THEME_TOKENS.base.color.neutral300)};
        border-color: ${getTokenValue(THEME_TOKENS.base.color.neutral400)};
        background-color: transparent;
      `};

    ${props => props.disabled && !props.checked && css`
        svg {
          display: none; /* hides checkbox icon */
        }
      `};

    ${props => props.disabled && props.checked && css`
        svg {
          color: ${getTokenValue(THEME_TOKENS.base.color.neutral400)};
        }
      `};
  }
`;
const CheckboxLabel = styled.label`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: inherit;
  line-height: 1;
  position: relative;
  user-select: none;
  outline: 0;
`;
const CheckboxLabelText = styled.span`
  padding-left: 0.5em;
`;
const HiddenNativeCheckbox = styled.input`
  position: absolute;
  z-index: 999;
  opacity: 0;

  &:focus-visible + ${CheckboxStyled} {
    transition: none;
    outline: 2px solid ${getKindColorFromProps};
    outline-offset: 2px;
  }
`;
const Checkbox = _ref => {
  let {
    name,
    id,
    className,
    checked,
    disabled,
    onChange,
    kind,
    label,
    icon,
    tabIndex,
    ...rest
  } = _ref;
  const [hover, setHover] = useState(false);
  const dataAttrs = Object.keys(rest).reduce((obj, key) => {
    if (key.indexOf('data-') === 0) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = rest[key];
    }
    return obj;
  }, {});
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  const renderLabel = () => {
    if (typeof label === 'function') {
      return label();
    }
    if (typeof label === 'string') {
      return /*#__PURE__*/React.createElement(CheckboxLabelText, null, label);
    }
    return label;
  };
  const getTabIndex = () => {
    if (disabled) {
      return -1;
    }
    if (tabIndex) {
      return tabIndex;
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(CheckboxContainer, {
    className: className,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement(CheckboxLabel, {
    disabled: disabled,
    checked: checked,
    htmlFor: id,
    kind: kind
  }, /*#__PURE__*/React.createElement(HiddenNativeCheckbox, _extends({
    tabIndex: getTabIndex(),
    type: "checkbox",
    id: id,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    kind: kind,
    name: name
  }, dataAttrs)), /*#__PURE__*/React.createElement(CheckboxStyled, {
    hover: hover,
    checked: checked,
    disabled: disabled,
    kind: kind
  }, icon), label ? renderLabel() : null));
};
Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  kind: PropTypes.string,
  icon: PropTypes.element,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  tabIndex: PropTypes.number
};
Checkbox.defaultProps = {
  disabled: false,
  className: undefined,
  label: undefined,
  kind: 'primary',
  icon: /*#__PURE__*/React.createElement(IconFlex, {
    size: "1em",
    widthOffset: -0.4
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: "Check",
    size: "1em",
    color: "white",
    strokeWidth: 1.5
  })),
  checked: false,
  name: ''
};

const getBadgeBackgroundColor$1 = () => props => {
  const isCavaTheme = Boolean(props.theme.themeSystemName === 'cava');
  if (props.defaultColor) {
    return 'white';
  }
  // used for Gather badges
  if (props.featured) {
    return '#d9f6ff'; // light variation of #82DCFA
  }
  // Additional Cava color support when using tinycolor
  if (props.kind === 'global.success--color' && isCavaTheme) {
    return '#D6FFEF';
  }
  return tinycolor.mix(getThemeProp(props.kind)(props), 'white', 90).toString();
};

const getBadgeTextColor$1 = () => props => {
  const isCavaTheme = Boolean(props.theme.themeSystemName === 'cava');
  const colorMixAmount = isCavaTheme ? 0 : 58;
  if (props.defaultColor) {
    return getThemeProp('global.textBody--color');
  }
  // used for Gather badges
  if (props.featured) {
    return '#146078'; // dark variation of #82DCFA
  }

  // Additional Cava color support when using tinycolor
  if (props.kind === 'global.info--color' && isCavaTheme) {
    return '#424242';
  }
  if (props.kind === 'global.warning--color' && isCavaTheme) {
    return '#805F00';
  }
  return tinycolor.mix(getThemeProp(props.kind)(props), 'black', colorMixAmount).toString();
};

const getBadgeToken = kind => {
  switch (kind) {
    case 'warning':
      return 'global.warning--color';
    case 'danger':
      return 'global.danger--color';
    case 'success':
      return 'global.success--color';
    case 'info':
    case 'neutral':
    case 'primary':
    case 'secondary':
    case 'dark':
      return 'global.info--color';
    default:
      return 'global.success--color';
  }
};
const TextOnlyBadgeStyled = styled.span`
  display: inline-block;
  padding: ${_ref => {
  let {
    size
  } = _ref;
  return size === 'small' ? '2px 5px' : '4px 8px';
}};
  color: ${getBadgeTextColor$1};
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  font-weight: ${props => props.theme.themeSystemName === 'cava' ? '700' : '600'};
  background-color: ${getBadgeBackgroundColor$1};
  text-transform: uppercase;
  border-radius: ${_ref2 => {
  let {
    noBorderRadius
  } = _ref2;
  return noBorderRadius ? 'unset' : '1em';
}};
  font-size: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'small' ? '10px' : '11px';
}};
  letter-spacing: 0.8px;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
`;
const IconTextBadgeStyled = styled.div`
  display: flex;
  align-items: center;
  width: min-content;
  color: ${getBadgeTextColor$1};
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  font-weight: ${props => props.theme.themeSystemName === 'cava' ? '700' : '600'};
  background-color: ${getBadgeBackgroundColor$1};
  text-transform: uppercase;
  border-radius: ${_ref4 => {
  let {
    noBorderRadius
  } = _ref4;
  return noBorderRadius ? 'unset' : '1em';
}};
  font-size: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'small' ? '10px' : '11px';
}};
  letter-spacing: 0.8px;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  max-width: -webkit-fill-available;
`;
const IconContainer$2 = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'small' ? '5px' : '6px';
}};
  padding-right: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'small' ? '2px' : '4px';
}};
  font-size: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'small' ? '12px' : '16px';
}};
`;
const TextContainer$4 = styled.div`
  padding-right: ${_ref9 => {
  let {
    size
  } = _ref9;
  return size === 'small' ? '5px' : '8px';
}};
  padding-top: ${_ref10 => {
  let {
    size
  } = _ref10;
  return size === 'small' ? '2px' : '4px';
}};
  padding-bottom: ${_ref11 => {
  let {
    size
  } = _ref11;
  return size === 'small' ? '2px' : '4px';
}};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const underlineStyles = `
  text-decoration: dotted underline;
  text-underline-position: under;
  cursor: default;
`;
const BadgeContainer = styled(Box)`
  display: inline-flex;
  align-items: center;
  min-width: 20px;
  height: 24px;
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  font-size: ${getTokenValue(THEME_TOKENS.badge.size.text)};
  font-weight: ${getTokenValue(THEME_TOKENS.badge.size.fontWeight)};
  white-space: nowrap;
  padding: 0 ${SPACE.size8};
  border-radius: 4px;
`;
const BadgeStyled$1 = styled(BadgeContainer)`
  color: ${_ref => {
  let {
    kind,
    strong,
    transparent
  } = _ref;
  return `${getBadgeKindColorObj$1(kind, strong, transparent).text}`;
}};
  background-color: ${_ref2 => {
  let {
    kind,
    strong,
    transparent
  } = _ref2;
  return `${getBadgeKindColorObj$1(kind, strong, transparent).background}`;
}};

  ${_ref3 => {
  let {
    interactive
  } = _ref3;
  return interactive && css`
      ${underlineStyles}
    `;
}};
`;
const Badge = _ref4 => {
  let {
    children,
    kind = 'neutral',
    iconToken,
    strong = false,
    interactive = false,
    transparent = false,
    featured = false,
    // ⇣ Legacy props ⇣
    size = 'medium',
    // ‼ Deprecated ‼
    noBorderRadius = false,
    // ‼ Deprecated ‼
    icon,
    // ‼ Deprecated ‼
    ...rest
  } = _ref4;
  // === I M P O R T A N T === \\
  // 'isHighlight' will continue to render our legacy badge under certain conditions. Those styles will
  // eventually move into a new 'Highlight' component, once they are fully deprecated in this component.

  const isHighlight = noBorderRadius || size === 'small';
  if (isHighlight && icon) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconTextBadgeStyled, _extends({
      kind: getBadgeToken(kind),
      size: size,
      noBorderRadius: noBorderRadius,
      featured: featured
    }, rest), icon ? /*#__PURE__*/React.createElement(IconContainer$2, {
      size: size
    }, icon) : null, /*#__PURE__*/React.createElement(TextContainer$4, {
      size: size
    }, children)));
  }
  if (isHighlight) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextOnlyBadgeStyled, _extends({
      kind: getBadgeToken(kind),
      size: size,
      noBorderRadius: noBorderRadius,
      featured: featured
    }, rest), children));
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BadgeStyled$1, _extends({
    kind: kind,
    strong: strong,
    transparent: transparent,
    interactive: interactive
  }, rest), iconToken ? /*#__PURE__*/React.createElement(IconLine, {
    icon: iconToken,
    size: 16,
    color: getBadgeKindColorObj$1(kind, strong, transparent).icon,
    mr: SPACE.size6,
    ml: "-2px"
  }) : null, children));
};
Badge.propTypes = {
  children: PropTypes.node,
  /**
   *primary, secondary, and dark are deprecated kinds.
   */
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'neutral', 'dark']),
  /**
   * An icon will be displayed when providing a token supported by the IconLine component.
   */
  iconToken: PropTypes.string,
  /**
   * Works in conjunction with `success`, `warning`, and `danger` to show an emphasized variant of those badges.
   */
  strong: PropTypes.bool,
  /**
   * Displays the text with a dotted underline - use in conjunction with a tooltip.
   */
  interactive: PropTypes.bool,
  /**
   * Enables transparent background mode.
   */
  transparent: PropTypes.bool,
  /**
   * Used for custom brand colors in Gather badges
   */
  featured: PropTypes.bool,
  /**
   *⚠ size prop is deprecated ⚠
   */
  size: PropTypes.oneOf(['small', 'medium']),
  /**
   *⚠ noBorderRadius prop is deprecated ⚠
   */
  noBorderRadius: PropTypes.bool,
  /**
   *⚠ icon prop is deprecated ⚠
   */
  icon: PropTypes.node
};

const NUMBER_BADGE_KINDS = {
  ONLINE: 'online',
  AVAILABLE: 'available',
  PAUSED: 'paused',
  UNREAD: 'unread',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
  INFO: 'info',
  NEUTRAL: 'neutral',
  DARK: 'dark'
};
const getBadgeKindColorObj = (kind, strong) => {
  const whiteToken = getTokenValue(THEME_TOKENS.base.color.neutral0);
  switch (kind) {
    case NUMBER_BADGE_KINDS.NEUTRAL:
      return {
        text: getTokenValue(THEME_TOKENS.badge.color.neutralText),
        background: getTokenValue(THEME_TOKENS.badge.color.neutralBackground)
      };
    case NUMBER_BADGE_KINDS.SUCCESS:
    case NUMBER_BADGE_KINDS.ONLINE:
    case NUMBER_BADGE_KINDS.AVAILABLE:
      return {
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.successText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.success) : getTokenValue(THEME_TOKENS.badge.color.successBackground)
      };
    case NUMBER_BADGE_KINDS.WARNING:
      return {
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.warningText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.warning) : getTokenValue(THEME_TOKENS.badge.color.warningBackground)
      };
    case NUMBER_BADGE_KINDS.DANGER:
    case NUMBER_BADGE_KINDS.UNREAD:
      return {
        text: strong ? whiteToken : getTokenValue(THEME_TOKENS.badge.color.dangerText),
        background: strong ? getTokenValue(THEME_TOKENS.badge.color.danger) : getTokenValue(THEME_TOKENS.badge.color.dangerBackground)
      };
    case NUMBER_BADGE_KINDS.INFO:
    case NUMBER_BADGE_KINDS.DARK:
      return {
        text: getTokenValue(THEME_TOKENS.badge.color.infoText),
        background: getTokenValue(THEME_TOKENS.badge.color.infoBackground)
      };
    // these are strictly for NumberBadge variants in our Agent / Advisor Console
    case NUMBER_BADGE_KINDS.PRIMARY:
      // variations of #82DCFA
      return {
        text: strong ? whiteToken : '#146078',
        background: strong ? '#48a7c7' : '#d9f6ff'
      };
    case NUMBER_BADGE_KINDS.SECONDARY:
    case NUMBER_BADGE_KINDS.PAUSED:
      // variations of #C8A0FF
      return {
        text: strong ? whiteToken : '#54436b',
        background: strong ? '#ae7cf2' : '#eadbff'
      };
    default:
      return {
        text: getTokenValue(THEME_TOKENS.badge.color.successText),
        background: getTokenValue(THEME_TOKENS.badge.color.successBackground)
      };
  }
};
const NumberBadgeStyled = styled(BadgeContainer)`
  color: ${_ref => {
  let {
    kind,
    strong
  } = _ref;
  return `${getBadgeKindColorObj(kind, strong).text}`;
}};
  background-color: ${_ref2 => {
  let {
    kind,
    strong
  } = _ref2;
  return `${getBadgeKindColorObj(kind, strong).background}`;
}};

  ${_ref3 => {
  let {
    compact
  } = _ref3;
  return compact && css`
      justify-content: center;
      min-width: 16px;
      height: unset;
      font-size: ${getTokenValue(THEME_TOKENS.base.size.detailText)};
      font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.bold)};
      letter-spacing: 0.8px;
      line-height: 1;
      padding: 2px 4px;
    `;
}}
`;
const NumberBadge = _ref4 => {
  let {
    children,
    kind,
    strong = false,
    compact = false,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumberBadgeStyled, _extends({
    kind: kind,
    strong: strong,
    compact: compact
  }, rest), children));
};
NumberBadge.propTypes = {
  children: PropTypes.node,
  kind: PropTypes.oneOf(['online', 'available', 'paused', 'unread', 'primary', 'secondary', 'warning', 'danger', 'success', 'info', 'neutral', 'dark']),
  strong: PropTypes.bool,
  compact: PropTypes.bool
};

const CircleIconBadgeStyled = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size;
}};
  border-radius: 50%;
  color: ${getBadgeTextColor$1};
  background-color: ${getBadgeBackgroundColor$1};
  flex: 0 0 auto;
`;
const IconStyled = styled(Flex)`
  position: relative;
  width: ${_ref3 => {
  let {
    iconSize
  } = _ref3;
  return iconSize;
}};
  height: ${_ref4 => {
  let {
    iconSize
  } = _ref4;
  return iconSize;
}};
  color: inherit;
  font-size: ${_ref5 => {
  let {
    iconSize
  } = _ref5;
  return iconSize;
}};
  text-align: center;

  ${_ref6 => {
  let {
    iconHeightOffset
  } = _ref6;
  return iconHeightOffset && css`
      top: ${iconHeightOffset};
    `;
}}

  ${_ref7 => {
  let {
    iconWidthOffset
  } = _ref7;
  return iconWidthOffset && css`
      left: ${iconWidthOffset};
    `;
}}
`;
const CircleIconBadge = _ref8 => {
  let {
    children,
    kind,
    defaultColor = true,
    featured = false,
    // used for Gather badges
    size = 38,
    iconSize = 'unset',
    iconHeightOffset,
    iconWidthOffset,
    ...rest
  } = _ref8;
  const heightOffsetVal = iconHeightOffset ? `${iconHeightOffset}px` : null;
  const widthOffsetVal = iconWidthOffset ? `${iconWidthOffset}px` : null;
  const sizeVal = typeof size === 'number' ? `${size}px` : size;
  const iconSizeVal = typeof iconSize === 'number' ? `${iconSize}px` : iconSize;
  return /*#__PURE__*/React.createElement(CircleIconBadgeStyled, _extends({
    kind: getBadgeToken(kind),
    defaultColor: defaultColor,
    size: sizeVal,
    featured: featured
  }, rest), /*#__PURE__*/React.createElement(IconStyled, {
    iconSize: iconSizeVal,
    iconHeightOffset: heightOffsetVal,
    iconWidthOffset: widthOffsetVal
  }, children));
};
CircleIconBadge.propTypes = {
  children: PropTypes.node,
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'vellum', 'dark']),
  defaultColor: PropTypes.bool,
  featured: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconHeightOffset: PropTypes.number,
  iconWidthOffset: PropTypes.number
};

const GatherBadge = _ref => {
  let {
    iconSize,
    ...rest
  } = _ref;
  // featured = Gather badges
  return /*#__PURE__*/React.createElement(CircleIconBadge, _extends({
    defaultColor: false,
    featured: true
  }, rest), /*#__PURE__*/React.createElement(IconLine, {
    icon: "Users",
    size: iconSize
  }));
};
GatherBadge.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconHeightOffset: PropTypes.number
};

const UserRoleBadge = _ref => {
  let {
    role,
    compact = false,
    ...rest
  } = _ref;
  switch (role) {
    case 'C':
      return /*#__PURE__*/React.createElement(Badge, _extends({}, rest, {
        kind: "warning"
      }), compact ? 'C' : 'Coordinator');
    case 'A':
      return /*#__PURE__*/React.createElement(Badge, _extends({}, rest, {
        kind: "success"
      }), compact ? 'A' : 'Administrator');
    default:
      return /*#__PURE__*/React.createElement(Badge, _extends({}, rest, {
        kind: "info"
      }), compact ? 'T' : 'Traveler');
  }
};
UserRoleBadge.propTypes = {
  role: PropTypes.string,
  compact: PropTypes.bool
};

const LinkBadgeContainer = styled(Flex)`
  color: ${getTokenValue(THEME_TOKENS.badge.color.danger)};
  filter: brightness(85%);
  transition: all 0.3s ease;

  &:hover {
    color: ${getTokenValue(THEME_TOKENS.badge.color.danger)};
    filter: brightness(1.2);
  }
`;
const TextLinkBadgeStyled = styled.div`
  display: inline-block;
  white-space: nowrap;
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.bold)};
  font-size: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}}px;
  color: inherit;
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;

  &:hover {
    color: inherit;
  }
`;

// previously named TextLinkBadge
const ActionBadgeCritical = _ref2 => {
  let {
    url,
    onClick,
    text = 'Needs Approval',
    size = 12,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(LinkBadgeContainer, _extends({
    alignItems: "center"
  }, rest), onClick ? /*#__PURE__*/React.createElement(TextLinkBadgeStyled, {
    onClick: onClick,
    size: size
  }, text) : /*#__PURE__*/React.createElement(TextLinkBadgeStyled, {
    as: "a",
    href: url,
    size: size
  }, text), /*#__PURE__*/React.createElement(IconLine, {
    icon: "ChevronRight",
    size: 12,
    ml: "2px"
  }));
};
ActionBadgeCritical.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  size: PropTypes.number
};

/* eslint-disable max-len */
const CircleCheckSolid = _ref => {
  let {
    size
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,12c0,4.97,4.03,9,9,9s9-4.03,9-9S16.97,3,12,3,3,7.03,3,12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,12.5l3,3.5,6-7"
  }));
};
CircleCheckSolid.propTypes = {
  size: PropTypes.number
};
const GreenCircleCheck = styled.span`
  width: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size;
}}px;
  height: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size;
}}px;
  color: ${getTokenValue(THEME_TOKENS.base.color.success)};
`;
const PreferredMark = _ref4 => {
  let {
    size = 16
  } = _ref4;
  return /*#__PURE__*/React.createElement(GreenCircleCheck, {
    size: size
  }, /*#__PURE__*/React.createElement(CircleCheckSolid, {
    size: size
  }));
};
PreferredMark.propTypes = {
  size: PropTypes.number
};

const StarContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: ${getBadgeTextColor$1};
  background-color: ${getBadgeBackgroundColor$1};
  border-radius: 50%;
`;
const PreferredMarkWrapper = styled(Flex)`
  align-items: center;
  gap: 4px;
`;
const PreferredSpacer = styled.div`
  width: 14px;
  height: 14px;
`;
const PreferredBadge = () => {
  return /*#__PURE__*/React.createElement(Badge, {
    size: "small",
    noBorderRadius: true
  }, /*#__PURE__*/React.createElement(PreferredMarkWrapper, null, /*#__PURE__*/React.createElement(PreferredMark, {
    size: 12
  }), "Preferred"));
};
const PreferredStar = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StarContainer, {
    kind: "global.success--color"
  }, /*#__PURE__*/React.createElement(IconFlex, {
    size: 12,
    inheritColor: true
  }, /*#__PURE__*/React.createElement(IconStarSolid, null))));
};

const ButtonRegion = styled(Box)`
  ${ButtonStyled} {
    border-width: 1px;
  }
`;
const CheckboxHeight = styled(Flex)`
  min-height: 40px;
  align-items: center;
  font-size: 16px;

  ${media.Large`
    min-height: 30px;
    font-size: 14px;
  `};

  @media (hover: hover) {
    ${ButtonRegion} {
      visibility: hidden;
    }

    &:hover ${ButtonRegion} {
      visibility: visible;
    }
  }
`;
const Count$1 = styled(Box)`
  opacity: 0.5;
  text-align: right;
  width: 34px;
`;
const FilterCheckbox = _ref => {
  let {
    withOnly,
    onlyOnClick,
    count,
    isPreferred = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(CheckboxHeight, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Checkbox, rest), isPreferred && /*#__PURE__*/React.createElement(Box, {
    pl: 2
  }, /*#__PURE__*/React.createElement(PreferredStar, null))), /*#__PURE__*/React.createElement(Flex, null, withOnly && /*#__PURE__*/React.createElement(ButtonRegion, {
    pl: 2
  }, /*#__PURE__*/React.createElement(Button, {
    text: "Only",
    onClick: onlyOnClick,
    borderedLight: true,
    size: "small"
  })), count || count === 0 ? /*#__PURE__*/React.createElement(Count$1, {
    pl: "12px"
  }, count) : null));
};
FilterCheckbox.propTypes = {
  withOnly: PropTypes.bool,
  onlyOnClick: PropTypes.func,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPreferred: PropTypes.bool
};

const FilterSectionContainer = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${getThemeProp('global.border--color')};

  ${media.Medium`
    padding-left: 16px;
    padding-right: 16px;  
  `};
`;
const FilterTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 10px;
`;
const FilterRegionSeparator = styled(Box)`
  margin-left: -16px;
  margin-right: -16px;
  border-bottom: 1px solid ${getThemeProp('global.border--color')};
`;
const FilterSection = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(FilterSectionContainer, null, title && /*#__PURE__*/React.createElement(FilterTitle, null, title), children);
};
FilterSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};

/* eslint-disable max-len */
const ActivityIndicatorStyled = styled.div`
  --spinner-size: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  height: var(--spinner-size);
  width: var(--spinner-size);
  border-radius: 50%;
  border-width: calc(0.12 * var(--spinner-size));
  border-style: solid;
  border-left-color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  border-top-color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  border-right-color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  border-bottom-color: transparent;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const VerticalCenter$1 = styled(Flex)`
  align-items: center;
  justify-content: center;
`;
const ActivityIndicator = _ref2 => {
  let {
    size = 24,
    ...rest
  } = _ref2;
  const sizeVal = typeof size === 'number' ? `${size}px` : size;
  return /*#__PURE__*/React.createElement(VerticalCenter$1, rest, /*#__PURE__*/React.createElement(ActivityIndicatorStyled, {
    size: sizeVal
  }));
};
ActivityIndicator.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const Trigger$1 = styled.div`
  display: ${_ref => {
  let {
    triggerDisplayProperty
  } = _ref;
  return triggerDisplayProperty;
}};
`;
const Tooltip = _ref2 => {
  let {
    children,
    content,
    maxWidth = '350px',
    placement = 'right',
    kind = 'dark',
    open,
    defaultOpen,
    onOpenChange,
    triggerDisplayProperty = 'inline-block',
    interactive = true,
    withPadding = true
  } = _ref2;
  if (window.matchMedia('(any-hover: none)').matches) {
    return /*#__PURE__*/React.createElement(Popover, {
      triggerDisplayProperty: triggerDisplayProperty,
      withPadding: withPadding,
      showCloseButton: true,
      content: content,
      maxWidth: maxWidth,
      placement: placement,
      kind: kind,
      open: open,
      defaultOpen: defaultOpen,
      onOpenChange: onOpenChange
    }, children);
  }

  /**
   * $maxWidth is used below instead of maxWidth to create a styled component transient prop
   * https://styled-components.com/docs/api#transient-props
   *
   * data-tooltip serves as a CSS selector allowing different styles to be applied by components contained within a
   * tooltip: ex. [data-within='tooltip'] & {...}
   */
  return /*#__PURE__*/React.createElement(TooltipPrimitive.Provider, {
    delayDuration: 200,
    disableHoverableContent: !interactive
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Root, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Trigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Trigger$1, {
    triggerDisplayProperty: triggerDisplayProperty
  }, children)), /*#__PURE__*/React.createElement(TooltipPrimitive.Portal, null, /*#__PURE__*/React.createElement(TooltipContent, {
    $maxWidth: maxWidth,
    collisionPadding: 5,
    sideOffset: 3,
    side: placement,
    "data-within": "tooltip"
  }, /*#__PURE__*/React.createElement(TooltipBox, {
    padding: withPadding ? '8px 12px' : '0px',
    kind: kind
  }, content), /*#__PURE__*/React.createElement(TooltipArrow, {
    kind: kind
  })))));
};
Tooltip.propTypes = {
  /**
   * The trigger for the Tooltip.
   */
  children: PropTypes.node.isRequired,
  /**
   * The content of the Tooltip.
   */
  content: PropTypes.node.isRequired,
  /**
   * The side of the trigger to render the Tooltip against. Will be reversed when collisions occur.
   */
  placement: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),
  /**
   * Controls the color of the Tooltip.
   */
  kind: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'light', 'dark']),
  /**
   * The allowed maximum width of the Tooltip content.
   */
  maxWidth: PropTypes.string,
  /**
   * Add padding around the Tooltip content.
   */
  withPadding: PropTypes.bool,
  /**
   * Prevents Tooltip from remaining open when hovering. Disabling this has accessibility consequences.
   */
  interactive: PropTypes.bool,
  /**
   * A CSS display property to control the layout of the trigger.
   */
  triggerDisplayProperty: PropTypes.string,
  /**
   * The controlled open state of the Tooltip. Must be used in conjunction with onOpenChange.
   */
  open: PropTypes.bool,
  /**
   * The open state of the Tooltip when it is initially rendered.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Event handler called when the open state of the Tooltip changes.
   * @param {bool} open
   */
  onOpenChange: PropTypes.func
};

const CodeWrapper = styled.span`
  font-size: ${_ref => {
  let {
    small
  } = _ref;
  return small ? 'inherit' : getTokenValue(THEME_TOKENS.base.size.header3);
}};
  font-weight: ${_ref2 => {
  let {
    small
  } = _ref2;
  return small ? getTokenValue(THEME_TOKENS.base.fontWeight.normal) : getTokenValue(THEME_TOKENS.base.fontWeight.bold);
}};
  text-transform: uppercase;
  display: inline-flex;
  cursor: default;
  color: ${_ref3 => {
  let {
    primary
  } = _ref3;
  return primary ? getTokenValue(THEME_TOKENS.base.color.primaryText) : 'inherit';
}};
  border-bottom: ${_ref4 => {
  let {
    isLoading,
    hasTooltip
  } = _ref4;
  return isLoading || !hasTooltip ? '0' : '1px dotted rgba(0, 0, 0, 0.2)';
}};
  ${_ref5 => {
  let {
    isLoading
  } = _ref5;
  return skeletonLoadingStyles(isLoading);
}};

  &:hover {
    border-bottom: ${_ref6 => {
  let {
    hasTooltip
  } = _ref6;
  return hasTooltip ? '1px solid' : 'none';
}};
  }

  ${props => props.highlight && css`
      background: ${getTokenValue(THEME_TOKENS.base.color.warningBackground)};
      box-shadow: 0 0px 0 2px ${getTokenValue(THEME_TOKENS.base.color.warningBackground)};
    `}
`;
const AirportCodeComponent = _ref7 => {
  let {
    name = '',
    code,
    isLoading = false,
    small = false,
    isDepartingArrivalMismatch = false,
    primary = false
  } = _ref7;
  if (name) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      content: name
    }, /*#__PURE__*/React.createElement(CodeWrapper, {
      highlight: !isLoading && isDepartingArrivalMismatch,
      small: small,
      hasTooltip: name,
      isLoading: isLoading,
      primary: primary
    }, /*#__PURE__*/React.createElement("span", null, code)));
  }
  return /*#__PURE__*/React.createElement(CodeWrapper, {
    highlight: !isLoading && isDepartingArrivalMismatch,
    small: small,
    primary: primary,
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement("span", null, code));
};
AirportCodeComponent.propTypes = {
  name: PropTypes.string,
  code: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  small: PropTypes.bool,
  isDepartingArrivalMismatch: PropTypes.bool,
  primary: PropTypes.bool
};

// Need to set displayName property for memoized components in Storybook 7
const AirportCode = /*#__PURE__*/memo(AirportCodeComponent);
AirportCode.displayName = 'AirportCode';

const KIND_OPTIONS = {
  NEUTRAL: 'neutral',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  PENDING: 'pending'
};

const hasValidChildren = _ref => {
  let {
    children
  } = _ref;
  if (React.Children.count(children) === 0) {
    return false;
  }
  if (React.Children.count(children) === 1 && typeof children === 'string' && isNilOrEmpty(children)) {
    return false;
  }
  return true;
};
const StyledNotice = styled(Flex)`
  align-items: flex-start;
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  font-size: ${getTokenValue(THEME_TOKENS.notice.size.text)};
  font-weight: ${getTokenValue(THEME_TOKENS.notice.size.fontWeight)};
  line-height: 1.3;
  border-style: solid;
  border-width: 1px;
  border-radius: ${SPACE.size12};
  padding: ${SPACE.size12};
  color: ${_ref2 => {
  let {
    kind
  } = _ref2;
  return `${getNoticeKindColorObj(kind).text}`;
}};
  background-color: ${_ref3 => {
  let {
    kind
  } = _ref3;
  return `${getNoticeKindColorObj(kind).background}`;
}};
  border-color: ${_ref4 => {
  let {
    kind
  } = _ref4;
  return `${getNoticeKindColorObj(kind).border}`;
}};
`;
const iconTokenFromKind = kind => {
  switch (kind) {
    case KIND_OPTIONS.SUCCESS:
      return 'CircleCheck';
    case KIND_OPTIONS.WARNING:
      return 'InfoCircle';
    case KIND_OPTIONS.DANGER:
      return 'AlertTriangle';
    default:
      return 'InfoCircle';
  }
};
const Notice = props => {
  const {
    children,
    kind,
    closable,
    onClose,
    icon,
    hideIcon,
    iconToken,
    ...rest
  } = props;
  const [showNotice, setShowNotice] = useState(true);
  const OnCloseNotice = () => {
    setShowNotice(false);
    onClose();
  };
  if (icon) {
    if (typeof icon === 'object') {
      console.warn('Notice no longer accepts icons as components. Please use. Please use iconToken to customize the icon.');
    } else {
      console.warn('Notice no longer uses the icon prop to display icons.');
    }
  }
  return showNotice && hasValidChildren(props) ? /*#__PURE__*/React.createElement(StyledNotice, _extends({
    kind: kind
  }, rest), hideIcon ? null : /*#__PURE__*/React.createElement(IconLine, {
    mr: SPACE.size8,
    icon: iconToken || iconTokenFromKind(kind),
    size: 20
  }), /*#__PURE__*/React.createElement(Box, {
    flex: "1 1 auto",
    alignSelf: "center"
  }, children), closable && /*#__PURE__*/React.createElement(Box, {
    flex: "0 0 auto",
    pl: SPACE.size6
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: OnCloseNotice,
    icon: /*#__PURE__*/React.createElement(IconLine, {
      icon: "X",
      size: 14
    }),
    kind: kind,
    size: "small",
    minimal: true,
    round: true
  }))) : null;
};
Notice.propTypes = {
  children: PropTypes.node,
  /**
   * Show a close button and allow the Notice to be dismissed.
   */
  closable: PropTypes.bool,
  /**
   * Notice kinds: 'neutral', 'info', 'success', 'warning', 'danger'.
   */
  kind: PropTypes.oneOf([...Object.values(KIND_OPTIONS), '']),
  /**
   * Function called on close of the Notice.
   */
  onClose: PropTypes.func,
  /**
   *⚠ icon prop is deprecated ⚠
   */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  hideIcon: PropTypes.bool,
  /**
   * Override the preset icon by providing a token supported by the IconLine component.
   */
  iconToken: PropTypes.string
};
Notice.defaultProps = {
  children: void 0,
  closable: false,
  kind: 'info',
  onClose: () => {},
  icon: false
};

const TrayStyled = styled(Flex)`
  position: fixed;
  bottom: 0;
  z-index: ${ZINDEX.FIXED};
  flex-direction: column;
  max-width: ${_ref => {
  let {
    maxWidth
  } = _ref;
  return maxWidth;
}};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const TrayNoticeContainer = styled(Flex)`
  border-radius: 0;
  overflow: hidden;
  box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)},
    0 0 0 1px ${getTokenValue(THEME_TOKENS.card.color.border)};
  flex-direction: column;
  ${media.Medium`
    border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)} ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)} 0 0;
  `};
`;
const TrayContent = styled(Flex)`
  flex: 1;
  min-height: ${_ref2 => {
  let {
    minHeight
  } = _ref2;
  return minHeight;
}};
  background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
  border-radius: 0;
  margin-top: ${_ref3 => {
  let {
    hasHeader
  } = _ref3;
  return hasHeader ? '-6px' : 0;
}};

  ${media.Medium`
    border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)} ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)} 0 0;
  `};
`;
const Tray = _ref4 => {
  let {
    backgroundColor = 'dark',
    minHeight = '78px',
    maxWidth = 'unset',
    content,
    headerMessage = '',
    headerKind = null,
    contentAboveTray = null,
    ...rest
  } = _ref4;
  const hasHeader = Boolean(headerMessage);
  return /*#__PURE__*/React.createElement(TrayStyled, _extends({
    width: "-webkit-fill-available",
    maxWidth: maxWidth
  }, rest), contentAboveTray, /*#__PURE__*/React.createElement(TrayNoticeContainer, null, hasHeader && /*#__PURE__*/React.createElement(Notice, {
    p: "8px 8px 14px 8px",
    mb: "unset",
    compact: true,
    icon: true,
    light: true,
    kind: headerKind,
    isHeader: true
  }, headerMessage), /*#__PURE__*/React.createElement(TrayContent, {
    $backgroundColor: backgroundColor,
    minHeight: minHeight,
    hasHeader: hasHeader
  }, content)));
};
Tray.propTypes = {
  /**
   * Can accept a color string or kind: `primary`, `secondary`, `info`, `dark`, `link`, `success`, etc.
   */
  backgroundColor: PropTypes.string,
  /**
   * This is a separate min-height for the Tray content that doesn't include the header.
   */
  minHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  content: PropTypes.node,
  /**
   * Display a message using the Notice component.
   */
  headerMessage: PropTypes.string,
  headerKind: PropTypes.string,
  /**
   * Content to be displayed above the Tray.
   */
  contentAboveTray: PropTypes.node
};

const AffixBoxStyled = styled(Flex)`
  align-items: center;
  white-space: nowrap;
  line-height: inherit;
  font-size: inherit;
`;
const PrefixBoxStyled = styled(AffixBoxStyled)`
  display: flex;
  align-items: center;
  min-height: inherit;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;

  ${_ref => {
  let {
    removeAffixSpacing
  } = _ref;
  return !removeAffixSpacing && css`
      padding-left: ${iconAffixPadding}px;
    `;
}};
`;
const TextInputContainer = styled(Flex)`
  align-items: center;
  position: relative;
  color: ${getTextColor};
  border-style: solid;
  border-color: ${getKindBorderColor};
  border-width: ${getTokenValue(THEME_TOKENS.textInput.size.border)};
  border-radius: ${getTokenValue(THEME_TOKENS.textInput.size.borderRadius)};
  background-color: ${getTokenValue(THEME_TOKENS.textInput.color.background)};
  overflow: visible;
  font-size: 100%;
  line-height: 1;

  // color of prefix content depends on if input is empty or not
  &:has(> input:not([value=''])) ${PrefixBoxStyled} {
    color: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
  }
  &:has(> input[value='']) ${PrefixBoxStyled} {
    color: ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.textInput.color.placeholderText);
}};
  }

  // if descendant input does not have focus and is not disabled, apply background hover
  &:not(:has(> input:focus)) {
    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
    }
  }

  // if descendant input is disabled
  &:has(> input:disabled) {
    background-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabled)};
    border-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabledBorder)};

    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabled)};
    }
    input {
      cursor: not-allowed;
    }
  }

  ${_ref4 => {
  let {
    withFocus
  } = _ref4;
  return withFocus && css`
      box-shadow: ${getTokenValue(THEME_TOKENS.textInput.shadow.focus)};
      border-color: ${getTokenValue(THEME_TOKENS.base.color.action)};
    `;
}}
`;
const TextFieldStyled = styled.input`
  width: 100%;
  border-width: 0;
  border-radius: inherit;
  min-height: ${_ref5 => {
  let {
    minHeight
  } = _ref5;
  return minHeight;
}};
  padding: ${textInputPaddingY}px ${_ref6 => {
  let {
    hasPrefix
  } = _ref6;
  return hasPrefix ? SPACE.size8 : `${textInputPaddingX}px`;
}};
  outline: none;
  overflow: hidden;
  background: transparent;
  text-overflow: ellipsis;
  color: inherit;
  line-height: inherit;
  font-size: ${getTokenValue(THEME_TOKENS.textInput.size.text)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};

  ::placeholder {
    color: ${_ref7 => {
  let {
    disabled
  } = _ref7;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.textInput.color.placeholderText);
}};
  }
`;
const SuffixBoxStyled = styled(AffixBoxStyled)`
  min-height: inherit;
  position: absolute;
  right: 0;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  background-color: transparent;
  ${_ref8 => {
  let {
    removeAffixSpacing
  } = _ref8;
  return !removeAffixSpacing && css`
      padding-right: ${iconAffixPadding}px;
    `;
}};
`;
const ClearableArea = styled(SuffixBoxStyled)`
  cursor: pointer;
`;
const generateAffix = _ref9 => {
  let {
    affixContent,
    WrappedComponent,
    removeAffixSpacing,
    clearable = false,
    onClear,
    inputRef,
    iconLineName
  } = _ref9;
  if (iconLineName) {
    return /*#__PURE__*/React.createElement(PrefixBoxStyled, null, /*#__PURE__*/React.createElement(Box, {
      width: "20px"
    }, /*#__PURE__*/React.createElement(IconLine, {
      icon: iconLineName,
      size: 20
    })));
  }
  if (clearable) {
    const onClearClick = () => {
      if (onClear) {
        onClear(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
        inputRef === null || inputRef === void 0 || inputRef.current.focus();
      }
    };
    return /*#__PURE__*/React.createElement(ClearableArea, {
      removeAffixSpacing: true,
      title: "Clear",
      onClick: onClearClick,
      pr: 2
    }, /*#__PURE__*/React.createElement(IconClose, null));
  }
  if (!affixContent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WrappedComponent, {
    removeAffixSpacing: removeAffixSpacing
  }, affixContent);
};
const TextInput = /*#__PURE__*/forwardRef((_ref10, ref) => {
  let {
    className,
    value,
    onChange,
    onFocus = () => {},
    onBlur = () => {},
    onClear = () => {},
    kind = 'primary',
    minHeight = null,
    prefixContent,
    suffixContent,
    placeholder,
    removeAffixSpacing = false,
    clearable = false,
    disabled = false,
    iconLineName = '',
    ...rest
  } = _ref10;
  const [withFocus, setWithFocus] = useState(false);
  const inputRef = useRef();

  // allows sharing of the ref between both useRef and forwardRef
  useImperativeHandle(ref, () => inputRef.current);
  const handleFocus = args => {
    setWithFocus(true);
    onFocus(args);
  };
  const handleBlur = args => {
    setWithFocus(false);
    onBlur(args);
  };
  const composedPrefix = generateAffix({
    affixContent: prefixContent,
    WrappedComponent: PrefixBoxStyled,
    removeAffixSpacing,
    inputRef,
    iconLineName
  });
  const composedSuffix = generateAffix({
    affixContent: suffixContent,
    WrappedComponent: SuffixBoxStyled,
    removeAffixSpacing,
    clearable: (value === null || value === void 0 ? void 0 : value.length) && clearable,
    // only show clearable if text input has a value
    onClear,
    inputRef
  });
  const minHeightVal = minHeight || getTokenValue(THEME_TOKENS.textInput.size.minHeight);
  return /*#__PURE__*/React.createElement(TextInputContainer, {
    disabled: disabled,
    withFocus: withFocus,
    className: className,
    kind: kind,
    minHeight: minHeightVal
  }, composedPrefix, /*#__PURE__*/React.createElement(TextFieldStyled, _extends({
    hasPrefix: composedPrefix,
    hasSuffix: composedSuffix,
    minHeight: minHeightVal,
    onFocus: handleFocus,
    onBlur: handleBlur,
    kind: kind,
    ref: inputRef,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    disabled: disabled
  }, rest)), composedSuffix);
});
TextInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  kind: PropTypes.string,
  /**
   * Content added to the start of the input.
   */
  prefixContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * Content added to end of the input.
   */
  suffixContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClear: PropTypes.func,
  clearable: PropTypes.bool,
  /**
   * Prevent margin or padding from being added to prefixContent OR suffixContent
   */
  removeAffixSpacing: PropTypes.bool,
  minHeight: PropTypes.string,
  iconLineName: PropTypes.string
};

const useModal = function (render) {
  let keyed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const baseKey = useRef(`genkey::${Math.random()}`);
  const [gen, setGen] = useState(0);
  const [open, setOpen] = useState(false);
  const [modalData, setData] = useState(null);
  const [defer, setDefer] = useState({
    resolve: console.log,
    reject: console.log
  });
  const launcher = data => {
    setGen(gen + 1);
    setData(data);
    const prom = new Promise((resolve, reject) => {
      setOpen(true);
      setDefer({
        resolve,
        reject
      });
    });
    prom.finally(() => setOpen(false)).catch(() => {});
    return prom;
  };
  return [launcher, keyed ? /*#__PURE__*/React.createElement(React.Fragment, {
    key: baseKey.current + gen
  }, render(open, defer.resolve, defer.reject, modalData)) : render(open, defer.resolve, defer.reject, modalData)];
};

const Heading1 = styled(Box)`
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.heading)};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header1)};
`;
const Heading2 = styled(Heading1)`
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header2)};
`;
const Heading3 = styled(Heading1)`
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header3)};
`;
const Heading4 = styled(Heading1)`
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header4)};
`;

const ACCEPT = 'A';
const REJECT = 'R';
const AcceptText = styled.span`
  color: ${getTokenValue(THEME_TOKENS.base.color.success)};
`;
const RejectText = styled.span`
  color: ${getTokenValue(THEME_TOKENS.base.color.danger)};
`;
const RejectModal = _ref => {
  let {
    isOpen,
    onReject,
    onClose
  } = _ref;
  const [reason, setReason] = useState('');
  return isOpen ? /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Reject Trip"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, "Enter an explanation to send to the booker (optional)"), /*#__PURE__*/React.createElement(TextInput, {
    value: reason,
    onChange: e => setReason(e.target.value)
  })), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    text: "Cancel",
    onClick: onClose,
    bordered: true
  })), /*#__PURE__*/React.createElement(Button, {
    text: "Reject",
    onClick: () => onReject(reason),
    kind: "danger"
  }))) : null;
};
RejectModal.propTypes = {
  isOpen: PropTypes.bool,
  onReject: PropTypes.func,
  onClose: PropTypes.func
};
RejectModal.defaultProps = {
  isOpen: false,
  onReject: () => {},
  onClose: () => {}
};
const ApproveModal = _ref2 => {
  let {
    isOpen,
    onApprove,
    onClose,
    list
  } = _ref2;
  return isOpen ? /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Please Confirm..."), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("span", null, "Are you sure you want to approve the selected trip", list && list.length > 1 ? 's' : '', "?")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    text: "Cancel",
    bordered: true,
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Button, {
    text: "Confirm",
    onClick: () => onApprove()
  }))) : null;
};
ApproveModal.propTypes = {
  isOpen: PropTypes.bool,
  onApprove: PropTypes.func,
  onClose: PropTypes.func,
  list: PropTypes.arrayOf(PropTypes.string)
};
ApproveModal.defaultProps = {
  isOpen: false,
  onApprove: () => {},
  onClose: () => {},
  list: []
};
const ApprovalTray = _ref3 => {
  let {
    list,
    onApprove,
    onReject,
    className,
    disabled,
    multipleAvailableToApprove
  } = _ref3;
  const [launchApprove, approve] = useModal((isOpen, res, rej, data) => /*#__PURE__*/React.createElement(ApproveModal, {
    isOpen: isOpen,
    onApprove: res,
    onClose: rej,
    list: data
  }));
  const [launchReject, reject] = useModal((isOpen, res, rej, data) => /*#__PURE__*/React.createElement(RejectModal, {
    isOpen: isOpen,
    onReject: res,
    onClose: rej,
    list: data
  }));
  const [working, setWorking] = useState(null);
  const confirm = async (bnList, action) => {
    const [launch, callback] = action === ACCEPT ? [launchApprove, onApprove] : [launchReject, onReject];
    try {
      const message = await launch(bnList);
      const payload = {
        bnList,
        action,
        message
      };
      try {
        setWorking(payload.action);
        await Promise.resolve(callback(payload));
      } finally {
        setWorking(null);
      }
    } catch (err) {
      // Modal Cancelled
    }
  };
  return /*#__PURE__*/React.createElement(Tray, {
    maxWidth: "1277px",
    mx: [0, 0, '24px'],
    className: className,
    content: /*#__PURE__*/React.createElement(Flex, {
      py: SPACE.size16,
      px: SPACE.size32,
      width: 1,
      justifyContent: "center",
      alignItems: "center",
      flexDirection: ['column', 'column', 'row']
    }, /*#__PURE__*/React.createElement(Box, {
      mr: 3,
      mb: [3, 3, 0],
      alignSelf: "center"
    }, disabled ? /*#__PURE__*/React.createElement(Heading2, null, /*#__PURE__*/React.createElement(Flex, {
      width: "100%",
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(IconLine, {
      icon: "Checkbox"
    })), /*#__PURE__*/React.createElement(Box, {
      pl: SPACE.size8
    }, "Select the trip", multipleAvailableToApprove ? 's' : '', " you would like to", ' ', /*#__PURE__*/React.createElement(AcceptText, null, "approve"), " or ", /*#__PURE__*/React.createElement(RejectText, null, "reject")))) : null), disabled ? null : /*#__PURE__*/React.createElement(Flex, {
      width: "100%",
      style: {
        gap: '16px'
      },
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(Box, {
      flex: "1 0 auto",
      maxWidth: "320px"
    }, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      text: "Reject",
      isLoading: working === REJECT,
      kind: "danger",
      size: "large",
      onClick: () => confirm(list, REJECT),
      disabled: disabled || working !== null
    })), /*#__PURE__*/React.createElement(Box, {
      flex: "1 0 auto",
      maxWidth: "320px"
    }, /*#__PURE__*/React.createElement(Button, {
      text: `Approve ${list && list.length > 1 ? 'Trips' : 'Trip'}`,
      isLoading: working === ACCEPT,
      kind: "success",
      fullWidth: true,
      size: "large",
      onClick: () => confirm(list, ACCEPT),
      disabled: disabled || working !== null
    }))), approve, reject)
  });
};
ApprovalTray.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.string),
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  multipleAvailableToApprove: PropTypes.bool
};
ApprovalTray.defaultProps = {
  className: undefined,
  disabled: false,
  list: [],
  onApprove: () => {},
  onReject: () => {},
  multipleAvailableToApprove: false
};

function assignRandomColor(_ref) {
  let {
    name,
    hasImage
  } = _ref;
  if (!name || hasImage) return getTokenValue(THEME_TOKENS.avatar.color.backgroundDefault);

  // Create a hash function
  const hashCode = str => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      // eslint-disable-next-line no-bitwise
      hash = (hash << 5) - hash + str.charCodeAt(i); // hash * 31 + charCode
      // eslint-disable-next-line no-bitwise
      hash |= 0; // Convert to 32-bit integer
    }
    return hash;
  };

  // Get the hash code for the name
  const hashValue = hashCode(name);

  // Map the hash value to one of the three numbers (0, 1, 2, 3)
  const assignedNumber = Math.abs(hashValue) % 4; // Use absolute value to avoid negative numbers

  switch (assignedNumber) {
    case 0:
      return getTokenValue(THEME_TOKENS.avatar.color.background1);
    case 1:
      return getTokenValue(THEME_TOKENS.avatar.color.background2);
    case 2:
      return getTokenValue(THEME_TOKENS.avatar.color.background3);
    case 3:
      return getTokenValue(THEME_TOKENS.avatar.color.background4);
    default:
      return getTokenValue(THEME_TOKENS.avatar.color.backgroundDefault);
  }
}
const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
`;
const AvatarWrapper = styled.div`
  width: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size;
}};
  height: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size;
}};
  border-radius: 50%;
  background: ${_ref4 => {
  let {
    name,
    hasImage
  } = _ref4;
  return assignRandomColor({
    name,
    hasImage
  });
}};
  overflow: hidden;

  ${_ref5 => {
  let {
    withInitials
  } = _ref5;
  return withInitials && css`
      // a font-size is set to the size of the Avatar so that AvatarInitials can size it proportionally to the
      // size of the Avatar wrapper using 'em' based sizing in AvatarInitials.
      font-size: ${_ref6 => {
    let {
      size
    } = _ref6;
    return size;
  }};
    `;
}};

  ${_ref7 => {
  let {
    bordered,
    withInitials
  } = _ref7;
  return bordered && withInitials && css`
      box-shadow: 0 0 0 1px ${getTokenValue(THEME_TOKENS.avatar.color.border)} inset;
    `;
}};
`;
const AvatarInitials = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.36em;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  font-weight: 600;
  line-height: normal;
`;
const Avatar = _ref8 => {
  let {
    imgUrl,
    initials,
    size = '35px',
    bordered = false
  } = _ref8;
  const [imgError, setImgError] = useState(false);
  const onImgError = () => {
    console.warn(`Avatar component failed to load image: ${imgUrl}`);
    setImgError(true);
  };
  return /*#__PURE__*/React.createElement(AvatarWrapper, {
    name: initials,
    hasImage: !!imgUrl,
    size: size,
    withInitials: !imgUrl || imgError,
    bordered: bordered
  }, imgUrl && !imgError ? /*#__PURE__*/React.createElement(AvatarImg, {
    onError: onImgError,
    src: imgUrl
  }) : null, initials || imgError ? /*#__PURE__*/React.createElement(AvatarInitials, {
    size: size
  }, initials) : null);
};
Avatar.propTypes = {
  imgUrl: PropTypes.string,
  /**
   * Initials are only shown if imageUrl is not provided.
   */
  initials: PropTypes.string,
  /**
   * Outputted size of avatar image, specified in pixels (ex. '40px').
   */
  size: PropTypes.string,
  /**
   * Show border around avatar.
   */
  bordered: PropTypes.bool
};

const disabledColor = '#a09c9c';
const declinedColor = '#b7b7b7';
const iconSmall = '24px';
const iconLarge = '46px';
const containerSmall = '32px';
const containerLarge = '58px';
const getStatusIconColor = _ref => {
  let {
    status,
    disabled
  } = _ref;
  if (disabled || status.value === BOOKING_ATTACHMENT_TYPES.OFFERED) {
    return disabledColor;
  }
  if (status.value === BOOKING_ATTACHMENT_TYPES.DECLINED) {
    return declinedColor;
  }
  return 'unset';
};
const getStatusCircleColor = _ref2 => {
  let {
    status
  } = _ref2;
  switch (status.value) {
    case BOOKING_ATTACHMENT_TYPES.BOOKED:
    case BOOKING_ATTACHMENT_TYPES.DECLINED:
      return getThemeProp('global.success--color');
    case BOOKING_ATTACHMENT_TYPES.OFFERED:
      return disabledColor;
    default:
      return disabledColor;
  }
};
const Container$1 = styled(Flex)`
  position: relative;
  align-items: center;
  justify-content: center;
  width: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'small' ? containerSmall : containerLarge;
}};
  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'small' ? containerSmall : containerLarge;
}};
`;
const Circle = styled(Box)`
  border-style: solid;
  border-width: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'large' ? '0.23rem' : '0.15rem';
}};
  border-color: ${getStatusCircleColor};
  border-radius: 50%;
`;
const Slash = styled.div`
  position: absolute;
  top: 0px;
  right: calc(50% - 2px);
  width: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'large' ? '0.23rem' : '0.15rem';
}};
  height: 104%;
  background-color: ${getThemeProp('global.success--color')};
  transform: rotate(45deg);
`;
const Icon$2 = styled(Flex)`
  width: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'small' ? iconSmall : iconLarge;
}};
  height: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'small' ? iconSmall : iconLarge;
}};
  font-size: ${_ref9 => {
  let {
    size
  } = _ref9;
  return size === 'small' ? iconSmall : iconLarge;
}};
  color: ${getStatusIconColor};
`;
const BookStatusIndicator = _ref10 => {
  let {
    size = 'small',
    type = 'flight',
    status,
    disabled = false,
    ...rest
  } = _ref10;
  const travelTypeIcon = t => {
    switch (t) {
      case 'flight':
        return /*#__PURE__*/React.createElement(IconPlaneLine, null);
      case 'train':
        return /*#__PURE__*/React.createElement(IconTrainLine, null);
      case 'car':
        return /*#__PURE__*/React.createElement(IconCarLine, null);
      case 'hotel':
        return /*#__PURE__*/React.createElement(IconHotelLine, null);
      default:
        return null;
    }
  };
  const showSlash = status.value === BOOKING_ATTACHMENT_TYPES.DECLINED;
  const TooltipText = `Booking Status: ${status.label}`;
  return /*#__PURE__*/React.createElement(Box, rest, /*#__PURE__*/React.createElement(Tooltip, {
    content: TooltipText
  }, /*#__PURE__*/React.createElement(Circle, {
    size: size,
    status: status
  }, /*#__PURE__*/React.createElement(Container$1, {
    size: size
  }, /*#__PURE__*/React.createElement(Icon$2, {
    size: size,
    status: status,
    disabled: disabled
  }, travelTypeIcon(type)), showSlash ? /*#__PURE__*/React.createElement(Slash, {
    size: size
  }) : null))));
};
BookStatusIndicator.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.oneOf(['flight', 'train', 'car', 'hotel']),
  /**
   * Value in {label, value} should be one of 'NotOffered', 'Offered', 'Booked', 'Declined'
   */
  status: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  disabled: PropTypes.bool
};

const TextCountString = styled.div`
  font-size: 12px;
  color: ${props => props.overMaxLen === true ? getThemeProp('global.danger--color') : 'null'}; //only show pointer if something was passed into onClick
`;
const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 12px;
`;
const CharacterCounter = _ref => {
  let {
    string,
    limit,
    setIsValid,
    children,
    showErrorOnLeft = false
  } = _ref;
  useEffect(() => {
    if (setIsValid) {
      if (string.length > limit) {
        setIsValid(false);
      } else {
        setIsValid(true);
      }
    }
  }, [string]);
  return /*#__PURE__*/React.createElement(ContentContainer, null, showErrorOnLeft ? children : null, /*#__PURE__*/React.createElement(Box, {
    pt: 1,
    mb: 2
  }, /*#__PURE__*/React.createElement(TextCountString, {
    overMaxLen: string.length > limit
  }, `${string.length}/${limit}`)), !showErrorOnLeft ? children : null);
};
CharacterCounter.propTypes = {
  /**
   * The string that will be counted
   */
  string: PropTypes.string,
  /**
   * The maximum number of characters in the string
   */
  limit: PropTypes.number,
  /**
   * A function that will be called and passed true if the string is valid, else false
   */
  setIsValid: PropTypes.func,
  /**
   * Will be rendered to the right of the counter (best used for an ErrorMessage to be shown alongside the counter)
   */
  children: PropTypes.node,
  showErrorOnLeft: PropTypes.bool
};

const BirthdayInputWrapper = styled.div`
  display: inline-flex;
  position: relative;
`;
const isSafariBrowser = navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0;
const BirthdayInputStyled = styled(TextInput)`
  /* all: unset; */

  ${isSafariBrowser && css`
    input {
      background-color: -webkit-control-background;
      color: text;
      min-height: 1rem;
      min-width: 7rem;
    }
  `};

  input::-webkit-calendar-picker-indicator {
    background: url('https://cdn.amtrav.com/web-bounce/search-forms/calendar-black.svg') no-repeat;
    background-size: 21px;
  }
`;
const BirthdayInput = _ref => {
  let {
    name,
    onChange = () => {},
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(BirthdayInputWrapper, null, /*#__PURE__*/React.createElement(BirthdayInputStyled, _extends({
    type: "date",
    name: name,
    onChange: onChange
  }, rest)));
};
BirthdayInput.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
  background-color: ${getTokenValue(THEME_TOKENS.textInput.color.background)};
  border-style: solid;
  border-color: ${getKindBorderColor};
  border-width: ${getTokenValue(THEME_TOKENS.textInput.size.border)};
  border-radius: ${getTokenValue(THEME_TOKENS.textInput.size.borderRadius)};
  overflow: hidden;

  &:has(> :focus) {
    box-shadow: ${getTokenValue(THEME_TOKENS.textInput.shadow.focus)};
    border-color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  }
  // if descendant select does not have focus apply background hover
  &:not(:has(> select:focus)) {
    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
    }
  }

  // if descendant input is disabled
  &:has(> select:disabled) {
    background-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabled)};
    border-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabledBorder)};

    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabled)};
    }
    select {
      cursor: not-allowed;
    }
  }
`;
const Caret = styled.span`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${ZINDEX.DROPDOWN};
  pointer-events: none;
`;
const PrefixContent = styled.div`
  display: flex;
  align-items: center;
  min-height: ${_ref2 => {
  let {
    minHeight
  } = _ref2;
  return minHeight;
}};
  padding-left: ${iconAffixPadding}px;
  z-index: ${ZINDEX.DROPDOWN + 1};
  color: ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
`;
const Dropdown$1 = styled.select`
  width: 100%;
  min-height: ${_ref4 => {
  let {
    minHeight
  } = _ref4;
  return minHeight;
}};
  font-size: ${getTokenValue(THEME_TOKENS.textInput.size.text)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  color: ${_ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
  appearance: none;
  position: relative;
  border: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  z-index: ${ZINDEX.DROPDOWN};
  padding: ${textInputPaddingY}px ${SPACE.size32} ${textInputPaddingY}px
    ${_ref6 => {
  let {
    hasPrefix
  } = _ref6;
  return hasPrefix ? SPACE.size8 : `${textInputPaddingX}px`;
}};
  background-color: transparent;

  &:disabled {
    opacity: 1;
  }

  &:focus {
    appearance: none;
    outline: none;
  }
`;
const DropdownSelect = /*#__PURE__*/forwardRef((_ref7, ref) => {
  let {
    className,
    options,
    value,
    onChange,
    onFocus = () => {},
    onBlur = () => {},
    prefixContent,
    kind,
    minHeight = null,
    iconLineName = '',
    disabled = false,
    ...rest
  } = _ref7;
  const optionComponents = options.map(o => /*#__PURE__*/React.createElement("option", {
    key: o.value,
    value: o.value,
    disabled: o.disabled || null
  }, o.label || o.value));
  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
    onFocus();
  };
  const handleUnfocus = () => {
    setFocused(false);
    onBlur();
  };
  const minHeightVal = minHeight || getTokenValue(THEME_TOKENS.textInput.size.minHeight);
  return /*#__PURE__*/React.createElement(Wrapper, {
    focused: focused,
    kind: kind,
    className: className,
    disabled: disabled
  }, !prefixContent && iconLineName ? /*#__PURE__*/React.createElement(PrefixContent, {
    disabled: disabled,
    minHeight: minHeightVal
  }, /*#__PURE__*/React.createElement(Box, {
    width: "20px"
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: iconLineName,
    size: 20
  }))) : null, prefixContent ? /*#__PURE__*/React.createElement(PrefixContent, {
    disabled: disabled,
    minHeight: minHeightVal
  }, prefixContent) : null, /*#__PURE__*/React.createElement(Dropdown$1, _extends({
    onFocus: handleFocus,
    onBlur: handleUnfocus,
    ref: ref,
    value: value,
    onChange: onChange,
    hasPrefix: iconLineName || prefixContent,
    prefixContent: prefixContent,
    minHeight: minHeightVal,
    disabled: disabled
  }, rest), optionComponents), /*#__PURE__*/React.createElement(Caret, null, /*#__PURE__*/React.createElement(IconLine, {
    strokeWidth: 1.5,
    icon: "ChevronDown"
  })));
});
const DropdownOption = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
});
DropdownSelect.propTypes = {
  className: PropTypes.string,
  /**
   * - { label } and { value } are acceptable keys when creating an option object
   * - Add { disabled: 'disabled' } to the option object to use native html disabling
   */
  options: PropTypes.arrayOf(DropdownOption).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefixContent: PropTypes.element,
  kind: PropTypes.string,
  minHeight: PropTypes.string,
  iconLineName: PropTypes.string,
  disabled: PropTypes.bool
};

const MonthPicker = _ref => {
  let {
    onChange,
    value,
    kind
  } = _ref;
  const monthOptions = [{
    value: '',
    label: 'Month'
  }, {
    value: '01',
    label: 'January'
  }, {
    value: '02',
    label: 'February'
  }, {
    value: '03',
    label: 'March'
  }, {
    value: '04',
    label: 'April'
  }, {
    value: '05',
    label: 'May'
  }, {
    value: '06',
    label: 'June'
  }, {
    value: '07',
    label: 'July'
  }, {
    value: '08',
    label: 'August'
  }, {
    value: '09',
    label: 'September'
  }, {
    value: '10',
    label: 'October'
  }, {
    value: '11',
    label: 'November'
  }, {
    value: '12',
    label: 'December'
  }];
  return /*#__PURE__*/React.createElement(DropdownSelect, {
    kind: kind,
    options: monthOptions,
    onChange: onChange,
    value: value
  });
};
MonthPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  kind: PropTypes.string
};
const ThreePartDateInput = _ref2 => {
  let {
    onChange = () => {},
    values,
    kind
  } = _ref2;
  const dayHandler = evt => {
    onChange({
      ...values,
      day: evt.target.value
    });
  };
  const yearHandler = evt => {
    onChange({
      ...values,
      year: evt.target.value
    });
  };
  const monthHandler = evt => {
    onChange({
      ...values,
      month: evt.target.value
    });
  };
  const removePaddedZeros = numStr => {
    // need to check for empty string since isNan('') will return 0
    if (numStr && !Number.isNaN(Number(numStr))) {
      var _Number;
      return (_Number = Number(numStr)) === null || _Number === void 0 ? void 0 : _Number.toString();
    }
    return numStr;
  };
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    width: "130px"
  }, /*#__PURE__*/React.createElement(MonthPicker, {
    kind: kind,
    onChange: monthHandler,
    value: (values === null || values === void 0 ? void 0 : values.month) || ''
  })), /*#__PURE__*/React.createElement(Box, {
    width: "70px",
    pl: 2
  }, /*#__PURE__*/React.createElement(TextInput, {
    placeholder: "Day",
    kind: kind,
    onChange: dayHandler,
    value: removePaddedZeros(values === null || values === void 0 ? void 0 : values.day)
  })), /*#__PURE__*/React.createElement(Box, {
    width: "70px",
    pl: 2
  }, /*#__PURE__*/React.createElement(TextInput, {
    kind: kind,
    placeholder: "Year",
    onChange: yearHandler,
    value: removePaddedZeros(values === null || values === void 0 ? void 0 : values.year)
  })));
};
ThreePartDateInput.propTypes = {
  values: PropTypes.shape({
    year: PropTypes.string,
    day: PropTypes.string,
    month: PropTypes.string
  }),
  kind: PropTypes.string,
  onChange: PropTypes.func
};

const SearchButton = styled(Button)`
  box-shadow: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  ${ButtonTextStyled} {
    padding-top: 7px;
    padding-bottom: 7px;
  }
`;
const SearchNewWindowButton = styled(Button)`
  box-shadow: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ${ButtonTextStyled} {
    padding-top: 7px;
    padding-bottom: 7px;
    padding-right: 11px;
  }
`;

const commonStyles = css`
  border: 1px solid ${() => getThemeProp('button.primary--color')};
  border-radius: 4px;
  padding: 0;
  background-color: white;
  font-family: ${() => getThemeProp('button.text--fontFamily')};
  overflow: hidden;
`;
const GroupContainer$1 = styled.div`
  display: inline-block;
  ${commonStyles}
`;
const FlexGroupContainer = styled(Flex)`
  display: flex;
  width: 100%;
  flex-direction: row;
  ${commonStyles}
`;
styled(Box)`
  text-align: center;
`;
const BgButton = styled.button`
  height: 100%;
  color: ${_ref => {
  let {
    selected
  } = _ref;
  return selected ? 'white' : getThemeProp('button.primary--color');
}};
  background-color: ${_ref2 => {
  let {
    selected
  } = _ref2;
  return selected ? getThemeProp('button.primary--color') : 'transparent';
}};
  border: none;
  border-right: 1px solid ${() => getThemeProp('global.border--color')};
  padding: 6px 8px;
  cursor: pointer;

  &:last-child {
    border-right: none;
  }

  &:focus {
    outline: 1px solid #dedede;
  }
`;
const FlexBgButton = styled(BgButton)`
  width: 100%;
`;
const ButtonGroup = _ref3 => {
  let {
    className,
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement(GroupContainer$1, {
    className: className
  }, children);
};
ButtonGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired
};
ButtonGroup.defaultProps = {
  className: undefined
};
const FlexButtonGroup = _ref4 => {
  let {
    className,
    children
  } = _ref4;
  const boxedChildren = children.map((child, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(Box, {
    key: `bxChild_${i}`,
    width: 1
  }, child));
  return /*#__PURE__*/React.createElement(FlexGroupContainer, {
    className: className
  }, boxedChildren);
};
FlexButtonGroup.propTypes = ButtonGroup.propTypes;

const medium = {
  trackWidth: '54px',
  trackHeight: '34px',
  thumb: '26px',
  thumbRightPosition: '24px',
  thumbLeftPosition: '4px'
};
const small = {
  trackWidth: '38px',
  trackHeight: '24px',
  thumb: '18px',
  thumbRightPosition: '17px',
  thumbLeftPosition: '3px'
};
const SwitchRootStyled = styled(SwitchPrimitive.Root)`
  display: flex;
  align-items: center;
  all: unset;
  width: ${_ref => {
  let {
    size
  } = _ref;
  return size === 'small' ? small.trackWidth : medium.trackWidth;
}};
  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'small' ? small.trackHeight : medium.trackHeight;
}};
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  background-color: ${_ref3 => {
  let {
    checked,
    kind
  } = _ref3;
  return checked ? getThemeProp(getButtonKindToken(kind)) : getThemeProp('global.greyPalette.400');
}};
  transition: background-color 200ms linear;
`;
const SwitchThumbStyled = styled(SwitchPrimitive.Thumb)`
  display: block;
  width: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'small' ? small.thumb : medium.thumb;
}};
  height: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'small' ? small.thumb : medium.thumb;
}};
  background-color: white;
  border-radius: 50%;
  transition: transform 200ms;
  will-change: transform;
  transform: ${_ref6 => {
  let {
    checked,
    size
  } = _ref6;
  return checked ? `translateX(${size === 'small' ? small.thumbRightPosition : medium.thumbRightPosition})` : `translateX(${size === 'small' ? small.thumbLeftPosition : small.thumbLeftPosition})`;
}};
`;
const Switch = _ref7 => {
  let {
    checked,
    onCheckedChange,
    size = 'medium',
    kind
  } = _ref7;
  return /*#__PURE__*/React.createElement(SwitchRootStyled, {
    checked: checked,
    onCheckedChange: onCheckedChange,
    size: size,
    kind: kind
  }, /*#__PURE__*/React.createElement(SwitchThumbStyled, {
    checked: checked,
    size: size
  }));
};
Switch.propTypes = {
  checked: PropTypes.bool,
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'dark']),
  onCheckedChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium'])
};

var _process$env$CDN_PATH$1, _process$1;
const CDN_URI$1 = (_process$env$CDN_PATH$1 = (_process$1 = process) === null || _process$1 === void 0 || (_process$1 = _process$1.env) === null || _process$1 === void 0 ? void 0 : _process$1.CDN_PATH) !== null && _process$env$CDN_PATH$1 !== void 0 ? _process$env$CDN_PATH$1 : 'https://cdn.amtrav.com';
const CreditCards = new Map([['VISA', {
  name: 'Visa',
  key: 'VISA',
  altKeys: ['VI'],
  pattern: /^4\d{15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/visa.svg`
}], ['VI', {
  name: 'Visa',
  key: 'VI',
  altKeys: ['VISA'],
  pattern: /^4\d{15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/visa.svg`
}], ['MAST', {
  name: 'Mastercard',
  key: 'MAST',
  altKeys: ['MC', 'CA'],
  pattern: /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/mastercard.svg`
}], ['MC', {
  name: 'Mastercard',
  key: 'MC',
  altKeys: ['MAST', 'CA'],
  pattern: /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/mastercard.svg`
}], ['CA', {
  name: 'Mastercard',
  key: 'CA',
  altKeys: ['MC', 'MAST'],
  pattern: /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/mastercard.svg`
}], ['AMEX', {
  name: 'American Express',
  key: 'AMEX',
  altKeys: ['AX'],
  pattern: /^(34|37)\d{13}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/amex.svg`
}], ['AX', {
  name: 'American Express',
  key: 'AX',
  altKeys: ['AMEX'],
  pattern: /^(34|37)\d{13}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/amex.svg`
}], ['DISC', {
  name: 'Discover',
  key: 'DISC',
  altKeys: ['DC', 'DS'],
  pattern: /^6011\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/discover.svg`
}], ['DC', {
  name: 'Discover',
  key: 'DC',
  altKeys: ['DS', 'DISC'],
  pattern: /^6011\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/discover.svg`
}], ['DS', {
  name: 'Discover',
  key: 'DS',
  altKeys: ['DC', 'DISC'],
  pattern: /^6011\d{12}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/discover.svg`
}], ['DINR', {
  name: 'Diners Club',
  key: 'DINR',
  altKeys: ['DN'],
  pattern: /^(36|38)\d{12}$|^(300|301|302|303|304|305)\d{11}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/diners.svg`
}], ['DN', {
  name: 'Diners Club',
  key: 'DN',
  altKeys: ['DINR'],
  pattern: /^(36|38)\d{12}$|^(300|301|302|303|304|305)\d{11}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/diners.svg`
}], ['EN', {
  // Pretty sure this card is no longer issued
  name: 'enRoute',
  key: 'EN',
  altKeys: [],
  pattern: /^(2014|2149)\d{11}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/default.svg`
}], ['JCB', {
  name: 'JCB',
  key: 'JCB',
  altKeys: ['JC'],
  pattern: /^(2131|1800)\d{11}$|^3\d{15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/jcb.svg`
}], ['JC', {
  name: 'JCB',
  key: 'JC',
  altKeys: ['JCB'],
  pattern: /^(2131|1800)\d{11}$|^3\d{15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/jcb.svg`
}], ['UATP', {
  name: 'UATP',
  key: 'UATP',
  altKeys: ['UA', 'TP'],
  pattern: /^(1)\d{14,15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/uatp.svg`
}], ['UA', {
  name: 'UATP',
  key: 'UA',
  altKeys: ['UATP', 'TP'],
  pattern: /^(1)\d{14,15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/uatp.svg`
}], ['TP', {
  name: 'UATP',
  key: 'TP',
  altKeys: ['UATP', 'UA'],
  pattern: /^(1)\d{14,15}$/m,
  svg: `${CDN_URI$1}/purchase/cc/svg/uatp.svg`
}], ['CFM', {
  name: 'Conferma Virtual Card',
  key: 'CFM',
  altKeys: [],
  pattern: null,
  svg: `${CDN_URI$1}/purchase/cc/svg/cfm.svg`
}]]);

var _process$env$CDN_PATH, _process;
const CDN_URI = (_process$env$CDN_PATH = (_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.CDN_PATH) !== null && _process$env$CDN_PATH !== void 0 ? _process$env$CDN_PATH : 'https://cdn.amtrav.com';
const creditCardByKey = key => {
  const result = CreditCards.get(key);
  if (result) return result;
  return {
    name: 'generic card',
    key,
    altKeys: [],
    patterns: null,
    svg: `${CDN_URI}/purchase/cc/svg/default.svg`
  };
};
const CreditCardsIncludingOnly = acceptedCards => {
  const newCreditCardMap = new Map();
  acceptedCards.forEach(abbvName => {
    const card = CreditCards.get(abbvName);
    if (card) {
      newCreditCardMap.set(abbvName, card);
    } else {
      console.error(`${abbvName} is not a valid credit card key.`);
    }
  });
  return newCreditCardMap;
};
const luhnCheck = num => {
  let nCheck = 0;
  let nDigit = 0;
  let bEven = false;
  let n;
  let cDigit;

  // eslint-disable-next-line no-plusplus
  for (n = num.length - 1; n >= 0; n--) {
    cDigit = num.charAt(n);
    nDigit = parseInt(cDigit, 10);
    if (bEven) {
      // eslint-disable-next-line no-cond-assign
      if ((nDigit *= 2) > 9) {
        nDigit -= 9;
      }
    }
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 === 0;
};
const detectCreditCardType = function (number) {
  let ccTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const type = '';
  const CreditCardsMap = ccTypes.length ? CreditCardsIncludingOnly(ccTypes) : CreditCards;

  // accept only spaces, digits and dashes
  if (/[^0-9 -]+/.test(number)) {
    return type;
  }
  const num = number.replace(/\D/g, '');
  if (num.length >= 13 && num.length <= 19) {
    if (luhnCheck(num)) {
      const iterator = CreditCardsMap.values();
      let cc = iterator.next();
      while (!cc.done) {
        const {
          pattern,
          key
        } = cc.value;
        if (pattern && pattern.test(num)) {
          return key;
        }
        cc = iterator.next();
      }
    }
  }
  return type;
};

// use in conjunction with creditCardByKey to to get card.svg for src
// Example: const card = creditCardByKey(key);
const CreditCardLogo = styled.img`
  width: 38px;
  height: 24px;
  margin: 3px 2px;
  opacity: 1;
  animation: ${fadeIn} 2.5s;
  transition: opacity 1s;

  ${_ref => {
  let {
    shouldFadeOut
  } = _ref;
  return shouldFadeOut && css`
      opacity: 0.2;
    `;
}};
`;
const AcceptedCardImages = _ref2 => {
  let {
    acceptedCreditCards,
    cardType
  } = _ref2;
  const shouldFadeOut = (card, altKeys) => {
    if (cardType === '') {
      return false;
    }
    return cardType !== '' && card !== cardType && !altKeys.includes(cardType);
  };
  const renderCreditCard = key => {
    const card = creditCardByKey(key);
    return /*#__PURE__*/React.createElement(CreditCardLogo, {
      key: key,
      src: card.svg,
      alt: "Credit Card",
      shouldFadeOut: shouldFadeOut(card.key, card.altKeys)
    });
  };
  const renderCreditCards = () => acceptedCreditCards.map(key => renderCreditCard(key));
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    justifyContent: "flex-end"
  }, renderCreditCards());
};
AcceptedCardImages.propTypes = {
  cardType: PropTypes.string,
  acceptedCreditCards: PropTypes.arrayOf(PropTypes.oneOf(['VISA', 'VI', 'MAST', 'MC', 'CA', 'AMEX', 'AX', 'DISC', 'DC', 'DS', 'DINR', 'DN', 'EN', 'JCB', 'JC', 'UATP', 'UA', 'TP']))
};

const CurrencyStyled = styled.span`
  position: relative;
  padding-left: 0.45em;
  display: inline-block;
  line-height: 1;
`;
const CurrencyDollarSign = styled.span``;
const CurrencyAmount = styled.span`
  text-transform: uppercase;
`;
const CurrencyNegative = styled.span`
  position: absolute;
  left: -9px;
`;
const Currency = _ref => {
  let {
    amount,
    isFree,
    showDashForZero,
    hideThousandsSeparator
  } = _ref;
  const showNegativeSign = Math.sign(amount) === -1;
  const showDollarSign = !isFree && !showDashForZero || amount !== 0 && amount !== '0.00' && amount !== '0';
  const dollarAmount = hideThousandsSeparator ? parseFloat(Math.abs(amount)).toFixed(2) : parseFloat(Math.abs(amount)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const value = (amount === 0 || amount === '0.00' || amount === '0') && showDashForZero ? '—' : dollarAmount;
  return /*#__PURE__*/React.createElement(CurrencyStyled, null, showNegativeSign ? /*#__PURE__*/React.createElement(CurrencyNegative, null, "-") : null, showDollarSign ? /*#__PURE__*/React.createElement(CurrencyDollarSign, null, "$") : null, /*#__PURE__*/React.createElement(CurrencyAmount, null, isFree ? 'Free' : value));
};
Currency.propTypes = {
  /**
   * Returns the text "FREE" if true
   */
  isFree: PropTypes$1.bool,
  /**
   * Sets the dollar amount to displayed
   */
  amount: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  /**
   * If the amount is set to zero, and showDashForZero is true, component will render
   * a dash in place of the zeroes
   */
  showDashForZero: PropTypes$1.bool,
  /**
   * Removes comma separator from groups of thousands
   */
  hideThousandsSeparator: PropTypes$1.bool
};
Currency.defaultProps = {
  isFree: false,
  showDashForZero: false,
  amount: 0,
  hideThousandsSeparator: false
};
Currency.displayName = 'Currency';

const TextAreaContainer = styled.textarea`
  color: ${getTextColor};
  border-style: solid;
  border-color: ${getKindBorderColor};
  border-width: ${getTokenValue(THEME_TOKENS.textInput.size.border)};
  border-radius: ${getTokenValue(THEME_TOKENS.textInput.size.borderRadius)};
  background-color: ${getTokenValue(THEME_TOKENS.textInput.color.background)};
  overflow: visible;
  font-size: ${getTokenValue(THEME_TOKENS.textInput.size.text)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  line-height: 1.3;
  width: 100%;
  min-height: 180px;
  resize: none;
  outline: none;
  padding-top: 0.375rem;
  padding-right: 8px;
  padding-bottom: 0.375rem;
  padding-left: 8px;

  ::placeholder {
    color: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? getTokenValue(THEME_TOKENS.textInput.color.disabledText) : getTokenValue(THEME_TOKENS.textInput.color.placeholderText);
}};
  }

  &:focus {
    box-shadow: ${getTokenValue(THEME_TOKENS.textInput.shadow.focus)};
    border-color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  }
  // if does not have focus apply background hover
  &:not(:focus) {
    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
    }
  }
  &:disabled,
  &:disabled:hover {
    background-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabled)};
    border-color: ${getTokenValue(THEME_TOKENS.textInput.color.disabledBorder)};
    color: ${getTokenValue(THEME_TOKENS.textInput.color.disabledText)};
    cursor: not-allowed;
  }
`;
const TextInputArea = _ref2 => {
  let {
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(TextAreaContainer, rest);
};

const Multiselect = props => {
  return /*#__PURE__*/React.createElement(Multiselect$1, props);
};

const ImgRegion = styled.div`
  // using a ternary to not render this element when
  // isBrokenImage = true does not work in this scenario
  display: ${_ref => {
  let {
    isBrokenImage
  } = _ref;
  return isBrokenImage ? 'none' : 'inline-block';
}};
`;
const Image = _ref2 => {
  let {
    alt,
    src,
    renderFallback
  } = _ref2;
  const [isBrokenImage, setISBrokenImage] = useState(false);
  const handleOnError = () => {
    setISBrokenImage(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImgRegion, {
    isBrokenImage: isBrokenImage
  }, /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src,
    onError: handleOnError
  })), isBrokenImage && renderFallback);
};
Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  renderFallback: PropTypes.element
};
Image.defaultProps = {
  alt: ''
};

const Anchor = styled.a`
  text-decoration: none;
`;
const getBackgroundColor$2 = kind => {
  switch (kind) {
    case 'warning':
      return lighten(getThemeProp('global.warning--color')(kind), 90);
    case 'danger':
      return lighten(getThemeProp('global.danger--color')(kind), 88);
    default:
      return getThemeProp('global.light--color');
  }
};
const SortOption = styled.div`
  text-decoration: none !important;
  cursor: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'not-allowed' : 'pointer';
}};
  color: ${props => {
  if (props.disabled) {
    return getThemeProp('global.disabled--color');
  }
  return props.kind ? getThemeProp(`global.${props.kind}--color`) : getThemeProp(`global.link--color`);
}};
  display: flex;
  font-size: 16px;
  justify-content: ${props => props.iconPlacement === 'left' ? 'default' : 'space-between'};
  &:hover {
    color: ${props => {
  if (props.disabled) {
    return null;
  }
  return props.kind ? getThemeProp(`global.${props.kind}--color`) : getThemeProp(`global.link--color`);
}};
    background: ${props => {
  if (props.disabled) {
    return null;
  }
  return props.kind ? getBackgroundColor$2(props.kind) : '#eeeeee';
}};
  }
  margin: 4px;
  border-radius: 4px;
  padding: 4px 8px;
  gap: 12px;
`;
const Trigger = styled.span`
  cursor: pointer;
`;
const PopoverMenu = _ref2 => {
  let {
    children,
    iconPlacement = 'right',
    items,
    ...rest
  } = _ref2;
  const [visible, setVisible] = useState(false);
  const showPopover = () => setVisible(true);
  const hidePopover = () => setVisible(false);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    withPadding: false,
    open: visible,
    onOpenChange: open => {
      if (!open) hidePopover();
    },
    onClickOutside: hidePopover,
    content: /*#__PURE__*/React.createElement(Box, {
      p: 1
    }, items.map(item => item.href ? /*#__PURE__*/React.createElement(Anchor, {
      href: item.disabled ? null : item.href,
      key: item.label
    }, /*#__PURE__*/React.createElement(SortOption, {
      disabled: item.disabled,
      kind: item.kind,
      iconPlacement: iconPlacement,
      onClick: () => {
        hidePopover();
      },
      key: item.label
    }, iconPlacement === 'left' ? item.icon : null, item.label, iconPlacement === 'right' ? item.icon : null)) : /*#__PURE__*/React.createElement(SortOption, {
      disabled: item.disabled,
      kind: item.kind,
      iconPlacement: iconPlacement,
      onClick: item.disabled ? () => {} : () => {
        hidePopover();
        setTimeout(() => {
          item.onClick();
        }, 100);
      },
      key: item.label
    }, iconPlacement === 'left' ? item.icon : null, item.label, iconPlacement === 'right' ? item.icon : null)))
  }, rest), /*#__PURE__*/React.createElement(Trigger, {
    onClick: visible ? hidePopover : showPopover
  }, children({
    isOpen: visible
  })));
};
PopoverMenu.propTypes = {
  /**
   * The popover trigger which is a function provided with a selected label prop.
   */
  children: PropTypes.func.isRequired,
  /**
   * If an href is supplied, the item will become a link and the onClick will be ignored
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    href: PropTypes.string,
    disabled: PropTypes.bool
  })).isRequired,
  /**
   * Controls wehther icon is to left of text, or to right (default).
   * If no icon is supplied, this does not need to be supplied.
   */
  iconPlacement: PropTypes.bool
};

const MoreButton = styled(IconLine).attrs({
  icon: 'DotsVertical'
})`
  color: ${getThemeProp('global.tertiary--color')};
  font-size: 20px;
  cursor: pointer;

  &:hover {
    color: ${getThemeProp('global.link--color')};
  }
`;
const MoreDotsMenu = _ref => {
  let {
    items,
    direction = 'horizontal'
  } = _ref;
  return /*#__PURE__*/React.createElement(PopoverMenu, {
    items: items
  }, () => /*#__PURE__*/React.createElement(MoreButton, {
    rotate: direction === 'vertical' ? 90 : 0
  }));
};
MoreDotsMenu.propTypes = {
  /**
   * If an href is supplied, the item will become a link and the onClick will be ignored
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    href: PropTypes.string
  })).isRequired,
  direction: PropTypes.oneOf(['horizontal', 'vertical'])
};

const ErrorPlaceholder = styled(Flex)`
  min-height: ${_ref => {
  let {
    height
  } = _ref;
  return height;
}};
  height: auto;
`;
const Message$1 = styled(Box)`
  font-size: 12px;
  color: ${getThemeProp('global.danger--color')};
`;
const ErrorMessage = _ref2 => {
  let {
    message = '',
    height = '18.5px',
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(ErrorPlaceholder, _extends({
    pt: 1,
    mb: 2,
    height: height
  }, rest), message ? /*#__PURE__*/React.createElement(Message$1, null, message) : null);
};
ErrorMessage.propTypes = {
  message: PropTypes.string,
  height: PropTypes.string
};

const RemoveButton = styled.button`
  background-color: transparent;
  color: ${props => props.palette};
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
  font: inherit;
  font-weight: bold;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ConfirmedEmail = styled.div`
  background-color: ${props => props.backgroundColor};
  color: ${props => props.palette};
  display: inline-block;
  font-size: 14px;
  font-weight: ${getTokenValue(THEME_TOKENS.badge.size.fontWeight)};
  border-radius: ${getTokenValue(THEME_TOKENS.base.size.borderRadius)};
  height: 26px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0 0.4rem 0.4rem 0;
`;
const getOutlineColor = kind => {
  switch (kind) {
    case 'warning':
      return getTokenValue(THEME_TOKENS.badge.color.warningText);
    case 'danger':
      return getTokenValue(THEME_TOKENS.badge.color.danger);
    default:
      return getTokenValue(THEME_TOKENS.badge.color.neutralText);
  }
};
const getBackgroundColor$1 = kind => {
  switch (kind) {
    case 'warning':
      return getTokenValue(THEME_TOKENS.badge.color.warningBackground);
    case 'danger':
      return getTokenValue(THEME_TOKENS.badge.color.dangerBackground);
    default:
      return getTokenValue(THEME_TOKENS.badge.color.neutralBackground);
  }
};
const EmailChipTile = _ref => {
  let {
    email,
    kind,
    handleDelete,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfirmedEmail, {
    className: className,
    palette: getOutlineColor(kind),
    outlineColor: getOutlineColor(kind),
    backgroundColor: getBackgroundColor$1(kind),
    key: email
  }, email, /*#__PURE__*/React.createElement(RemoveButton, {
    type: "button",
    className: "button",
    onClick: () => handleDelete(email),
    palette: getOutlineColor(kind)
  }, "\xD7"));
};
EmailChipTile.propTypes = {
  email: PropTypes.string,
  kind: PropTypes.string,
  handleDelete: PropTypes.func,
  className: PropTypes.string
};

const EmailChipsContainer = styled.div`
  padding-top: 12px;
`;
const EnterEmailContainer = styled.div`
  display: flex;
  gap: 4px;
`;
const EmailChipGroupLabel = styled.div`
  padding-bottom: 4px;
  font-size: 13px;
`;
const EmailTextInput = styled(TextInput)`
  width: 100%;
`;
const EmailChip = _ref => {
  let {
    emailObjects,
    setEmailObjects,
    getEmailObject
  } = _ref;
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = email => {
    setEmailObjects(emailObjects.filter(i => i.email !== email));
  };
  const getConfirmedEmail = function (email) {
    let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
    return /*#__PURE__*/React.createElement(EmailChipTile, {
      kind: kind,
      email: email,
      handleDelete: handleDelete
    });
  };
  const isInList = email => {
    return emailObjects.some(e => e.email === email);
  };
  const attemptAddEmail = () => {
    if (!isInList(value)) {
      setIsLoading(true);
      setValue(value.trim());
      getEmailObject(value).then(newEmail => {
        if (value && newEmail) {
          setEmailObjects([...emailObjects, newEmail]);
          setValue('');
        }
        setIsLoading(false);
      });
    } else {
      setError(`${value} has already beed added.`);
    }
  };
  const handleKeyDown = evt => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault();
      attemptAddEmail();
    }
  };
  const handleChange = evt => {
    setValue(evt.target.value);
    setError(null);
  };
  const handlePaste = evt => {
    setIsLoading(true);
    evt.preventDefault();
    const paste = evt.clipboardData.getData('text');
    const emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);
    if (emails) {
      const emailsToBeAdded = emails.filter(email => !isInList(email));
      const emailObjectsToBeAdded = emailsToBeAdded.map(email => getEmailObject(email));
      Promise.all(emailObjectsToBeAdded).then(results => {
        setEmailObjects([...emailObjects, ...results]);
        setIsLoading(false);
      });
    }
  };
  const getMessages = (item, index, self) => {
    return self.indexOf(item) === index;
  };
  const uniqueMessages = emailObjects.map(item => {
    return item.message;
  }).filter(getMessages).sort();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EnterEmailContainer, null, /*#__PURE__*/React.createElement(EmailTextInput, {
    className: `input ${error && ' has-error'}`,
    value: value,
    placeholder: "johnny@acme.com",
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    onPaste: handlePaste
  }), /*#__PURE__*/React.createElement(Button, {
    text: "Add",
    size: "medium",
    isLoading: isLoading,
    onClick: attemptAddEmail
  })), error && /*#__PURE__*/React.createElement(ErrorMessage, {
    mb: [1, 1, 2],
    message: error
  }), uniqueMessages.map(message => {
    return /*#__PURE__*/React.createElement(EmailChipsContainer, {
      key: message
    }, /*#__PURE__*/React.createElement(EmailChipGroupLabel, null, message), emailObjects.filter(item => {
      return item.message === message;
    }).map(item => getConfirmedEmail(item.email, item.kind)));
  }));
};
EmailChip.propTypes = {
  setEmailObjects: PropTypes.func.isRequired,
  getEmailObject: PropTypes.func.isRequired,
  emailObjects: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string,
    kind: PropTypes.string,
    email: PropTypes.string,
    valid: PropTypes.bool
  })).isRequired
};

const RadioButtonContainer = styled.label`
  display: block;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  border-color: ${getKindColorFromProps};
  border-width: 0;
  border-style: solid;
  padding: 3px 5px;
  color: ${getTextColor};

  &:focus {
    outline: -webkit-focus-ring-color auto 5px;
  }
`;
const RadioLabelStyled = styled.div`
  cursor: pointer;
  padding-top: 0.15rem;
  display: flex;
  color: inherit;
  line-height: inherit;
  position: relative;
  user-select: none;
  outline: 0;
`;
const RadioCircleStyled = styled.span`
  background-color: inherit;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  border-color: ${getTokenValue(THEME_TOKENS.textInput.color.border)};
  box-shadow: inset 0 0 0 1em transparent;
  content: '';
  height: 1.125em;
  width: 1.125em;
  transition: 0.3s;
  display: inline-block;

  ${props => props.checked && !props.disabled && css`
      box-shadow: inset 0 0 0 0.25em ${getTokenValue(THEME_TOKENS.base.color.action)};
      border-color: ${getKindColorFromProps};
      background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
    `};

  ${props => !props.disabled && !props.checked && props.hover && css`
      box-shadow: inset 0 0 0 1em ${getTokenValue(THEME_TOKENS.base.color.white)},
        0 0 0 0.25em ${tinycolor(getThemeProp('textfield.border--color')(props)).lighten(12).toString()};
    `};

  ${props => props.disabled && css`
      border-color: ${getTokenValue(THEME_TOKENS.base.color.neutral300)};
      border-width: 1px;
      box-shadow: inset 0 0 0 1em ${getTokenValue(THEME_TOKENS.base.color.neutral300)};
    `};

  ${props => props.disabled && props.checked && css`
      border-color: ${getTokenValue(THEME_TOKENS.base.color.neutral300)};
      background-color: ${getTokenValue(THEME_TOKENS.base.color.neutral800)};
      box-shadow: inset 0 0 0 0.25em ${getTokenValue(THEME_TOKENS.base.color.neutral300)};
    `};
`;
const HiddenNativeRadioButton = styled.input`
  position: absolute;
  opacity: 0;

  &:focus-visible + ${RadioCircleStyled} {
    transition: none;
    outline: 2px solid ${getKindColorFromProps};
    outline-offset: 2px;
  }
`;
const RadioLabelText = styled.div`
  height: 1.125em;
  padding-left: 0.5rem;
  line-height: 1.1;

  ${props => props.disabled && css`
      color: ${getTextColor};
    `};
`;
const RadioButton = _ref => {
  let {
    label,
    name,
    kind,
    id,
    checked,
    onChange,
    disabled,
    value,
    className,
    ...rest
  } = _ref;
  const [hover, setHover] = useState(false);
  const dataAttrs = Object.keys(rest).reduce((obj, key) => {
    if (key.indexOf('data-') === 0) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = rest[key];
    }
    return obj;
  }, {});
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  return /*#__PURE__*/React.createElement(RadioButtonContainer, {
    className: className,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    kind: kind,
    checked: checked
  }, /*#__PURE__*/React.createElement(RadioLabelStyled, _extends({
    id: `${id}-label`,
    htmlFor: id
  }, dataAttrs), /*#__PURE__*/React.createElement(HiddenNativeRadioButton, {
    type: "radio",
    id: id,
    name: name,
    onChange: onChange,
    value: value,
    disabled: disabled,
    checked: checked
  }), /*#__PURE__*/React.createElement(RadioCircleStyled, {
    kind: kind,
    checked: checked,
    disabled: disabled,
    hover: hover
  }), /*#__PURE__*/React.createElement(RadioLabelText, {
    disabled: disabled
  }, label)));
};
RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  kind: PropTypes.string,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
RadioButton.defaultProps = {
  checked: false,
  kind: 'primary',
  label: undefined,
  disabled: false,
  className: undefined
};

const getIncrementorCountSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '11px';
    case 'small':
      return '10px';
    case 'inherit':
      return '10px';
    default:
      return '10px';
  }
};
const getIncrementorFontSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '16px';
    case 'small':
      return '14px';
    case 'inherit':
      return 'inherit';
    default:
      return '14px';
  }
};
const getIncrementorSpacing = () => props => {
  switch (props.size) {
    case 'medium':
      return '86px';
    case 'small':
      return '52px';
    case 'inherit':
      return '52px';
    default:
      return '52px';
  }
};

const Container = styled(Flex)`
  justify-content: space-between;
  border-style: solid;
  border-width: ${_ref => {
  let {
    transparent
  } = _ref;
  return transparent ? 0 : '1px';
}};
  border-color: ${getThemeProp('textfield.border--color')};
  border-radius: ${getThemeProp('textfield.borderRadius--size')};
  background: ${_ref2 => {
  let {
    transparent
  } = _ref2;
  return transparent ? 'transparent' : 'white';
}};
`;
const Count = styled(Box)`
  display: inline-flex;
  justify-content: center;
  min-width: ${getIncrementorCountSize};
  font-size: ${getIncrementorFontSize};
  font-weight: bold;
`;
const ButtonsContainer = styled(Flex)`
  width: ${getIncrementorSpacing};
  align-items: center;
  justify-content: space-between;
`;
const Incrementor = _ref3 => {
  let {
    label,
    count,
    transparent = false,
    disableDecrease = false,
    disableIncrease = false,
    onIncrement,
    onDecrement,
    size = 'small',
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container, _extends({
    p: 2,
    alignItems: "center",
    transparent: transparent
  }, rest), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Count, {
    mr: 1,
    size: size
  }, count), /*#__PURE__*/React.createElement(Count, {
    mr: 2,
    size: size
  }, label)), /*#__PURE__*/React.createElement(ButtonsContainer, {
    size: size
  }, /*#__PURE__*/React.createElement(Button, {
    round: true,
    icon: /*#__PURE__*/React.createElement(IconRemove, null),
    size: size === 'inherit' ? 'small' : size,
    onClick: onDecrement,
    disabled: disableDecrease
  }), /*#__PURE__*/React.createElement(Button, {
    round: true,
    icon: /*#__PURE__*/React.createElement(IconAdd, null),
    size: size === 'inherit' ? 'small' : size,
    onClick: onIncrement,
    disabled: disableIncrease
  })));
};
Incrementor.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  transparent: PropTypes.bool,
  disableDecrease: PropTypes.bool,
  disableIncrease: PropTypes.bool,
  onIncrement: PropTypes.func.isRequired,
  onDecrement: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['inherit', 'small', 'medium'])
};

const RailContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 2rem;
  transform: translate(0%, -50%);
  border-radius: ${getThemeProp('global.borderRadius--size')};
  cursor: pointer;
  border-style: solid;
  border-color: red;
  border-width: 0;
`;
const Rail = styled.div`
  position: absolute;
  width: 100%;
  height: 4px;
  transform: translate(0%, -50%);
  border-radius: ${getThemeProp('global.borderRadius--size')};
  pointer-events: none;
  background-color: ${props => getThemeProp('greyPalette')(props)[300]};
  border-radius: 12px;
`;
function SliderRail(_ref) {
  let {
    getRailProps
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RailContainer, getRailProps()), /*#__PURE__*/React.createElement(Rail, null));
}
SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired
};

// Use styled-components attrs for frequently changing values.
const HandleContainer = styled.div.attrs(props => ({
  style: {
    left: `${props.percent}%`
  }
}))`
  position: absolute;
  transform: translate(-50%, -50%);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  z-index: 5;
  width: 28px;
  height: 42px;
  cursor: pointer;
  background-color: transparent;
`;
const HandleControl = styled.div.attrs(props => ({
  style: {
    left: `${props.percent}%`,
    backgroundColor: props.disabled ? props.theme.global['disabled--color'] : props.theme.global['light--color']
  }
}))`
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.3);
`;
function Handle(_ref) {
  let {
    domain: [min, max],
    handle: {
      id,
      value,
      percent
    },
    disabled,
    getHandleProps
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HandleContainer, _extends({
    percent: percent
  }, getHandleProps(id))), /*#__PURE__*/React.createElement(HandleControl, {
    percent: percent,
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    disabled: disabled
  }));
}
Handle.propTypes = {
  domain: PropTypes.arrayOf(PropTypes.number).isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
Handle.defaultProps = {
  disabled: false
};

const StyledTrack = styled.div.attrs(props => ({
  style: {
    left: `${props.sourcePercent}%`,
    width: `${props.targetPercent - props.sourcePercent}%`
  }
}))`
  position: absolute;
  transform: translate(0%, -50%);
  height: 8px;
  z-index: 1;
  background-color: ${getKindColorFromProps};
  border-radius: 7px;
  cursor: pointer;
`;
function Track(_ref) {
  let {
    source,
    target,
    getTrackProps,
    disabled
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledTrack, _extends({
    disabled: disabled,
    sourcePercent: source.percent,
    targetPercent: target.percent
  }, getTrackProps()));
}
Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
Track.defaultProps = {
  disabled: false
};

const TickLine = styled.div`
  position: absolute;
  margin-top: 14px;
  width: 1px;
  height: 5px;
  background-color: ${getTextColor};
  left: ${_ref => {
  let {
    tick
  } = _ref;
  return tick.percent;
}}%;
  color: red;
`;
const TickLabel = styled.div`
  position: absolute;
  margin-top: 22px;
  font-size: 10px;
  text-align: center;
  margin-left: ${_ref2 => {
  let {
    count
  } = _ref2;
  return -(100 / count) / 2;
}}%;
  width: ${_ref3 => {
  let {
    count
  } = _ref3;
  return 100 / count;
}}%;
  left: ${_ref4 => {
  let {
    tick
  } = _ref4;
  return tick.percent;
}}%;
  color: ${getTextColor};
`;
function Tick(_ref5) {
  let {
    tick,
    count,
    format
  } = _ref5;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TickLine, {
    tick: tick
  }), /*#__PURE__*/React.createElement(TickLabel, {
    tick: tick,
    count: count
  }, format(tick.value)));
}
Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func
};
Tick.defaultProps = {
  format: d => d
};

const SliderContainer$1 = styled(Slider)`
  position: relative;
  margin-top: 1.4rem;
  width: 100%;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
`;
const RangeSlider = props => {
  const {
    className,
    domain,
    onChange,
    onUpdate,
    values,
    defaultValues,
    mode,
    step,
    leftTrackActive,
    rightTrackActive,
    ticksCount,
    tickFormatter
  } = props;
  return /*#__PURE__*/React.createElement(SliderContainer$1, {
    className: className,
    mode: mode,
    step: step,
    domain: domain,
    onUpdate: onUpdate,
    onChange: onChange,
    values: values || defaultValues
  }, /*#__PURE__*/React.createElement(Rail$1, null, _ref => {
    let {
      getRailProps
    } = _ref;
    return /*#__PURE__*/React.createElement(SliderRail, {
      getRailProps: getRailProps
    });
  }), /*#__PURE__*/React.createElement(Handles, null, _ref2 => {
    let {
      handles,
      getHandleProps
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, handles.map(handle => /*#__PURE__*/React.createElement(Handle, {
      key: handle.id,
      handle: handle,
      domain: domain,
      getHandleProps: getHandleProps
    })));
  }), /*#__PURE__*/React.createElement(Tracks, {
    left: leftTrackActive,
    right: rightTrackActive
  }, _ref3 => {
    let {
      tracks,
      getTrackProps
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "slider-tracks"
    }, tracks.map(_ref4 => {
      let {
        id,
        source,
        target
      } = _ref4;
      return /*#__PURE__*/React.createElement(Track, {
        key: id,
        source: source,
        target: target,
        getTrackProps: getTrackProps
      });
    }));
  }), ticksCount ? /*#__PURE__*/React.createElement(Ticks, {
    count: ticksCount
  }, _ref5 => {
    let {
      ticks
    } = _ref5;
    return /*#__PURE__*/React.createElement("div", {
      className: "slider-ticks"
    }, ticks.map(tick => /*#__PURE__*/React.createElement(Tick, {
      key: tick.id,
      tick: tick,
      count: ticks.length,
      format: tickFormatter
    })));
  }) : null);
};
RangeSlider.propTypes = {
  className: PropTypes.string,
  /**
   * Two element array of numbers providing the min and max values for the slider [min, max] e.g. [0, 100]
   */
  domain: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * An array of numbers. You can supply one for a value slider, two for
   * a range slider or more to create n-handled sliders
   */
  values: PropTypes.arrayOf(PropTypes.number),
  /**
   * An array of numbers. You can supply one for a value slider, two for
   * a range slider or more to create n-handled sliders
   */
  defaultValues: PropTypes.arrayOf(PropTypes.number),
  /**
   * The interaction mode. Value of 1 will allow handles to cross each other. Value of 2 will keep the sliders
   * from crossing and separated by a step. Value of 3 will make the handles pushable and keep them a step apart.
   */
  mode: PropTypes.number,
  /**
   * The step value for the slider.
   */
  step: PropTypes.number,
  /**
   * Should the left most track be active (primary color) or inactive (dark color)
   */
  leftTrackActive: PropTypes.bool,
  /**
   * Should the right most track be active (primary color) or inactive (dark color)
   */
  rightTrackActive: PropTypes.bool,
  /**
   * How many ticks to display. 0 ticks will not display any ticks.
   */
  ticksCount: PropTypes.number,
  tickFormatter: PropTypes.func,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func
};
RangeSlider.defaultProps = {
  className: undefined,
  values: undefined,
  defaultValues: undefined,
  mode: 1,
  step: 0.1,
  leftTrackActive: false,
  rightTrackActive: false,
  ticksCount: 0,
  tickFormatter: undefined,
  onChange: () => {},
  onUpdate: () => {}
};

const timeToTimestamp = (timeString, date) => parse(timeString, 'HH:mm', date || new Date()).getTime();
const outputDict = (newValues, formatString) => ({
  value1: newValues[0],
  time1: format(newValues[0], formatString),
  value2: newValues[1],
  time2: format(newValues[1], formatString)
});
const formatDefaults = (valuesArray, refDate, formatString) => {
  return outputDict([timeToTimestamp(valuesArray[0], refDate), timeToTimestamp(valuesArray[1], refDate)], formatString);
};

/**
 * This uses the UNIX Epoch as the date to remove DST ambiguity. The date should be considered irrelevant.
 * Only number of seconds relevant to a 24 hour period should be considered.
 * TODO Remove direct access to the `format` function.
 */
const HourlyRangeSlider = _ref => {
  let {
    className,
    domainStartTime,
    domainEndTime,
    defaultStartTime,
    defaultEndTime,
    values,
    stepInMs,
    onUpdate,
    onChange,
    formatString,
    referenceDate,
    ...rest
  } = _ref;
  const domainTimestamps = useMemo(() => [timeToTimestamp(domainStartTime, referenceDate), timeToTimestamp(domainEndTime, referenceDate)], [domainStartTime, domainEndTime]);
  const defaultValues = useMemo(() => [timeToTimestamp(defaultStartTime, referenceDate), timeToTimestamp(defaultEndTime, referenceDate)], [defaultStartTime, defaultEndTime]);
  const changeHandler = newValues => onChange(outputDict(newValues, formatString));
  const updateHandler = newValues => onUpdate(outputDict(newValues, formatString));
  return /*#__PURE__*/React.createElement(RangeSlider, _extends({
    className: className,
    domain: domainTimestamps,
    values: values || defaultValues,
    onUpdate: updateHandler,
    onChange: changeHandler,
    step: stepInMs
  }, rest));
};
HourlyRangeSlider.propTypes = {
  className: PropTypes.string,
  domainStartTime: PropTypes.string,
  domainEndTime: PropTypes.string,
  defaultStartTime: PropTypes.string,
  defaultEndTime: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.number),
  referenceDate: PropTypes.instanceOf(Date),
  stepInMs: PropTypes.number,
  formatString: PropTypes.string,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func
};
HourlyRangeSlider.defaultProps = {
  className: undefined,
  domainStartTime: '00:00',
  domainEndTime: '23:59',
  defaultStartTime: '00:00',
  defaultEndTime: '23:59',
  values: undefined,
  stepInMs: 1800000,
  // 30 minutes
  formatString: 'h:mm a',
  referenceDate: new Date(),
  onChange: () => {},
  onUpdate: () => {}
};

const TooltipButton = styled(Button)`
  ${ButtonTextStyled} {
    padding: 1px;
  }
  &:hover {
    background: ${GreyPalette['200']};
  }
`;
const InfoTooltip = _ref => {
  let {
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    triggerDisplayProperty: "inline-flex",
    placement: "top"
  }, rest), /*#__PURE__*/React.createElement(TooltipButton, {
    icon: /*#__PURE__*/React.createElement(IconInfoLine, null),
    transparent: true
  }));
};

const Label$1 = styled(Box)`
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const Asterisk = styled(Box)`
  font-weight: 600;
  padding-left: 1px;
  color: ${getThemeProp('global.danger--color')};
`;
const InputLabel = _ref => {
  let {
    label = '',
    infoTooltipContent = null,
    required = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    mb: 2,
    alignItems: "center"
  }, rest), /*#__PURE__*/React.createElement(Label$1, null, label), required ? /*#__PURE__*/React.createElement(Asterisk, null, "*") : null, infoTooltipContent ? /*#__PURE__*/React.createElement(InfoTooltip, {
    content: infoTooltipContent
  }) : null);
};
InputLabel.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  infoTooltipContent: PropTypes.string
};

const StyledLabelText = styled.span`
  display: block;
  width: auto;
  font-size: 14px;
  color: ${getThemeProp('global.greyPalette.600')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-bottom: 1px;
`;
const StyledValueText = styled.span`
  display: block;
  width: auto;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-height: 15px;
  padding-bottom: 1px;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};

  // this wil ensure that any wrapper components needed for
  // adding extra styles will also have ellipsis on overflow
  * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
const StyledFlex = styled(Flex)`
  /* width: fit-content; */
  margin-right: 22px;
`;
const LabeledValue = _ref => {
  let {
    label,
    children,
    required,
    infoTooltipContent
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(StyledFlex, {
    mb: [1],
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StyledLabelText, null, label), required ? /*#__PURE__*/React.createElement(Asterisk, null, "*") : null, infoTooltipContent && /*#__PURE__*/React.createElement(Box, {
    ml: "2px"
  }, /*#__PURE__*/React.createElement(InfoTooltip, {
    content: infoTooltipContent,
    placement: "top"
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledValueText, {
    title: typeof children === 'string' ? children : null
  }, children || 'Not Provided')));
};
LabeledValue.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  infoTooltipContent: PropTypes.string,
  /**
   * Show a red asterisk next to the label.
   */
  required: PropTypes.bool
};

const GroupContainer = styled.div`
  display: grid;
  grid-template-columns: ${_ref => {
  let {
    colCount,
    colWidth
  } = _ref;
  return `repeat(${colCount}, ${colWidth})`;
}};
  column-gap: ${_ref2 => {
  let {
    colGap
  } = _ref2;
  return colGap;
}};
  row-gap: ${_ref3 => {
  let {
    rowGap
  } = _ref3;
  return rowGap;
}};
`;
const GroupWithDivider = styled(Flex)`
  flex-direction: column;
  gap: ${_ref4 => {
  let {
    rowGap
  } = _ref4;
  return rowGap;
}};
`;
const GroupDivider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${getThemeProp('global.border--color')};
`;
const Grouping = _ref5 => {
  let {
    colCount = 2,
    colWidth = null,
    colGap = '12px',
    rowGap = '24px',
    divider = 'none',
    children,
    ...rest
  } = _ref5;
  let colPercentage = 10;
  if (colCount > 0 && colCount < 10) {
    colPercentage = 100 / colCount;
  }
  const colWidthOrPercentage = !colWidth ? `${parseInt(colPercentage, 10)}%` : colWidth;
  return /*#__PURE__*/React.createElement(GroupWithDivider, _extends({
    rowGap: rowGap
  }, rest), divider === 'top' && /*#__PURE__*/React.createElement(GroupDivider, {
    mt: rowGap
  }), /*#__PURE__*/React.createElement(GroupContainer, {
    colCount: colCount,
    colWidth: colWidthOrPercentage,
    colGap: colGap,
    rowGap: rowGap
  }, children), divider === 'bottom' && /*#__PURE__*/React.createElement(GroupDivider, {
    mb: rowGap
  }));
};
Grouping.propTypes = {
  /**
   * colCount must be a number between 1 & 10
   */
  colCount: PropTypes.number.isRequired,
  /**
   * if a width value is not provided, a percentage is used based on colCount
   */
  colWidth: PropTypes.string,
  colGap: PropTypes.string,
  rowGap: PropTypes.string,
  divider: PropTypes.oneOf(['top', 'bottom', 'none']),
  children: PropTypes.node.isRequired
};

const getElementPadding = () => props => {
  const {
    size,
    noPadding
  } = props;
  if (noPadding) {
    return '0';
  }
  if (size === 'large') {
    // purposely using medium padding instead of large
    return `${getThemeProp('global.spacerMD--size')(props)}`;
  }
  if (size === 'small') {
    return `${getThemeProp('global.spacerXS--size')(props)}`;
  }
  return `${getThemeProp('global.spacerMD--size')(props)}`;
};

const getElementFontSize = () => props => {
  switch (props.size) {
    case 'large':
      return '24px';
    case 'small':
      return '14px';
    default:
      return '16px';
  }
};

const getElementTextShadow = () => props => {
  const {
    inverted
  } = props;
  if (!inverted && getThemeProp('button.uiDesign')(props) === '3D') {
    return '1px 1px 2px rgba(0, 0, 0, 0.2)';
  }
  return 'unset';
};

const getKindColor$4 = props => {
  switch (props.kind) {
    case 'dark':
      return getThemeProp('global.dark--color')(props);
    case 'primary':
      return getThemeProp('button.primary--color')(props);
    case 'secondary':
      return getThemeProp('button.secondary--color')(props);
    case 'warning':
      return getThemeProp('global.warning--color')(props);
    case 'danger':
      return getThemeProp('global.danger--color')(props);
    case 'success':
      return getThemeProp('global.success--color')(props);
    case 'info':
      return getThemeProp('global.info--color')(props);
    case 'vellum':
      return 'rgba(255,255,255,0.3)';
    default:
      return getThemeProp('global.dark--color')(props);
  }
};

const getElementTextColor = () => props => {
  const {
    inverted,
    disabled
  } = props;
  if (disabled) {
    return tinycolor(getThemeProp('global.disabled--color')(props)).darken(8).toString();
  }
  if (inverted) {
    return 'white';
  }
  return getKindColor$4(props);
};

const getElementHoverTextColor = () => props => {
  const {
    inverted,
    disabled
  } = props;
  if (inverted || disabled) {
    return 'lightgrey';
  }
  return tinycolor(getKindColor$4(props)).darken(15).toString();
};

const IconAffixStyled = styled.div`
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: background-color;
  font-size: ${_ref => {
  let {
    iconSize
  } = _ref;
  return iconSize;
}};
`;
const IconAffix$1 = props => {
  const {
    icon,
    iconSize
  } = props;
  return /*#__PURE__*/React.createElement(IconAffixStyled, _extends({}, props, {
    text: null,
    iconSize: iconSize
  }), icon);
};
IconAffix$1.propTypes = {
  icon: PropTypes.element.isRequired,
  suffix: PropTypes.bool,
  iconSize: PropTypes.string
};
IconAffix$1.defaultProps = {
  suffix: false,
  iconSize: 'inherit'
};

const ClickableGraphicStyled = styled.button`
  background: transparent;
  color: ${getElementTextColor};
  padding: 0;
  font-size: ${getElementFontSize};
  width: ${_ref => {
  let {
    fullWidth
  } = _ref;
  return fullWidth ? '100%' : 'auto';
}};
  text-shadow: ${getElementTextShadow};
  cursor: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? 'not-allowed' : 'pointer';
}};
  opacity: ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? '0.7' : 'unset';
}};
  min-width: unset;
  font-family: ${getThemeProp('button.text--fontFamily')};
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: stretch;
  outline: 0;
  line-height: 1;
  text-align: center;
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: border-color, background-color;
  position: relative;
  -webkit-appearance: initial;

  @media (hover: hover) {
    &:hover {
      color: ${getElementHoverTextColor};
    }
  }
`;
const TextStyled$2 = styled.div`
  display: inline-flex;
  padding: ${getElementPadding};
`;
const ClickableGraphic = props => {
  const {
    onClick,
    className,
    text,
    icon,
    style,
    ...rest
  } = props;
  const [hover, setHover] = useState(false);
  const handleMouseOver = () => setHover(true);
  const handleMouseOut = () => setHover(false);
  return /*#__PURE__*/React.createElement(ClickableGraphicStyled, _extends({}, rest, {
    style: style,
    onClick: onClick,
    className: className,
    onMouseEnter: handleMouseOver,
    onMouseLeave: handleMouseOut
  }), props.iconPrefix ? /*#__PURE__*/React.createElement(IconAffix$1, _extends({}, rest, {
    icon: props.iconPrefix,
    iconSize: props.iconSize,
    hover: hover
  })) : null, text || icon ? /*#__PURE__*/React.createElement(TextStyled$2, rest, icon, text) : null, props.iconSuffix ? /*#__PURE__*/React.createElement(IconAffix$1, _extends({
    suffix: true
  }, rest, {
    icon: props.iconSuffix,
    iconSize: props.iconSize,
    hover: hover
  })) : null);
};
ClickableGraphic.propTypes = {
  /** Graphic text. */
  text: PropTypes.string,
  /**
   * Function to call on graphic click.
   */
  onClick: PropTypes.func,
  kind: PropTypes.oneOf(['dark', 'primary', 'secondary', 'warning', 'danger', 'success', 'info']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  noPadding: PropTypes.bool,
  inverted: PropTypes.bool,
  disabled: PropTypes.bool,
  /**
   * Span the width at 100% of available space.
   */
  fullWidth: PropTypes.bool,
  icon: PropTypes.element,
  iconSize: PropTypes.string,
  /**
   * Icon to be applied at start of graphic.
   */
  iconPrefix: PropTypes.element,
  /**
   * Icon to be applied at end of graphic.
   */
  iconSuffix: PropTypes.element,
  /**
   * Typically used for an icon-only graphic.
   */
  className: PropTypes.string,
  style: PropTypes.shape({})
};
ClickableGraphic.defaultProps = {
  text: '',
  onClick: () => {},
  kind: 'dark',
  size: 'medium',
  noPadding: false,
  inverted: false,
  disabled: false,
  fullWidth: false,
  icon: null,
  iconSize: 'inherit',
  iconPrefix: null,
  iconSuffix: null,
  className: ''
};

const CardContext = /*#__PURE__*/createContext({});
const PaddedBox = props => /*#__PURE__*/React.createElement(Box, _extends({
  p: 3
}, props), props.children);
const getKindObj = _ref => {
  let {
    kind
  } = _ref;
  switch (kind) {
    case 'success':
      return {
        text: getTokenValue(THEME_TOKENS.base.color.successText),
        background: getTokenValue(THEME_TOKENS.base.color.successBackground),
        border: getTokenValue(THEME_TOKENS.base.color.successBorder)
      };
    case 'warning':
      return {
        text: getTokenValue(THEME_TOKENS.base.color.warning),
        background: getTokenValue(THEME_TOKENS.base.color.warningBackground),
        border: getTokenValue(THEME_TOKENS.base.color.warningBorder)
      };
    case 'danger':
      return {
        text: getTokenValue(THEME_TOKENS.base.color.danger),
        background: getTokenValue(THEME_TOKENS.base.color.dangerBackground),
        border: getTokenValue(THEME_TOKENS.base.color.dangerBorder)
      };
    default:
      return {
        text: 'unset',
        background: getTokenValue(THEME_TOKENS.base.color.infoBackground),
        border: getTokenValue(THEME_TOKENS.base.color.infoBorder)
      };
  }
};
const CardStyled = styled(Box)`
  border-color: ${props => `${getKindObj(props).border}`};
  border-style: solid;
  border-width: 1px;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
  background: white;
  width: 100%;
  overflow: hidden;
`;
const CardHeaderStyled = styled(PaddedBox)`
  background-color: ${props => `${getKindObj(props).background}`};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.heading)};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header4)};

  /* only include bottom border if kind is not set */
  ${props => props.kind === '' && css`
      border-bottom: 1px solid ${getTokenValue(THEME_TOKENS.card.color.border)};
    `}

  ${media.Large`
    font-size: ${getTokenValue(THEME_TOKENS.base.size.header3)};    
  `};
`;
const CardSubHeaderStyled = styled(Flex)`
  align-items: center;
  min-height: 40px;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-style: solid;
  border-width: ${_ref2 => {
  let {
    enclosed
  } = _ref2;
  return enclosed ? '1px 0' : '0 0 1px 0';
}};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};

  ${media.Large`
    font-size: ${getTokenValue(THEME_TOKENS.base.size.header4)};    
  `};

  ${_ref3 => {
  let {
    inverted
  } = _ref3;
  return inverted && css`
      @media screen {
        background: ${getTokenValue(THEME_TOKENS.card.color.background)};
      }
    `;
}};
`;
const CardBodyStyled = styled(PaddedBox)``;
const CardBodySectionStyled = styled(CardBodyStyled)`
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
`;
const CardFooterStyled = styled(PaddedBox)`
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-style: solid;
  border-width: 1px 0 0;
`;
const Card$2 = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  const contextValue = React.useMemo(() => ({
    ...rest
  }), [rest]);
  return /*#__PURE__*/React.createElement(CardContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(CardStyled, rest, children));
};
Card$2.Header = _ref5 => {
  let {
    children,
    ...rest
  } = _ref5;
  const settings = useContext(CardContext);
  return /*#__PURE__*/React.createElement(CardHeaderStyled, _extends({
    kind: settings.kind
  }, rest), children);
};
Card$2.SubHeader = _ref6 => {
  let {
    children,
    ...rest
  } = _ref6;
  const settings = useContext(CardContext);
  return /*#__PURE__*/React.createElement(CardSubHeaderStyled, _extends({
    py: 3,
    px: 3,
    kind: settings.kind
  }, rest), children);
};
Card$2.Body = _ref7 => {
  let {
    children,
    ...rest
  } = _ref7;
  const settings = useContext(CardContext);
  return /*#__PURE__*/React.createElement(CardBodyStyled, _extends({
    kind: settings.kind
  }, rest), children);
};
Card$2.BodySection = CardBodySectionStyled;
Card$2.Footer = CardFooterStyled;
Card$2.propTypes = {
  /**
   * A `<Card>` is expected to receive one of its child components, all of which support props from @rebass/grid such as
   * `p` and `m`:
   */
  children: PropTypes.node.isRequired,
  kind: PropTypes.oneOf(['', 'success', 'warning', 'danger'])
};
Card$2.defaultProps = {
  kind: ''
};
Card$2.Header.propTypes = {
  children: PropTypes.node.isRequired
};
Card$2.SubHeader.propTypes = {
  children: PropTypes.node.isRequired
};
Card$2.Body.propTypes = {
  children: PropTypes.node.isRequired
};
PaddedBox.propTypes = {
  children: PropTypes.node
};
PaddedBox.defaultProps = {
  children: void 0
};

const StyledCommonCard = styled(Card$2)`
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
`;
const StyledCommonCardHeader = styled(Card$2.SubHeader)`
  background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
  min-height: unset;
  border: 0;
  font-weight: 600;
`;
const StyledCommonCardBody = styled(Card$2.Body)``;
const StyledCommonCardFooter = styled(Card$2.Footer)`
  background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
`;
const StyledCommonCardSubheader = styled(StyledCommonCardFooter)`
  background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
  border-width: 1px 0 1px 0;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const CommonCard = StyledCommonCard;
CommonCard.Header = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledCommonCardHeader, _extends({
    py: "6px"
  }, rest), children);
};
CommonCard.Subheader = _ref2 => {
  let {
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledCommonCardSubheader, _extends({
    py: 2,
    enclosed: true
  }, rest), children);
};
CommonCard.Body = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(StyledCommonCardBody, _extends({
    px: 3,
    py: "24px",
    enclosed: true
  }, rest), children);
};
CommonCard.Footer = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(StyledCommonCardFooter, _extends({
    py: 2,
    enclosed: true
  }, rest), children);
};

const CardFlat = styled(Box)`
  /* DO NOT ADD PADDING HERE */
  background-color: white;
  border-style: solid;
  border-color: ${getThemeProp('global.border--color')};
  border-width: 1px 0;
  box-shadow: ${getThemeProp('card.box-shadow')};

  ${media.Medium`
    border-width: 1px;
    border-radius: ${getThemeProp('global.borderRadius--size')};
  `};
`;

const CardShellStyled = styled(Box)`
  border-style: dashed;
  border-width: 1px;
  border-color: ${getTokenValue(THEME_TOKENS.textInput.color.border)};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
`;
const IconShell = styled(Box)`
  font-size: 26px;

  ${IconSvgStyled} {
    display: flex;
  }
`;
const CardShell = _ref => {
  let {
    children,
    icon = null,
    borderOnly = false,
    ...rest
  } = _ref;
  return borderOnly ? /*#__PURE__*/React.createElement(CardShellStyled, rest, children) : /*#__PURE__*/React.createElement(CardShellStyled, _extends({
    p: 3
  }, rest), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, icon && /*#__PURE__*/React.createElement(IconShell, {
    pr: 2
  }, icon), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    width: "100%"
  }, children)));
};
CardShell.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Optional icon to include along the card content.
   */
  icon: PropTypes.node,
  borderOnly: PropTypes.bool
};

const StripStyled$1 = styled(Box)`
  background: ${getTokenValue(THEME_TOKENS.base.color.neutral0)};
  border-width: 1px;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
  border-style: solid;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
`;
const CardStrip = _ref => {
  let {
    children,
    kind = 'vellum',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StripStyled$1, _extends({
    p: "12px 16px",
    kind: kind
  }, rest), children);
};
CardStrip.propTypes = {
  kind: PropTypes.string,
  children: PropTypes.node.isRequired
};

const Card$1 = styled.div`
  background-color: white;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  padding: 16px;
  margin-bottom: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
`;
const CardWithIconContainer = styled.div`
  position: relative;
  cursor: ${props => props.onClick ? 'pointer' : 'default'};

  &:hover ${Card$1} {
    ${props => props.onClick && css`
        border-color: transparent;
        box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
      `};
  }
`;
const IconContainer$1 = styled(Flex)`
  position: absolute;
  top: 16px;
  right: 16px;
`;
const CardWithIcon = _ref => {
  let {
    icon,
    children,
    kind,
    defaultColor,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(CardWithIconContainer, {
    onClick: onClick,
    kind: kind,
    defaultColor: defaultColor
  }, /*#__PURE__*/React.createElement(IconContainer$1, null, icon), /*#__PURE__*/React.createElement(Card$1, null, children));
};
CardWithIcon.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'vellum', 'dark']),
  defaultColor: PropTypes.bool
};

/* eslint-disable react/require-default-props */
const StripStyled = styled(Flex)`
  background: ${getTokenValue(THEME_TOKENS.base.color.neutral0)};
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-width: 1px;
  border-style: solid;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
`;
const DismissibleCard = _ref => {
  let {
    children,
    onClose,
    mt = 0,
    mr = 0,
    mb = 0,
    ml = 0,
    pt = 2,
    pb = 2,
    pr = 2,
    pl = 3
  } = _ref;
  const [isOpen, setIsOpen] = useState(true);
  const [cardHeight, setCardHeight] = useState('');
  const cardRef = useRef(null);
  const springOpacity = useSpring({
    opacity: isOpen ? 1 : 0
  });
  const springHeight = useSpring({
    delay: 300,
    height: isOpen ? cardHeight : 0
  });
  const closeCard = () => {
    setIsOpen(false);
    onClose();
  };
  useEffect(() => {
    // Sets card height
    if (cardRef.current) {
      setCardHeight(cardRef.current.offsetHeight);
    }
  }, [cardRef]);
  return /*#__PURE__*/React.createElement(animated.div, {
    style: {
      ...springOpacity,
      ...springHeight
    }
  }, /*#__PURE__*/React.createElement(Box, {
    ref: cardRef,
    pt: mt,
    pr: mr,
    pb: mb,
    pl: ml
  }, /*#__PURE__*/React.createElement(StripStyled, {
    alignItems: "center",
    justifyContent: "space-between",
    pt: pt,
    pb: pb,
    pr: pr,
    pl: pl
  }, /*#__PURE__*/React.createElement(Box, null, children), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    iconLineName: "X",
    onClick: closeCard,
    minimal: true,
    round: true
  })))));
};
DismissibleCard.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  /**
   * Margin top (rebass grid)
   */
  mt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Margin left (rebass grid)
   */
  ml: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Margin right (rebass grid)
   */
  mr: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Margin bottom (rebass grid)
   */
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding top (rebass grid)
   */
  pt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding left (rebass grid)
   */
  pl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding right (rebass grid)
   */
  pr: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding bottom (rebass grid)
   */
  pb: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const FloatingCardContext = /*#__PURE__*/createContext({});
const cardBorderRadius = getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge);
const FloatingCardHeading = styled(Flex)`
  align-items: center;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.4px;
  background-color: transparent;
  padding-right: 16px;
  /*
  * min-height: 24px is needed for consistency because when an 
  * icon is present it will take up 24px of height and throw
  * off the alignment of the header text & cause odd spacing
   */
  min-height: 24px;
  margin-bottom: 12px;
`;
const FloatingCardShadedSection = styled(Box)`
  background-color: ${props => `${getKindObj(props).background}`};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const FloatingCardSection = styled(Box)`
  background-color: white;
`;
const FloatingCardContent = styled(Box)`
  background-color: white;
  border: 1px solid ${props => `${getKindObj(props).border}`};
  border-radius: ${cardBorderRadius};

  ${FloatingCardSection}:first-child {
    border-top-right-radius: ${cardBorderRadius};
    border-top-left-radius: ${cardBorderRadius};
  }

  ${FloatingCardSection}:last-child {
    border-bottom-left-radius: ${cardBorderRadius};
    border-bottom-right-radius: ${cardBorderRadius};
  }

  ${FloatingCardShadedSection}:first-child {
    border-top-width: 0;
    border-top-right-radius: ${cardBorderRadius};
    border-top-left-radius: ${cardBorderRadius};
  }

  ${FloatingCardShadedSection}:last-child {
    border-bottom-width: 0;
    border-bottom-left-radius: ${cardBorderRadius};
    border-bottom-right-radius: ${cardBorderRadius};
  }
`;
const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${getTokenValue(THEME_TOKENS.base.color.infoBorder)};
`;
const FloatingCard = _ref => {
  let {
    children,
    kind = 'info',
    ...rest
  } = _ref;
  const providerProps = useMemo(() => ({
    kind
  }), [kind]);
  return /*#__PURE__*/React.createElement(FloatingCardContext.Provider, {
    value: providerProps
  }, /*#__PURE__*/React.createElement(Box, rest, children));
};
FloatingCard.propTypes = {
  kind: PropTypes.oneOf(['warning', 'danger', 'success', 'info']),
  children: PropTypes.node
};

// eslint-disable-next-line react/prop-types
FloatingCard.Heading = _ref2 => {
  let {
    children,
    iconToken = '',
    ...rest
  } = _ref2;
  const {
    kind
  } = useContext(FloatingCardContext);
  return /*#__PURE__*/React.createElement(FloatingCardHeading, rest, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, iconToken ? /*#__PURE__*/React.createElement(IconLine, {
    color: getKindObj({
      kind
    }).text,
    icon: iconToken,
    mr: "8px"
  }) : null, children));
};

// eslint-disable-next-line react/prop-types
FloatingCard.SectionShaded = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  const {
    kind
  } = useContext(FloatingCardContext);
  return /*#__PURE__*/React.createElement(FloatingCardShadedSection, _extends({
    p: "16px",
    kind: kind
  }, rest), children);
};

// eslint-disable-next-line react/prop-types
FloatingCard.Content = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  const {
    kind
  } = useContext(FloatingCardContext);
  return /*#__PURE__*/React.createElement(FloatingCardContent, _extends({
    kind: kind
  }, rest), children);
};

// eslint-disable-next-line react/prop-types
FloatingCard.Divider = _ref5 => {
  let {
    ...rest
  } = _ref5;
  const {
    kind
  } = useContext(FloatingCardContext);
  return /*#__PURE__*/React.createElement(Divider, _extends({
    kind: kind
  }, rest));
};

// eslint-disable-next-line react/prop-types
FloatingCard.InnerSection = _ref6 => {
  let {
    children,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(FloatingCardSection, _extends({
    p: "16px"
  }, rest), children);
};

// eslint-disable-next-line react/prop-types
FloatingCard.Section = _ref7 => {
  let {
    children,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(FloatingCardSection, _extends({
    p: "16px"
  }, rest), children);
};

const DotStyled = styled(Box)`
  width: auto;
  height: auto;
  font-size: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  font-weight: ${_ref2 => {
  let {
    weight
  } = _ref2;
  return weight;
}};
`;
const DotSeparator = _ref3 => {
  let {
    size = 10,
    weight = 'bolder',
    ...rest
  } = _ref3;
  const sizeVal = typeof size === 'number' ? `${size}px` : size;
  return /*#__PURE__*/React.createElement(DotStyled, _extends({
    size: sizeVal,
    weight: weight
  }, rest), "\u2022");
};
DotSeparator.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  weight: PropTypes.oneOf(['normal', 'bold', 'lighter', 'bolder', '100', '200', '300', '400', '500', '600', '700', '800', '900', 'inherit', 'unset'])
};

const convertHexToRGB = hexCode => {
  let hex = hexCode.replace('#', '');
  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r},${g},${b}`;
};
const getKindColor$3 = kind => {
  const theme = useTheme();
  switch (kind) {
    case 'primary':
      return theme.global['primary--color'];
    case 'secondary':
      return theme.global['secondary--color'];
    case 'info':
      return theme.global['info--color'];
    case 'neutral':
      return '#a9a9a9';
    default:
      return '#a9a9a9';
  }
};

const ElasticDotsContainer = styled.div`
  width: 85px;
  padding: 8px;
  background-color: ${_ref => {
  let {
    bgColor
  } = _ref;
  return bgColor;
}};
  border-radius: 20px;
`;
const ElasticDots = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: typing 1s linear infinite alternate;
  position: relative;
  left: 4px;

  @keyframes typing {
    0% {
      background-color: rgba(${_ref2 => {
  let {
    dotsRGBColor
  } = _ref2;
  return dotsRGBColor;
}}, 1);
      box-shadow: 24px 0px 0px 0px rgba(${_ref3 => {
  let {
    dotsRGBColor
  } = _ref3;
  return dotsRGBColor;
}}, 0.2),
        48px 0px 0px 0px rgba(${_ref4 => {
  let {
    dotsRGBColor
  } = _ref4;
  return dotsRGBColor;
}}, 0.2);
    }
    25% {
      background-color: rgba(${_ref5 => {
  let {
    dotsRGBColor
  } = _ref5;
  return dotsRGBColor;
}}, 0.4);
      box-shadow: 24px 0px 0px 0px rgba(${_ref6 => {
  let {
    dotsRGBColor
  } = _ref6;
  return dotsRGBColor;
}}, 2),
        48px 0px 0px 0px rgba(${_ref7 => {
  let {
    dotsRGBColor
  } = _ref7;
  return dotsRGBColor;
}}, 0.2);
    }
    75% {
      background-color: rgba(${_ref8 => {
  let {
    dotsRGBColor
  } = _ref8;
  return dotsRGBColor;
}}, 0.4);
      box-shadow: 24px 0px 0px 0px rgba(${_ref9 => {
  let {
    dotsRGBColor
  } = _ref9;
  return dotsRGBColor;
}}, 0.2),
        48px 0px 0px 0px rgba(${_ref10 => {
  let {
    dotsRGBColor
  } = _ref10;
  return dotsRGBColor;
}}, 1);
    }
  }
`;
const ElasticDotsLoader = _ref11 => {
  let {
    kind = 'neutral',
    backgroundColor = 'transparent'
  } = _ref11;
  const dotsColor = getKindColor$3(kind);
  return /*#__PURE__*/React.createElement(ElasticDotsContainer, {
    bgColor: backgroundColor
  }, /*#__PURE__*/React.createElement(ElasticDots, {
    dotsRGBColor: convertHexToRGB(dotsColor)
  }));
};
ElasticDotsLoader.propTypes = {
  backgroundColor: PropTypes.string,
  kind: PropTypes.oneOf(['primary', 'secondary', 'info', 'neutral'])
};

const availableIllustrationKeys = ['actionable-insights', 'all-in-one', 'customer-care-01', 'customer-care-02', 'effortless-autonomy', 'empowering', 'error-404', 'freedom', 'freedom-of-flexibility', 'global-reach-local-resonance-01', 'global-reach-local-resonance-02', 'independence', 'insight', 'productivity', 'simpler-smarter-travel', 'transparency-that-builds-trust-01', 'transparency-that-builds-trust-02', 'travel-companion-01', 'travel-companion-02', 'travel-for-work'];
const IllustrationImage = styled.img`
  width: 160px;
  ${media.Large`
    width: 320px;
  `}
`;
const EmptyStateIllustration = _ref => {
  let {
    illustrationKey
  } = _ref;
  return /*#__PURE__*/React.createElement(IllustrationImage, {
    src: `https://cdn.amtrav.com/cava-illustrations/${illustrationKey}.svg`,
    alt: illustrationKey.replace(/-/g, ' ')
  });
};
EmptyStateIllustration.propTypes = {
  illustrationKey: PropTypes.oneOf(availableIllustrationKeys).isRequired
};

const getIconSize$1 = () => _ref => {
  let {
    size
  } = _ref;
  switch (size) {
    case 'fullWidthLargeText':
    case 'fullWidth':
    case 'large':
      return '60px';
    case 'small':
      return '30px';
    default:
      return '40px';
  }
};
const getElementWidth = () => _ref2 => {
  let {
    size
  } = _ref2;
  switch (size) {
    case 'fullWidthLargeText':
    case 'fullWidth':
      return '100%';
    case 'large':
      return '550px';
    case 'small':
      return '300px';
    default:
      return '400px';
  }
};
const CenteredHeading2 = styled(Heading2)`
  text-align: center;
  color: ${_ref3 => {
  let {
    subtle
  } = _ref3;
  return subtle ? getTokenValue(THEME_TOKENS.base.color.secondaryText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
`;
const CenteredHeading3 = styled(Heading3)`
  color: ${_ref4 => {
  let {
    subtle
  } = _ref4;
  return subtle ? getTokenValue(THEME_TOKENS.base.color.secondaryText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
  text-align: center;
`;
const CenteredHeading4 = styled(Heading4)`
  text-align: center;
  color: ${_ref5 => {
  let {
    subtle
  } = _ref5;
  return subtle ? getTokenValue(THEME_TOKENS.base.color.secondaryText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
`;
const Message = _ref6 => {
  let {
    children,
    size,
    subtle
  } = _ref6;
  switch (size) {
    case 'fullWidthLargeText':
      return /*#__PURE__*/React.createElement(CenteredHeading2, {
        subtle: subtle
      }, children);
    case 'small':
      return /*#__PURE__*/React.createElement(CenteredHeading4, {
        subtle: subtle
      }, children);
    default:
      return /*#__PURE__*/React.createElement(CenteredHeading3, {
        subtle: subtle
      }, children);
  }
};
Message.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string,
  subtle: PropTypes.bool
};
const EmptyStateContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${getElementWidth};
  min-height: 100px;
  padding-top: ${SPACE.size32};
  padding-bottom: ${SPACE.size32};
  padding-left: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'small' ? SPACE.size12 : SPACE.size16;
}};
  padding-right: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'small' ? SPACE.size12 : SPACE.size16;
}};
  margin: ${_ref9 => {
  let {
    center
  } = _ref9;
  return center ? 'auto' : '0';
}};
  color: ${_ref10 => {
  let {
    subtle
  } = _ref10;
  return subtle ? getTokenValue(THEME_TOKENS.base.color.secondaryText) : getTokenValue(THEME_TOKENS.base.color.primaryText);
}};
  background-color: ${_ref11 => {
  let {
    transparent
  } = _ref11;
  return transparent ? 'transparent' : getTokenValue(THEME_TOKENS.card.color.background);
}};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
`;
const Spacer = styled(Box)`
  height: ${_ref12 => {
  let {
    size
  } = _ref12;
  return size === 'small' ? SPACE.size12 : SPACE.size16;
}};
`;
const IconRegion = styled(Flex)`
  font-size: ${getIconSize$1};
`;
const EmptyState = props => {
  const isFlagship = getConfigValue(THEME_CONFIG.base.flag.isFlagshipSite);
  const {
    icon,
    iconLineName,
    illustrationKey,
    size = 'medium',
    text = '',
    center = false,
    secondaryContent,
    subtle = false,
    transparent = false
  } = props;
  return /*#__PURE__*/React.createElement(EmptyStateContainer, {
    subtle: subtle,
    transparent: transparent,
    size: size,
    center: center
  }, icon && /*#__PURE__*/React.createElement(IconRegion, {
    size: size
  }, icon), (() => {
    const showIllustration = illustrationKey && isFlagship;
    if (showIllustration) {
      return /*#__PURE__*/React.createElement(EmptyStateIllustration, {
        illustrationKey: illustrationKey
      });
    }
    if (iconLineName && !showIllustration) {
      const iconSize = size === 'small' || size === 'medium' ? 'xlarge' : 60;
      const strokeWidth = size === 'small' || size === 'medium' ? null : 3;
      return /*#__PURE__*/React.createElement(IconLine, {
        size: iconSize,
        strokeWidth: strokeWidth,
        icon: iconLineName
      });
    }
    return null;
  })(), /*#__PURE__*/React.createElement(Spacer, {
    size: size
  }), /*#__PURE__*/React.createElement(Message, {
    subtle: subtle,
    size: size
  }, text), secondaryContent || null);
};
EmptyState.propTypes = {
  iconLineName: PropTypes.string,
  illustrationKey: PropTypes.oneOf(availableIllustrationKeys),
  /**
   * The 'small' size is meant for small areas and not necessarily for mobile.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large', 'fullWidth', 'fullWidthLargeText']),
  /**
   * `iconLineName` is preferred over icon but icon is still supported.
   */
  icon: PropTypes.element,
  /**
   * Centers the empty state.
   */
  center: PropTypes.bool,
  /**
   * Enables a subtle empty state.
   */
  subtle: PropTypes.bool,
  /**
   * Removes background color.
   */
  transparent: PropTypes.bool,
  /**
   * The text to display in the empty state.
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * The secondary content to display. Usually to display a button.
   */
  secondaryContent: PropTypes.node
};

const FadeStyled = styled.div`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
const Fade = _ref => {
  let {
    show,
    children
  } = _ref;
  const [render, setRender] = useState(show);
  useEffect(() => {
    if (show) setRender(true);
  }, [show]);
  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };
  const transition = {
    animation: `${show ? 'fadeIn' : 'fadeOut'} 0.5s`
  };
  if (render) {
    return /*#__PURE__*/React.createElement(FadeStyled, {
      style: transition,
      onAnimationEnd: onAnimationEnd
    }, children);
  }
  return null;
};
Fade.propTypes = {
  show: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  children: PropTypes.node
};

const rotateAnimation = keyframes`
  100% { transform: rotate(360deg) }
`;
const inAndOutAnimation = keyframes`
  0% ,100% { transform: scale(0) }
  50% { transform: scale(1) }
`;
const ChasingDots = styled.div`
  margin: 0 auto;

  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  animation: ${css`
    ${rotateAnimation} 1s infinite linear;
  `};

  &:after,
  &:before {
    content: '';
    width: 60%;
    height: 60%;
    display: inline-block;
    position: absolute;
    top: 0;
    background-color: ${getThemeProp('global.primary--color')};
    border-radius: 100%;
    animation: ${css`
      ${inAndOutAnimation} 1s infinite ease-in-out;
    `};
  }

  &:before {
    top: auto;
    background-color: ${getThemeProp('global.secondary--color')};
    bottom: 0px;
    animation-delay: -0.5s;
  }
`;
var ChasingDots$1 = () => /*#__PURE__*/React.createElement(ChasingDots, null);

const FullPageOverlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: ${ZINDEX.OVERLAY};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  background: ${getTokenValue(THEME_TOKENS.base.color.overlayBackdrop)};
`;

const VerticalCenter = styled.div`
  display: flex;
  min-height: ${_ref => {
  let {
    withoutMinHeight
  } = _ref;
  return withoutMinHeight ? '100%' : '50vh';
}};
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line react/prop-types
const InlineLoader = _ref2 => {
  let {
    ...rest
  } = _ref2;
  // eslint-disable-next-line react/prop-types
  return /*#__PURE__*/React.createElement(VerticalCenter, rest, /*#__PURE__*/React.createElement(ActivityIndicator, {
    size: 26
  }));
};
InlineLoader.propTypes = {
  withoutMinHeight: PropTypes.bool
};
InlineLoader.defaultProps = {
  withoutMinHeight: false
};

/* eslint-disable react/forbid-prop-types */
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

const LoaderCard = styled(Box)`
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  background: white;
  border-radius: ${getThemeProp('global.borderRadius--size')};
  box-shadow: 0 1px 6px -1px rgba(0, 0, 0, 0.3);
`;
const LoaderContainer = _ref => {
  let {
    theme,
    children
  } = _ref;
  if (theme.loader.withCard) return /*#__PURE__*/React.createElement(LoaderCard, {
    p: 4
  }, children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
LoaderContainer.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node
};
LoaderContainer.defaultProps = {
  children: null
};
const FullPageLoader = _ref2 => {
  let {
    theme
  } = _ref2;
  return /*#__PURE__*/React.createElement(FullPageOverlay, null, /*#__PURE__*/React.createElement(LoaderContainer, {
    theme: theme
  }, /*#__PURE__*/React.createElement(InlineLoader, {
    withoutMinHeight: true
  })));
};
FullPageLoader.propTypes = {
  theme: PropTypes.object.isRequired
};
FullPageLoader.propTypes = {};
FullPageLoader.defaultProps = {};
var FullPageLoader$1 = withTheme(FullPageLoader);

const getNoticeProperty = kind => {
  switch (kind) {
    case 'warning':
      return {
        icon: /*#__PURE__*/React.createElement(IconWarning, null),
        kind
      };
    case 'danger':
      return {
        icon: /*#__PURE__*/React.createElement(IconWarning, null),
        kind
      };
    case 'success':
      return {
        icon: /*#__PURE__*/React.createElement(IconCheckCircle, null),
        kind
      };
    default:
      return {
        icon: /*#__PURE__*/React.createElement(IconInfo, null),
        kind
      };
  }
};

// returns notices but with properties like icon and color
const getNoticesWithProperties = notices => {
  return notices.map(notice => ({
    text: notice.text,
    id: notice.id,
    ...getNoticeProperty(notice.kind)
  }));
};

const LINK_FINDER$1 = /((?:\[[\w\s\d\.]+\]\((?:\/|https?:\/\/)\S+?\))|(?:https?:\/\/\S+))/gi;
const MARKDOWN_LINK$1 = /(\[([\w\s\d\.]+)\]\(((?:\/|https?:\/\/)\S+?)\))/i;
const PLAIN_LINK$1 = /(https?:\/\/\S+)/i;
const linkify = message => {
  const bits = message.split(LINK_FINDER$1);
  return bits.map(bit => {
    const potentialMarkdown = bit.match(MARKDOWN_LINK$1);
    if (potentialMarkdown) return /*#__PURE__*/React.createElement("a", {
      href: potentialMarkdown[3],
      target: "_blank",
      rel: "noreferrer",
      key: bit
    }, potentialMarkdown[2]);
    const potentialLink = bit.match(PLAIN_LINK$1);
    if (potentialLink) return /*#__PURE__*/React.createElement("a", {
      href: bit,
      target: "_blank",
      rel: "noreferrer",
      key: bit
    }, bit);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: bit
    }, bit);
  });
};
const ViewMoreText = styled.div`
  display: none;
  ${media.Medium`
    padding-right: 4px;
    display: inline;
    opacity: 0;
    transition: opacity 0.2s;
  `}
`;

// Shows inside first notice when expandable
const ViewMoreIconContainer = styled.div`
  color: ${getThemeProp('global.link--color')};
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  cursor: pointer;
`;
const NoticeTextContainer = styled.div`
  display: grid;
  align-items: center;
  flex: 1;
  line-height: 1.3;
  min-width: 0;
`;
const NoticeText = styled.div`
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
  ${_ref => {
  let {
    isExpanded
  } = _ref;
  return !isExpanded && css`
      white-space: nowrap;
      text-overflow: ellipsis;
    `;
}}
  overflow: hidden;
`;
const NoticeContainer = styled.div`
  display: flex;
  align-items: stretch;

  width: 100%;

  ${media.Medium`
    &:hover ${ViewMoreText} {
      opacity: 1;
    }
  `}
  &::last-of-type {
    margin-bottom: 0;
  }
`;

// Configures and returns an individual notice
const NoticeItem = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    kind,
    text,
    isExpanded = false,
    isExpandable = true,
    handleClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(Notice, {
    kind: kind,
    isExpandable: isExpandable
  }, /*#__PURE__*/React.createElement(NoticeContainer, null, /*#__PURE__*/React.createElement(NoticeTextContainer, null, /*#__PURE__*/React.createElement(NoticeText, {
    ref: ref,
    isExpanded: isExpanded
  }, linkify(text))), isExpandable && !isExpanded ? /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ViewMoreIconContainer, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(ViewMoreText, null, "Expand"), /*#__PURE__*/React.createElement(IconCaretDown, null))) : null));
});
NoticeItem.propTypes = {
  text: PropTypes.string,
  isExpanded: PropTypes.bool,
  isExpandable: PropTypes.bool,
  handleClick: PropTypes.func,
  kind: PropTypes.string
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
const NoticeBoardContainer = styled.div`
  position: relative;
  width: 100%;
`;
const CollapseContainer = styled.div`
  display: flex;
  color: ${getThemeProp('global.link--color')};
  cursor: pointer;
  align-items: center;
`;

// Shows underneath when expanded
const HideContainer = styled.div`
  display: flex;
  margin-top: -7px;
  justify-content: flex-end;
  font-weight: 600;
  align-items: center;
`;
const DrawerContent = styled.div`
  min-height: 55px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  overflow: hidden;
  padding-bottom: 4px;

  ${_ref => {
  let {
    isExpanded
  } = _ref;
  return css`
      max-height: ${isExpanded ? '800px' : '0'};
      transition: ${isExpanded ? 'all .3s ease-out' : 'all 0.01s ease-out'};
    `;
}}
`;

// Main Notice Board Component
const NoticeBoard = _ref2 => {
  let {
    notices,
    startExpanded = false,
    onCollapse = () => {},
    onExpand = () => {}
  } = _ref2;
  const [isExpanded, setIsExpanded] = useState(startExpanded);
  const [isExpandable, setIsExpandable] = useState(true);
  const [isFirstTruncated, setIsFirstTruncated] = useState(null);

  // get an array of notices with properties like color and icon
  const noticesWithProperties = getNoticesWithProperties(notices);

  // determines if noticeBoard should be expandable
  if (noticesWithProperties.length === 1) {
    if (isFirstTruncated && !isExpandable) {
      setIsExpandable(true);
    } else if (!isFirstTruncated && isExpandable) {
      setIsExpandable(false);
    }
  } else if (!isExpandable) {
    setIsExpandable(true);
  }

  // This attempts to set isExpanded based on isExpandable when isFirstTruncated changes
  useEffect(() => {
    if (isExpandable) {
      setIsExpanded(startExpanded);
    }
  }, []);
  const handleClick = () => {
    if (isExpandable) {
      if (isExpanded) {
        onCollapse();
      } else {
        onExpand();
      }
      setIsExpanded(!isExpanded);
    }
  };

  // splits the notices array into the first and remaining
  const [firstNotice, ...remainingNotices] = noticesWithProperties;

  // this ref is passed to the first notice so we can determine if it is truncated below
  const targetRef = useRef();

  // Sets isTruncated on load
  useEffect(() => {
    setIsFirstTruncated(targetRef.current.offsetWidth < targetRef.current.scrollWidth || targetRef.current.offsetHeight > 30);
  });

  // Watches for window resize an sets isTruncated
  React.useEffect(() => {
    function handleResize() {
      setIsFirstTruncated(targetRef.current.offsetWidth < targetRef.current.scrollWidth || targetRef.current.offsetHeight > 30);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return /*#__PURE__*/React.createElement(NoticeBoardContainer, {
    isFirstTruncated: isFirstTruncated
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    isFirstTruncated: isFirstTruncated,
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement(NoticeItem, {
    ref: targetRef,
    noticeColor: firstNotice.noticeColor,
    icon: firstNotice.icon,
    text: firstNotice.text,
    isExpanded: isExpanded,
    isExpandable: isExpandable,
    handleClick: handleClick,
    kind: firstNotice.kind
  }), isExpanded ? remainingNotices.map(_ref3 => {
    let {
      kind,
      noticeColor,
      icon,
      text,
      id
    } = _ref3;
    return /*#__PURE__*/React.createElement(NoticeItem, {
      key: id,
      kind: kind,
      noticeColor: noticeColor,
      icon: icon,
      text: text,
      isExpanded: true
    });
  }) : null, /*#__PURE__*/React.createElement(HideContainer, null, isExpanded && isExpandable ? /*#__PURE__*/React.createElement(CollapseContainer, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", null, "Collapse "), /*#__PURE__*/React.createElement(IconLine, {
    icon: "ChevronUp"
  })) : null)));
};
NoticeBoard.propTypes = {
  /**
   * Array of announcement objects, with each containing id, kind, and text.
   * Kind can be success, warning, danger, or info.
   */
  notices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    kind: PropTypes.string,
    text: PropTypes.string
  })),
  /**
   * Dicates whether the Notice Board will be rendered in an expanded or collapsed state.
   */
  startExpanded: PropTypes.bool,
  onCollapse: PropTypes.func,
  onExpand: PropTypes.func
};

const ToastifyWrapper = styled.div`
  .Toastify__toast-container {
    z-index: 9999;
    position: fixed;
    padding: 4px;
    width: 320px;
    box-sizing: border-box;
    color: #fff;
  }
  .Toastify__toast-container--top-left {
    top: 1em;
    left: 1em;
  }
  .Toastify__toast-container--top-center {
    top: 1em;
    left: 50%;
    margin-left: -160px;
  }
  .Toastify__toast-container--top-right {
    top: 1em;
    right: 1em;
  }
  .Toastify__toast-container--bottom-left {
    bottom: 1em;
    left: 1em;
  }
  .Toastify__toast-container--bottom-center {
    bottom: 1em;
    left: 50%;
    margin-left: -160px;
  }
  .Toastify__toast-container--bottom-right {
    bottom: 1em;
    right: 1em;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0;
    }
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top: 0;
    }
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom: 0;
    }
    .Toastify__toast-container--rtl {
      right: 0;
      left: initial;
    }
  }

  .Toastify__toast {
    position: relative;
    min-height: 64px;
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 8px;
    border-radius: 1px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-height: 800px;
    overflow: hidden;
    font-family: sans-serif;
    cursor: pointer;
    direction: ltr;
  }
  .Toastify__toast--rtl {
    direction: rtl;
  }
  .Toastify__toast--default {
    background: #fff;
    color: #aaa;
  }
  .Toastify__toast--info {
    background: #3498db;
  }
  .Toastify__toast--success {
    background: #07bc0c;
  }
  .Toastify__toast--warning {
    background: #f1c40f;
  }
  .Toastify__toast--error {
    background: #e74c3c;
  }
  .Toastify__toast-body {
    margin: auto 0;
    -ms-flex: 1;
    flex: 1;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast {
      margin-bottom: 0;
    }
  }

  .Toastify__close-button {
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    -ms-flex-item-align: start;
    align-self: flex-start;
  }
  .Toastify__close-button--default {
    color: #000;
    opacity: 0.3;
  }
  .Toastify__close-button:hover,
  .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }

  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 9999;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }
  .Toastify__progress-bar--rtl {
    right: 0;
    left: initial;
    transform-origin: right;
  }
  .Toastify__progress-bar--default {
    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  }

  @keyframes Toastify__bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }
  }

  @keyframes Toastify__bounceInLeft {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0);
    }
    75% {
      transform: translate3d(-10px, 0, 0);
    }
    90% {
      transform: translate3d(5px, 0, 0);
    }
    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }
  }

  @keyframes Toastify__bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    75% {
      transform: translate3d(0, 10px, 0);
    }
    90% {
      transform: translate3d(0, -5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }

  @keyframes Toastify__bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }
  }

  .Toastify__bounce-enter--top-left,
  .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft;
  }

  .Toastify__bounce-enter--top-right,
  .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }

  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }

  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left,
  .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }

  .Toastify__bounce-exit--top-right,
  .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }

  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }

  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes Toastify__zoomOut {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    to {
      opacity: 0;
    }
  }

  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn;
  }

  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut;
  }

  @keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1;
    }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }
    to {
      transform: perspective(400px);
    }
  }

  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px);
    }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1;
    }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0;
    }
  }

  .Toastify__flip-enter {
    animation-name: Toastify__flipIn;
  }

  .Toastify__flip-exit {
    animation-name: Toastify__flipOut;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0);
    }
  }

  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0);
    }
  }

  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0);
    }
  }

  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0);
    }
  }

  .Toastify__slide-enter--top-left,
  .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft;
  }

  .Toastify__slide-enter--top-right,
  .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }

  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }

  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-left,
  .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft;
  }

  .Toastify__slide-exit--top-right,
  .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
  }

  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
  }

  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
  }
`;

const NotificationStyled = styled(ToastContainer$1)`
  .ats-notification {
    color: white;
    padding: 0;
    min-height: 0;
    border-radius: ${getThemeProp('global.borderRadius--size')};
  }

  .ats-notification--info {
    background: ${getThemeProp('global.info--color')};
  }

  .ats-notification--success {
    background: ${getThemeProp('global.success--color')};
  }

  .ats-notification--warning {
    background: ${getThemeProp('global.warning--color')};
  }

  .ats-notification--danger {
    background: ${getThemeProp('global.danger--color')};
  }

  .ats-notification__progressbar {
    background: rgba(0, 0, 0, 0.2);
  }
  .ats-notification--shake {
    animation: ${css`
      ${shake} 1s linear;
    `};
  }
  .ats-notification--flip {
    animation: ${css`
      ${flipInX} 1s linear;
    `};
  }
`;
function createRootElement(classTarget) {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('class', classTarget);
  return rootContainer;
}
function addRootElement(rootElem) {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
}
function usePortal(classTarget) {
  const rootElemRef = useRef(null);
  useEffect(function setupElement() {
    // Look for existing target dom element to append to
    const existingParent = document.querySelector(`.${classTarget}`);
    // Parent is either a new root or the existing dom element
    const parentElem = existingParent || createRootElement(classTarget);

    // If there is no existing DOM element, add a new one.
    if (!existingParent) {
      addRootElement(parentElem);
    }

    // Add the detached element to the parent
    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.remove();
      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [classTarget]);
  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  }
  return getRootElem();
}
const Notification = () => {
  const target = usePortal('ReactNotificationPortal');
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToastifyWrapper, null, /*#__PURE__*/React.createElement(NotificationStyled, null))), target);
};

const NotificationContent = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    p: 3
  }, content);
};
NotificationContent.propTypes = {
  content: PropTypes.node.isRequired
};

const CloseButton = _ref => {
  let {
    onClose,
    kind
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    flex: "0 1 auto",
    alignSelf: "flex-start",
    m: 3
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    icon: /*#__PURE__*/React.createElement(IconClose, null),
    kind: kind,
    minimal: true
  }));
};
CloseButton.propTypes = {
  onClose: PropTypes.func,
  kind: PropTypes.string
};
CloseButton.defaultProps = {
  onClose: () => {},
  kind: 'sucesss'
};

const CloseToast = _ref => {
  let {
    closeToast,
    kind
  } = _ref;
  return /*#__PURE__*/React.createElement(CloseButton, {
    kind: kind,
    onClose: closeToast
  });
};
CloseToast.propTypes = {
  /**
   * Function to call on close
   */
  closeToast: PropTypes.func,
  /**
   * Specify UI Style (Success, warning, etc.)
   */
  kind: PropTypes.string
};
CloseToast.defaultProps = {
  closeToast: () => {},
  kind: 'sucesss'
};

const classNameProgressbar = 'ats-notification__progressbar';
const classNameNotification = 'ats-notification';
const preconfiguredToastOptions = function () {
  let modifierName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
  return {
    className: `${classNameNotification} ${classNameNotification}--${modifierName}`,
    progressClassName: classNameProgressbar,
    closeButton: /*#__PURE__*/React.createElement(CloseToast, {
      kind: modifierName
    })
  };
};
const notify = (content, options) => toast(/*#__PURE__*/React.createElement(NotificationContent, {
  content: content
}), {
  ...preconfiguredToastOptions(),
  ...options
});
notify.info = (content, options) => toast(/*#__PURE__*/React.createElement(NotificationContent, {
  content: content
}), {
  ...preconfiguredToastOptions('info'),
  ...options
});
notify.success = (content, options) => toast(/*#__PURE__*/React.createElement(NotificationContent, {
  content: content
}), {
  ...preconfiguredToastOptions('success'),
  ...options
});
notify.warning = (content, options) => toast(/*#__PURE__*/React.createElement(NotificationContent, {
  content: content
}), {
  ...preconfiguredToastOptions('warning'),
  ...options
});
notify.danger = (content, options) => toast(/*#__PURE__*/React.createElement(NotificationContent, {
  content: content
}), {
  ...preconfiguredToastOptions('danger'),
  autoClose: false,
  ...options
});
notify.updateWithError = (id, content, options) => {
  toast.update(id, {
    render: /*#__PURE__*/React.createElement(NotificationContent, {
      content: content
    }),
    ...preconfiguredToastOptions('danger'),
    autoClose: false,
    className: 'ats-notification--shake ats-notification ats-notification--danger',
    ...options
  });

  // 1100ms timeout is added to allow the shake animation to finish, after which
  // 'ats-notification--shake'is removed so that the slide animation is re-applied
  // for the close notification animation
  setTimeout(() => toast.update(id, {
    className: 'ats-notification ats-notification--danger'
  }), 1100);
};
notify.updateWithSuccess = (id, content, options) => {
  toast.update(id, {
    render: /*#__PURE__*/React.createElement(NotificationContent, {
      content: content
    }),
    ...preconfiguredToastOptions('success'),
    autoClose: false,
    className: 'ats-notification--flip ats-notification ats-notification--success',
    ...options
  });

  // 1100ms timeout is added to allow the flip animation to finish, after which
  // 'ats-notification--flip'is removed so that the slide animation is re-applied
  // for the close notification animation
  setTimeout(() => toast.update(id, {
    className: 'ats-notification ats-notification--success'
  }), 1100);
};

const PStyled = styled.p`
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  color: ${props => props.darkColor ? getThemeProp('global.dark--color')(props) : getThemeProp('global.textBody--color')(props)};
  font-size: ${props => props.fontSize};
  margin: 0;
`;
const P = _ref => {
  let {
    children,
    darkColor,
    fontSize,
    ...rest
  } = _ref;
  return (
    /*#__PURE__*/
    // this 'P' component can take color, size and regular rebass props
    React.createElement(Box, rest, /*#__PURE__*/React.createElement(PStyled, {
      fontSize: fontSize,
      darkColor: darkColor
    }, children))
  );
};
P.propTypes = {
  children: PropTypes.node,
  fontSize: PropTypes.string,
  darkColor: PropTypes.bool
};
P.defaultProps = {
  fontSize: '14px',
  darkColor: false
};

const LINK_FINDER = /((?:\[[\w\s\d]+\]\((?:\/|https?:\/\/)\S+?\))|(?:https?:\/\/\S+))/gi;
const MARKDOWN_LINK = /(\[([\w\s\d]+)\]\(((?:\/|https?:\/\/)\S+?)\))/i;
const PLAIN_LINK = /(https?:\/\/\S+)/i;
const linkifyMessage = message => {
  const bits = message.split(LINK_FINDER);
  return bits.map((bit, index) => {
    const potentialMarkdown = bit.match(MARKDOWN_LINK);
    if (potentialMarkdown) return /*#__PURE__*/React.createElement("a", {
      href: potentialMarkdown[3],
      target: "_blank",
      rel: "noreferrer",
      key: bit.concat(index)
    }, potentialMarkdown[2]);
    const potentialLink = bit.match(PLAIN_LINK);
    if (potentialLink) return /*#__PURE__*/React.createElement("a", {
      href: bit,
      target: "_blank",
      rel: "noreferrer"
    }, bit);
    return bit;
  });
};
const Linkify = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, linkifyMessage(children));
};
Linkify.propTypes = {
  children: PropTypes.string
};

const unhighlightFirstCellStyles$1 = _ref => {
  let {
    unhighlightFirstCell
  } = _ref;
  return unhighlightFirstCell && css`
    th {
      &:nth-child(1) {
        background: transparent;
        border-bottom: 1px solid ${getThemeProp('global.border--color')};
      }
      ${media.Medium`
        &:nth-child(2) {
          border-top-left-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
        }
      `};
    }
  `;
};
const alignHeadersRightStyles = _ref2 => {
  let {
    alignHeadersRight
  } = _ref2;
  return alignHeadersRight && css`
    th {
      text-align: right;
      &:nth-child(1) {
        text-align: left;
      }
    }
  `;
};
const neutralStyles = _ref3 => {
  let {
    neutral
  } = _ref3;
  return neutral && css`
    th {
      color: ${getThemeProp('global.textBody--color')};
      background: ${getThemeProp('global.greyPalette.100')};
    }
  `;
};
const Head = styled.thead`
  th {
    font-family: ${getThemeProp('global.textBody--fontFamily')};
    border-bottom: 1px solid ${getThemeProp('global.border--color')};
    color: ${getThemeProp('global.dark--color')};
    ${media.Medium`
      &:first-of-type {
        border-top-left-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
      }
      &:last-of-type {
        border-top-right-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
      }
    `};
  }

  ${unhighlightFirstCellStyles$1};
  ${alignHeadersRightStyles};
  ${neutralStyles};
`;

const stripedStyles = _ref => {
  let {
    striped
  } = _ref;
  return striped && css`
    & tr:nth-of-type(odd) td {
      background-color: ${getThemeProp('table.primaryBackground--color')};
    }
  `;
};
const dottedBorderStyles = _ref2 => {
  let {
    dotted
  } = _ref2;
  return dotted && css`
    td {
      border-bottom: 1px dotted ${getThemeProp('global.border--color')};
    }
  `;
};
const Body$1 = styled.tbody`
  td {
    font-size: 0.875rem;
    background: white;
    border-bottom: 1px solid ${getThemeProp('global.border--color')};
  }

  tr:first-of-type {
    td {
      border-top: 1px solid ${getThemeProp('global.border--color')};
    }
  }
  tr:last-child {
    td {
      border-bottom: 1px solid ${getThemeProp('global.border--color')};
    }
  }

  thead + & {
    tr:first-of-type {
      td {
        border-top: 0;
      }
    }
    tr:last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  ${stripedStyles};
  ${dottedBorderStyles}
`;

const unhighlightFirstCellStyles = _ref => {
  let {
    unhighlightFirstCell
  } = _ref;
  return unhighlightFirstCell && css`
    td {
      &:nth-child(1) {
        color: inherit;
        background: transparent;
        border-top: 1px solid ${getThemeProp('global.border--color')};
      }

      ${media.Medium`
        &:nth-child(2) {
          border-bottom-left-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
        }
      `};
    }
  `;
};
const yellowInvoiceStyles = _ref2 => {
  let {
    yellowInvoice
  } = _ref2;
  return yellowInvoice && css`
    td {
      background: ${getTokenValue(THEME_TOKENS.card.color.background)};
      font-family: ${getThemeProp('global.textBody--fontFamily')};
      color: ${getThemeProp('global.textBody--color')};
      border-top: 1px solid ${getThemeProp('global.border--color')};
      font-size: 16px;
    }
  `;
};
const Foot = styled.tfoot`
  td {
    font-size: 1.125rem;
    font-family: ${getThemeProp('global.headings--fontFamily')};
    color: white;
    background: ${getThemeProp('global.dark--color')};
    font-weight: bold;

    &:first-of-type {
      border-bottom-left-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
    }
    &:last-of-type {
      border-bottom-right-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
    }
  }
  ${unhighlightFirstCellStyles};
  ${yellowInvoiceStyles};
`;

const successStyles = _ref => {
  let {
    success
  } = _ref;
  return success && css`
    && {
      & td {
        background: #f4ffeb;
      }
    }
  `;
};
const whiteStyles = _ref2 => {
  let {
    white
  } = _ref2;
  return white && css`
    && {
      & td {
        background: white;
      }
    }
  `;
};
const boldStyles = _ref3 => {
  let {
    bold
  } = _ref3;
  return bold && css`
    && {
      & td {
        font-weight: bold;
      }
    }
  `;
};
const Row = styled.tr`
  ${whiteStyles};
  ${successStyles};
  ${boldStyles};
`;

const alignRightStyles = _ref => {
  let {
    alignRight
  } = _ref;
  return alignRight && css`
    text-align: right;
  `;
};
const redTextStyles = _ref2 => {
  let {
    redText
  } = _ref2;
  return redText && css`
    color: ${getThemeProp('global.danger--color')};
  `;
};
const borderLeftStyles = _ref3 => {
  let {
    borderLeft
  } = _ref3;
  return borderLeft && css`
    border-left: 1px solid ${getThemeProp('global.border--color')};
  `;
};
const borderRightStyles = _ref4 => {
  let {
    borderRight
  } = _ref4;
  return borderRight && css`
    border-right: 1px solid ${getThemeProp('global.border--color')};
`;
};
const Cell = styled.td`
  ${alignRightStyles};
  ${redTextStyles};
  ${borderLeftStyles};
  ${borderRightStyles};
`;

const alignCellsCenter = _ref => {
  let {
    alignCenter = []
  } = _ref;
  return alignCenter.length && css`
    tr td,
    tr th {
      ${alignCenter.map(x => `
      &:nth-child(${x}) {
        text-align: center;
      }`)};
    }
  `;
};
const alignCellsRight = _ref2 => {
  let {
    alignRight = []
  } = _ref2;
  return alignRight.length && css`
    tr td,
    tr th {
      ${alignRight.map(x => `
      &:nth-child(${x}) {
        text-align: right;
      }`)};
    }
  `;
};
const outerBorderStyles = _ref3 => {
  let {
    outerBorder
  } = _ref3;
  return outerBorder && css`
    border: 1px solid ${getThemeProp('global.border--color')};
    border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
  `;
};
const fontSize16Styles = _ref4 => {
  let {
    fontSize16
  } = _ref4;
  return fontSize16 && css`
    tr td,
    tr th {
      font-size: 16px;
    }
  `;
};
const minimalStyles = _ref5 => {
  let {
    minimal
  } = _ref5;
  return minimal && css`
    && {
      border-collapse: separate;
      border-spacing: 0 10px;
      box-shadow: none;
    }

    /*
    A table row <tr> does not support a background color when used with a border-radius. To work around this 
    limitation, we use a large inset box-shadow to create the appearance of a background color.
    */
    tbody tr {
      box-shadow: 0px 0px 0px 1px ${getTokenValue(THEME_TOKENS.card.color.border)} inset,
        0px 0px 0px 1000px ${getTokenValue(THEME_TOKENS.base.color.neutral0)} inset;
      border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
    }

    thead th {
      border-bottom: none;
      padding-bottom: 0;

      &:first-of-type {
        padding-left: 16px;
      }
    }

    tr td {
      background: none;
      border: none;
      padding: 12px 8px;

      ${media.Small`
        padding: 12px 16px;
        `};
    }

    tr:first-of-type {
      td {
        border-top: none;
      }
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  `;
};
const Table = styled.table`
  width: 100%;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  text-align: left;
  border-collapse: separate;
  border-spacing: 0;
  overflow: ${_ref6 => {
  let {
    overflow
  } = _ref6;
  return overflow || 'visible';
}};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};

  & th,
  & td {
    padding: ${_ref7 => {
  let {
    cellPadding
  } = _ref7;
  return cellPadding || '12px 16px';
}};
  }
  ${outerBorderStyles};
  ${fontSize16Styles};
  ${minimalStyles}
`;
Table.Head = styled(Head)`
  ${alignCellsCenter};
  ${alignCellsRight};
`;
Table.Body = styled(Body$1)`
  ${alignCellsCenter};
  ${alignCellsRight};
`;
Table.Foot = styled(Foot)`
  ${alignCellsCenter};
  ${alignCellsRight};
`;
Table.Row = Row;
Table.Cell = Cell;

const ListTable = _ref => {
  let {
    headerContent,
    rowContent
  } = _ref;
  return /*#__PURE__*/React.createElement(Table, {
    minimal: true
  }, /*#__PURE__*/React.createElement(MatchMedia.Medium, null, headerContent), /*#__PURE__*/React.createElement(Table.Body, null, rowContent));
};
ListTable.propTypes = {
  headerContent: PropTypes.element.isRequired,
  rowContent: PropTypes.element.isRequired
};

const InnerContainer = styled.div`
  display: flex;
  gap: 10px;
  padding: 1px; /* accounts for SoloFilter active state which adds a 1px border */
  overflow-x: scroll;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
  box-sizing: content-box;
`;
const SliderContainer = styled.div`
  position: relative;
  color: ${getThemeProp('global.link--color')};
  display: flex;
  overflow: hidden;
  align-items: center;
  box-sizing: content-box;
`;
const Arrow = styled.div`
  opacity: ${_ref => {
  let {
    visible
  } = _ref;
  return visible ? '1' : '0';
}};
  position: absolute;
  z-index: ${_ref2 => {
  let {
    visible
  } = _ref2;
  return visible ? '1' : '-1';
}};
  transition: opacity 0.3s, z-index 0.3s;
`;
const RightArrow = styled(Arrow)`
  right: 0;
  display: flex;
  justify-content: flex-end;
  background-image: linear-gradient(
    to left,
    ${getTokenValue(THEME_TOKENS.base.color.siteBackground)} 80%,
    rgba(245, 245, 245, 0) 100%
  );
`;
const LeftArrow = styled(Arrow)`
  left: 0;
  display: flex;
  justify-content: flex-start;
  background-image: linear-gradient(
    to right,
    ${getTokenValue(THEME_TOKENS.base.color.siteBackground)} 80%,
    rgba(245, 245, 245, 0) 100%
  );
`;

// Custom hook to track changes in clientWidth
const useClientWidthChange = ref => {
  const [clientWidth, setClientWidth] = useState(null);
  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        setClientWidth(ref.current.clientWidth);
      }
    };

    // Initial measurement
    handleResize();

    // Event listener for resize
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);
  return clientWidth;
};
const HorizontalScroll = _ref3 => {
  let {
    children
  } = _ref3;
  const ref = useRef(null);
  const [showScrollLeft, setShowScrollLeft] = useState(false);
  const [showScrollRight, setShowScrollRight] = useState(false);
  const clientWidth = useClientWidthChange(ref);
  useEffect(() => {
    if (ref.current.clientWidth < ref.current.scrollWidth) {
      setShowScrollRight(true);
    } else {
      setShowScrollRight(false);
    }
  }, [clientWidth]);
  const scrollRight = () => {
    ref.current.scrollLeft += 280;
  };
  const scrollLeft = () => {
    ref.current.scrollLeft -= 280;
  };
  const hideShowScrollArrows = () => {
    const maxScrollValue = ref.current.scrollWidth - ref.current.clientWidth;
    if (ref.current.scrollLeft > 0) {
      setShowScrollLeft(true);
    } else {
      setShowScrollLeft(false);
    }
    if (ref.current.scrollLeft + 1 >= maxScrollValue || maxScrollValue === 0) {
      setShowScrollRight(false);
    } else {
      setShowScrollRight(true);
    }
  };
  return /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(LeftArrow, {
    visible: showScrollLeft
  }, /*#__PURE__*/React.createElement(Flex, {
    py: 3
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(IconAngleLeft, null),
    onClick: scrollLeft,
    size: "large",
    transparent: true
  })))), /*#__PURE__*/React.createElement(InnerContainer, {
    ref: ref,
    onScroll: hideShowScrollArrows
  }, children), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(RightArrow, {
    visible: showScrollRight
  }, /*#__PURE__*/React.createElement(Flex, {
    py: 3
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(IconAngleRight, null),
    onClick: scrollRight,
    size: "large",
    transparent: true
  })))));
};
HorizontalScroll.propTypes = {
  children: PropTypes.node
};

var RadioGroup = styled(RadioButton)`
  border-width: 1px;
  border-style: solid;
  border-color: ${_ref => {
  let {
    checked
  } = _ref;
  return checked ? getThemeProp('global.link--color') : getThemeProp('global.border--color');
}};
  color: ${_ref2 => {
  let {
    checked
  } = _ref2;
  return !checked && getThemeProp('global.link--color');
}};
  border-radius: 40px;
  padding: 8px 12px;
  line-height: 1;
  display: block;
  background: white;

  ${RadioLabelStyled} {
    display: flex;
    align-items: center;
  }

  ${RadioLabelText} {
    padding-top: 0;
    display: flex;
    align-items: center;
  }
`;

const RadioCardContainer = styled.label`
  display: block;
  min-width: 230px;
  font-family: ${getTokenValue(THEME_TOKENS.base.fontFamily.body)};
  box-shadow: ${_ref => {
  let {
    checked
  } = _ref;
  return checked ? `0 0 0 1.5px ${getTokenValue(THEME_TOKENS.base.color.action)} inset` : `0 0 0 1px ${getTokenValue(THEME_TOKENS.base.color.infoBorder)} inset`;
}};
  padding: ${SPACE.size16};
  background-color: ${_ref2 => {
  let {
    checked,
    showBackgroundColor
  } = _ref2;
  return checked && showBackgroundColor ? getTokenValue(THEME_TOKENS.base.color.infoBackground) : getTokenValue(THEME_TOKENS.base.color.white);
}};
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: ${getTokenValue(THEME_TOKENS.base.color.infoBackground)};
  }

  &:focus {
    outline: -webkit-focus-ring-color auto 5px;
  }
`;
const RadioCircle = styled(RadioCircleStyled)`
  // Minor tweaks to core RadioButton circle to fit RadioCard format
  width: 16px;
  height: 16px;
  display: block;

  ${props => !props.disabled && !props.checked && props.hover && css`
      box-shadow: inset 0 0 0 1em white;
    `};
`;
const NativeRadio = styled(HiddenNativeRadioButton)`
  left: 2px;
  width: 16px;
  height: 16px;
`;
const CircleWithLabelContainer = styled(Flex)`
  position: relative;
  user-select: none;
  outline: 0;
`;
const RadioCardLabel = styled.section`
  width: 100%;
  padding-left: ${SPACE.size12};
`;
const RadioCardContent = styled.section`
  margin-top: ${SPACE.size8};
`;
const RadioCard = _ref3 => {
  let {
    label = '',
    secondaryContent,
    showSelectedBackgroundColor = false,
    buttonAlignment = 'center',
    name,
    id,
    checked,
    onChange,
    // TODO: add disable state
    // disabled = false,
    value,
    className,
    ...rest
  } = _ref3;
  const [hover, setHover] = useState(false);
  const dataAttrs = Object.keys(rest).reduce((obj, key) => {
    if (key.indexOf('data-') === 0) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = rest[key];
    }
    return obj;
  }, {});
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  return /*#__PURE__*/React.createElement(RadioCardContainer, {
    className: className,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    showBackgroundColor: showSelectedBackgroundColor,
    checked: checked
  }, /*#__PURE__*/React.createElement(CircleWithLabelContainer, _extends({
    alignItems: buttonAlignment,
    id: `${id}-label`,
    htmlFor: id
  }, dataAttrs), /*#__PURE__*/React.createElement(NativeRadio, {
    type: "radio",
    id: id,
    name: name,
    onChange: onChange,
    value: value
    // TODO: add disable state
    // disabled={disabled}
    ,
    checked: checked
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioCircle, {
    checked: checked
    // disabled={disabled}
    ,
    hover: hover
  })), /*#__PURE__*/React.createElement(RadioCardLabel, null, label)), secondaryContent && /*#__PURE__*/React.createElement(RadioCardContent, null, secondaryContent));
};
RadioCard.propTypes = {
  /** `id` for native radio input. This is inherited from the `RadioButton` component.
   */
  id: PropTypes.string,
  /** `name` for native radio input. This is inherited from the `RadioButton` component.
   */
  name: PropTypes.string.isRequired,
  /** `value` for native radio input. This is inherited from the `RadioButton` component.
   */
  value: PropTypes.string.isRequired,
  /** `checked` prop for native radio input. This is inherited from the `RadioButton` component.
   */
  checked: PropTypes.bool,
  // disabled: PropTypes.bool,
  /** This works like a traditional radio `label` since it's positioned to the right of the radio circle.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** `secondaryContent` appears directly below the radio button + `label` section & uses the full width of the card.
   */
  secondaryContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Shows the light/dim `infoBackground` color of the selected card (instead of white) if set to `true`.
   */
  showSelectedBackgroundColor: PropTypes.bool,
  buttonAlignment: PropTypes.oneOf(['normal', 'center', 'start', 'end', 'flex-start', 'flex-end', 'self-start', 'self-end', 'baseline', 'unset']),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

const CheckboxCardContainer = styled(RadioCardContainer)``;
const CheckboxSquare = styled(CheckboxStyled)`
  // Minor tweaks to core Checkbox square to fit RadioCard format
  width: 16px;
  height: 16px;
  display: block;

  && {
    ${props => !props.disabled && !props.checked && props.hover && css`
        box-shadow: inset 0 0 0 1em white;
      `};
  }
`;
const NativeCheckbox = styled(HiddenNativeCheckbox)`
  width: 16px;
  height: 16px;
`;
const CbWithLabelContainer = styled(Flex)`
  position: relative;
  user-select: none;
  outline: 0;
`;
const CheckboxCardLabel = styled.section`
  width: 100%;
  padding-left: ${SPACE.size12};
`;
const CheckboxCardContent = styled.section`
  margin-top: ${SPACE.size8};
`;
const CheckboxCard = _ref => {
  let {
    label = '',
    secondaryContent,
    showSelectedBackgroundColor = false,
    buttonAlignment = 'center',
    name,
    id,
    checked,
    onChange,
    // TODO: add disable state
    // disabled = false,
    value,
    className,
    ...rest
  } = _ref;
  const [hover, setHover] = useState(false);
  const dataAttrs = Object.keys(rest).reduce((obj, key) => {
    if (key.indexOf('data-') === 0) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = rest[key];
    }
    return obj;
  }, {});
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  return /*#__PURE__*/React.createElement(CheckboxCardContainer, {
    className: className,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    showBackgroundColor: showSelectedBackgroundColor,
    checked: checked,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(CbWithLabelContainer, {
    alignItems: buttonAlignment
  }, /*#__PURE__*/React.createElement(NativeCheckbox, _extends({
    type: "checkbox",
    id: id,
    name: name,
    onChange: onChange,
    value: value
    // TODO: add disable state
    // disabled={disabled}
    ,
    checked: checked
  }, dataAttrs)), /*#__PURE__*/React.createElement(CheckboxSquare, {
    checked: checked
    // disabled={disabled}
    ,
    hover: hover
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconLine, {
    icon: "Check",
    size: "small"
  }))), /*#__PURE__*/React.createElement(CheckboxCardLabel, null, label)), secondaryContent && /*#__PURE__*/React.createElement(CheckboxCardContent, null, secondaryContent));
};
CheckboxCard.propTypes = {
  /** `id` for native Checkbox input. This is inherited from the `Checkbox` component.
   */
  id: PropTypes.string,
  /** `name` for native Checkbox input. This is inherited from the `Checkbox` component.
   */
  name: PropTypes.string.isRequired,
  /** `value` for native Checkbox input. This is inherited from the `Checkbox` component.
   */
  value: PropTypes.string,
  /** `checked` prop for native Checkbox input. This is inherited from the `Checkbox` component.
   */
  checked: PropTypes.bool,
  // disabled: PropTypes.bool,
  /** This works like a traditional Checkbox `label` since it's positioned to the right of the Checkbox box.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** `secondaryContent` appears directly below the Checkbox box + `label` section & uses the full width of the card.
   */
  secondaryContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Shows the light/dim `infoBackground` color of the selected card (instead of white) if set to `true`.
   */
  showSelectedBackgroundColor: PropTypes.bool,
  buttonAlignment: PropTypes.oneOf(['normal', 'center', 'start', 'end', 'flex-start', 'flex-end', 'self-start', 'self-end', 'baseline', 'unset']),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

const ToastWrapper = _ref => {
  let {
    children,
    id
  } = _ref;
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 3000);
    return () => {
      clearTimeout(timer);
    };
  });
  return /*#__PURE__*/React.createElement(Fade, {
    id: id,
    show: show
  }, children);
};
ToastWrapper.propTypes = {
  children: PropTypes.node,
  id: PropTypes.number
};
ToastWrapper.defaultProps = {
  children: null,
  id: 0
};

const Ctx = /*#__PURE__*/React.createContext();

// the containing parent element also needs to have position: relative
const ToastContainerStyled = styled.div`
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translate(-50%, 0);
`;
const ToastContainer = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ToastContainerStyled, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column-reverse",
    mt: 1
  }, children));
};
ToastContainer.propTypes = {
  children: PropTypes.node
};
ToastContainer.defaultProps = {
  children: null
};
let toastCount = 0;
function ToastProvider(_ref2) {
  let {
    children
  } = _ref2;
  const [toasts, setToasts] = useState([]);
  const add = content => {
    const id = toastCount++;
    const toast = {
      content,
      id
    };
    // use this if we decide to implement multiple toasts later
    // setToasts([...toasts, toast]);
    setToasts([toast]);
  };
  const remove = id => {
    const newToasts = toasts.filter(t => t.id !== id);
    setToasts(newToasts);
  };
  const onDismiss = id => () => remove(id);
  return /*#__PURE__*/React.createElement(Ctx.Provider, {
    value: {
      add,
      remove
    }
  }, children, /*#__PURE__*/React.createElement(ToastContainer, null, toasts.map(_ref3 => {
    let {
      content,
      id
    } = _ref3;
    return /*#__PURE__*/React.createElement(ToastWrapper, {
      key: id,
      id: id,
      dismiss: onDismiss(id)
    }, content);
  })));
}
ToastProvider.propTypes = {
  children: PropTypes.node
};
ToastProvider.defaultProps = {
  children: null
};
const useToasts = () => React.useContext(Ctx);

const getColor$1 = kind => {
  switch (kind) {
    case 'warning':
      return {
        backgroundColor: getTokenValue(THEME_TOKENS.base.color.warningBackground),
        textColor: getTokenValue(THEME_TOKENS.base.color.warningText),
        borderColor: getTokenValue(THEME_TOKENS.base.color.warningBorder)
      };
    case 'danger':
      return {
        backgroundColor: getTokenValue(THEME_TOKENS.base.color.dangerBackground),
        textColor: getTokenValue(THEME_TOKENS.base.color.dangerText),
        borderColor: getTokenValue(THEME_TOKENS.base.color.dangerBorder)
      };
    case 'success':
      return {
        backgroundColor: getTokenValue(THEME_TOKENS.base.color.successBackground),
        textColor: getTokenValue(THEME_TOKENS.base.color.successText),
        borderColor: getTokenValue(THEME_TOKENS.base.color.successBorder)
      };
    default:
      return {
        backgroundColor: getTokenValue(THEME_TOKENS.base.color.infoBackground),
        textColor: getTokenValue(THEME_TOKENS.base.color.infoText),
        borderColor: getTokenValue(THEME_TOKENS.base.color.infoBorder)
      };
  }
};
const ToastNoticeStyled = styled.div`
  display: inline-flex;
  align-items: center;
  height: 52px;
  min-width: 150px;
  padding-left: 24px;
  padding-right: 24px;
  margin: 4px;
  background-color: ${_ref => {
  let {
    kind
  } = _ref;
  return getColor$1(kind).backgroundColor;
}};
  border-style: solid;
  border-width: 1px;
  border-color: ${_ref2 => {
  let {
    kind
  } = _ref2;
  return getColor$1(kind).borderColor;
}};
  background-clip: border-box;
  box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
`;
const TextStyled$1 = styled.span`
  color: ${_ref3 => {
  let {
    kind
  } = _ref3;
  return getColor$1(kind).textColor;
}};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header3)};
  text-align: center;
  white-space: nowrap;
`;
const IconAffix = styled.div`
  height: ${getTokenValue(THEME_TOKENS.base.size.header3)};
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header3)};
  color: ${_ref4 => {
  let {
    kind
  } = _ref4;
  return getColor$1(kind).textColor;
}};
  margin-right: 6px;
`;
const ToastNotice = _ref5 => {
  let {
    icon,
    text,
    kind,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(ToastNoticeStyled, _extends({
    kind: kind
  }, rest), icon ? /*#__PURE__*/React.createElement(IconAffix, {
    kind: kind
  }, icon) : null, text ? /*#__PURE__*/React.createElement(TextStyled$1, {
    kind: kind
  }, text) : null);
};
ToastNotice.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string,
  kind: PropTypes.oneOf(['warning', 'danger', 'success', 'info'])
};
ToastNotice.defaultProps = {
  icon: null,
  text: '',
  kind: 'info'
};

const getFontWeight = _ref => {
  let {
    weight
  } = _ref;
  if (weight === 'normal' || weight === '400') {
    return getTokenValue(THEME_TOKENS.base.fontWeight.normal);
  }
  if (weight === 'semiBold' || weight === '500' || weight === '600') {
    return getTokenValue(THEME_TOKENS.base.fontWeight.semiBold);
  }
  if (weight === 'bold' || weight === 'bolder' || weight === '700' || weight === '800') {
    return getTokenValue(THEME_TOKENS.base.fontWeight.bold);
  }
  return weight;
};
const TextStyled = styled(Box)`
  width: ${_ref2 => {
  let {
    width
  } = _ref2;
  return width;
}};
  height: auto;
  font-size: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size || getTokenValue(THEME_TOKENS.base.size.bodyText);
}};
  font-weight: ${getFontWeight};
  font-style: ${_ref4 => {
  let {
    italic
  } = _ref4;
  return italic ? 'italic' : 'normal';
}};
  line-height: ${_ref5 => {
  let {
    lineHeight
  } = _ref5;
  return lineHeight;
}};
  color: ${_ref6 => {
  let {
    primary,
    colorToken
  } = _ref6;
  return primary ? getTokenValue(THEME_TOKENS.base.color.primaryText) : colorToken;
}};

  ${_ref7 => {
  let {
    width
  } = _ref7;
  return width !== 'auto' && css`
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `;
}}
`;
const Text$2 = _ref8 => {
  let {
    titleHover = null,
    size,
    weight = 'normal',
    width = 'auto',
    primary = false,
    colorToken = 'inherit',
    lineHeight = 1,
    italic = false,
    children,
    ...rest
  } = _ref8;
  const sizeVal = typeof size === 'number' ? `${size}px` : size;
  const widthVal = typeof width === 'number' ? `${width}px` : width;
  return /*#__PURE__*/React.createElement(TextStyled, _extends({
    primary: primary,
    colorToken: colorToken,
    size: sizeVal,
    weight: weight,
    width: widthVal,
    lineHeight: lineHeight,
    italic: italic
  }, rest), titleHover ? /*#__PURE__*/React.createElement("span", {
    title: titleHover
  }, children) : children);
};
Text$2.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  titleHover: PropTypes.string,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  primary: PropTypes.bool,
  colorToken: PropTypes.string,
  weight: PropTypes.oneOf(['normal', 'semiBold', 'bold', 'bolder', '400',
  // normal
  '500', '600', '700',
  // bold
  '800', 'inherit']),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  italic: PropTypes.bool
};

const StyledToggleGroup = styled(ToggleGroupPrimitive.Root)`
  display: inline-flex;
  padding: 2px;
  border-radius: 5px;
  border-style: solid;
  gap: 2px;
  border-width: 1px;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};
`;
const StyledToggleItem = styled(ToggleGroupPrimitive.Item)`
  all: unset;
  display: flex;
  line-height: 1;
  align-items: center;
  justify-content: center;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 3px;

  &:xfirst-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  &:xlast-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  &[data-state='off'] {
    background-color: rgba(255, 255, 255, 0);

    &:hover {
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
      cursor: pointer;
    }
  }
  &[data-state='on'] {
    background-color: ${getTokenValue(THEME_TOKENS.base.color.action)};
    color: ${getTokenValue(THEME_TOKENS.base.color.neutral0)};
    position: relative;
  }
  &:focus-visible {
    outline: 2px solid ${getTokenValue(THEME_TOKENS.base.color.link)};
    position: relative;
    z-index: ${ZINDEX.TOOLTIP};
  }
`;
const ToggleGroup = _ref => {
  let {
    children,
    onValueChange = () => {},
    defaultValue,
    ...props
  } = _ref;
  const [value, setValue] = useState(defaultValue);
  const onChange = newValue => {
    if (newValue) {
      setValue(newValue);
      onValueChange(newValue);
    }
  };
  return /*#__PURE__*/React.createElement(StyledToggleGroup, _extends({
    value: value,
    onValueChange: onChange
  }, props), children);
};
ToggleGroup.Item = StyledToggleItem;
ToggleGroup.propTypes = {
  children: PropTypes.node,
  onValueChange: PropTypes.func,
  defaultValue: PropTypes.string
};

const DebounceRenderer = _ref => {
  let {
    value,
    debounce,
    onDebounce,
    className,
    track,
    children
  } = _ref;
  const [queuedValue, updateQueuedValue] = useState(value);
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      onDebounce(queuedValue);
    }, debounce);
    return () => clearTimeout(debounceTimeout);
  }, [queuedValue]);
  useEffect(() => {
    if (track) {
      updateQueuedValue(value);
    }
  }, [value]);
  const renderProps = {
    debounce,
    updateQueuedValue,
    queuedValue,
    value
  };
  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, children(renderProps));
};
DebounceRenderer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  debounce: PropTypes.number,
  onDebounce: PropTypes.func,
  className: PropTypes.string,
  track: PropTypes.bool,
  children: PropTypes.func.isRequired
};
DebounceRenderer.defaultProps = {
  value: undefined,
  debounce: 220,
  onDebounce: () => console.warn('No onDebounce prop given'),
  className: undefined,
  track: false
};

const CalendarTitle = styled(Flex)`
  font-family: ${getThemeProp('global.headings--fontFamily')};
  font-size: 1.5rem;

  ${media.Medium`
    font-size: 1.625rem;
  `}
`;
const PrevNextRegion = styled(Box)`
  visibility: ${_ref => {
  let {
    isVisible
  } = _ref;
  return isVisible ? 'visible' : 'hidden';
}};
`;
const HeaderTitleRegion = styled(Flex)`
  border-top-right-radius: ${getThemeProp('global.borderRadius--size')};
  border-top-left-radius: ${getThemeProp('global.borderRadius--size')};
  margin-left: auto;
  margin-right: auto;
  text-transform: uppercase;

  ${_ref2 => {
  let {
    withButtons
  } = _ref2;
  return withButtons && css`
      background: ${getThemeProp('global.textBody--color')};
      color: white;
    `;
}}
`;
const CalendarHeader = _ref3 => {
  let {
    children,
    onClickPrev,
    onClickNext
  } = _ref3;
  const hasClickEvents = onClickPrev || onClickNext;
  return /*#__PURE__*/React.createElement(HeaderTitleRegion, {
    py: 2,
    px: hasClickEvents ? [2, 3] : 0,
    mb: 1,
    justifyContent: hasClickEvents ? 'space-between' : ['center', 'space-between'],
    alignItems: "center",
    withButtons: hasClickEvents
  }, /*#__PURE__*/React.createElement(CalendarTitle, null, children), hasClickEvents && /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(PrevNextRegion, {
    isVisible: onClickPrev
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickPrev,
    icon: /*#__PURE__*/React.createElement(IconCaretUp, {
      rotate: -90
    })
  })), /*#__PURE__*/React.createElement(PrevNextRegion, {
    pl: 2,
    isVisible: onClickNext
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickNext,
    icon: /*#__PURE__*/React.createElement(IconCaretUp, {
      rotate: 90
    })
  }))));
};
CalendarHeader.propTypes = {
  /**
   * Text to display (ex. January 2020)
   */
  children: PropTypes.node,
  /**
   * Function to call on previous button click. Previous button is hidden if `onClickPrev` is not provided.
   */
  onClickPrev: PropTypes.func,
  /**
   * Function to call on next button click. Next button is hidden if `onClickNext` prop is not provided.
   */
  onClickNext: PropTypes.func
};
CalendarHeader.defaultProps = {
  children: null,
  onClickPrev: undefined,
  onClickNext: undefined
};

const getColor = () => props => {
  const {
    isLow,
    selected
  } = props;
  if (selected) {
    return 'white';
  }
  if (isLow) {
    return getThemeProp('global.success--color')(props);
  }
  return getThemeProp('global.link--color')(props);
};
const Fare = styled.span`
  font-size: ${_ref => {
  let {
    withIcon
  } = _ref;
  return withIcon ? '1rem' : '0.725rem';
}};
  font-weight: bold;
  color: ${getColor};
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: color;
  opacity: ${_ref2 => {
  let {
    withIcon
  } = _ref2;
  return withIcon ? '0.3' : 'unset';
}};

  ${media.Medium`
    font-size: ${_ref3 => {
  let {
    withIcon
  } = _ref3;
  return withIcon ? '1.5rem' : '1rem';
}};
  `}
`;
const DayFare = _ref4 => {
  let {
    amount,
    isLow,
    selected
  } = _ref4;
  return /*#__PURE__*/React.createElement(Fare, {
    selected: selected,
    isLow: isLow,
    withIcon: !amount
  }, amount ? `$${Math.round(amount)}` : /*#__PURE__*/React.createElement(IconSearch, null));
};
DayFare.propTypes = {
  /**
   * A search icon is shown if amount is omitted.
   */
  amount: PropTypes.number,
  isLow: PropTypes.bool,
  selected: PropTypes.bool
};
DayFare.defaultProps = {
  amount: undefined,
  isLow: false,
  selected: false
};

const TILE_KINDS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INACTIVE: 'inactive',
  BLANK: 'blank'
};
const getBackgroundColor = () => props => {
  const {
    kind,
    selected
  } = props;
  if (selected) {
    return getThemeProp('global.primary--color')(props);
  }
  if (kind === TILE_KINDS.BLANK) {
    return 'white';
  }
  if (kind === TILE_KINDS.SECONDARY) {
    return getThemeProp('global.light--color')(props);
  }
  if (kind === TILE_KINDS.INACTIVE) {
    return lighten(getThemeProp('global.light--color')(props), 0.5);
  }
  return darken(getThemeProp('global.light--color')(props), 3);
};
const stipesSvg = `
  <svg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'>
    <g fill='rgba(0, 0, 0, .025)' fill-opacity='1' fill-rule='evenodd'>
      <path d='M0 40L40 0H20L0 20M40 40V20L20 40'/>
    </g>
  </svg>
`;
const Day$1 = styled(Flex)`
  text-align: center;
  font-size: 0.625rem;
  margin: 1px;
  position: relative;
  min-height: 3.2rem;
  flex-direction: column;
  justify-content: center;
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: background-color, min-height;
  background-color: ${getBackgroundColor};
  border-radius: ${getThemeProp('global.borderRadius--size')};
  ${media.Large`
    min-height: 5rem;
    font-size: 0.825rem;
  `}

  ${_ref => {
  let {
    kind
  } = _ref;
  return kind === 'inactive' && css`
    background-image: url("data:image/svg+xml;,${encodeURIComponent(stipesSvg)}");
  `;
}};

  ${_ref2 => {
  let {
    kind
  } = _ref2;
  return kind === TILE_KINDS.BLANK && css`
      visibility: hidden;
    `;
}};

  ${_ref3 => {
  let {
    selected
  } = _ref3;
  return selected && css`
      color: white;
    `;
}};

  ${props => props.onClick && css`
      @media (hover: hover) {
        &:hover {
          background: ${getThemeProp('global.link--color')};
          cursor: pointer;

          ${Fare} {
            color: white;
          }
        }
      }
    `};
`;
const DayNumber = styled.div`
  color: ${_ref4 => {
  let {
    selected
  } = _ref4;
  return selected ? 'white' : 'unset';
}};
  opacity: ${_ref5 => {
  let {
    selected
  } = _ref5;
  return selected ? '1' : '0.5';
}};
  padding: 0px 2px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.15s;
  transition-property: color;

  ${Day$1} & {
    position: absolute;
    top: 4px;
    right: 4px;
  }
  ${props => props.selectable && css`
      @media (hover: hover) {
        ${Day$1}:hover & {
          color: white;
        }
      }
    `}
  }
`;
const DayTile = _ref6 => {
  let {
    day,
    className,
    selected,
    children,
    onClick,
    onClickPayload,
    kind
  } = _ref6;
  const localOnClick = event => {
    onClick(event, onClickPayload);
  };
  return /*#__PURE__*/React.createElement(Day$1, {
    className: className,
    py: [1],
    onClick: onClick ? localOnClick : undefined,
    selected: selected,
    kind: kind
  }, /*#__PURE__*/React.createElement(DayNumber, {
    selectable: onClick,
    selected: selected
  }, day), /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, children));
};
DayTile.propTypes = {
  day: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * Class name passed through to the containing div generated by the renderer. This is mostly for
   * styled-components but could be used for applying CSS.
   */
  className: PropTypes.string,
  children: PropTypes.node,
  /**
   * UI style of `DayTile`:
   *
   * - `primary` – Default styles for a selectable tile.
   * - `secondary` – Can be used when a tile needs to be slightly deemphasized.
   * - `inactive` – Indicates the day is inactive. Typically used for past dates and/or dates that are not selectable.
   * - `blank` – Completely blank tile.
   */
  kind: PropTypes.oneOf(Object.values(TILE_KINDS)),
  /**
   * Indicates the day is selected.
   */
  selected: PropTypes.bool,
  /**
   * Function to call on click of a `DayTile`
   */
  onClick: PropTypes.func,
  /**
   * Arbitrary data that will be provided to the onClick event handler as a second paramter.
   */
  onClickPayload: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({}), PropTypes.array])
};
DayTile.defaultProps = {
  kind: 'primary',
  children: null,
  className: undefined,
  selected: false,
  onClick: undefined,
  onClickPayload: undefined
};

const HeaderRegion = styled(Flex)`
  font-weight: bold;
  font-size: 1.25rem;
  font-family: ${getThemeProp('global.headings--fontFamily')};
  justify-content: space-between;

  ${media.Medium`
    font-size: 1.75rem;
  `}
`;
const FareRegion = styled(Box)`
  text-align: right;
  visibility: ${_ref => {
  let {
    visible
  } = _ref;
  return visible ? 'visible' : 'hidden';
}};
`;
const FromLabel = styled(Box)`
  font-size: 0.75rem;
  font-weight: normal;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
`;
const Price = styled.span`
  color: ${getThemeProp('global.success--color')};
  font-size: 1.5rem;

  ${media.Medium`
    font-size: 2rem;
  `}
`;
const Route = styled(Box)`
  background: ${getThemeProp('global.dark--color')};
  font-size: 1rem;
  color: white;
`;
const Breadcrumb = styled(Flex)`
  font-size: 1.25rem;

  ${media.Medium`
    font-size: 1.75rem;
  `}
`;
const SelectedDateRegion = styled(Flex)`
  font-size: 0.75rem;

  ${media.Medium`
  font-size: 0.9rem;
  `}
`;
const EditDate = styled(Box)`
  color: ${getThemeProp('global.link--color')};
  display: inline;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;
const getFareInstructions = step => {
  if (step === 0) {
    return 'Choose a Departure Date';
  }
  return 'Choose a Return Date';
};
const FareCalendarHeader = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    departDate,
    returnDate,
    onDepartDateClick,
    fromCity,
    toCity,
    lowFare
  } = _ref2;
  let currStep = 0;
  if (departDate) {
    currStep = 1;
  }
  if (returnDate) {
    currStep = 2;
  }
  const animatedHeader = useSpring({
    opacity: 1,
    from: {
      opacity: 0
    }
  });
  const animatedDepart = useSpring({
    opacity: departDate ? 1 : 0,
    transform: departDate ? 'translate3d(0px, 0px, 0)' : 'translate3d(20px, 0px, 0)'
  });
  return /*#__PURE__*/React.createElement(animated.div, {
    style: animatedHeader
  }, /*#__PURE__*/React.createElement(HeaderRegion, {
    width: 1,
    px: [2, 3, 4],
    py: 3,
    alignItems: "center",
    ref: ref
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    flexDirection: "column"
  }, departDate ? /*#__PURE__*/React.createElement(animated.div, {
    style: animatedDepart
  }, /*#__PURE__*/React.createElement(SelectedDateRegion, {
    onClick: onDepartDateClick,
    alignItems: "baseline",
    pb: 2
  }, /*#__PURE__*/React.createElement(Box, null, "Depart"), /*#__PURE__*/React.createElement(EditDate, {
    pl: 1
  }, formatDate(departDate, 'EEE MMM d'), " ", /*#__PURE__*/React.createElement(IconEdit, null)))) : null, getFareInstructions(currStep)), /*#__PURE__*/React.createElement(FareRegion, {
    visible: lowFare
  }, /*#__PURE__*/React.createElement(FromLabel, {
    py: 1
  }, "Roundtrip from"), /*#__PURE__*/React.createElement(Price, null, "$", lowFare))), /*#__PURE__*/React.createElement(Route, {
    py: 2,
    px: [2, 3, 4]
  }, /*#__PURE__*/React.createElement("i", null, "Roundtrip"), " ", /*#__PURE__*/React.createElement("b", null, fromCity), " ", /*#__PURE__*/React.createElement("i", null, "to"), " ", /*#__PURE__*/React.createElement("b", null, toCity)));
});
FareCalendarHeader.propTypes = {
  /**
   * Selected departure date.
   */
  departDate: PropTypes.instanceOf(Date),
  /**
   * Selected return date.
   */
  returnDate: PropTypes.instanceOf(Date),
  /**
   * Function to call to change selected departure date.
   */
  onDepartDateClick: PropTypes.func,
  /**
   * Departure city.
   */
  fromCity: PropTypes.string,
  /**
   * Destination city.
   */
  toCity: PropTypes.string,
  /**
   * Low fare amount.
   */
  lowFare: PropTypes.number
};
FareCalendarHeader.defaultProps = {
  departDate: null,
  returnDate: null,
  onDepartDateClick: undefined,
  fromCity: '',
  toCity: '',
  lowFare: undefined
};

/* eslint-disable react/no-array-index-key */
const TileGroupRegion = styled(Flex)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;
const TileGroup = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(TileGroupRegion, null, children.map((tile, idx) => /*#__PURE__*/React.createElement(Box, {
    key: `tile-${idx}`,
    width: 1 / children.length
  }, tile)));
};
TileGroup.propTypes = {
  children: PropTypes.node.isRequired
};
TileGroup.defaultProps = {};

const WeekDay = styled(Box)`
  text-align: center;
  font-weight: bold;
  font-size: 0.625rem;
  margin: 1px;
  flex-direction: column;
  justify-content: center;
  opacity: ${_ref => {
  let {
    inactive
  } = _ref;
  return inactive ? '0.3' : '0.7';
}};
  text-transform: uppercase;
  font-family: ${getThemeProp('global.headings--fontFamily')};

  ${media.Medium`
    font-size: 0.825rem;
  `}
`;
const WeekDayLabel$1 = _ref2 => {
  let {
    day
  } = _ref2;
  return /*#__PURE__*/React.createElement(WeekDay, {
    py: [1]
  }, day);
};
WeekDayLabel$1.propTypes = {
  day: PropTypes.string.isRequired
};

const divideToRows = function (arr) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
  return Array.from({
    length: Math.ceil(arr.length / size)
  }, (_, i) => arr.slice(i * size, i * size + size));
};
const MonthlyCalendarRenderer = _ref => {
  let {
    className,
    epoch,
    blockStartDate,
    blockEndDate,
    children: renderFunction,
    weekStartsOn
  } = _ref;
  const firstDayOfBlock = startOfWeek(blockStartDate || startOfMonth(epoch), {
    weekStartsOn
  });
  const lastDayOfBlock = endOfWeek(blockEndDate || endOfMonth(epoch), {
    weekStartsOn
  });
  const daysOfCalBlock = eachDayOfInterval({
    start: firstDayOfBlock,
    end: lastDayOfBlock
  });
  const renderProps = {
    epoch,
    blockStartDate,
    blockEndDate,
    days: daysOfCalBlock,
    weeks: divideToRows(daysOfCalBlock, 7),
    divideToRows
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, renderFunction(renderProps));
};
MonthlyCalendarRenderer.propTypes = {
  /**
   * A point in time from which to base generate weeks/days of the month.
   * This is used if `blockStartDate` and `BlockEndDate` are falsey.
   */
  epoch: PropTypes.instanceOf(Date),
  /**
   * A start date to build out the calendar. If the `blockStartDate` happens to occur midweek, days will be padded
   * to the front of the week. This prop takes precedence over `epoch`.
   */
  blockStartDate: PropTypes.instanceOf(Date),
  /**
   * An end date to build out the calendar. If the `blockEndDate` happens to occur midweek, days will be padded
   * to the end of the week. This prop takes precedence over `epoch`.
   */
  blockEndDate: PropTypes.instanceOf(Date),
  /**
   * Class name passed through to the containing div generated by the renderer. This is mostly for
   * styled-components but could be used for applying CSS.
   */
  className: PropTypes.string,
  /**
   * This is a function provided as a child of the component. This function will be called and given props that
   * can be used to compose a calendar.
   */
  children: PropTypes.func.isRequired,
  /**
   * Sets the start of the week for calendar layouts that do not start on Sunday.
   */
  weekStartsOn: PropTypes.number
};
MonthlyCalendarRenderer.defaultProps = {
  epoch: new Date(),
  blockStartDate: null,
  blockEndDate: null,
  className: undefined,
  weekStartsOn: 0
};

const shimmer = keyframes`
  0% {
    background-position: -700px 0;
  }
  100% {
    background-position: 700px 0;
  }
`;
const LoaderTile = styled(DayTile)`
  ${_ref => {
  let {
    isLoading
  } = _ref;
  return isLoading ? css`
          animation: ${shimmer} 2s linear infinite;
          background: linear-gradient(115deg, #f7f7f7 15%, rgba(226, 226, 226, 1) 32%, #f7f7f7 45%);
          background-size: 700px 100%;
        ` : null;
}}
`;

// TODO handle null values for the dates for cases where we don't yet know
const FareCalendar = _ref2 => {
  let {
    fares,
    lowestFare,
    earliestDate,
    latestDate,
    selectedFare,
    tripKey,
    onDateClicked,
    isLoading,
    title
  } = _ref2;
  // calendar date is internal state so prev and next month buttons can work independent of the selectedFare
  const [calendarDate, setCalendarDate] = useState(startOfMonth(selectedFare[tripKey]));
  useEffect(() => {
    setCalendarDate(startOfMonth(selectedFare[tripKey]));
  }, [selectedFare]);
  if (latestDate < endOfMonth(calendarDate)) ;
  const getFareForDay = day => {
    const fare = fares.get(isoExtendedFormat(day));
    return fare ? /*#__PURE__*/React.createElement(DayFare, {
      isLow: fare.amount === lowestFare,
      amount: fare.amount,
      selected: fare === selectedFare
    }) : /*#__PURE__*/React.createElement(DayFare, null);
  };
  const onDayClickHandler = (e, payload) => {
    const {
      day,
      key
    } = payload;
    if (!isSameMonth(day, calendarDate)) {
      setCalendarDate(startOfMonth(day));
    }
    // TODO may need to handle passing down a payload better or just send back the fare object
    onDateClicked(fares.get(key));
  };
  const pastBoundary = startOfMonth(earliestDate);
  const prevMonth = addMonths(calendarDate, -1);
  const nextMonth = addMonths(calendarDate, 1);
  const futureBoundary = addMonths(pastBoundary, 11);

  // if the next and previous months surpass the boundaries do not provide a function
  const prevMonthHandler = compareAsc(prevMonth, pastBoundary) !== -1 ? () => setCalendarDate(prevMonth) : null;
  const nextMonthHandler = compareAsc(nextMonth, futureBoundary) !== 1 ? () => setCalendarDate(nextMonth) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CalendarHeader, {
    title: title,
    onClickNext: nextMonthHandler,
    onClickPrev: prevMonthHandler
  }, monthYearFormatter(calendarDate)), /*#__PURE__*/React.createElement(TileGroup, null, ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(dayName => /*#__PURE__*/React.createElement(WeekDayLabel$1, {
    day: dayName,
    key: dayName
  }))), /*#__PURE__*/React.createElement(MonthlyCalendarRenderer, {
    epoch: calendarDate
  }, _ref3 => {
    let {
      weeks,
      epoch
    } = _ref3;
    const rows = weeks.map(week => /*#__PURE__*/React.createElement(TileGroup, {
      key: `${getWeek(week[0])}`
    }, week.map(day => {
      return /*#__PURE__*/React.createElement(LoaderTile, {
        isLoading: isLoading,
        key: day.getDay(),
        day: dayOfMonthFormatter(day),
        selected: isSameDay(day, selectedFare[tripKey]),
        secondary: !isSameMonth(day, epoch),
        inactive: isBefore(day, earliestDate),
        onClick: !isBefore(day, earliestDate) ? onDayClickHandler : null,
        onClickPayload: {
          day,
          key: isoExtendedFormat(day)
        }
      }, !isBefore(day, earliestDate) ? getFareForDay(day) : null);
    })));
    return rows;
  }));
};
FareCalendar.propTypes = {
  fares: PropTypes.instanceOf(Map).isRequired,
  tripKey: PropTypes.string.isRequired,
  title: PropTypes.string,
  lowestFare: PropTypes.number,
  isLoading: PropTypes.bool,
  earliestDate: PropTypes.instanceOf(Date),
  latestDate: PropTypes.instanceOf(Date),
  selectedFare: PropTypes.shape({}),
  onDateClicked: PropTypes.func
};
FareCalendar.defaultProps = {
  lowestFare: undefined,
  isLoading: false,
  earliestDate: null,
  // make these null so that can be compared
  latestDate: null,
  selectedFare: undefined,
  title: undefined,
  onDateClicked: () => {}
};

const fill = props => keyframes`
  100% {
    box-shadow: inset 0px 0px 0px 30px ${getThemeProp('global.success--color')(props)};
  }
`;
const scale = keyframes`
  50% {
    transform: translateX(-50%);
  }
`;
const Checkmark = styled.svg`
  color: white;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px 0px ${props => getThemeProp('global.success--color')(props)};
  z-index: 0;
  animation: ${css`
    ${fill} .4s ease-in-out forwards, ${scale} .3s ease-in-out .6s both
  `};
`;
const CheckmarkCircle = styled.circle`
  stroke-dasharray: 166;
  stroke-dashoffset: 0;
  stroke-width: 5;
  stroke-miterlimit: 10;
  stroke: ${getThemeProp('global.success--color')};
  fill: none;
`;
const CheckmarkCheck = styled.path`
  stroke: #fff;
  stroke-width: 5;
`;
const Component = () => /*#__PURE__*/React.createElement(Checkmark, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}, /*#__PURE__*/React.createElement(CheckmarkCircle, {
  cx: "26",
  cy: "26",
  r: "25",
  fill: "none"
}), /*#__PURE__*/React.createElement(CheckmarkCheck, {
  fill: "none",
  d: "M14.1 27.2l7.1 7.2 16.7-16.8"
}));
Component.propTypes = {};
Component.defaultProps = {};

/* eslint-disable react/no-array-index-key */

// Inspired from https://codepen.io/kaueburiti/pen/YNZGZO by Kaue Buriti

const WizardTrailContainer = styled.div`
  transform: translateY(-20px);
`;
const Steps = styled(Flex)`
  display: flex;
`;
const Step = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
  border-radius: 5px;
`;
const StepLabel = styled(Box)`
  font-size: 13px;
  opacity: ${props => props.active || props.completed ? 1 : 0.5};
`;
const StepText = styled(Box)`
  font-size: 1rem;
`;
const SmallIcon = styled.span`
  font-size: 20px;
`;
const StepNumber = styled.div`
  font-size: 20px;
  background: #fff;
  font-weight: 800;
  color: ${getThemeProp('global.textBody--color')};
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
  border-color: ${props => props.active || props.completed ? getThemeProp('global.success--color')(props) : '#c3c3c3'};
  transition: ${_ref => {
  let {
    completed,
    active
  } = _ref;
  return completed || active ? 'opacity 0.5s, border-color 0.3s ease-in' : 'unset';
}};
  transition-delay: ${_ref2 => {
  let {
    completed,
    active
  } = _ref2;
  return completed || active ? '0s, 0.7s' : '0s, 0s';
}};
  opacity: ${_ref3 => {
  let {
    completed
  } = _ref3;
  return completed ? 0 : 1;
}};
  z-index: 5;
  display: flex;
  justify-content: center;
  position: relative;
`;
const StepContent = styled.div`
  position: relative;
  z-index: 2;
`;
const Line = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  z-index: -1;
  height: 2px;
  transition: ${_ref4 => {
  let {
    completed
  } = _ref4;
  return completed ? 'all 0.3s ease-out 0.6s' : 'all 0.3s ease-out';
}};
`;
const LineBackground = styled(Line)`
  background: #c3c3c3;
  width: ${_ref5 => {
  let {
    last
  } = _ref5;
  return last ? '0%' : '100%';
}};
`;
const LineProgress = styled(Line)`
  background: ${getThemeProp('global.success--color')};
  width: ${_ref6 => {
  let {
    last
  } = _ref6;
  return last ? '0%' : '100%';
}};
  transform-origin: left center;
  transform: ${_ref7 => {
  let {
    completed
  } = _ref7;
  return completed ? 'scaleX(1)' : 'scaleX(0)';
}};
`;
const WizardTracker = _ref8 => {
  let {
    activeStep,
    steps
  } = _ref8;
  const stepsView = steps && steps.length ? steps.map((step, idx) => {
    const {
      icon,
      label,
      additionalInfo,
      onClick
    } = step;
    return /*#__PURE__*/React.createElement(Step, {
      key: idx,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(StepNumber, {
      active: idx === activeStep,
      completed: idx < activeStep
    }, icon), idx < activeStep && /*#__PURE__*/React.createElement(Component, null), /*#__PURE__*/React.createElement(LineBackground, {
      last: idx === steps.length - 1
    }), /*#__PURE__*/React.createElement(LineProgress, {
      last: idx === steps.length - 1,
      completed: idx < activeStep
    }), /*#__PURE__*/React.createElement(StepLabel, {
      pt: 1,
      active: idx === activeStep,
      completed: idx < activeStep
    }, label), additionalInfo && /*#__PURE__*/React.createElement(StepText, {
      pt: 1
    }, additionalInfo, ' ', onClick && /*#__PURE__*/React.createElement(SmallIcon, null, /*#__PURE__*/React.createElement(IconEdit, null)))));
  }) : null;
  return /*#__PURE__*/React.createElement(WizardTrailContainer, null, /*#__PURE__*/React.createElement(Steps, null, stepsView));
};
WizardTracker.propTypes = {
  /**
   * Array of step objects:
   *
   * - `label` – Text describing step.
   * - `additionalInfo` – Additional text to add to step (ex. summary of user selection).
   * - `icon` – Icon depicting step.
   * - `onClick` – Function to be called on click of step.
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    additionalInfo: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func
  })).isRequired,
  /**
   * Indicates which step in the `steps` array is active (zero-based).
   */
  activeStep: PropTypes.number
};
WizardTracker.defaultProps = {
  activeStep: 0
};

/* Please keep this list alphabetically sorted. */
var AirlineList = {
  default: {
    alName: '',
    imageUrl: 'yy.png'
  },
  '0c': {
    alName: '',
    imageUrl: '0C.png'
  },
  '1b': {
    alName: '',
    imageUrl: '1B.png'
  },
  '2v': {
    alName: '',
    imageUrl: '2v.png'
  },
  '4o': {
    alName: '',
    imageUrl: '4O.png'
  },
  '4m': {
    alName: '',
    imageUrl: '4m.png'
  },
  '6a': {
    alName: '',
    imageUrl: '6a.png'
  },
  '7h': {
    alName: '',
    imageUrl: '7H.png'
  },
  '9b': {
    alName: '',
    imageUrl: '9B.png'
  },
  '9x': {
    alName: '',
    imageUrl: '9x.png'
  },
  a3: {
    alName: '',
    imageUrl: 'a3.png'
  },
  aa: {
    alName: '',
    imageUrl: 'aa.png'
  },
  ab: {
    alName: '',
    imageUrl: 'ab.png'
  },
  ac: {
    alName: '',
    imageUrl: 'ac.png'
  },
  af: {
    alName: '',
    imageUrl: 'af.png'
  },
  ai: {
    alName: '',
    imageUrl: 'ai.png'
  },
  am: {
    alName: '',
    imageUrl: 'am.png'
  },
  ar: {
    alName: '',
    imageUrl: 'ar.png'
  },
  as: {
    alName: '',
    imageUrl: 'as.png'
  },
  at: {
    alName: '',
    imageUrl: 'at.png'
  },
  av: {
    alName: '',
    imageUrl: 'av.png'
  },
  ay: {
    alName: '',
    imageUrl: 'ay.png'
  },
  az: {
    alName: '',
    imageUrl: 'az.png'
  },
  b6: {
    alName: '',
    imageUrl: 'b6.png'
  },
  ba: {
    alName: '',
    imageUrl: 'ba.png'
  },
  bd: {
    alName: '',
    imageUrl: 'bd.png'
  },
  be: {
    alName: '',
    imageUrl: 'be.png'
  },
  br: {
    alName: '',
    imageUrl: 'br.png'
  },
  ca: {
    alName: '',
    imageUrl: 'ca.png'
  },
  ci: {
    alName: '',
    imageUrl: 'ci.png'
  },
  cm: {
    alName: '',
    imageUrl: 'cm.png'
  },
  co: {
    alName: '',
    imageUrl: 'co.png'
  },
  cx: {
    alName: '',
    imageUrl: 'cx.png'
  },
  cz: {
    alName: '',
    imageUrl: 'cz.png'
  },
  d8: {
    alName: '',
    imageUrl: 'd8.png'
  },
  dy: {
    alName: '',
    imageUrl: 'dy.png'
  },
  dh: {
    alName: '',
    imageUrl: 'dh.png'
  },
  di: {
    alName: '',
    imageUrl: 'di.png'
  },
  dl: {
    alName: '',
    imageUrl: 'dl.png'
  },
  ei: {
    alName: '',
    imageUrl: 'ei.png'
  },
  ek: {
    alName: '',
    imageUrl: 'ek.png'
  },
  et: {
    alName: '',
    imageUrl: 'et.png'
  },
  ey: {
    alName: '',
    imageUrl: 'ey.png'
  },
  f9: {
    alName: '',
    imageUrl: 'f9.png'
  },
  fi: {
    alName: '',
    imageUrl: 'fi.png'
  },
  fj: {
    alName: '',
    imageUrl: 'fj.png'
  },
  fl: {
    alName: '',
    imageUrl: 'fl.png'
  },
  fr: {
    alName: '',
    imageUrl: 'FR.png'
  },
  g3: {
    alName: '',
    imageUrl: 'g3.png'
  },
  g4: {
    alName: '',
    imageUrl: 'g4.png'
  },
  gf: {
    alName: '',
    imageUrl: 'gf.png'
  },
  ha: {
    alName: '',
    imageUrl: 'ha.png'
  },
  ib: {
    alName: '',
    imageUrl: 'ib.png'
  },
  ir: {
    alName: '',
    imageUrl: 'ir.png'
  },
  jj: {
    alName: '',
    imageUrl: 'jj.png'
  },
  jl: {
    alName: '',
    imageUrl: 'jl.png'
  },
  jm: {
    alName: '',
    imageUrl: 'jm.png'
  },
  jq: {
    alName: '',
    imageUrl: 'jq.png'
  },
  jr: {
    alName: '',
    imageUrl: 'jr.png'
  },
  jx: {
    alName: '',
    imageUrl: 'JX.png'
  },
  ka: {
    alName: '',
    imageUrl: 'ka.png'
  },
  ke: {
    alName: '',
    imageUrl: 'ke.png'
  },
  kk: {
    alName: '',
    imageUrl: 'kk.png'
  },
  kl: {
    alName: '',
    imageUrl: 'kl.png'
  },
  kq: {
    alName: '',
    imageUrl: 'kq.png'
  },
  ku: {
    alName: '',
    imageUrl: 'ku.png'
  },
  la: {
    alName: '',
    imageUrl: 'la.png'
  },
  lh: {
    alName: '',
    imageUrl: 'lh.png'
  },
  lo: {
    alName: '',
    imageUrl: 'lo.png'
  },
  lp: {
    alName: '',
    imageUrl: 'lp.png'
  },
  lr: {
    alName: '',
    imageUrl: 'lr.png'
  },
  lx: {
    alName: '',
    imageUrl: 'lx.png'
  },
  ly: {
    alName: '',
    imageUrl: 'ly.png'
  },
  mh: {
    alName: '',
    imageUrl: 'mh.png'
  },
  mm: {
    alName: '',
    imageUrl: 'mm.png'
  },
  ms: {
    alName: '',
    imageUrl: 'ms.png'
  },
  mu: {
    alName: '',
    imageUrl: 'mu.png'
  },
  mx: {
    alName: '',
    imageUrl: 'mx.png'
  },
  n7: {
    alName: '',
    imageUrl: 'n7.png'
  },
  nh: {
    alName: '',
    imageUrl: 'nh.png'
  },
  nk: {
    alName: '',
    imageUrl: 'nk.png'
  },
  nz: {
    alName: '',
    imageUrl: 'nz.png'
  },
  oa: {
    alName: '',
    imageUrl: 'oa.png'
  },
  ok: {
    alName: '',
    imageUrl: 'ok.png'
  },
  os: {
    alName: '',
    imageUrl: 'os.png'
  },
  ou: {
    alName: '',
    imageUrl: 'ou.png'
  },
  oz: {
    alName: '',
    imageUrl: 'oz.png'
  },
  pd: {
    alName: '',
    imageUrl: 'pd.png'
  },
  pr: {
    alName: '',
    imageUrl: 'pr.png'
  },
  ps: {
    alName: '',
    imageUrl: 'ps.png'
  },
  qf: {
    alName: '',
    imageUrl: 'qf.png'
  },
  qr: {
    alName: '',
    imageUrl: 'qr.png'
  },
  qs: {
    alName: '',
    imageUrl: 'qs.png'
  },
  rj: {
    alName: '',
    imageUrl: 'rj.png'
  },
  sa: {
    alName: '',
    imageUrl: 'sa.png'
  },
  sk: {
    alName: '',
    imageUrl: 'sk.png'
  },
  sn: {
    alName: '',
    imageUrl: 'sn.png'
  },
  sq: {
    alName: '',
    imageUrl: 'sq.png'
  },
  su: {
    alName: '',
    imageUrl: 'su.png'
  },
  sv: {
    alName: '',
    imageUrl: 'sv.png'
  },
  sy: {
    alName: '',
    imageUrl: 'sy.png'
  },
  ta: {
    alName: '',
    imageUrl: 'ta.png'
  },
  tg: {
    alName: '',
    imageUrl: 'tg.png'
  },
  tk: {
    alName: '',
    imageUrl: 'tk.png'
  },
  tn: {
    alName: '',
    imageUrl: 'tn.png'
  },
  tp: {
    alName: '',
    imageUrl: 'tp.png'
  },
  u2: {
    alName: '',
    imageUrl: 'U2.png'
  },
  ua: {
    alName: '',
    imageUrl: 'ua.png'
  },
  un: {
    alName: '',
    imageUrl: 'un.png'
  },
  up: {
    alName: '',
    imageUrl: 'up.png'
  },
  us: {
    alName: '',
    imageUrl: 'us.png'
  },
  ux: {
    alName: '',
    imageUrl: 'ux.png'
  },
  va: {
    alName: '',
    imageUrl: 'va.png'
  },
  vc: {
    alName: '',
    imageUrl: 'vc.png'
  },
  vn: {
    alName: '',
    imageUrl: 'vn.png'
  },
  vs: {
    alName: '',
    imageUrl: 'vs.png'
  },
  vt: {
    alName: '',
    imageUrl: 'vt.png'
  },
  vu: {
    alName: '',
    imageUrl: 'vu.png'
  },
  vv: {
    alName: '',
    imageUrl: 'vv.png'
  },
  vw: {
    alName: '',
    imageUrl: 'vw.png'
  },
  vx: {
    alName: '',
    imageUrl: 'vx.png'
  },
  vy: {
    alName: '',
    imageUrl: 'vy.png'
  },
  wn: {
    alName: '',
    imageUrl: 'wn.png'
  },
  ws: {
    alName: '',
    imageUrl: 'ws.png'
  },
  ww: {
    alName: '',
    imageUrl: 'ww.png'
  },
  wy: {
    alName: '',
    imageUrl: 'wy.png'
  },
  xe: {
    alName: '',
    imageUrl: 'xe.png'
  },
  xl: {
    alName: '',
    imageUrl: 'xl.png'
  },
  yx: {
    alName: '',
    imageUrl: 'yx.png'
  },
  yy: {
    alName: '',
    imageUrl: 'yy.png'
  },
  zz: {
    alName: '',
    imageUrl: 'zz.png'
  }
};

const LogoContainer$1 = styled.span`
  width: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  display: inline-flex;
  align-items: center;

  img {
    width: 100%;
  }
`;
const AirlineLogo = _ref2 => {
  let {
    alCode,
    size
  } = _ref2;
  const alCodeLower = alCode.toLowerCase();
  const airlineObj = AirlineList[alCodeLower] || AirlineList.default;
  return /*#__PURE__*/React.createElement(LogoContainer$1, {
    size: size
  }, /*#__PURE__*/React.createElement("img", {
    alt: airlineObj.alName,
    src: `https://cdn.amtrav.com/airline-logos/${airlineObj.imageUrl}`
  }));
};
AirlineLogo.propTypes = {
  /**
   * Airline Code
   */
  alCode: PropTypes$1.string,
  /**
   * To avoid rastering on high-DPI displays, 35px should be the maximum size specified.
   */
  size: PropTypes$1.string
};
AirlineLogo.defaultProps = {
  alCode: 'YY',
  size: '35px'
};

const logoHeightTransform = {
  AD: 1.2,
  ES: 1.2,
  ET: 0.9,
  GI: 1.1,
  SC: 1.3,
  ZA: 0.7,
  ZH: 1.2,
  ZI: 0.8,
  ZR: 1.2
};
const validHeightCodes = Object.keys(logoHeightTransform);
const logoWidthTransform = {
  NU: 0.75,
  PR: 0.6,
  SC: 0.8,
  ZH: 0.7
};
const validWidthCodes = Object.keys(logoWidthTransform);
const getLogoTransformNum = (code, size, constrain) => {
  let sizeNum = 0;
  if (validHeightCodes.includes(code) && constrain === 'height') {
    sizeNum = parseInt(size, 10);
    const newSizeStr = `${logoHeightTransform[code] * sizeNum}px`;
    return newSizeStr;
  }
  if (validWidthCodes.includes(code) && constrain === 'width') {
    sizeNum = parseInt(size, 10);
    const newSizeStr = `${logoWidthTransform[code] * sizeNum}px`;
    return newSizeStr;
  }
  return size;
};
const LogoContainer = styled(Flex)`
  height: ${_ref => {
  let {
    size,
    constrain
  } = _ref;
  return constrain === 'height' ? size : 'auto';
}};
  width: ${_ref2 => {
  let {
    size,
    constrain
  } = _ref2;
  return constrain === 'width' ? size : 'auto';
}};
  align-items: center;
  justify-content: ${_ref3 => {
  let {
    constrain
  } = _ref3;
  return constrain === 'width' ? 'center' : 'unset';
}};

  img {
    max-height: ${_ref4 => {
  let {
    code,
    size,
    constrain
  } = _ref4;
  return constrain === 'height' ? getLogoTransformNum(code, size, constrain) : 'auto';
}};
    max-width: ${_ref5 => {
  let {
    code,
    size,
    constrain
  } = _ref5;
  return constrain === 'width' ? getLogoTransformNum(code, size, constrain) : 'auto';
}};
  }
`;
const LogoFallback = () => /*#__PURE__*/React.createElement("svg", {
  width: "60",
  height: "30",
  viewBox: "0 0 40 20"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "20",
  fill: "whitesmoke",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m5.5,8.42V3.74h.96v3.88h2.38v.79h-3.33Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.3,6.66c0-.3.07-.59.22-.87.15-.28.36-.5.63-.64s.58-.22.91-.22c.52,0,.94.17,1.28.5.33.34.5.76.5,1.27s-.17.94-.5,1.28c-.33.34-.76.51-1.26.51-.31,0-.61-.07-.9-.21-.29-.14-.5-.35-.65-.62-.15-.27-.22-.61-.22-1Zm.93.05c0,.34.08.6.24.78.16.18.36.27.6.27s.44-.09.6-.27c.16-.18.24-.44.24-.78s-.08-.59-.24-.77c-.16-.18-.36-.27-.6-.27s-.44.09-.6.27c-.16.18-.24.44-.24.78Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.46,8.64l1.04.13c.02.12.06.2.12.25.09.06.22.1.41.1.24,0,.41-.04.53-.11.08-.05.14-.12.18-.23.03-.07.04-.21.04-.41v-.5c-.27.37-.61.55-1.03.55-.46,0-.83-.19-1.09-.58-.21-.31-.32-.69-.32-1.14,0-.57.14-1.01.42-1.31s.62-.45,1.03-.45.77.19,1.05.56v-.48h.85v3.06c0,.4-.03.7-.1.9-.07.2-.16.36-.28.47-.12.11-.28.2-.48.27-.2.06-.46.1-.76.1-.58,0-.99-.1-1.24-.3-.24-.2-.37-.45-.37-.75,0-.03,0-.07,0-.11Zm.81-2c0,.36.07.63.21.8.14.17.31.25.52.25.22,0,.41-.09.56-.26.15-.17.23-.43.23-.77s-.07-.62-.22-.79c-.15-.17-.33-.26-.56-.26s-.4.08-.54.25c-.14.17-.21.42-.21.77Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.38,6.66c0-.3.07-.59.22-.87.15-.28.36-.5.63-.64s.58-.22.91-.22c.52,0,.94.17,1.28.5.33.34.5.76.5,1.27s-.17.94-.5,1.28c-.33.34-.76.51-1.26.51-.31,0-.61-.07-.9-.21-.29-.14-.5-.35-.65-.62-.15-.27-.22-.61-.22-1Zm.93.05c0,.34.08.6.24.78.16.18.36.27.6.27s.44-.09.6-.27c.16-.18.24-.44.24-.78s-.08-.59-.24-.77c-.16-.18-.36-.27-.6-.27s-.44.09-.6.27c-.16.18-.24.44-.24.78Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.48,8.42V3.7h.93l1.94,3.15v-3.15h.89v4.71h-.96l-1.91-3.07v3.07h-.89Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.03,6.66c0-.3.07-.59.22-.87s.36-.5.63-.64c.27-.15.58-.22.91-.22.52,0,.94.17,1.27.5.33.34.5.76.5,1.27s-.17.94-.5,1.28c-.33.34-.76.51-1.26.51-.31,0-.61-.07-.9-.21-.29-.14-.5-.35-.65-.62-.15-.27-.22-.61-.22-1Zm.93.05c0,.34.08.6.24.78.16.18.36.27.6.27s.44-.09.6-.27.24-.44.24-.78-.08-.59-.24-.77-.36-.27-.6-.27-.44.09-.6.27c-.16.18-.24.44-.24.78Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.85,5v.72h-.62v1.38c0,.28,0,.44.02.49.01.05.04.08.08.11.04.03.09.04.15.04.08,0,.21-.03.37-.09l.08.7c-.21.09-.45.14-.72.14-.16,0-.31-.03-.44-.08-.13-.05-.23-.13-.29-.21-.06-.09-.1-.2-.13-.35-.02-.1-.03-.32-.03-.64v-1.49h-.42v-.72h.42v-.68l.91-.53v1.21h.62Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.89,16.52v-4.71h3.25v.8h-2.29v1.12h1.98v.8h-1.98v2h-.96Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.71,14.77c0-.3.07-.59.22-.87.15-.28.36-.5.63-.64.27-.15.58-.22.91-.22.52,0,.94.17,1.28.5.33.33.5.76.5,1.27s-.17.94-.5,1.28c-.33.34-.76.51-1.26.51-.31,0-.61-.07-.9-.21s-.5-.35-.65-.62c-.15-.27-.22-.61-.22-1Zm.93.05c0,.34.08.6.24.78.16.18.36.27.6.27s.44-.09.6-.27c.16-.18.24-.44.24-.78s-.08-.59-.24-.77c-.16-.18-.36-.27-.6-.27s-.44.09-.6.27c-.16.18-.24.44-.24.78Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.21,16.52v-.51c-.12.18-.29.33-.49.43-.2.1-.42.16-.64.16s-.44-.05-.62-.15-.32-.24-.4-.42c-.08-.18-.12-.43-.12-.76v-2.16h.91v1.57c0,.48.02.77.05.88.03.11.09.19.18.26.09.06.2.09.34.09.15,0,.29-.04.42-.13.12-.08.21-.19.25-.31.04-.13.07-.43.07-.92v-1.44h.91v3.42h-.84Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.11,16.52h-.91v-1.74c0-.37-.02-.61-.06-.72-.04-.11-.1-.19-.19-.25-.09-.06-.19-.09-.32-.09-.16,0-.3.04-.42.13s-.21.2-.26.34c-.05.14-.07.4-.07.78v1.55h-.91v-3.42h.84v.5c.3-.39.68-.58,1.13-.58.2,0,.38.04.55.11.17.07.29.16.38.27s.14.24.18.38c.03.14.05.34.05.61v2.12Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.18,16.52h-.84v-.5c-.14.2-.3.34-.5.44-.19.09-.38.14-.58.14-.39,0-.73-.16-1.01-.47-.28-.32-.42-.76-.42-1.32s.14-1.02.41-1.32c.27-.3.62-.45,1.04-.45.38,0,.71.16.99.48v-1.7h.91v4.71Zm-2.42-1.78c0,.36.05.63.15.79.15.24.35.35.61.35.21,0,.39-.09.53-.27.15-.18.22-.44.22-.79,0-.39-.07-.67-.21-.85-.14-.17-.32-.26-.54-.26s-.4.09-.54.26c-.15.17-.22.42-.22.76Z",
  strokeWidth: "0"
})));
const CarVendorLogo = _ref6 => {
  let {
    carCode = '',
    size = '150px',
    constrain = 'width',
    ...rest
  } = _ref6;
  const carCodeLower = carCode.toLowerCase();
  const getCarUrlFragment = code => `${code}.png`;
  return /*#__PURE__*/React.createElement(LogoContainer, _extends({
    className: "car-vendor-cont",
    code: carCode,
    size: size,
    constrain: constrain,
    mb: "10px"
  }, rest), carCode === '_' ? /*#__PURE__*/React.createElement(LogoFallback, null) : /*#__PURE__*/React.createElement(Image, {
    alt: carCodeLower,
    src: `https://cdn.amtrav.com/cars-vendor-logos/${getCarUrlFragment(carCodeLower)}`,
    renderFallback: /*#__PURE__*/React.createElement(LogoFallback, null)
  }));
};
CarVendorLogo.propTypes = {
  /**
   * Car Vendor Code
   */
  carCode: PropTypes$1.string,
  size: PropTypes$1.string,
  constrain: PropTypes$1.oneOf(['width', 'height'])
};
CarVendorLogo.displayName = 'CarVendorLogo';

const CABIN_OPTIONS = [{
  value: 'Y',
  label: 'Lowest Fare'
}, {
  value: 'W',
  label: 'Premium Economy'
}, {
  value: 'C',
  label: 'Business'
}, {
  value: 'F',
  label: 'First'
}];
const PASSENGER_LABELS = {
  ADULT: 'Adult',
  ADULTS: 'Adults',
  SENIOR: 'Senior',
  SENIORS: 'Seniors',
  CHILD: 'Child',
  CHILDREN: 'Children',
  INFANT: 'Infant in Lap',
  INFANTS: 'Infants in Lap'
};
const truncateText = function (text) {
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  let suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return `${text.substr(0, length).trim()}${suffix}`;
};
const passengerOptionsSummary = (passengerData, withCabin) => {
  const {
    adults,
    seniors,
    children,
    infants,
    cabin
  } = passengerData;
  const totalPassengers = adults + seniors + children + infants;
  let cabinName = '';
  if (withCabin) {
    cabinName = CABIN_OPTIONS.find(o => o.value === cabin).label;
  }
  const getChipLabelStr = () => {
    const passengerCountArr = [adults, seniors, children, infants];
    const twoGreaterThanZero = arr => arr.filter(x => x > 0).length >= 2;
    const hasNumberCount = Object.entries(passengerData).filter(_ref => {
      let [, value] = _ref;
      return value > 0;
    });
    if (twoGreaterThanZero(passengerCountArr)) {
      return 'Travelers';
    }
    if (hasNumberCount[0] !== undefined) {
      const travelerType = hasNumberCount[0][0];
      const travelerTypeIsPlural = hasNumberCount[0][1] > 1;
      if (travelerType === 'adults' && !travelerTypeIsPlural) {
        return PASSENGER_LABELS.ADULT;
      }
      if (travelerType === 'adults' && travelerTypeIsPlural) {
        return PASSENGER_LABELS.ADULTS;
      }
      if (travelerType === 'seniors' && !travelerTypeIsPlural) {
        return PASSENGER_LABELS.SENIOR;
      }
      if (travelerType === 'seniors' && travelerTypeIsPlural) {
        return PASSENGER_LABELS.SENIORS;
      }
      if (travelerType === 'children' && !travelerTypeIsPlural) {
        return PASSENGER_LABELS.CHILD;
      }
      if (travelerType === 'children' && travelerTypeIsPlural) {
        return PASSENGER_LABELS.CHILDREN;
      }
    }
    if (totalPassengers > 1) {
      return 'Travelers';
    }
    return 'Traveler(s)';
  };
  const cabinText = withCabin ? `, ${truncateText(cabinName)}` : '';
  const filterText = `${totalPassengers} ${getChipLabelStr()}${cabinText}`;
  return filterText;
};

/* eslint-disable react/require-default-props */
const ClassDropdown = styled(DropdownSelect)`
  select {
    width: 100%;
    padding: 8px;
    border-color: ${getThemeProp('global.border--color')};
    font-size: inherit;
    font-family: ${getThemeProp('global.textBody--fontFamily')};
    color: ${getThemeProp('textfield.text--color')};
  }
`;
const applyBoundaries = val => val < 0 ? 0 : val;
const PassengerOptions = _ref => {
  let {
    passengerData,
    onChange = () => {},
    withCabin = true,
    inheritFontSize = false
  } = _ref;
  const {
    adults,
    seniors,
    children,
    infants,
    cabin
  } = passengerData;
  const changeHandler = update => onChange({
    ...passengerData,
    ...update
  });
  const themeContext = useContext(ThemeContext);
  const isTabletOrSmaller = isMatchedMaxWidth(`${themeContext.global['breakpointMD--size']}px`);
  const incrementorSize = isTabletOrSmaller ? 'medium' : 'small';
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Incrementor, {
    label: "Adult(s)",
    count: adults,
    onIncrement: () => changeHandler({
      adults: adults + 1
    }),
    onDecrement: () => changeHandler({
      adults: applyBoundaries(adults - 1)
    }),
    size: inheritFontSize ? 'inherit' : incrementorSize
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Incrementor, {
    label: "Senior(s) 65+",
    count: seniors,
    onIncrement: () => changeHandler({
      seniors: seniors + 1
    }),
    onDecrement: () => changeHandler({
      seniors: applyBoundaries(seniors - 1)
    }),
    size: inheritFontSize ? 'inherit' : incrementorSize
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Incrementor, {
    label: "Children (under 12)",
    count: children,
    onIncrement: () => changeHandler({
      children: children + 1
    }),
    onDecrement: () => changeHandler({
      children: applyBoundaries(children - 1)
    }),
    size: inheritFontSize ? 'inherit' : incrementorSize
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Incrementor, {
    label: "Infant in Lap",
    count: infants,
    onIncrement: () => changeHandler({
      infants: infants + 1
    }),
    onDecrement: () => changeHandler({
      infants: applyBoundaries(infants - 1)
    }),
    size: inheritFontSize ? 'inherit' : incrementorSize
  })), withCabin ? /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(ClassDropdown, {
    value: cabin,
    options: CABIN_OPTIONS,
    onChange: e => changeHandler({
      cabin: e.target.value
    })
  })) : null);
};
const passengerDataShape$1 = {
  adults: PropTypes.number,
  seniors: PropTypes.number,
  children: PropTypes.number,
  infants: PropTypes.number,
  cabin: PropTypes.string
};
PassengerOptions.propTypes = {
  passengerData: PropTypes.shape(passengerDataShape$1),
  onChange: PropTypes.func,
  withCabin: PropTypes.bool,
  inheritFontSize: PropTypes.bool
};

/* eslint-disable react/require-default-props */
const FlexRegion = styled(Flex)`
  ${TextInputContainer} {
    width: 100%;
  }
`;
const PassengersFilterChip = _ref => {
  let {
    data,
    onChange = () => {},
    withCabin = true,
    kind = ''
  } = _ref;
  return /*#__PURE__*/React.createElement(Popover, {
    triggerDisplayProperty: "flex",
    content: /*#__PURE__*/React.createElement(PassengerOptions, {
      passengerData: data,
      onChange: onChange,
      withCabin: withCabin
    })
  }, /*#__PURE__*/React.createElement(FlexRegion, {
    width: 1
  }, /*#__PURE__*/React.createElement(TextInput, {
    kind: kind,
    readonly: true,
    suffixContent: /*#__PURE__*/React.createElement(IconLine, {
      strokeWidth: 1.5,
      icon: "ChevronDown"
    }),
    fullWidth: true,
    value: passengerOptionsSummary(data, withCabin),
    onChange: onChange
  })));
};
const passengerDataShape = {
  adults: PropTypes.number,
  seniors: PropTypes.number,
  children: PropTypes.number,
  infants: PropTypes.number,
  cabin: PropTypes.string
};
PassengersFilterChip.propTypes = {
  data: PropTypes.shape(passengerDataShape),
  // onReset: PropTypes.func,
  onChange: PropTypes.func,
  withCabin: PropTypes.bool,
  kind: PropTypes.string
};

const OnlyRegion = styled.div`
  display: flex;
  position: absolute;
  right: 0;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    top: 4px;
  }
`;
const LabelText$1 = styled.span`
  color: ${_ref => {
  let {
    isDisabled
  } = _ref;
  return isDisabled ? '#999' : 'inherit';
}};
`;
const AirlineName = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
`;
const AirlineNameLabel = styled(Flex)`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
`;
const AirlineCheckboxRegion = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;

  ${CheckboxContainer} {
    display: flex;
    height: 38px;

    ${media.XLargeOnly`
      height: 30px;
    `}
  }

  ${media.XLargeOnly`
    ${OnlyRegion} {
      display: none;
    }
    &:hover {
      ${OnlyRegion} {
        display: block;
      }

      ${AirlineName} {
        color: ${props => props.isDisabled ? 'unset' : getThemeProp('global.link--color')(props)};
      }
    }
  `}
`;
const AirlineCheckbox = styled(Checkbox)`
  width: 100%;

  ${CheckboxLabel} {
    display: flex;
    align-items: center;
  }

  ${CheckboxLabelText} {
    color: ${_ref2 => {
  let {
    isDisabled
  } = _ref2;
  return isDisabled ? '#999' : 'inherit';
}};
  }

  @media (hover: hover) {
    &:hover {
      ${props => !props.isDisabled && css`
          cursor: pointer;
          color: ${getThemeProp('global.link--color')(props)};
        `};
    }
  }
`;
const PreferredMarkFlex = styled(Flex)`
  display: inline-flex;
`;
const ChipCheckbox = _ref3 => {
  let {
    label,
    disabled,
    onlyButton,
    isPreferred,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(AirlineCheckboxRegion, {
    isDisabled: disabled
  }, /*#__PURE__*/React.createElement(AirlineCheckbox, _extends({
    label: /*#__PURE__*/React.createElement(LabelText$1, {
      isDisabled: disabled
    }, /*#__PURE__*/React.createElement(Box, {
      pl: 2
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(AirlineNameLabel, null, label), isPreferred && /*#__PURE__*/React.createElement(PreferredMarkFlex, {
      pl: 1
    }, /*#__PURE__*/React.createElement(PreferredMark, null))))),
    disabled: disabled
  }, rest)), onlyButton && /*#__PURE__*/React.createElement(OnlyRegion, null, onlyButton));
};
ChipCheckbox.propTypes = {
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onlyButton: PropTypes.node,
  isPreferred: PropTypes.bool
};
ChipCheckbox.defaultProps = {
  disabled: false,
  onlyButton: null,
  isPreferred: false
};

const Header = styled(Box)`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  opacity: 0.6;
  font-weight: 600;
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const ChipHeader = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Header, rest, children);
};
ChipHeader.propTypes = {
  children: PropTypes.node.isRequired
};

const PanelHeader = styled(Flex)`
  background: white;
  width: 100%;
  flex-shrink: 0;
  box-shadow: 0 -1px 0 ${getTokenValue(THEME_TOKENS.base.color.neutral400)} inset;
`;
const BackText = styled(Flex)`
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};

  &:hover {
    cursor: pointer;
  }
`;
const OverlayPanelHeader = _ref => {
  let {
    children,
    onClose = () => {}
  } = _ref;
  return /*#__PURE__*/React.createElement(PanelHeader, {
    p: 3,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, children), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(BackText, {
    mr: 2,
    onClick: onClose
  }, "Back to results"), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    round: true,
    minimal: true,
    bordered: true,
    icon: /*#__PURE__*/React.createElement(IconClose, null)
  })));
};
OverlayPanelHeader.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func
};

const PanelBody = styled(Box)`
  width: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  overflow-x: auto;
  flex: 1 1 0px;

  background-color: ${getTokenValue(THEME_TOKENS.base.color.neutral100)};
`;
const OverlayPanelBody = _ref => {
  let {
    children,
    noPadding = false
  } = _ref;
  return /*#__PURE__*/React.createElement(PanelBody, {
    p: noPadding ? 0 : 3
  }, children);
};
OverlayPanelBody.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool
};

const PanelFooter = styled(Flex)`
  background: white;
  box-shadow: 0 1px 0 ${getTokenValue(THEME_TOKENS.base.color.neutral400)} inset;
  flex-shrink: 0;
`;
const OverlayPanelFooter = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(PanelFooter, _extends({
    justifyContent: "flex-end",
    p: 3
  }, rest), children);
};
OverlayPanelFooter.propTypes = {
  children: PropTypes.node.isRequired
};

const ModalContext = /*#__PURE__*/createContext({});
const OverlayPanel = _ref => {
  let {
    onClose,
    noPadding,
    ...rest
  } = _ref;
  const providerProps = useMemo(() => ({
    onClose,
    noPadding
  }), [onClose]);
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: providerProps
  }, /*#__PURE__*/React.createElement(Modal, _extends({
    fullscreen: true,
    drawer: true,
    overlayColor: "transparent",
    onClose: onClose
  }, rest)));
};
OverlayPanel.propTypes = {
  onClose: PropTypes.func,
  noPadding: PropTypes.bool
};
OverlayPanel.Header = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    onClose
  } = useContext(ModalContext);
  return /*#__PURE__*/React.createElement(OverlayPanelHeader, {
    onClose: onClose
  }, children);
};
OverlayPanel.Header.propTypes = {
  children: PropTypes.node.isRequired
};
OverlayPanel.Body = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    noPadding
  } = useContext(ModalContext);
  return /*#__PURE__*/React.createElement(OverlayPanelBody, {
    noPadding: noPadding
  }, children);
};
OverlayPanel.Body.propTypes = {
  children: PropTypes.node.isRequired
};
OverlayPanel.Footer = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement(OverlayPanelFooter, null, children);
};
OverlayPanel.Footer.propTypes = {
  children: PropTypes.node.isRequired
};

const ButtonWrapper = styled.div`
  z-index: 1;
  visibility: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'hidden' : 'visible';
}};
`;
const PrevButton = _ref2 => {
  let {
    enabled,
    onClick,
    size,
    innerOverlayButtons
  } = _ref2;
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    disabled: !enabled
  }, /*#__PURE__*/React.createElement(Button, {
    size: size,
    onClick: onClick,
    icon: /*#__PURE__*/React.createElement(IconPrevious, null),
    disabled: !enabled,
    bordered: size !== 'small' || innerOverlayButtons
  }));
};
PrevButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string,
  innerOverlayButtons: PropTypes.bool
};
PrevButton.defaultProps = {
  size: 'medium'
};
const NextButton = _ref3 => {
  let {
    enabled,
    onClick,
    size,
    innerOverlayButtons
  } = _ref3;
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    disabled: !enabled
  }, /*#__PURE__*/React.createElement(Button, {
    size: size,
    onClick: onClick,
    icon: /*#__PURE__*/React.createElement(IconNext, null),
    disabled: !enabled,
    bordered: size !== 'small' || innerOverlayButtons
  }));
};
NextButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string,
  innerOverlayButtons: PropTypes.bool
};
NextButton.defaultProps = {
  size: 'medium'
};

const dotSize = '6px';
const DotSlide = styled.div`
  flex: 0 0 14px;
  min-width: 0;
  padding-top: 3px;
  padding-bottom: 3px;
`;
const DotSlideButton = styled.div`
  -webkit-appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: block;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  opacity: ${_ref => {
  let {
    selected
  } = _ref;
  return selected ? 1 : 0.4;
}};
  transition: opacity 0.2s;
`;
const DotSlideCircle = styled.div`
  width: ${dotSize};
  height: ${dotSize};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.36);
`;
const DotButton = _ref2 => {
  let {
    selected,
    onClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(DotSlide, null, /*#__PURE__*/React.createElement(DotSlideButton, {
    selected: selected,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(DotSlideCircle, null)));
};
DotButton.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

/* eslint-disable react/no-array-index-key */
const Embla = styled(Box)`
  position: relative;
  max-width: 100%;

  ${_ref => {
  let {
    hoverButtons
  } = _ref;
  return hoverButtons && css`
      .ats-carousel-buttons {
        visibility: hidden;
        opacity: 0;
        transition: all 0.2s ease-out;
      }

      :hover {
        .ats-carousel-buttons {
          visibility: visible;
          opacity: 1;
          transition: all 0.2s ease-in;
        }
      }
    `;
}};
`;
const Viewport = styled.div`
  overflow: hidden;
  position: relative;
  z-index: 1;

  &.is-draggable {
    cursor: move;
    cursor: grab;

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      cursor: default;
    }
  }

  &.is-dragging {
    cursor: grabbing;

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      cursor: default;
    }
  }
`;
const CarouselContainer = styled.div`
  display: flex;
  will-change: transform;
  align-items: center;
`;
const Slide = styled.div`
  flex: 0 0 auto;
  min-width: ${_ref2 => {
  let {
    slideWidth
  } = _ref2;
  return slideWidth;
}};
  position: relative;
`;
const SlideInner = styled.div``;
const PageCount = styled.div`
  position: relative;
  display: flex;
  list-style: none;
  padding-left: 0;
  justify-content: center;
  font-weight: 600;
  opacity: 0.6;
`;
const Navigator = styled(Flex)`
  ${_ref3 => {
  let {
    overlayButtons
  } = _ref3;
  return overlayButtons && css`
      display: none;

      ${media.Large`
        display: flex;
        position: absolute;
        top: calc(50% - 11px);
        left: -35px;
        right: -35px;
        z-index: 0;
      `}
    `;
}};

  ${_ref4 => {
  let {
    innerOverlayButtons
  } = _ref4;
  return innerOverlayButtons && css`
      display: none;

      ${media.Large`
        display: flex;
        position: absolute;
        top: calc(50% - 11px);
        left: -4px;
        right: -4px;
        z-index: 1;
      `}
    `;
}};
`;
const DotsContainer = styled.div`
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%, 0);
  /* base this off 14px dot width
    14 X 6 max */
  width: ${_ref5 => {
  let {
    numDots
  } = _ref5;
  return numDots > 5 ? 84 : numDots * 14;
}}px;
  z-index: 1;
`;
const DotsViewport = styled.div`
  overflow: hidden;
`;
const DotsLayout = styled.div`
  display: flex;
  flex-direction: row;
`;
const EmblaCarousel = _ref6 => {
  let {
    children,
    showDots,
    showCount,
    slideWidth,
    loopSlides,
    overlayButtons,
    innerOverlayButtons,
    hoverButtons,
    dragFree = false
  } = _ref6;
  const emblaConfig = {
    loop: loopSlides,
    align: loopSlides ? 'center' : 'start',
    dragFree,
    containScroll: loopSlides ? '' : 'trimSnaps'
  };
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel(emblaConfig);
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);
  const slideComponents = React.Children.toArray(children);
  const slides = Array.from(slideComponents.keys());
  const slideLength = slideComponents.length;
  const scrollPrev = useCallback(() => emblaMainApi.scrollPrev(), [emblaMainApi]);
  const scrollNext = useCallback(() => emblaMainApi.scrollNext(), [emblaMainApi]);
  const onThumbClick = useCallback(index => {
    if (!emblaMainApi || !emblaThumbsApi) return;
    if (emblaThumbsApi.clickAllowed()) emblaMainApi.scrollTo(index);
  }, [emblaMainApi, emblaThumbsApi]);
  useEffect(() => {
    const onSelect = () => {
      setSelectedIndex(emblaMainApi.selectedScrollSnap());
      setPrevBtnEnabled(emblaMainApi.canScrollPrev());
      setNextBtnEnabled(emblaMainApi.canScrollNext());
      if (emblaThumbsApi) {
        emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap());
      }
    };
    if (emblaMainApi) {
      emblaMainApi.reInit();
      setScrollSnaps(emblaMainApi.scrollSnapList());
      emblaMainApi.on('select', onSelect);
      onSelect();
    }
  }, [emblaMainApi, slideLength]);
  return /*#__PURE__*/React.createElement(Embla, {
    hoverButtons: hoverButtons
  }, /*#__PURE__*/React.createElement(Viewport, {
    ref: emblaMainRef
  }, /*#__PURE__*/React.createElement(CarouselContainer, null, slideComponents.map((child, index) => /*#__PURE__*/React.createElement(Slide, {
    slideWidth: slideWidth,
    key: index
  }, /*#__PURE__*/React.createElement(SlideInner, null, child)))), showDots && /*#__PURE__*/React.createElement(DotsContainer, {
    numDots: slideLength
  }, /*#__PURE__*/React.createElement(DotsViewport, {
    ref: emblaThumbsRef
  }, /*#__PURE__*/React.createElement(DotsLayout, null, slides.map(index => /*#__PURE__*/React.createElement(DotButton, {
    onClick: () => onThumbClick(index),
    selected: index === selectedIndex,
    index: index,
    key: index
  })))))), /*#__PURE__*/React.createElement(Navigator, {
    overlayButtons: overlayButtons,
    innerOverlayButtons: innerOverlayButtons,
    pt: overlayButtons || innerOverlayButtons ? 0 : 2,
    mx: overlayButtons || innerOverlayButtons ? 2 : 0,
    justifyContent: overlayButtons || innerOverlayButtons ? 'space-between' : 'space-around',
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ats-carousel-buttons"
  }, /*#__PURE__*/React.createElement(PrevButton, {
    size: overlayButtons || innerOverlayButtons ? 'small' : 'medium',
    onClick: scrollPrev,
    enabled: prevBtnEnabled,
    innerOverlayButtons: innerOverlayButtons
  })), showCount && /*#__PURE__*/React.createElement(PageCount, null, `${selectedIndex + 1} of ${scrollSnaps.length}`), /*#__PURE__*/React.createElement("div", {
    className: "ats-carousel-buttons"
  }, /*#__PURE__*/React.createElement(NextButton, {
    size: overlayButtons || innerOverlayButtons ? 'small' : 'medium',
    onClick: scrollNext,
    enabled: nextBtnEnabled,
    innerOverlayButtons: innerOverlayButtons
  }))));
};
EmblaCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  showDots: PropTypes.bool.isRequired,
  showCount: PropTypes.bool.isRequired,
  slideWidth: PropTypes.string.isRequired,
  loopSlides: PropTypes.bool.isRequired,
  overlayButtons: PropTypes.bool.isRequired,
  innerOverlayButtons: PropTypes.bool,
  hoverButtons: PropTypes.bool,
  dragFree: PropTypes.bool
};

const Carousel = _ref => {
  let {
    children,
    showDots,
    showCount,
    slideWidth,
    loopSlides,
    overlayButtons,
    innerOverlayButtons,
    hoverButtons,
    dragFree
  } = _ref;
  if (children.length && children.length > 1) {
    return /*#__PURE__*/React.createElement(EmblaCarousel, {
      overlayButtons: overlayButtons,
      innerOverlayButtons: innerOverlayButtons,
      hoverButtons: hoverButtons,
      dragFree: dragFree,
      loopSlides: loopSlides,
      slideWidth: slideWidth,
      showDots: showDots,
      showCount: showCount
    }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Show dots with active slide indicator.
   */
  showDots: PropTypes.bool,
  /**
   * Width of each slide
   */
  slideWidth: PropTypes.string,
  /**
   * Enable infinite looping.
   */
  loopSlides: PropTypes.bool,
  /**
   * Overlay navigation buttons on top of slides.
   */
  overlayButtons: PropTypes.bool,
  /**
   * Overlay navigation buttons inside container.
   */
  innerOverlayButtons: PropTypes.bool,
  /**
   * Shows prev & next buttons on hover if innerOverlayButtons is true.
   */
  hoverButtons: PropTypes.bool,
  /**
   * Enables momentum scrolling while disabling snapping.
   */
  dragFree: PropTypes.bool,
  /**
   * Show image count (ex. 1 of 12)
   */
  showCount: PropTypes.bool
};
Carousel.defaultProps = {
  slideWidth: '100%',
  showDots: false,
  loopSlides: true,
  overlayButtons: false,
  showCount: false
};

const getKindColor$2 = props => {
  switch (props.kind) {
    case 'warning':
      return getThemeProp('global.warning--color')(props);
    case 'danger':
      return getThemeProp('global.danger--color')(props);
    case 'success':
      return getThemeProp('global.success--color')(props);
    default:
      return getThemeProp('button.primary--color')(props);
  }
};
const BoxDialogTitle = styled(Box)`
  color: ${getKindColor$2};
  font-styled: bold;
  font-size: 20px;
`;
const Dialog = _ref => {
  let {
    title,
    kind,
    primaryAction,
    primaryActionText,
    primaryActionIsLoading,
    secondaryAction,
    secondaryActionText,
    onClose,
    children,
    closeOnEsc = false,
    closeOnOverlayClick = false
  } = _ref;
  const showSecondaryAction = secondaryActionText.length > 0;
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    closeOnEsc: closeOnEsc,
    closeOnOverlayClick: closeOnOverlayClick
  }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, title && /*#__PURE__*/React.createElement(BoxDialogTitle, {
    kind: kind,
    pb: 4
  }, title), children)), /*#__PURE__*/React.createElement(Modal.Footer, null, showSecondaryAction && /*#__PURE__*/React.createElement(Box, {
    pr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    kind: kind,
    onClick: secondaryAction,
    bordered: true,
    text: secondaryActionText
  })), /*#__PURE__*/React.createElement(Button, {
    kind: kind,
    onClick: primaryAction,
    text: primaryActionText,
    isLoading: primaryActionIsLoading
  })));
};
Dialog.propTypes = {
  /**
   * The title of the `Dialog` – typically the purpose of the primary action.
   */
  title: PropTypes.string,
  /**
   * onClose is called when user presses the _esc_ key to dismiss the `Dialog`
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Primary action that user can do with the Dialog.
   */
  primaryAction: PropTypes.func.isRequired,
  /**
   * Text of primary action.
   */
  primaryActionText: PropTypes.string.isRequired,
  /**
   * Loading state of primary action.
   */
  primaryActionIsLoading: PropTypes.bool,
  /**
   * Secondary action that user can do with the Dialog - typically a cancel or close option.
   */
  secondaryAction: PropTypes.func,
  /**
   * Text of secondary action.
   */
  secondaryActionText: PropTypes.string,
  kind: PropTypes.oneOf(['primary', 'success', 'warning', 'danger']),
  /**
   * Content of the dialog, i.e. description of the action the Dialog performs.
   */
  children: PropTypes.node,
  /**
   * If clicking the overlay should close the dialog.
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * If pressing the esc key should close the dialog.
   */
  closeOnEsc: PropTypes.bool
};
Dialog.defaultProps = {
  title: '',
  kind: 'primary',
  primaryActionIsLoading: false,
  secondaryAction: () => {},
  secondaryActionText: '',
  children: void 0
};

const ListStyled$1 = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
const Item = styled.li`
  margin: 0;
  padding: 0.4em 0.25em;

  ${media.Small`
    padding: 0.4em 1.25em;
  `}
`;
const IconBullet = styled(Box)`
  font-size: 1.25em;
`;
const ItemBullet = styled.span`
  list-style: square;
  display: list-item;
  list-style-position: inside;
`;
const ListItem$1 = _ref => {
  let {
    children,
    icon
  } = _ref;
  return /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, icon ? /*#__PURE__*/React.createElement(IconBullet, {
    pt: "2px",
    pr: 2
  }, icon) : /*#__PURE__*/React.createElement(ItemBullet, null), /*#__PURE__*/React.createElement(Box, null, children)));
};
ListItem$1.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node
};
ListItem$1.defaultProps = {
  icon: null
};
const List = _ref2 => {
  let {
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, rest, /*#__PURE__*/React.createElement(ListStyled$1, null, children));
};
List.propTypes = {
  children: PropTypes.node.isRequired
};
List.Item = ListItem$1;

const AutocompleteRenderer = _ref => {
  let {
    items,
    selectedItem,
    defaultSelectedItem,
    onChange,
    suggestionsCount,
    itemToString,
    labelKey,
    children: renderFunction,
    ...rest
  } = _ref;
  const [isInFocus, updateInputFocus] = useState(false);
  const [controlledSelectedItem, updateControlledSelectedItem] = useState(defaultSelectedItem);
  const isUncontrolled = selectedItem === undefined;
  const someRef = useRef(null);
  if (selectedItem !== undefined && defaultSelectedItem !== undefined) {
    console.warn('`selectedItem` prop is set, the component is controlled. Do not use `defaultSelectedItem`' + ' when using `selectedItem` Prop. The `defaultSelectedItem` is ignored in this case.');
  }
  if (selectedItem === undefined && defaultSelectedItem === undefined) {
    console.warn('`selectedItem` and `defaultSelectedItem` are both undefined. Pick one and set default it to null.' + ' Use `selectedItem` Prop for a controlled component. Use `defaultSelectedItem` for uncontrolled.');
  }
  const changeHandler = selection => {
    onChange(selection);
    if (isUncontrolled) {
      updateControlledSelectedItem(selection);
    }
    // take focus away from the text input so if user clicks on it the options will reappear
    if (someRef.current) {
      someRef.current.focus();
    }
  };
  return /*#__PURE__*/React.createElement(Downshift, _extends({
    selectedItem: isUncontrolled ? controlledSelectedItem : selectedItem,
    onChange: changeHandler,
    itemToString: itemToString
  }, rest), downshiftProps => {
    const filteredItems = items.filter(item => {
      return !downshiftProps.inputValue || item[labelKey].toLocaleLowerCase().includes(downshiftProps.inputValue.toLocaleLowerCase());
    });
    const dropdownProps = {
      items,
      defaultSelectedItem,
      filteredItems,
      suggestionsCount,
      someRef,
      isInFocus,
      selectedItem: isUncontrolled ? controlledSelectedItem : selectedItem,
      updateInputFocus,
      autocomplete: 'downshift'
    };
    return /*#__PURE__*/React.createElement("div", null, renderFunction(downshiftProps, dropdownProps));
  });
};
AutocompleteRenderer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemToString: PropTypes.func.isRequired,
  /**
   * Callback function which provides the selected traveler object as an argument.
   */
  onChange: PropTypes.func,
  defaultSelectedItem: PropTypes.shape({}),
  selectedItem: PropTypes.shape({}),
  /**
   * Maximum options to show in drop down.
   */
  suggestionsCount: PropTypes.number,
  /**
   * the property within the item shape to be used for a label.
   */
  labelKey: PropTypes.string,
  /**
   * This is a function provided as a child of the component. This function will be called and given props that
   * can be used to compose a calendar.
   */
  children: PropTypes.func.isRequired
};
AutocompleteRenderer.defaultProps = {
  suggestionsCount: 10,
  // eslint-disable-next-line no-console
  onChange: () => console.warn('No onChange handler was passed to this component.'),
  selectedItem: undefined,
  defaultSelectedItem: undefined,
  labelKey: 'label'
};

/* eslint-disable max-len */
const DropDownContainer$1 = styled.div`
  position: relative;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
`;
const ComboBox = styled(Flex)`
  position: relative;
  background-color: ${getThemeProp('global.light--color')};
  border-style: solid;
  border-width: ${getThemeProp('button.borderWidth--standard')};
  border-color: ${getThemeProp('global.border--color')};
  border-radius: ${getThemeProp('button.borderRadius--size')};
  max-width: 100%;
  min-width: 220px;
  align-items: center;

  &:focus {
    outline: none;
  }

  ${props => props.isInFocus && css`
      border-color: ${getThemeProp('global.border--focus--color')};
    `}
`;
const RightAlignedChevron = styled(IconChevron)`
  position: absolute;
  bottom: 11px;
  right: 10px;
  z-index: 10;
  pointer-events: none;
`;
const ComboBoxLabel = styled(Box)`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  padding: 14px 0 12px;
  align-self: center;
`;
const ComboBoxInputContainer = styled(Box)`
  background-color: ${getThemeProp('textfield.background--color')};
  border: 1px solid ${getThemeProp('textfield.background--color')};
  border-radius: ${getThemeProp('button.borderRadius--size')};
`;
const ComboBoxInput = styled.input`
  font-size: 14px;
  background-color: ${getThemeProp('textfield.background--color')};
  border: none;
  padding: 4px 10px;
  width: 100%;
  height: 36px;
  outline: 0;
  border-top-right-radius: ${getThemeProp('button.borderRadius--size')};
  border-bottom-right-radius: ${getThemeProp('button.borderRadius--size')};

  &:focus {
    background-color: ${getThemeProp('textfield.background--focus--color')};
  }
`;
const FloatingList = styled.ul`
  position: absolute;
  top: 47px;
  left: 0;
  list-style: none;
  width: 100%;
  border-bottom: 1px solid ${getThemeProp('global.border--focus--color')};
  border-left: 1px solid ${getThemeProp('global.border--focus--color')};
  border-right: 1px solid ${getThemeProp('global.border--focus--color')};
  border-radius: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: ${ZINDEX.DROPDOWN};
`;
const ListItem = styled.li`
  background-color: ${props => props.isSelectedItem || props['aria-selected'] ? getThemeProp('global.border--focus--color') : getThemeProp('textfield.background--color')};
  color: ${getThemeProp('global.textBody--color')};
  padding: 8px 0 8px 16px;
  border-top: 1px solid ${getThemeProp('global.border--focus--color')};
  border-color: ${getThemeProp('global.border--focus--color')};
  font-size: 16px;
  font-weight: ${props => props.isSelectedItem ? 'bold' : 'normal'};

  &:hover {
    background-color: ${getThemeProp('global.border--focus--color')};
  }
`;
const LastListItem = styled(ListItem)`
  background-color: ${getThemeProp('global.light--color')};
  text-align: left;
`;
const AutocompleteInput = _ref => {
  let {
    items,
    onChange,
    suggestionsCount,
    defaultSelectedItem,
    itemToString,
    labelKey,
    placeholder,
    inputLabel
  } = _ref;
  const label = typeof inputLabel === 'string' ? /*#__PURE__*/React.createElement(ComboBoxLabel, null, inputLabel) : inputLabel;
  return /*#__PURE__*/React.createElement(DropDownContainer$1, null, /*#__PURE__*/React.createElement(AutocompleteRenderer, {
    items: items,
    defaultSelectedItem: defaultSelectedItem,
    onChange: onChange,
    itemToString: itemToString,
    suggestionsCount: suggestionsCount,
    labelKey: labelKey
  }, (downshiftProps, dropdownProps) => {
    const {
      getInputProps,
      getLabelProps,
      getMenuProps,
      getItemProps,
      isOpen,
      openMenu,
      setState
    } = downshiftProps;
    const {
      filteredItems,
      someRef,
      isInFocus,
      selectedItem,
      updateInputFocus
    } = dropdownProps;
    const filteredTotal = filteredItems.length;
    let filteredList = filteredItems.slice(0, suggestionsCount).map((item, index) => /*#__PURE__*/React.createElement(ListItem, getItemProps({
      key: item[labelKey],
      index,
      item,
      isSelectedItem: selectedItem ? item[labelKey] === selectedItem[labelKey] : false
    }), /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Box, null, item[labelKey]))));
    if (filteredTotal > suggestionsCount) {
      filteredList = filteredList.concat(/*#__PURE__*/React.createElement(LastListItem, {
        key: "last-item"
      }, filteredTotal - suggestionsCount, " more results. Type to filter."));
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ComboBox, {
      flexWrap: "nowrap",
      isInFocus: isInFocus,
      ref: someRef,
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Box, getLabelProps({
      flex: '0 0 76px'
    }), label), /*#__PURE__*/React.createElement(ComboBoxInputContainer, {
      flex: "1 0 auto"
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(ComboBoxInput, getInputProps({
      placeholder,
      onFocus: () => {
        setState({
          highlightedIndex: null,
          inputValue: ''
        });
        updateInputFocus(true);
        openMenu();
      },
      onBlur: () => updateInputFocus(false)
    })))), /*#__PURE__*/React.createElement(RightAlignedChevron, {
      rotate: isOpen ? 180 : 0
    })), isOpen ? /*#__PURE__*/React.createElement(FloatingList, getMenuProps(), filteredList) : null);
  }));
};
AutocompleteInput.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /**
   * A function that is called on each item in the items array. The function should return the string used for search.
   */
  itemToString: PropTypes.func.isRequired,
  /**
   * Callback function which provides the selected item object as an argument.
   */
  onChange: PropTypes.func,
  /**
   * The default item that is selected on component creation
   */
  defaultSelectedItem: PropTypes.shape({}),
  /**
   * Maximum options to show in drop down.
   */
  suggestionsCount: PropTypes.number,
  /**
   * the property within the item shape to be used for a label.
   */
  labelKey: PropTypes.string,
  /**
   * A string that can be put in the placeholder attribute of the text field.
   */
  placeholder: PropTypes.string,
  /**
   * A string or component that will be placed inside the input label. If a string
   * is provided it will be wrapped in the `ComboBoxLabel` styled component. No styling
   * or centering is given to a non-string value.
   */
  inputLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
AutocompleteInput.defaultProps = {
  suggestionsCount: 10,
  // eslint-disable-next-line no-console
  onChange: () => console.warn('No onChange handler was passed to this component.'),
  defaultSelectedItem: null,
  labelKey: 'label',
  placeholder: 'Type or select...',
  inputLabel: 'Search'
};

/* eslint-disable max-len */
const PoweredByAmTrav = _ref => {
  let {
    dark
  } = _ref;
  const fillColor = dark ? '#14140f' : '#fff';
  return /*#__PURE__*/React.createElement("svg", {
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "145",
    height: "25",
    viewBox: "0 0 145 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.13,16.23h1.43v.52c.3-.42.9-.69,1.58-.69,1.51,0,2.56,1.17,2.56,2.74s-1.06,2.73-2.56,2.73c-.69,0-1.3-.29-1.57-.68v2.6h-1.42v-6.26c0-.41-.01-.75-.02-.95ZM6.2,18.79c0-.88-.56-1.49-1.33-1.49s-1.33.61-1.33,1.49.56,1.47,1.33,1.47,1.33-.59,1.33-1.47Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,18.79c0-1.54,1.1-2.74,2.84-2.74s2.84,1.2,2.84,2.74-1.11,2.73-2.84,2.73-2.84-1.2-2.84-2.73ZM12.47,18.79c0-.88-.56-1.49-1.33-1.49s-1.33.61-1.33,1.49.55,1.47,1.33,1.47,1.33-.61,1.33-1.47Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31,16.23h1.49l.66,3.96h.22l.66-3.96h2.39l.66,3.96h.22l.66-3.96h1.48l-.98,5.12h-2.48l-.66-3.96h-.22l-.66,3.96h-2.45l-.99-5.12Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12,18.78c0-1.63,1.09-2.73,2.71-2.73s2.52.97,2.54,2.67c.01.1.01.22,0,.4h-3.83c.1.76.56,1.21,1.29,1.21.56,0,.97-.25,1.12-.73h1.41c-.18,1.11-1.19,1.91-2.52,1.91-1.61,0-2.72-1.1-2.72-2.74ZM26.94,18.13c-.1-.63-.51-1-1.13-1s-1.03.34-1.2,1h2.33Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.15,16.23h1.47v.63c.22-.37.7-.73,1.36-.73.19,0,.35.02.45.04v1.32c-.11-.01-.22-.02-.33-.02-.95,0-1.47.56-1.47,1.5v2.38h-1.46v-4.17l-.02-.95Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.57,18.78c0-1.63,1.09-2.73,2.71-2.73s2.52.97,2.54,2.67c.01.1.01.22,0,.4h-3.83c.1.76.56,1.21,1.29,1.21.56,0,.97-.25,1.12-.73h1.41c-.18,1.11-1.19,1.91-2.52,1.91-1.61,0-2.72-1.1-2.72-2.74ZM36.39,18.13c-.1-.63-.51-1-1.13-1s-1.03.34-1.2,1h2.33Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,18.78c0-1.57,1.06-2.73,2.55-2.73.69,0,1.29.28,1.57.67v-2.58h1.43v6.26c0,.41.01.75.02.95h-1.44v-.51c-.3.42-.89.68-1.58.68-1.5,0-2.55-1.17-2.55-2.74ZM42.56,18.78c0-.88-.55-1.47-1.33-1.47s-1.32.59-1.32,1.47.55,1.49,1.32,1.49,1.33-.61,1.33-1.49Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.96,20.83v.52h-1.43c.01-.2.02-.54.02-.95v-6.26h1.42v2.6c.28-.4.88-.68,1.57-.68,1.51,0,2.56,1.16,2.56,2.73s-1.06,2.74-2.56,2.74c-.68,0-1.29-.28-1.58-.69ZM51.6,18.78c0-.88-.55-1.47-1.33-1.47s-1.33.59-1.33,1.47.56,1.49,1.33,1.49,1.33-.61,1.33-1.49Z",
    fill: fillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.84,23.51v-1.17c.2.02.53.05.86.05.58,0,.89-.23,1.05-.75l.1-.31h-.96l-1.63-5.12h1.53l1.17,3.93h.27l1.25-3.93h1.48l-1.87,5.67c-.42,1.25-1,1.72-2.33,1.72-.32,0-.65-.04-.92-.1Z",
    fill: fillColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.03,11.82h-2.41c-.05,0-.1.03-.11.09l-2.38,8.61h-.62l-2.4-8.61c-.01-.05-.06-.09-.11-.09h-2.39c-.08,0-.13.08-.11.15l3.12,10.58c.01.05.06.09.11.09h4.17c.05,0,.1-.03.11-.09l3.12-10.58c.02-.08-.03-.15-.11-.15h0ZM121.44,11.93h.01c0-.06-.05-.12-.12-.12h-2.31c-.06,0-.12.05-.12.12v.97h-.51c-.55-1-1.66-1.49-2.95-1.49-3.26,0-5.34,2.58-5.34,5.79s1.89,5.77,5.22,5.77c1.73,0,2.71-.88,3.16-1.54h.51v1.04c0,.06.05.12.12.12h2.25c.06,0,.12-.05.12-.12-.02-.43-.04-1.1-.04-1.87v-8.67h0ZM115.88,20.69c-1.81,0-3.12-1.37-3.12-3.49s1.29-3.53,3.12-3.53,3.16,1.42,3.16,3.53-1.31,3.49-3.16,3.49h0ZM75.33,11.93h.01c0-.06-.05-.12-.12-.12h-2.31c-.06,0-.12.05-.12.12v.97h-.51c-.55-1-1.66-1.49-2.95-1.49-3.26,0-5.34,2.58-5.34,5.79s1.89,5.77,5.22,5.77c1.73,0,2.71-.88,3.16-1.54h.51v1.04c0,.06.05.12.12.12h2.25c.06,0,.12-.05.12-.12-.02-.43-.04-1.1-.04-1.87v-8.67h0ZM69.77,20.69c-1.81,0-3.12-1.37-3.12-3.49s1.29-3.53,3.12-3.53,3.16,1.42,3.16,3.53-1.31,3.49-3.16,3.49h0ZM102.22,11.82h-2.88v-3.5c0-.06-.05-.12-.12-.12h-2.34c-.06,0-.12.05-.12.12v3.5h-2.22c-.06,0-.12.05-.12.12v1.86c0,.06.05.12.12.12h2.22v6.59c0,1.22.98,2.21,2.2,2.21h2.74c.06,0,.12-.05.12-.12v-1.87c0-.06-.05-.12-.12-.12h-2.37v-6.68h2.88c.06,0,.12-.05.12-.12v-1.86c0-.06-.05-.12-.12-.12h0ZM109.93,11.7c-.13-.03-.32-.05-.52-.06-1.22.03-2.22.36-2.74,1.3h-.51v-1c-.01-.06-.06-.12-.13-.12h-2.31c-.06,0-.12.05-.12.12.02.48.04,1.17.04,1.87v8.69c0,.06.05.12.12.12h2.34c.06,0,.12-.05.12-.12v-5.25c0-2.07,1.15-3.21,3.1-3.21.19,0,.38.01.57.03.06.01.13-.04.13-.12v-2.15c0-.05-.03-.1-.09-.11h0ZM136.04,4.69l.84-.14h.04l.84.14c.09.01.15-.05.14-.13l-.47-3.46c-.01-.05-.06-.1-.12-.1h-.81c-.05,0-.11.04-.12.1l-.48,3.46c-.01.08.06.14.14.13h0ZM142.21,6.23l-5.28-.5h-.02l-5.29.5c-.06.01-.11.05-.11.12v.8c0,.06.04.11.11.12l3.91.32s.05.01.08.03l.28.28s.03.04.03.06l.48,3.74c.01.05.05.1.12.1h.81c.05,0,.11-.04.12-.1l.48-3.74s.01-.05.03-.06l.28-.28s.04-.03.08-.03l3.91-.32c.06,0,.11-.05.11-.12v-.8c0-.06-.04-.11-.11-.12h0,0ZM89.9,11.44c-1.47,0-2.77.47-3.66,1.7-.05.07-.16.07-.21,0-.67-1.06-1.86-1.69-3.27-1.7h-.03c-1.98,0-2.64,1.29-2.67,1.36h-.51v-.86c0-.07-.06-.13-.13-.13h-2.32c-.07,0-.13.06-.13.13l.04,1.89v8.66c0,.07.06.13.13.13h2.33c.07,0,.13-.06.13-.13v-5.8c0-1.84.95-2.98,2.39-2.98,1.35,0,2.19.91,2.19,2.56v6.22c0,.07.06.13.13.13h2.33c.07,0,.13-.06.13-.13v-5.8c0-1.84.95-2.98,2.37-2.98s2.21.91,2.21,2.56v6.22c0,.07.06.13.13.13h2.33c.07,0,.13-.06.13-.13v-6.45c0-2.81-1.51-4.6-4.02-4.6h0s0,0,0,0h0Z",
    fill: fillColor
  }));
};
PoweredByAmTrav.propTypes = {
  dark: PropTypes.bool
};
const PoweredBy = _ref2 => {
  let {
    dark = true
  } = _ref2;
  return /*#__PURE__*/React.createElement(PoweredByAmTrav, {
    dark: dark
  });
};
PoweredBy.propTypes = {
  dark: PropTypes.bool
};

/* eslint-disable max-len */
const BounceNextNavigation$1 = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 267 84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.62,7.88a7.62,7.62,0,0,0-7.81,7.91c0,4.68,3.53,7.9,8.63,7.9A11.56,11.56,0,0,0,86,22.34a.39.39,0,0,0,.19-.41l-.34-2.07a.4.4,0,0,0-.45-.32l-.09,0a11.12,11.12,0,0,1-4.86,1.21c-2.94,0-4.87-1.37-5.42-3.86H86.5a.38.38,0,0,0,.39-.32C87.59,11.81,84.44,7.88,79.62,7.88Zm-4.51,6.55c.24-2.2,2.11-3.69,4.6-3.69A4,4,0,0,1,84,14.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.57,7.88a6.29,6.29,0,0,0-5.43,2.83,5.75,5.75,0,0,0-5.4-2.83A5.36,5.36,0,0,0,93,10.29,2.92,2.92,0,0,0,90.2,8.2a.21.21,0,0,0-.21.21V23a.39.39,0,0,0,.39.38h2.37a.38.38,0,0,0,.39-.38V14.82a3.86,3.86,0,0,1,4.11-4c2.23,0,3.57,1.46,3.57,4V23a.38.38,0,0,0,.39.38h2.37A.39.39,0,0,0,104,23V14.63a3.8,3.8,0,0,1,4.11-3.78c2.23,0,3.57,1.46,3.57,4V23a.38.38,0,0,0,.39.38h2.37a.39.39,0,0,0,.39-.38V14.16C114.8,10.47,112.61,7.88,108.57,7.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36,7.88A6.41,6.41,0,0,0,121,10.25v-8a.22.22,0,0,0-.22-.21,2.93,2.93,0,0,0-2.93,2.93h0V23.12a.21.21,0,0,0,.21.21,2.93,2.93,0,0,0,2.83-2.16,6.43,6.43,0,0,0,5.5,2.52c4.31,0,7.62-3.32,7.62-8A7.46,7.46,0,0,0,126.36,7.88Zm-.38,13a5,5,0,0,1-5-5v-.13a4.91,4.91,0,0,1,4.8-5H126a4.78,4.78,0,0,1,4.87,5A4.92,4.92,0,0,1,126,20.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,8.2H148a.38.38,0,0,0-.38.38h0v8.17c0,2.51-1.88,4-4.27,4s-3.7-1.46-3.7-4V8.58a.38.38,0,0,0-.39-.38h-2.35a.38.38,0,0,0-.39.38v8.84c0,3.68,2.2,6.27,6.34,6.27a5.43,5.43,0,0,0,4.87-2.42,2.94,2.94,0,0,0,2.81,2.06.21.21,0,0,0,.21-.21V8.58a.38.38,0,0,0-.39-.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.85,8.15a6.36,6.36,0,0,0-1.79-.27,4.25,4.25,0,0,0-4,2.55,2.92,2.92,0,0,0-2.84-2.23.21.21,0,0,0-.21.21h0V23a.38.38,0,0,0,.38.38h2.38a.38.38,0,0,0,.38-.38h0V15.11c0-3.43,2.18-4.32,3.86-4.32a5.16,5.16,0,0,1,1.41.2.39.39,0,0,0,.48-.26.2.2,0,0,0,0-.07l.25-2.09A.4.4,0,0,0,162.85,8.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.16,14.59l-1.77-.37c-1.91-.39-2.62-.87-2.62-1.82,0-1.12,1.14-1.77,3.43-1.77a13.12,13.12,0,0,1,4.16.71.38.38,0,0,0,.49-.23.29.29,0,0,0,0-.09l.24-1.93a.38.38,0,0,0-.25-.41,14.38,14.38,0,0,0-4.82-.8c-3.79,0-6.32,1.9-6.32,4.48,0,2.34,1.42,3.87,4.09,4.41l2.25.46c2,.39,2.78.94,2.78,2s-1.06,1.74-3.34,1.74a13.88,13.88,0,0,1-4.73-.9.38.38,0,0,0-.5.22.24.24,0,0,0,0,.08L165,22.28a.38.38,0,0,0,.2.4,13.61,13.61,0,0,0,5.53,1c3.68,0,6.18-1.47,6.18-4.53C176.89,16.51,175.24,15.22,172.16,14.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,7.88a7.63,7.63,0,0,0-7.82,7.91c0,4.68,3.53,7.9,8.64,7.9a11.49,11.49,0,0,0,5.54-1.35.38.38,0,0,0,.2-.41l-.35-2.07a.39.39,0,0,0-.44-.32l-.1,0a11,11,0,0,1-4.85,1.21c-2.94,0-4.87-1.37-5.43-3.86h11.49a.37.37,0,0,0,.38-.32C194.54,11.81,191.4,7.88,186.58,7.88Zm-4.51,6.55c.24-2.2,2.1-3.69,4.6-3.69A4,4,0,0,1,191,14.43Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.79,53.86c5.87,1.17,9,3.81,9,8.42,0,5.75-4.58,8.82-11.74,8.82a26.63,26.63,0,0,1-10.69-2,.54.54,0,0,1-.31-.58l.5-3.22a.54.54,0,0,1,.62-.46.33.33,0,0,1,.14,0,23.89,23.89,0,0,0,9.4,1.9c4.73,0,7.28-1.48,7.28-4.21s-2.27-3.75-6.42-4.55l-3.84-.77c-4.89-1-8-3.53-8-8.08,0-5.25,4.64-8.76,12-8.76a27.61,27.61,0,0,1,9.06,1.47.55.55,0,0,1,.34.6l-.45,3.15a.54.54,0,0,1-.63.47l-.09,0A24.79,24.79,0,0,0,254,44.71c-4.79,0-7.43,1.59-7.43,4.3,0,2.55,2,3.44,6.17,4.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.43,40.37a20.62,20.62,0,0,1,8.5,1.79.54.54,0,0,1,.3.56L203.84,46a.54.54,0,0,1-.6.48l-.16,0A20.07,20.07,0,0,0,195.43,45c-6.91,0-11.65,4.33-11.65,10.69s4.76,10.88,11.71,10.88a21.3,21.3,0,0,0,7.88-1.58.54.54,0,0,1,.72.28.5.5,0,0,1,0,.13l.59,3.31a.55.55,0,0,1-.32.61,23.92,23.92,0,0,1-8.91,1.82c-9.9,0-16.65-6.27-16.65-15.45S185.56,40.37,195.43,40.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,41A4.56,4.56,0,0,0,97,45.56v.25c-2.22-3.16-6.09-5.44-11.38-5.44-8.44,0-14.87,6.43-14.87,15.27S77.13,71.1,85.57,71.1c5.29,0,9.16-2.3,11.38-5.47v.3a4.56,4.56,0,0,0,4.55,4.56h0a.32.32,0,0,0,.33-.32V41.33A.33.33,0,0,0,101.5,41ZM86.07,66.67c-6.15,0-10.51-4.91-10.51-11S79.92,44.8,86.07,44.8A10.66,10.66,0,0,1,97,55.21c0,.14,0,.29,0,.43a10.81,10.81,0,0,1-10.59,11A2,2,0,0,1,86.07,66.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.19,41a4.56,4.56,0,0,0-4.56,4.56v.25c-2.21-3.17-6.08-5.44-11.37-5.44-8.45,0-14.87,6.42-14.87,15.27s6.42,15.46,14.87,15.46c5.29,0,9.16-2.31,11.37-5.47v.3a4.56,4.56,0,0,0,4.56,4.56.33.33,0,0,0,.33-.33V41.33A.33.33,0,0,0,174.19,41ZM158.75,66.67c-6.14,0-10.5-4.91-10.5-11s4.36-10.85,10.5-10.85A10.68,10.68,0,0,1,169.69,55.2a3.23,3.23,0,0,1,0,.44,10.8,10.8,0,0,1-10.58,11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,40.37c-5.28,0-9.15,2.31-11.37,5.47V29.34a.32.32,0,0,0-.32-.33h0A4.56,4.56,0,0,0,108,33.57V70.16a.33.33,0,0,0,.33.33,4.56,4.56,0,0,0,4.55-4.56v-.24c2.22,3.14,6.09,5.41,11.37,5.41,8.45,0,14.88-6.57,14.88-15.42S132.66,40.37,124.2,40.37Zm-.49,26.3A10.8,10.8,0,0,1,112.77,56v-.33A10.69,10.69,0,0,1,123.26,44.8h.45c6.15,0,10.51,4.76,10.51,10.88s-4.36,11-10.51,11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,41a.55.55,0,0,0-.55.55V57.68c0,5.38-4,8.82-9.12,8.82-5.26,0-8.24-3-8.24-8.73V41.55a.55.55,0,0,0-.55-.55H210a.55.55,0,0,0-.56.55V59c0,7.56,4.64,12.14,12.33,12.14,4.76,0,8.23-2.27,9.89-5v-.13a4.55,4.55,0,0,0,4.56,4.55h0a.31.31,0,0,0,.31-.32V41.55A.54.54,0,0,0,236,41Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,29H14.41A12.41,12.41,0,0,0,2,41.42V81.59a.42.42,0,0,0,.41.41H42.58A12.41,12.41,0,0,0,55,69.59V29.42A.41.41,0,0,0,54.58,29ZM17.23,70.42a5.83,5.83,0,1,1,5.83-5.83A5.84,5.84,0,0,1,17.23,70.42ZM28.5,52.25a5.83,5.83,0,1,1,5.83-5.83A5.83,5.83,0,0,1,28.5,52.25ZM39.76,70.42a5.83,5.83,0,1,1,5.83-5.83A5.83,5.83,0,0,1,39.76,70.42Z",
    fill: "#fff"
  })));
};

/* eslint-disable max-len */
const BounceNextNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 140 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.3,25.2c-0.2,0.1-0.5,0.3-0.7,0.5c-0.2,0.1-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.4-0.6,0.6\r c-0.2,0.2-0.4,0.5-0.5,0.7c-0.1,0.1-0.2,0.6-0.3,0.6H33v-3.9c0,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.3,0.2-0.5,0.3\r C31.8,24.9,31.6,25.1,31.3,25.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M34.1,23.3c-0.1,0.1-0.3,0.2-0.4,0.2l1.3,1.2v-2.3C34,22.7,34.5,23,34.1,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11.9,21.7c-1.1,0-1.9,0.2-2.6,0.7c-0.7,0.5-1,1.1-1,1.9C8.2,25,8.5,25.5,9,26c0.5,0.4,1.2,0.7,2,0.7\r c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.5-0.5,1.9-0.9c0.6-0.4,1.2-0.9,1.2-1.4v-1.8c-2-0.2-1.5-0.3-2.1-0.5\r C13.3,21.7,12.4,21.7,11.9,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.1,24.7c-0.2,0.2-0.5,0.3-0.8,0.5c-0.2,0.1-0.5,0.3-0.7,0.5c-0.2,0.1-0.4,0.3-0.6,0.4\r c-0.2,0.1-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.5-0.5,0.7c-0.1,0.1-0.2,0.6-0.3,0.6H33v-3.9c0,0.1-0.3,0.2-0.5,0.3\r C32.4,24.5,32.3,24.6,32.1,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6,20.8c0.8-0.4,1.4-0.8,1.9-1.1c0.5-0.4,0.8-0.6,0.9-0.8c0.1-0.2,0.2-0.4,0.2-0.6c0-0.5-0.2-0.9-0.6-1.2\r c-0.4-0.3-1-0.5-1.8-0.5c-0.9,0-1.8,0.2-2.5,0.7c-0.7,0.5-1.5,1.1-2.2,1.9L22,19.7L21,18.5c0,0.2,0,0.4,0,0.6v4.9c0,0,0,0.1,0,0.1\r c0.7-0.6,1.6-1.1,2.6-1.7C24.8,21.7,25.8,21.2,26.6,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M33,24.2V29h-5.6c0.3-1,0.6-1.6,1-1.9c0.4-0.3,0.8-1.1,1.2-1.3c0.4-0.3,0.9-0.8,1.3-1\r c0.4-0.3,0.9-0.6,1.3-0.8c0.6-0.3,1-0.7,1.5-1.1c0.5-0.4,0.2-0.8,1.2-1.3V13c0-0.2-0.3-0.4-0.5-0.6c-1.5-1.2-3.5-1.8-6.3-1.8\r c-1.1,0-2.2,0.1-3.2,0.3c-1,0.2-2,0.5-2.8,0.8s-1.6,0.7-2.3,1.2c-0.3,0.2-0.6,0.4-0.8,0.6c1,1,1.6,2.3,1.9,3.9l1.2,1.4\r c0.7-0.8,1.5-1.5,2.3-2.1c0.8-0.5,1.7-0.8,2.8-0.8c0.9,0,1.7,0.2,2.2,0.7c0.5,0.4,0.8,1,0.8,1.7c0,0.4-0.1,0.7-0.3,1\r c-0.2,0.3-0.6,0.6-1,0.9c-0.5,0.3-1.1,0.7-1.9,1.2c-0.8,0.4-1.8,1-3,1.6c-1.1,0.6-2,1.2-2.8,1.9c0,0.1-0.1,0.2,0,0.3\r c0.2,0.2,0.9,0.4,0.9,0.4v4.9c0,0.1-0.8,0.2-1.3,0.2c-0.5,0-0.8,0.1-1.1,0.1c-0.6,0-1-0.2-1.4-0.3c-0.2,1-0.2,2.6-0.2,3.6H33v1.5\r v1.6l7.9-6.5l0.1-0.4V31h-6v-5.2l-2-1.6V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M48.4,17.7c-0.4-0.5-0.8-0.8-1.4-1.1c-0.5-0.3-1.1-0.4-1.7-0.4c-0.9,0-1.3,0.3-2.1,0.9\r c-0.8,0.6-1.3,1.4-1.3,2.4v4c0,0.8,0.5,1.5,1.2,1.9c0.7,0.5,1.3,0.7,2.1,0.7c0.7,0,1.2-0.1,1.8-0.4c0.6-0.3,1-0.6,1.4-1\r c0.4-0.4,0.7-0.9,0.9-1.5s0.3-1.2,0.3-1.9c0-0.7-0.1-1.3-0.3-1.9C49.1,18.7,48.8,18.2,48.4,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M18.6,26.7c0.5-0.9,1.2-1.6,2-2.4c0.1-0.1,0.3-0.2,0.4-0.3c0,0,0-0.1,0-0.1V19c0-0.2,0-0.4,0-0.6l-3.6-4.2\r l0.4-0.4c0.2-0.3,0.5-0.5,0.8-0.8c-1.6-1.3-3.7-1.9-6.6-1.9c-1.5,0-3,0.2-4.3,0.6c-1.4,0.4-2.7,1-3.9,1.8l1.7,3.6\r c1-0.7,2-1.2,3-1.6c0.9-0.4,2.4-0.5,3.4-0.5c2.5,0,4.2,1.1,4.2,3.3v0.9c-2-0.3-1.6-0.5-2.4-0.6c-0.7-0.1-1.7-0.2-2.5-0.2\r c-1.2,0-2.4,0.2-3.4,0.5c-1,0.3-1.9,0.7-2.6,1.3c-0.7,0.6-1.3,1.2-1.7,2C3,23,2.8,23.8,2.8,24.8c0,0.9,0.2,1.7,0.5,2.4\r c0.3,0.7,0.8,1.4,1.4,1.9c0.6,0.5,1.3,1,2.1,1.3s1.7,0.5,2.6,0.5c1.3,0,2.5-0.3,3.7-0.9c1.2-0.6,2.2-1.4,3-2.5l0.1,0.9\r c0.1,0.8,0.5,1.4,1.1,1.8c0.1,0.1,0.2,0.1,0.2,0.1c0,0,0-0.1,0-0.1C17.8,28.5,18.2,27.4,18.6,26.7z M16,24.1\r c0,0.5-0.7,0.9-1.3,1.4c-0.4,0.4-1.1,0.7-1.7,0.9c-0.6,0.2-1.3,0.3-1.9,0.3c-0.8,0-1.6-0.2-2.1-0.7c-0.5-0.4-0.8-1-0.8-1.7\r c0-0.8,0.3-1.4,1-1.9s1.6-0.7,2.6-0.7c0.5,0,1.5,0.1,2.1,0.2c0.6,0.1,0.1,0.3,2.1,0.5V24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M55,17.4c-0.4-1.2-1-2.3-1.7-3.2c-0.7-0.9-1.6-1.6-2.6-2.1c-1-0.5-2.1-0.8-3.3-0.8c-1.4,0-2.2,0.3-3.3,0.9\r C43,12.8,42,13.7,42,14.8V4h-7v8.1c2,1.3,2.4,3,2.4,5.2c0,0.9-0.1,1.8-0.4,2.5c-0.3,0.7-0.8,1.4-1.3,2C35.5,22,35,22.2,35,22.4\r v2.3l6,4.5v-1.7c0,1.1,1.2,2,2.2,2.6c1.1,0.6,2.2,0.9,3.6,0.9c1.3,0,2.3-0.2,3.4-0.7c1.1-0.5,2-1.2,2.8-2.1\r c0.8-0.9,1.4-1.9,1.8-3.1c0.4-1.2,0.7-2.5,0.7-3.9C55.6,19.9,55.4,18.6,55,17.4z M49.3,23.2c-0.2,0.6-0.5,1.1-0.9,1.5\r c-0.4,0.4-0.9,0.8-1.4,1c-0.6,0.3-1.2,0.4-1.9,0.4c-0.8,0-1.1-0.2-1.8-0.7C42.5,25,42,24.3,42,23.5v-4c0-0.9,0.5-1.7,1.3-2.4\r c0.8-0.6,1.4-0.9,2.3-0.9c0.6,0,1.1,0.1,1.6,0.4c0.5,0.3,0.9,0.6,1.3,1.1c0.4,0.5,0.7,1,0.9,1.6s0.3,1.3,0.3,1.9\r C49.7,22,49.5,22.6,49.3,23.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,16.2C24,16.2,24,16.2,24,16.2C24,16.2,24,16.2,24,16.2C24,16.2,24,16.2,24,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.4,12.3c0.8-0.3,1.8-0.6,2.8-0.8c1-0.2,2-0.3,3.1-0.3c2.6,0,4.6,0.6,6,1.7c1.3,1.1,2,2.5,2,4.4\r c0,0.8-0.1,1.4-0.4,2c-0.2,0.6-0.6,1.2-1,1.6c-0.4,0.5-0.9,0.9-1.4,1.3c-0.6,0.4-1.1,0.8-1.6,1.1c-0.2,0.1-0.4,0.2-0.5,0.3\r c-0.2,0.1-0.5,0.3-0.7,0.4c-0.3,0.2-0.5,0.3-0.8,0.5c0.2-0.2,0.5-0.4,0.7-0.5c0.2-0.1,0.5-0.3,0.7-0.4c0.2-0.1,0.4-0.2,0.5-0.3\r c0.5-0.3,1.1-0.7,1.6-1.1c0.5-0.3,0.9-0.8,1.4-1.3c0.4-0.5,0.7-1,1-1.6c0.2-0.6,0.4-1.3,0.4-2c0-1.9-0.6-3.3-2-4.4\r c-1.4-1.1-3.4-1.7-6-1.7c-1.1,0-2.1,0.1-3.1,0.3C24.2,11.7,23.3,11.9,22.4,12.3c-0.7,0.3-1.5,0.6-2.1,1c-0.4,0.3-0.8,0.5-1.1,0.8\r l0,0c0.3-0.3,0.6-0.5,1-0.8C20.8,13,21.5,12.6,22.4,12.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "40,30.7 40,30.7 37.4,33 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "29.3,29 26.3,29 26.2,29 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "34,25.6 34.2,25.6 34.3,29 34,29 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "34.1,35.8 34,35.7 34,33 29.3,33 34.2,33.2 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.8,27.4c0.4-0.7,1-1.4,1.7-2c0.7-0.6,1.6-1.3,2.7-1.8c1.2-0.6,2.2-1.2,3-1.6c0.3-0.2,0.5-0.3,0.8-0.4\r c-0.2,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.8,1-3,1.6c-1.1,0.6-2,1.2-2.7,1.8C20.7,25.9,20.2,26.6,19.8,27.4c-0.3,0.5-0.7,1.3-1,2.7\r c-0.1,0.7-0.3,1.9-0.3,2.9h0.1c0-1,0.1-2.1,0.3-2.8C19.1,28.8,19.4,27.9,19.8,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E0F6",
    d: "M34,35.7l3.3-2.7l2.5-2.3L34,25.6v3.4l0,0v0L29.3,29h-3.1h0h-0.1l0.7-1c0.1-0.1,0.2-0.3,0.3-0.5\r c0.2-0.4,0.5-0.9,0.9-1.2c0.1-0.1,0.3-0.3,0.4-0.4c0.3-0.3,0.5-0.6,0.9-0.8c0.2-0.1,0.3-0.2,0.5-0.4c0,0,0.1-0.1,0.1-0.1\r c0.2-0.2,0.5-0.4,0.8-0.5c0.2-0.1,0.5-0.3,0.7-0.4c0.2-0.1,0.4-0.2,0.5-0.3c0.5-0.3,1.1-0.7,1.6-1.1c0.5-0.3,0.9-0.8,1.4-1.3\r c0.4-0.5,0.7-1,1-1.6c0.2-0.6,0.4-1.3,0.4-2c0-1.9-0.7-3.3-2-4.4c-1.4-1.1-3.4-1.7-6-1.7c-1.1,0-2.1,0.1-3.1,0.3\r c-1,0.2-1.9,0.5-2.8,0.8c-0.8,0.3-1.6,0.7-2.2,1.1c-0.4,0.3-0.7,0.5-1,0.8l3,3.5c0.6-0.6,1.2-1.1,1.9-1.6c0,0,0,0,0,0c0,0,0,0,0,0\r c0,0,0,0,0.1,0c0.9-0.6,2-0.9,3.2-0.9c1.1,0,2,0.3,2.6,0.8c0.7,0.6,1,1.3,1,2.2c0,0.5-0.2,0.9-0.4,1.3c-0.3,0.3-0.6,0.7-1.2,1.1\r c-0.3,0.2-0.8,0.5-1.2,0.7c-0.2,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.8,1-3,1.6c-1.1,0.6-2,1.2-2.7,1.8c-0.7,0.6-1.3,1.3-1.7,2\r c-0.3,0.5-0.6,1.5-0.9,3c-0.1,0.7-0.2,1.6-0.3,2.7L29.3,33H34V35.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M67.2,18.6c0.6,0.7,0.8,1.6,0.8,2.7c0,1.1-0.3,2.1-0.8,2.9c-0.5,0.8-1.3,1.1-2.3,1.1c-0.6,0-1.1-0.1-1.5-0.4\r c-0.2-0.1-0.5-0.4-0.7-0.8v0.9h-1.9v-10h1.9v3.6c0.2-0.3,0.5-0.6,0.8-0.8c0.3-0.2,0.8-0.3,1.3-0.3C65.9,17.5,66.7,17.9,67.2,18.6z\r M65.6,23.1c0.3-0.4,0.4-0.9,0.4-1.6c0-0.5-0.1-1-0.2-1.3c-0.3-0.7-0.7-1-1.4-1c-0.7,0-1.2,0.3-1.5,1c-0.1,0.3-0.2,0.8-0.2,1.3\r c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6C64.9,23.7,65.3,23.5,65.6,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M69.7,26.5l0.2,0c0.2,0,0.4,0,0.5,0c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.5s0.1-0.4,0.1-0.4l-2.7-7.7\r h2.2l1.6,5.5l1.5-5.5H76L73.4,25c-0.5,1.4-0.9,2.3-1.2,2.6s-0.9,0.5-1.7,0.5c-0.2,0-0.3,0-0.4,0s-0.3,0-0.5,0\r C69.7,28.1,69.7,26.5,69.7,26.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M88.2,23.4h-3.9l-0.8,3h-2.9l4-12.7h3.4l4,12.7h-3L88.2,23.4z M87.7,21.1L87.3,20c-0.4-1.3-0.7-2.8-1-4.1\r h-0.1c-0.3,1.3-0.6,2.8-1,4.1l-0.3,1.2H87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M92.2,16.7h2.3l0.2,1.2h0.1c0.8-0.8,1.7-1.5,2.9-1.5c1.4,0,2.2,0.6,2.7,1.6c0.9-0.9,1.8-1.6,3-1.6\r c2.1,0,3,1.5,3,3.9v6h-2.9v-5.6c0-1.4-0.4-1.8-1.2-1.8c-0.5,0-1,0.3-1.7,0.9v6.5h-2.9v-5.6c0-1.4-0.4-1.8-1.2-1.8\r c-0.5,0-1,0.3-1.6,0.9v6.5h-2.9L92.2,16.7L92.2,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M108.6,16.1H105v-2.4h9.9v2.4h-3.5v10.3h-2.9L108.6,16.1L108.6,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M113.7,16.7h2.3l0.2,1.7h0.1c0.7-1.3,1.8-1.9,2.7-1.9c0.5,0,0.9,0.1,1.1,0.2l-0.5,2.5\r c-0.4-0.1-0.6-0.2-1.1-0.2c-0.7,0-1.6,0.5-2.1,1.8v5.6h-2.9V16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M125.4,20.2c-0.1-0.9-0.5-1.4-1.5-1.4c-0.8,0-1.6,0.3-2.6,0.9l-1-1.9c1.2-0.7,2.6-1.3,4.1-1.3\r c2.5,0,3.8,1.4,3.8,4.4v5.5H126l-0.2-1h-0.1c-0.8,0.7-1.7,1.2-2.8,1.2c-1.8,0-2.9-1.3-2.9-2.9C120,21.7,121.6,20.6,125.4,20.2z\r M123.8,24.4c0.7,0,1.1-0.3,1.6-0.8v-1.7c-2,0.3-2.7,0.9-2.7,1.6C122.7,24.1,123.1,24.4,123.8,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M128,16.7h2.9l1.2,4.6c0.3,1,0.5,2,0.8,3h0.1c0.2-1,0.5-2,0.7-3l1.3-4.6h2.7l-3.2,9.7h-3.3L128,16.7z"
  }))));
};

/* eslint-disable max-len */
const CavaNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 900 347",
    style: {
      padding: '8% 0'
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M21.4,265.1h13.7l21.4,62.1h-8.8l-6.9-20.4h-25l-6.9,20.4H0L21.4,265.1L21.4,265.1z M38.2,299.2l-9-26.5h-1.9\r l-9,26.5H38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M77.8,265.1h48.4v7.6h-19.9v54.5h-8.5v-54.5H77.8L77.8,265.1C77.8,265.1,77.9,265.1,77.8,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M123.9,283.1h8.3v6.4c2-3.4,6-6.9,13.1-6.9c0.9,0,2.2,0.1,2.8,0.2v8.2c-0.9-0.1-1.9-0.2-2.8-0.2\r c-7.9,0-12.7,4.5-12.7,13.1v23.4h-8.4v-35.9C124.1,287.8,124,284.8,123.9,283.1L123.9,283.1L123.9,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M150.3,305.2c0-13.1,8.5-23.6,21.8-23.6c6.2,0,11.9,2.7,14.8,6.5v-4.9h8.4v35.9c0,3.5,0.1,6.5,0.2,8.2h-8.2\r v-5.5c-3.2,4.5-8.9,7-15.2,7C158.8,328.7,150.3,318.2,150.3,305.2L150.3,305.2L150.3,305.2z M187.8,305.2c0-9.7-6.2-15.9-14.5-15.9\r s-14.3,6.3-14.3,15.9S165,321,173.2,321S187.8,314.8,187.8,305.2L187.8,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M201.1,283.1h8.5l11,36.9h2.8l11-36.9h8.4l-13.5,44.1h-14.9L201.1,283.1L201.1,283.1L201.1,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M244.7,305.2c0-14,8.9-23.6,21.8-23.6c12.9,0,20.4,7.7,21.1,20.5c0.1,1.6,0.1,3.3,0,5.1h-34.3\r c0.8,8.5,5.9,13.8,13.8,13.8c5.8,0,10.1-2.8,12-8.1h8.4c-1.5,9-10.5,15.8-20.5,15.8C253.9,328.7,244.7,319,244.7,305.2L244.7,305.2z\r M278.8,300.2c-0.9-7.3-5.2-11.5-12.3-11.5s-11.4,4-12.8,11.5H278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M296.1,265.1h8.4v62.1h-8.4V265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M316.6,265.1h23.6c12,0,19.2,6.7,19.2,18.2s-6.9,18.4-18.1,18.4h-16.2v25.5h-8.5L316.6,265.1L316.6,265.1\r L316.6,265.1z M340.1,294.1c7.2,0,10.6-3.4,10.6-10.8s-3.5-10.6-10.6-10.6h-15v21.4H340.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M361.7,305.2c0-14,8.9-23.6,21.8-23.6s20.4,7.7,21.1,20.5c0.1,1.6,0.1,3.3,0,5.1h-34.3\r c0.8,8.5,5.9,13.8,13.9,13.8c5.8,0,10.1-2.8,12-8.1h8.4c-1.5,9-10.5,15.8-20.5,15.8C370.9,328.7,361.7,319,361.7,305.2L361.7,305.2z\r M395.8,300.2c-0.9-7.3-5.2-11.5-12.3-11.5s-11.4,4-12.8,11.5H395.8L395.8,300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M412.9,283.1h8.4v6.4c2-3.4,6-6.9,13.1-6.9c0.9,0,2.2,0.1,2.8,0.2v8.2c-1-0.1-1.9-0.2-2.8-0.2\r c-7.9,0-12.7,4.5-12.7,13.1v23.4h-8.4v-35.9C413.1,287.8,413,284.8,412.9,283.1L412.9,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M442.5,265.1h8.4v36.3h1.1l18.3-18.3h10.9v0.3l-18.5,18.2l19.6,25.1v0.5h-10L457,307.3l-6.1,6v13.9h-8.4\r L442.5,265.1L442.5,265.1L442.5,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M507.1,296.1c0-19.1,13.1-32.5,31.7-32.5c14.6,0,26.2,8.5,28.5,22.2h-8.3c-2.6-8.9-10.3-14.3-20.3-14.3\r c-13.7,0-23,9.9-23,24.8s9.5,24.7,23.3,24.7c10,0,18-5.4,20.5-14.3h8.3c-2.3,13-14.5,22.2-29,22.2\r C520.3,328.7,507.1,314.9,507.1,296.1L507.1,296.1L507.1,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M572.4,305.2c0-13.1,9-23.6,23.1-23.6s23.1,10.5,23.1,23.6s-9,23.5-23.1,23.5S572.4,318.2,572.4,305.2z\r M610.1,305.2c0-9.7-6.1-15.9-14.5-15.9s-14.5,6.3-14.5,15.9s6.1,15.8,14.5,15.8S610.1,314.8,610.1,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M626.7,283.1h8.2v5.3c2.5-4.2,8-6.8,13.5-6.8c5.8,0,11.3,2.8,13.8,8c3.9-6.1,9.4-8,15.5-8\r c10.2,0,16.2,7.2,16.2,18.6v27h-8.4v-26.6c0-7.3-3.6-11.3-10-11.3s-10.8,5.3-10.8,13.4v24.6h-8.4v-26.6c0-7.3-3.9-11.3-10-11.3\r s-10.8,5.3-10.8,13.4v24.6h-8.4v-35.9L626.7,283.1L626.7,283.1L626.7,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M704.5,283.1h8.2v5.5c3.2-4.5,8.9-7,15.2-7c13.3,0,21.8,10.5,21.8,23.5s-8.5,23.6-21.8,23.6\r c-6.2,0-12-2.7-14.8-6.5v23h-8.4v-54C704.7,287.7,704.6,284.8,704.5,283.1L704.5,283.1L704.5,283.1z M741.1,305.1\r c0-9.7-6.1-15.8-14.3-15.8s-14.5,6.3-14.5,15.8s6.2,15.9,14.5,15.9S741.1,314.8,741.1,305.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M755.2,305.2c0-13.1,8.5-23.6,21.8-23.6c6.2,0,12,2.7,14.8,6.5v-4.9h8.4v35.9c0,3.5,0.1,6.5,0.2,8.2h-8.2v-5.5\r c-3.2,4.5-8.9,7-15.2,7C763.8,328.7,755.2,318.2,755.2,305.2L755.2,305.2L755.2,305.2z M792.7,305.2c0-9.7-6.2-15.9-14.5-15.9\r s-14.3,6.3-14.3,15.9S770,321,778.2,321S792.7,314.8,792.7,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M811.3,283.1h8.2v5.3c2.5-4.2,7.9-6.8,14.1-6.8c10.8,0,17,7,17,18.6v27h-8.4v-26.6c0-7.3-3.7-11.3-10.5-11.3\r c-8.4,0-11.8,6.4-11.8,15.4v22.6h-8.4v-35.9L811.3,283.1L811.3,283.1L811.3,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M857.6,345.8v-7c1.4,0.2,4.8,0.6,7.2,0.6c5,0,6.7-2.8,8.1-6.5l2-5.6h-5.3l-15.3-44.1h8.7l12,36.1h2.7l12.8-36.1\r h8.5l-16.9,48.4c-3.4,9.7-7,15.3-17.2,15.3C862,346.8,859,346.2,857.6,345.8L857.6,345.8L857.6,345.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14140f",
    d: "M639.3,100.2H617c-0.5,0-0.9,0.3-1,0.8l-22,79.7h-5.8L566,101c-0.1-0.5-0.6-0.8-1-0.8h-22.1\r c-0.7,0-1.2,0.7-1,1.4l28.9,98c0.1,0.5,0.6,0.8,1,0.8h38.7c0.5,0,0.9-0.3,1-0.8l28.9-98C640.5,100.9,640,100.2,639.3,100.2\r L639.3,100.2z M532.1,101.3c0-0.6-0.5-1.1-1.1-1.1h-21.4c-0.6,0-1.1,0.5-1.1,1.1v9h-4.7c-5.1-9.3-15.4-13.8-27.3-13.8\r c-30.2,0-49.4,23.9-49.4,53.6s17.5,53.4,48.3,53.4c16,0,25.1-8.2,29.3-14.2h4.7v9.7c0,0.6,0.5,1.1,1.1,1.1h20.8\r c0.6,0,1.1-0.5,1.1-1.1c-0.2-4-0.4-10.2-0.4-17.3L532.1,101.3z M480.5,182.4c-16.7,0-28.9-12.7-28.9-32.3s12-32.7,28.9-32.7\r s29.3,13.2,29.3,32.7S497.6,182.4,480.5,182.4L480.5,182.4z M105,101.3c0-0.6-0.5-1.1-1.1-1.1H82.5c-0.6,0-1.1,0.5-1.1,1.1v9h-4.7\r c-5.1-9.3-15.3-13.8-27.3-13.8C19.2,96.5,0,120.4,0,150.1s17.5,53.4,48.3,53.4c16,0,25.1-8.2,29.3-14.2h4.7v9.7\r c0,0.6,0.5,1.1,1.1,1.1h20.8c0.6,0,1.1-0.5,1.1-1.1c-0.2-4-0.4-10.2-0.4-17.3L105,101.3z M53.4,182.4c-16.7,0-28.9-12.7-28.9-32.3\r s12-32.7,28.9-32.7s29.3,13.2,29.3,32.7S70.6,182.4,53.4,182.4L53.4,182.4z M353.9,100.2h-26.7V67.8c0-0.6-0.5-1.1-1.1-1.1h-21.6\r c-0.6,0-1.1,0.5-1.1,1.1v32.4h-20.5c-0.6,0-1.1,0.5-1.1,1.1v17.2c0,0.6,0.5,1.1,1.1,1.1h20.5v61c0,11.3,9.1,20.4,20.3,20.4h25.4\r c0.6,0,1.1-0.5,1.1-1.1v-17.3c0-0.6-0.5-1.1-1.1-1.1h-21.9v-61.9h26.7c0.6,0,1.1-0.5,1.1-1.1v-17.2\r C355,100.7,354.5,100.2,353.9,100.2L353.9,100.2L353.9,100.2z M425.4,99.1c-1.2-0.3-3-0.5-4.8-0.6c-11.3,0.3-20.5,3.3-25.4,12.1\r h-4.7l-0.1-9.3c0-0.6-0.5-1.1-1.1-1.1h-21.4c-0.6,0-1.1,0.5-1.1,1.1c0.2,4.5,0.4,10.9,0.4,17.3v80.5c0,0.6,0.5,1.1,1.1,1.1h21.6\r c0.6,0,1.1-0.5,1.1-1.1v-48.6c0-19.1,10.7-29.7,28.7-29.7c1.8,0,3.5,0.1,5.3,0.3c0.6,0.1,1.2-0.4,1.2-1.1v-19.9\r C426.2,99.6,425.9,99.2,425.4,99.1L425.4,99.1L425.4,99.1z M667.2,34.2l7.8-1.3h0.4l7.8,1.3c0.8,0.1,1.4-0.5,1.3-1.2l-4.4-32.1\r C680,0.4,679.5,0,679,0h-7.5c-0.5,0-1,0.4-1.1,0.9L665.9,33C665.8,33.7,666.5,34.3,667.2,34.2L667.2,34.2L667.2,34.2z M724.3,48.4\r l-48.9-4.6h-0.2l-49,4.6c-0.6,0.1-1,0.5-1,1.1v7.4c0,0.6,0.4,1,1,1.1l36.2,3c0.3,0,0.5,0.1,0.7,0.3l2.6,2.6c0.2,0.2,0.3,0.4,0.3,0.6\r l4.5,34.7c0.1,0.5,0.5,0.9,1.1,0.9h7.5c0.5,0,1-0.4,1.1-0.9l4.5-34.7c0-0.2,0.1-0.5,0.3-0.6l2.6-2.6c0.2-0.2,0.4-0.3,0.7-0.3l36.2-3\r c0.6,0,1-0.5,1-1.1v-7.4C725.3,48.9,724.9,48.5,724.3,48.4L724.3,48.4L724.3,48.4z M239.8,96.7c-13.6,0-25.7,4.4-33.9,15.8\r c-0.5,0.7-1.5,0.6-1.9-0.1c-6.2-9.8-17.3-15.6-30.2-15.7h-0.3c-18.3,0-24.4,12-24.8,12.6H144v-7.9c0-0.7-0.5-1.2-1.2-1.2h-21.5\r c-0.7,0-1.2,0.5-1.2,1.2l0.4,17.5v80.2c0,0.6,0.5,1.2,1.2,1.2h21.6c0.6,0,1.2-0.5,1.2-1.2v-53.7c0-17,8.8-27.6,22.2-27.6\r c12.5,0,20.2,8.4,20.2,23.7v57.6c0,0.6,0.5,1.2,1.2,1.2h21.6c0.6,0,1.2-0.5,1.2-1.2v-53.7c0-17,8.8-27.6,22-27.6s20.5,8.4,20.5,23.7\r V199c0,0.6,0.5,1.2,1.2,1.2h21.6c0.6,0,1.2-0.5,1.2-1.2v-59.8C277.1,113.2,263.1,96.6,239.8,96.7L239.8,96.7L239.8,96.7L239.8,96.7z\r "
  }));
};

/* eslint-disable max-len */

// aka Emburse Professional

const CertifyNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 962 86",
    style: {
      maxWidth: 180
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    "data-name": "Emburse",
    d: "M335.76,22.32h-6.9c-.63,0-1.13.51-1.13,1.13v23.92c0,7.36-5.51,11.62-12.5,11.62s-10.84-4.26-10.84-11.62v-23.92c0-.63-.51-1.13-1.13-1.13h-6.9c-.63,0-1.13.51-1.13,1.13v25.87c0,10.79,6.44,18.38,18.57,18.38,8.1,0,12.3-4,14.28-7.1,1.09,3.5,4.35,6.04,8.21,6.04.34,0,.62-.28.62-.62V23.45c0-.63-.51-1.13-1.13-1.13h0ZM128.48,21.39c-13.29,0-22.88,9.91-22.88,23.16s10.33,23.15,25.28,23.15c5.92,0,11.3-1.31,16.24-3.96.43-.23.66-.71.58-1.19l-1.01-6.07c-.12-.73-.91-1.15-1.59-.84-5.27,2.4-9.43,3.54-14.22,3.54-8.61,0-14.26-4.03-15.88-11.3h33.63c.56,0,1.04-.4,1.12-.96,2.07-14.02-7.15-25.53-21.28-25.53ZM441.79,21.39c-13.29,0-22.88,9.91-22.88,23.16s10.33,23.15,25.28,23.15c5.92,0,11.3-1.31,16.24-3.96.43-.23.66-.71.58-1.19l-1.01-6.07c-.12-.73-.91-1.15-1.59-.84-5.27,2.4-9.43,3.54-14.22,3.54-8.61,0-14.26-4.03-15.88-11.3h33.63c.56,0,1.04-.4,1.12-.96,2.07-14.02-7.15-25.53-21.28-25.53h0ZM399.57,41.02l-5.19-1.07c-5.6-1.16-7.69-2.55-7.69-5.33,0-3.29,3.33-5.19,10.05-5.19,4.09,0,8.68.79,12.19,2.06.69.25,1.42-.2,1.51-.93l.69-5.65c.06-.52-.24-1.01-.73-1.2-3.7-1.43-9.05-2.34-14.12-2.34-11.12,0-18.52,5.56-18.52,13.11,0,6.85,4.17,11.34,11.99,12.92l6.58,1.34c5.74,1.16,8.15,2.78,8.15,5.79,0,3.43-3.1,5.09-9.77,5.09-4.48,0-9.58-.99-13.87-2.65-.68-.26-1.42.18-1.52.9l-.8,5.67c-.07.48.17.96.61,1.17,3.88,1.86,9.83,2.97,16.18,2.97,10.79,0,18.11-4.31,18.11-13.29,0-7.73-4.82-11.53-13.85-13.38h0ZM265.39,21.39c-7.51,0-12.5,2.75-15.79,6.94V4.78c0-.34-.28-.62-.62-.62-4.75,0-8.59,3.85-8.59,8.59v53.27c0,.34.28.62.62.62,3.96,0,7.28-2.68,8.28-6.31,3.42,4.59,8.63,7.37,16.11,7.37,12.64,0,22.32-9.73,22.32-23.39s-9.68-22.92-22.32-22.92ZM213.28,21.39c-7.64,0-13.2,3.94-15.88,8.29-2.83-5.14-8.2-8.29-15.84-8.29s-12.18,4.24-13.84,7.06c-1.06-3.55-4.34-6.13-8.23-6.13-.34,0-.62.28-.62.62v42.71c0,.63.51,1.13,1.13,1.13h6.95c.63,0,1.13-.51,1.13-1.13v-23.92c0-7.36,5.42-11.62,12.04-11.62s10.47,4.26,10.47,11.62v23.92c0,.63.51,1.13,1.13,1.13h6.95c.63,0,1.13-.51,1.13-1.13v-24.48c0-6.99,5.56-11.07,12.04-11.07s10.47,4.26,10.47,11.62v23.92c0,.63.51,1.13,1.13,1.13h6.95c.63,0,1.13-.51,1.13-1.13v-25.87c0-10.79-6.39-18.38-18.25-18.38h0ZM372.28,22.19c-1.06-.33-2.96-.8-5.22-.8-4.82,0-9.16,2.07-11.83,7.46-.92-3.75-4.3-6.54-8.34-6.54-.34,0-.62.28-.62.62v42.7c0,.63.51,1.13,1.13,1.13h6.95c.63,0,1.13-.51,1.13-1.13v-23.09c0-10.05,6.39-12.64,11.3-12.64,1.76,0,3.17.3,4.14.58.68.2,1.36-.26,1.44-.96l.71-6.13c.06-.54-.27-1.05-.79-1.21h0ZM264.28,59.46c-8.57,0-14.68-6.95-14.68-15.14s6.16-14.68,14.68-14.68,14.26,6.48,14.26,14.68-5.7,15.14-14.26,15.14ZM115.29,40.56c.69-6.44,6.16-10.79,13.48-10.79s11.95,4.35,12.55,10.79h-26.03ZM428.59,40.56c.69-6.44,6.16-10.79,13.48-10.79s11.95,4.35,12.55,10.79h-26.03Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    "data-name": "professional",
    d: "M508.59,21.62c-7.93,0-13.74,3.41-17.06,8.16v-.37c0-3.78-3.06-6.84-6.84-6.84-.27,0-.49.22-.49.49v53.97c0,3.78,3.06,6.84,6.84,6.84.27,0,.49-.22.49-.49v-23.86c3.32,4.75,9.13,8.21,17.06,8.21,12.68,0,22.32-9.64,22.32-22.97,0-13.28-9.64-23.15-22.32-23.15h0ZM718.32,41.87l-4.61-.92c-6.23-1.2-9.27-2.54-9.27-6.36,0-4.06,3.97-6.46,11.16-6.46,3.97,0,8.4.77,11.88,2,.49.17,1.01-.16,1.08-.67l.68-4.74c.06-.38-.15-.76-.51-.89-3.46-1.3-8.55-2.2-13.6-2.2-11.02,0-17.98,5.26-17.98,13.14,0,6.82,4.7,10.7,12.04,12.13l5.76,1.15c6.23,1.2,9.64,2.86,9.64,6.82s-3.83,6.32-10.93,6.32c-4.93,0-10.14-1.06-14.1-2.85-.49-.22-1.06.1-1.14.63l-.75,4.84c-.06.36.13.72.46.88,4.14,1.91,10.05,3.05,16.05,3.05,10.75,0,17.62-4.61,17.62-13.24,0-6.92-4.66-10.88-13.47-12.64h0ZM758.22,41.87l-4.61-.92c-6.23-1.2-9.27-2.54-9.27-6.36,0-4.06,3.97-6.46,11.16-6.46,3.97,0,8.4.77,11.88,2,.49.17,1.01-.16,1.08-.67l.68-4.74c.06-.38-.15-.76-.51-.89-3.46-1.3-8.55-2.2-13.6-2.2-11.02,0-17.98,5.26-17.98,13.14,0,6.82,4.7,10.7,12.04,12.13l5.76,1.15c6.23,1.2,9.64,2.86,9.64,6.82s-3.83,6.32-10.93,6.32c-4.93,0-10.14-1.06-14.1-2.85-.49-.22-1.06.1-1.14.63l-.75,4.84c-.06.36.13.72.46.88,4.14,1.91,10.05,3.05,16.05,3.05,10.75,0,17.62-4.61,17.62-13.24,0-6.92-4.66-10.88-13.47-12.64h0ZM669.61,21.62h0c-13.28,0-22.78,9.87-22.78,23.06s10.28,23.06,25.18,23.06c5.75,0,11.15-1.25,16.17-4.04.31-.17.48-.54.41-.89l-.96-4.96c-.11-.54-.71-.82-1.2-.57-5.48,2.8-9.86,3.58-14.74,3.58-8.58,0-15.96-4.8-17.2-13.51h35.49c.41,0,.76-.3.82-.7,1.99-13.32-6.46-25.03-21.19-25.03ZM942.4,22.56c-3.78,0-6.84,3.06-6.84,6.84v.38c-3.32-4.75-9.13-8.16-17.06-8.16-12.68,0-22.32,9.64-22.32,22.92s9.64,23.2,22.32,23.2c7.93,0,13.74-3.46,17.06-8.21v.46c0,3.78,3.06,6.84,6.84,6.84.27,0,.49-.22.49-.49V23.05c0-.27-.22-.49-.49-.49h0ZM817.72,21.62c-13.47,0-23.52,10.1-23.52,23.06s10.05,23.06,23.52,23.06,23.52-10.1,23.52-23.06-10.05-23.06-23.52-23.06ZM589.03,21.62c-13.47,0-23.52,10.1-23.52,23.06s10.05,23.06,23.52,23.06,23.52-10.1,23.52-23.06-10.05-23.06-23.52-23.06ZM959.17,8.34h-5.68c-.46,0-.83.37-.83.83v56.82c0,.46.37.83.83.83h5.68c.46,0,.83-.37.83-.83V9.16c0-.46-.37-.83-.83-.83ZM785.76,22.54h-5.68c-.46,0-.83.37-.83.83v42.61c0,.46.37.83.83.83h5.68c.46,0,.83-.37.83-.83V23.37c0-.46-.37-.83-.83-.83ZM870.69,21.62c-7.05,0-12.36,3.55-14.86,7.64-.08-3.71-3.12-6.7-6.85-6.69-.26,0-.47.23-.47.49v42.92c0,.46.37.83.83.83h5.68c.46,0,.83-.37.83-.83v-24.17c0-8.07,6.13-13.28,13.7-13.28,8.02,0,12.54,4.52,12.54,13.14v24.31c0,.46.37.83.83.83h5.63c.46,0,.83-.37.83-.83v-26.1c0-11.39-7.01-18.26-18.68-18.26h0ZM646.89,3.46c-1.16-.45-3.44-1.18-6.68-1.18-10.15,0-16.56,6.04-16.56,16.09v4.16h-7.56c-.46,0-.83.37-.83.83v4.66c0,.46.37.83.83.83h7.52v37.13c0,.46.37.83.83.83h5.68c.46,0,.83-.37.83-.83V28.86h12.82c.46,0,.83-.37.83-.83v-4.66c0-.46-.37-.83-.83-.83h-12.91v-3.66c0-7.56,4.06-10.33,9.68-10.33,2.01,0,3.87.35,5.18.77.48.15.98-.17,1.06-.67l.63-4.29c.06-.38-.15-.75-.52-.89h0ZM563.19,22.53c-1.11-.39-3.11-.91-5.66-.91-5.05,0-9.5,2.51-12,7.57-.12-3.68-3.14-6.63-6.85-6.62-.26,0-.47.23-.47.49v42.92c0,.46.37.83.83.83h5.72c.46,0,.83-.37.83-.83v-23.75c0-9.91,5.76-13.79,11.67-13.79,2.19,0,3.7.38,4.85.76.5.17,1.02-.17,1.08-.7l.56-5.11c.04-.39-.18-.74-.55-.87h0ZM507.85,61.09c-9.45,0-16.42-7.15-16.42-16.33s6.96-16.51,16.42-16.51,15.77,7.38,15.77,16.51-6.55,16.33-15.77,16.33h0ZM919.24,61.09c-9.22,0-15.77-7.38-15.77-16.56s6.55-16.28,15.77-16.28,16.42,7.15,16.42,16.28-6.96,16.56-16.42,16.56ZM589.03,60.91h0c-9.31,0-16.19-7.1-16.19-16.23s6.87-16.23,16.19-16.23,16.19,7.1,16.19,16.23-6.87,16.23-16.19,16.23ZM817.72,60.91h0c-9.31,0-16.19-7.1-16.19-16.23s6.87-16.23,16.19-16.23,16.19,7.1,16.19,16.23-6.87,16.23-16.19,16.23ZM654.66,41.35c.69-7.56,6.82-12.91,15.17-12.91s13.65,5.35,14.16,12.91h-29.33ZM782.89,16.5c2.68,0,4.61-1.89,4.61-4.57s-1.94-4.52-4.61-4.52-4.52,1.84-4.52,4.52,1.85,4.57,4.52,4.57h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    "data-name": "Leaf",
    d: "M20.69,4.16C10.37,4.16,2,12.53,2,22.85v60.5c0,.34.28.62.62.62h60.5c10.32,0,18.69-8.37,18.69-18.69V4.79c0-.34-.28-.62-.62-.62,0,0-60.5,0-60.5,0ZM65.67,58.05H26.11c-4.75,0-8.59,3.85-8.59,8.59,0,.34.28.62.62.62h39.56c4.75,0,8.59-3.85,8.59-8.59,0-.34-.28-.62-.62-.62ZM18.14,48.68h16.22c4.75,0,8.59-3.85,8.59-8.59,0-.34-.28-.62-.62-.62h-16.22c-4.75,0-8.59,3.85-8.59,8.59,0,.34.28.62.62.62ZM18.14,30.09h39.56c4.75,0,8.59-3.85,8.59-8.59,0-.34-.28-.62-.62-.62H26.11c-4.75,0-8.59,3.85-8.59,8.59,0,.34.28.62.62.62Z",
    fill: "#fff",
    fillRule: "evenodd"
  }));
};

/* eslint-disable max-len */

// aka Emburse Enterprise

const ChromeRiverNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 886 84",
    style: {
      maxWidth: 180
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    "data-name": "Logo",
    d: "M20.67,2.11C10.36,2.11,2,10.47,2,20.78v60.44c0,.34.28.62.62.62h60.44c10.31,0,18.67-8.36,18.67-18.67V2.73c0-.34-.28-.62-.62-.62,0,0-60.44,0-60.44,0ZM723.96,19.54c-7.92,0-13.73,3.41-17.05,8.15v-.37c0-3.77-3.06-6.83-6.83-6.83-.27,0-.49.22-.49.49v53.92c0,3.77,3.06,6.84,6.84,6.84.27,0,.49-.22.49-.49v-23.84c3.32,4.74,9.12,8.2,17.05,8.2,12.67,0,22.3-9.63,22.3-22.94,0-13.27-9.63-23.13-22.3-23.13h0ZM612.07,58.75c-.08-.49-.57-.81-1.04-.67-2.02.6-4.58.95-6.66.95-4.51,0-7.65-2.53-7.65-8.34v-23.91h13.27c.46,0,.83-.37.83-.83v-4.66c0-.46-.37-.83-.83-.83h-13.32v-7.44c0-3.73-3.03-6.76-6.77-6.75-.26,0-.47.22-.47.48v7.79h0v5.91h-7.37c-.46,0-.83.37-.83.83v4.66c0,.46.37.83.83.83h7.33v25.11c0,9.03,5.67,13.73,14.19,13.73,3.22,0,6.64-.56,8.67-1.27.38-.13.6-.51.54-.91l-.72-4.69h0ZM821.28,39.77l-4.61-.92c-6.22-1.2-9.26-2.53-9.26-6.36,0-4.05,3.96-6.45,11.15-6.45,3.97,0,8.4.77,11.87,2,.49.17,1.01-.16,1.08-.67l.68-4.74c.05-.38-.15-.75-.51-.89-3.46-1.3-8.54-2.2-13.58-2.2-11.01,0-17.97,5.25-17.97,13.13,0,6.82,4.7,10.69,12.02,12.12l5.76,1.15c6.22,1.2,9.63,2.86,9.63,6.82s-3.82,6.31-10.92,6.31c-4.93,0-10.13-1.06-14.09-2.85-.49-.22-1.06.1-1.14.63l-.75,4.83c-.06.36.13.72.46.88,4.13,1.91,10.04,3.05,16.03,3.05,10.74,0,17.6-4.61,17.6-13.22,0-6.91-4.66-10.87-13.45-12.62h0ZM660.19,44.55c1.99-13.3-6.45-25-21.17-25-13.27,0-22.76,9.86-22.76,23.04s10.27,23.04,25.15,23.04c5.74,0,11.14-1.25,16.15-4.03.31-.17.48-.54.41-.89l-.96-4.95c-.11-.54-.71-.82-1.2-.57-5.48,2.8-9.85,3.58-14.72,3.58-8.57,0-15.94-4.79-17.18-13.5h35.45c.41,0,.76-.3.82-.7ZM883.45,44.55c1.99-13.3-6.45-25-21.17-25-13.27,0-22.76,9.86-22.76,23.04s10.27,23.04,25.15,23.04c5.74,0,11.14-1.25,16.15-4.03.31-.17.48-.54.41-.89l-.96-4.95c-.11-.54-.71-.82-1.2-.57-5.48,2.8-9.85,3.58-14.72,3.58-8.57,0-15.94-4.79-17.18-13.5h35.45c.41,0,.76-.3.82-.7ZM527.64,44.55c1.99-13.3-6.45-25-21.17-25-13.27,0-22.76,9.86-22.76,23.04s10.27,23.04,25.15,23.04c5.74,0,11.14-1.25,16.15-4.03.31-.17.48-.54.41-.89l-.96-4.95c-.11-.54-.71-.82-1.2-.57-5.48,2.8-9.85,3.58-14.72,3.58-8.57,0-15.94-4.79-17.18-13.5h35.45c.41,0,.76-.3.82-.7ZM335.43,20.24h-6.89c-.63,0-1.13.51-1.13,1.13v23.9c0,7.36-5.51,11.61-12.49,11.61s-10.83-4.26-10.83-11.61v-23.9c0-.63-.51-1.13-1.13-1.13h-6.89c-.63,0-1.13.51-1.13,1.13v25.84c0,10.78,6.43,18.37,18.55,18.37,8.09,0,12.29-3.99,14.26-7.09,1.09,3.5,4.35,6.04,8.2,6.04.34,0,.62-.28.62-.62V21.37c0-.63-.51-1.13-1.13-1.13ZM441.35,19.32c-13.28,0-22.85,9.9-22.85,23.13s10.32,23.13,25.26,23.13c5.92,0,11.28-1.31,16.23-3.96.43-.23.65-.71.57-1.19l-1.01-6.06c-.12-.73-.91-1.15-1.58-.84-5.27,2.4-9.42,3.54-14.21,3.54-8.6,0-14.25-4.02-15.87-11.29h33.59c.56,0,1.04-.4,1.12-.95,2.06-14.01-7.14-25.51-21.25-25.51h0ZM128.36,19.32c-13.28,0-22.85,9.9-22.85,23.13s10.32,23.13,25.26,23.13c5.92,0,11.28-1.31,16.23-3.96.43-.23.65-.71.57-1.19l-1.01-6.06c-.12-.73-.91-1.15-1.58-.84-5.27,2.4-9.42,3.54-14.21,3.54-8.6,0-14.25-4.02-15.87-11.29h33.59c.56,0,1.04-.4,1.12-.95,2.06-14.01-7.14-25.51-21.25-25.51ZM399.17,38.93l-5.18-1.06c-5.6-1.16-7.68-2.54-7.68-5.32,0-3.28,3.33-5.18,10.04-5.18,4.08,0,8.67.79,12.18,2.06.69.25,1.42-.2,1.51-.92l.69-5.65c.06-.52-.24-1.01-.73-1.2-3.7-1.43-9.05-2.34-14.11-2.34-11.1,0-18.51,5.55-18.51,13.09,0,6.85,4.16,11.33,11.98,12.91l6.57,1.34c5.74,1.16,8.14,2.78,8.14,5.78,0,3.42-3.1,5.09-9.76,5.09-4.48,0-9.57-.98-13.85-2.65-.68-.26-1.42.18-1.52.9l-.79,5.67c-.07.48.17.96.61,1.17,3.88,1.86,9.82,2.96,16.17,2.96,10.78,0,18.09-4.3,18.09-13.28,0-7.73-4.81-11.52-13.83-13.37ZM265.13,19.32c-7.51,0-12.49,2.75-15.78,6.93V2.73c0-.34-.28-.62-.62-.62-4.74,0-8.59,3.84-8.59,8.59v53.21c0,.34.28.62.62.62,3.95,0,7.27-2.67,8.27-6.31,3.42,4.59,8.62,7.36,16.09,7.36,12.63,0,22.3-9.72,22.3-23.36s-9.67-22.9-22.3-22.9ZM65.61,55.94H26.08c-4.74,0-8.59,3.84-8.59,8.59,0,.34.28.62.62.62h39.52c4.74,0,8.59-3.84,8.59-8.58,0-.34-.28-.62-.62-.62ZM557.85,19.54c-7.04,0-12.35,3.54-14.84,7.63-.08-3.71-3.11-6.69-6.84-6.68-.26,0-.47.23-.47.49v42.88c0,.46.37.83.83.83h5.67c.46,0,.83-.37.83-.83v-24.14c0-8.06,6.13-13.27,13.68-13.27,8.02,0,12.53,4.52,12.53,13.13v24.28c0,.46.37.83.83.83h5.62c.46,0,.83-.37.83-.83v-26.08c0-11.38-7-18.24-18.66-18.24h0ZM791.32,20.46h-5.67c-.46,0-.83.37-.83.83v42.57c0,.46.37.83.83.83h5.67c.46,0,.83-.37.83-.83V21.29c0-.46-.37-.83-.83-.83ZM693.2,20.45c-1.1-.39-3.1-.91-5.65-.91-5.04,0-9.49,2.5-11.99,7.56-.12-3.68-3.13-6.62-6.84-6.61-.26,0-.47.23-.47.49v42.88c0,.46.37.83.83.83h5.72c.46,0,.83-.37.83-.83v-23.73c0-9.9,5.76-13.78,11.66-13.78,2.18,0,3.69.38,4.84.76.5.17,1.02-.17,1.08-.7l.56-5.1c.04-.39-.18-.74-.55-.87h0ZM778.51,20.45c-1.1-.39-3.1-.91-5.65-.91-5.04,0-9.49,2.5-11.99,7.56-.12-3.68-3.13-6.62-6.84-6.61-.26,0-.47.23-.47.49v42.88c0,.46.37.83.83.83h5.72c.46,0,.83-.37.83-.83v-23.73c0-9.9,5.76-13.78,11.66-13.78,2.18,0,3.69.38,4.84.76.5.17,1.02-.17,1.08-.7l.56-5.1c.04-.39-.18-.74-.55-.87h0ZM213.07,19.32c-7.63,0-13.18,3.93-15.87,8.28-2.82-5.14-8.19-8.28-15.82-8.28s-12.16,4.23-13.82,7.05c-1.06-3.54-4.34-6.13-8.22-6.13-.34,0-.62.28-.62.62v42.66c0,.63.51,1.13,1.13,1.13h6.94c.63,0,1.13-.51,1.13-1.13v-23.9c0-7.36,5.41-11.61,12.03-11.61s10.46,4.26,10.46,11.61v23.9c0,.63.51,1.13,1.13,1.13h6.94c.63,0,1.13-.51,1.13-1.13v-24.45c0-6.99,5.55-11.06,12.03-11.06s10.46,4.26,10.46,11.61v23.9c0,.63.51,1.13,1.13,1.13h6.94c.63,0,1.13-.51,1.13-1.13v-25.84c0-10.78-6.38-18.37-18.23-18.37h0ZM371.91,20.11c-1.06-.33-2.96-.8-5.21-.8-4.81,0-9.15,2.07-11.82,7.46-.92-3.75-4.3-6.53-8.33-6.53-.34,0-.62.28-.62.62v42.66c0,.63.51,1.13,1.13,1.13h6.94c.63,0,1.13-.51,1.13-1.13v-23.06c0-10.04,6.38-12.63,11.29-12.63,1.75,0,3.17.3,4.14.58.67.2,1.36-.26,1.44-.96l.71-6.13c.06-.54-.27-1.05-.79-1.21ZM723.22,58.98c-9.44,0-16.4-7.14-16.4-16.31s6.96-16.49,16.4-16.49,15.76,7.37,15.76,16.49-6.54,16.31-15.76,16.31h0ZM264.02,57.34c-8.56,0-14.67-6.94-14.67-15.13s6.15-14.66,14.67-14.66,14.25,6.48,14.25,14.66-5.69,15.13-14.25,15.13ZM18.12,46.58h16.21c4.74,0,8.59-3.84,8.59-8.59,0-.34-.28-.62-.62-.62h-16.21c-4.74,0-8.59,3.84-8.59,8.58,0,.34.28.62.62.62ZM491.54,39.26c.69-7.55,6.82-12.9,15.16-12.9s13.64,5.34,14.14,12.9h-29.3ZM847.36,39.26c.69-7.55,6.82-12.9,15.16-12.9s13.64,5.34,14.14,12.9h-29.3ZM624.1,39.26c.69-7.55,6.82-12.9,15.16-12.9s13.64,5.34,14.14,12.9h-29.3ZM428.17,38.47c.69-6.43,6.15-10.78,13.46-10.78s11.94,4.35,12.54,10.78h-26ZM115.18,38.47c.69-6.43,6.15-10.78,13.46-10.78s11.94,4.35,12.54,10.78h-26ZM18.12,28.01h39.52c4.74,0,8.59-3.84,8.59-8.59,0-.34-.28-.62-.62-.62H26.08c-4.74,0-8.59,3.84-8.59,8.58,0,.34.28.62.62.62ZM788.46,14.43c2.67,0,4.61-1.89,4.61-4.56s-1.94-4.51-4.61-4.51-4.51,1.84-4.51,4.51,1.84,4.56,4.51,4.56h0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }));
};

/* eslint-disable max-len */
const EANavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 528 84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.12,62.68V5.29H28.48v9.54H13.12V29.14H27.59v9.53H13.2V53.14H29.53v9.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.42,42.07,66,62.76H54.59L49.65,52.25a18.54,18.54,0,0,1-1.13-3.63h-.16a30.72,30.72,0,0,1-1.13,3.71L42.62,62.76h-11L43,42.07,32,21.7h11.8l4.05,10.18A27.4,27.4,0,0,1,49,35.6h.16a31.47,31.47,0,0,1,.89-3.47l5-10.43H65.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,58.32h0l-.08,23.2H68.73V21.7H79.16v5.74h.08c2-4.29,5.33-6.47,9.7-6.47a9.9,9.9,0,0,1,9,5.17c2.1,3.4,3.15,8.33,3.15,14.64,0,7.19-1.13,12.77-3.47,16.73s-5.58,6-9.86,6A9.48,9.48,0,0,1,79.24,58.32ZM78.83,41v2.91A18.05,18.05,0,0,0,80.29,52a4.42,4.42,0,0,0,4.12,2.83c3.88,0,5.82-4.61,5.82-13.74,0-7.68-1.86-11.56-5.58-11.56C80.77,29.62,78.83,33.42,78.83,41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,45.46c.08,6.39,3.07,9.62,9,9.62a18.47,18.47,0,0,0,9.38-2.83v8.57a24.58,24.58,0,0,1-11,2.51c-5.74,0-10.19-1.78-13.34-5.42s-4.69-8.81-4.69-15.76q0-9.33,4.37-15.28c2.91-4,7-6,12.36-6,4.77,0,8.49,1.62,10.92,4.93s3.71,7.92,3.71,14.07v5.57Zm11.08-7.35a16.42,16.42,0,0,0-1.14-6.71,3.94,3.94,0,0,0-4-2.43c-3.72,0-5.66,3.08-6,9.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.65,62.68V36.25c0-4.37-1.7-6.63-5-6.63a4.77,4.77,0,0,0-3.88,1.86,7.53,7.53,0,0,0-1.45,4.85V62.68H136.87v-41H147.3v5.9h.16A10.33,10.33,0,0,1,157.57,21Q168,21,168,33.58v29.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,61.39V52.33a15.6,15.6,0,0,0,9,3.08c3.24,0,4.85-1.38,4.85-4a3.26,3.26,0,0,0-1.29-2.66,27.74,27.74,0,0,0-3.64-2.43c-3.8-2.18-6.3-4.28-7.43-6.3a13.14,13.14,0,0,1-1.7-6.47,11.63,11.63,0,0,1,3.8-9c2.5-2.27,6-3.4,10.51-3.4a22.29,22.29,0,0,1,8.48,1.54v8.89a16.19,16.19,0,0,0-7.43-2.34c-3.24,0-4.85,1.37-4.85,4A3.65,3.65,0,0,0,182,35.6a17.76,17.76,0,0,0,4.36,3.07c3.56,2,5.9,4,7,5.9a12.49,12.49,0,0,1,1.7,6.55,11.45,11.45,0,0,1-3.72,9c-2.5,2.35-6.06,3.48-10.75,3.48C176.48,63.41,173.17,62.76,170.74,61.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,45.46c.08,6.39,3.07,9.62,9,9.62a18.47,18.47,0,0,0,9.38-2.83v8.57a24.58,24.58,0,0,1-11,2.51c-5.74,0-10.19-1.78-13.34-5.42S196,49.1,196,42.15q0-9.33,4.37-15.28c2.91-4,7-6,12.36-6,4.77,0,8.49,1.62,10.92,4.93s3.71,7.92,3.71,14.07v5.57Zm11-7.35a16.44,16.44,0,0,0-1.13-6.71,3.94,3.94,0,0,0-4-2.43c-3.72,0-5.66,3.08-6,9.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.3,62.68l-3.23-14.06H242.76l-3.31,14.06H227.89L243.81,5.29h12.86l15.27,57.39Zm-9.05-41c-.24-1.29-.57-3.32-.89-6.06-.08-.57-.16-1-.16-1.14h-.32a69,69,0,0,1-1.22,6.88l-4.2,18.51h10.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,62.68V36.25c0-4.37-1.7-6.63-5-6.63a4.75,4.75,0,0,0-3.88,1.86,7.54,7.54,0,0,0-1.46,4.85V62.68H275.18v-41H285.6v5.9h.17A10.32,10.32,0,0,1,295.87,21q10.42,0,10.43,12.61v29.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5,65.83c-3.08,10.75-8,16.17-14.72,16.17a14.4,14.4,0,0,1-6.3-1.29V72.22a6.64,6.64,0,0,0,4,1.13c2.51,0,4.2-1.53,5.26-4.61l1.94-6.06-13-40.9h11.64L323.68,46a57,57,0,0,1,1.05,6.95h.08c.08-.4.16-.89.24-1.45A54.44,54.44,0,0,1,326,46l5.42-24.25h10.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,62.68H375.49l-4.37-23.76a51.68,51.68,0,0,1-.72-7.28h-.16a60,60,0,0,1-.81,7.2l-4.61,23.84H353.18l-8.73-41h10.67L359.24,47a44.91,44.91,0,0,1,.65,6.39h.24c.24-2.27.49-4.37.73-6.39l4.93-25.3h10.67L380.91,47a25.65,25.65,0,0,1,.32,3.23l.16,3.16h.24a33.7,33.7,0,0,1,.65-6.31l4.28-25.3h9.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38,62.68V36.25c0-4.37-1.7-6.63-5-6.63a4.75,4.75,0,0,0-3.88,1.86A7.53,7.53,0,0,0,409,36.33V62.68H398.61V2.06H409V27.6h.16A10.32,10.32,0,0,1,419.3,21q10.43,0,10.43,12.61v29.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.39,45.46c.08,6.39,3.07,9.62,9,9.62a18.5,18.5,0,0,0,9.38-2.83v8.57a24.63,24.63,0,0,1-11,2.51c-5.73,0-10.18-1.78-13.33-5.42s-4.69-8.81-4.69-15.76q0-9.33,4.36-15.28c2.91-4,7-6,12.37-6,4.77,0,8.49,1.62,10.91,4.93s3.72,7.92,3.72,14.07v5.57Zm11.07-7.35a16.44,16.44,0,0,0-1.13-6.71,4,4,0,0,0-4-2.43c-3.72,0-5.66,3.08-6,9.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.49,31.48a9.6,9.6,0,0,0-3.63-.73c-5.1,0-7.6,3.8-7.6,11.32V62.76H466.83V21.7h10.43v6.79h.16Q479.6,21,485.91,21a9.74,9.74,0,0,1,2.58.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.7,45.46c.08,6.39,3.07,9.62,9,9.62a18.5,18.5,0,0,0,9.38-2.83v8.57a24.58,24.58,0,0,1-11,2.51c-5.74,0-10.19-1.78-13.34-5.42S490,49.1,490,42.15q0-9.33,4.36-15.28c2.91-4,7-6,12.37-6,4.77,0,8.49,1.62,10.91,4.93s3.72,7.92,3.72,14.07v5.57Zm11.07-7.35a16.44,16.44,0,0,0-1.13-6.71,4,4,0,0,0-4-2.43c-3.72,0-5.66,3.08-6,9.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.36,21.13a3.5,3.5,0,0,1-2.58-1,3.37,3.37,0,0,1-1-2.5,3.25,3.25,0,0,1,1-2.51,3.81,3.81,0,0,1,5.17-.08,3.55,3.55,0,0,1,1,2.51,3.21,3.21,0,0,1-1,2.5A3.3,3.3,0,0,1,522.36,21.13Zm.08-6.54a3,3,0,0,0-2.18.88,2.91,2.91,0,0,0-.81,2.11,2.83,2.83,0,0,0,.89,2.1,2.9,2.9,0,0,0,2.1.81,3,3,0,0,0,3-3,2.81,2.81,0,0,0-.89-2.11A3.23,3.23,0,0,0,522.44,14.59Zm1.78,5.17h-1.13l-.32-1.13c-.16-.41-.33-.57-.49-.57H522v1.7h-1V15.39h1.53c1.14,0,1.78.41,1.78,1.22,0,.56-.32,1-1,1.13h0c.33.08.49.32.65.73ZM521.8,16.2v1.05h.56c.41,0,.65-.16.65-.56s-.24-.57-.73-.57h-.48Z",
    fill: "#fff"
  }));
};

/* eslint-disable max-len */
const EdenredPayNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 245 84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.6,36.53c-2.37,0-3.88,1.55-4.35,3.6h8.45c-.29-2.27-1.87-3.6-4.1-3.6Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.02,37.43c-3.02,0-4.93,2.09-4.93,5s1.94,5.03,4.93,5.03,5-2.05,5-5.03-2.01-5-5-5Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90,32.65c-4.54,0-8.07,1.81-8.64,6.51-.04,0,.03,0-.01,0C79.91,17.85,63.1,1,41.42,1,24.29,1,9.63,11.53,3.53,26.47h14.52l-.76,4.89H5.9v5.18h10.32l-.79,4.71H5.9v3.02c0,1.83.79,2.7,2.3,2.7h9.74l-.79,4.89H6.37c-.53,0-1.03-.05-1.5-.13h0s-1.87-.2-3.02-1.7c-.03-.03-.5-.59-.73-1.52-.06-.24-.06-.26-.11-.44.08.61.21,1.43.27,1.73.33,1.71.74,3.15.78,3.25,4.85,17.19,20.63,29.8,39.37,29.8s35.36-13.19,39.8-30.98h-5.5v-10c0-2.7-1.04-4.42-3.7-4.42s-3.7,1.73-3.7,4.42v10h-5.5v-11.36c0-5.43,3.95-7.84,9.2-7.84s9.21,2.41,9.21,7.84v11.36s5.53,0,5.53,0v-10c0-2.7.72-4.42,3.34-4.42.83,0,1.83.25,2.19.43l1.04-4.82c-.61-.07-2.16-.4-3.34-.4Zm-50.44,8.67c0,6.87-4.06,10.89-10.79,10.89-6.22,0-10.43-4.17-10.43-9.78s3.99-9.78,9.96-9.78c2.73,0,4.75,1.08,5.75,2.16v-8.34h5.5v14.85Zm13.88,6.76c1.62,0,3.12-.47,4.52-1.11l-.46,4.35c-1.58.65-3.49.9-5.39.9-6.33,0-10.79-3.7-10.79-10,0-5.47,3.99-9.56,10.1-9.56,6.9,0,10.36,4.39,10.21,11.15h-14.24c.54,3.09,3.49,4.28,6.04,4.28Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.47,32.65c-6.11,0-10.1,4.1-10.1,9.56,0,6.29,4.46,10,10.79,10,1.91,0,3.81-.25,5.39-.9l.46-4.35c-1.4.65-2.9,1.11-4.52,1.11-2.55,0-5.5-1.19-6.04-4.28h14.24c.14-6.76-3.31-11.15-10.21-11.15Zm-4.17,7.48c.47-2.05,1.98-3.6,4.35-3.6,2.23,0,3.81,1.33,4.1,3.6h-8.45Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.01,26.47v8.34c-1.01-1.08-3.02-2.16-5.75-2.16-5.97,0-9.96,3.92-9.96,9.78s4.21,9.78,10.43,9.78c6.72,0,10.79-4.03,10.79-10.89v-14.85h-5.5Zm-5.03,21c-2.98,0-4.93-2.16-4.93-5.03s1.91-5,4.93-5,5,2.01,5,5-2.01,5.03-5,5.03Z",
    fill: "#f72717",
    strokeWidth: "0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "154.37",
    y: "6.84",
    width: "5.44",
    height: "64.38",
    rx: "2.63",
    ry: "2.63",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.2,26.26c5.24,0,7.7,3.81,7.7,8.12s-2.67,8.12-8.2,8.08h-4.96c-2.04,0-2.57-.97-3.06-1.8v10.96h-5.03v-25.36h13.54Zm-8.51,9.66c0,1.4.81,2.3,2.85,2.3h3.94c2.74,0,3.97-1.65,3.97-3.88,0-2.95-1.51-3.88-3.83-3.88h-6.93v5.46Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.39,51.62h-4.57v-2.66c-1.55,1.87-3.97,2.94-6.65,2.94-5.35,0-9.46-3.74-9.46-9.59s4.19-9.88,10.31-9.88,10.38,4.02,10.38,10.17v9.02Zm-10.41-15.05c-3.27,0-5.42,2.51-5.42,5.64s2.08,5.64,5.42,5.64,5.45-2.3,5.45-5.64-2.18-5.64-5.45-5.64Z",
    fill: "#f72717",
    strokeWidth: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.17,58.23s3.97-3.56,4.15-8.73c-1.34,1.83-3.45,2.48-5.35,2.48-4.54,0-7.28-2.3-7.28-7.61v-11.67h4.64v10.38c0,2.87.88,4.78,3.76,4.78,3.31,0,4.26-2.3,4.26-4.71v-10.45h4.64v16.24c0,5.68-3.34,9.3-3.34,9.3h-5.49Z",
    fill: "#f72717",
    strokeWidth: "0"
  })));
};

/* eslint-disable max-len */
const LassoNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 192 46"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "-8",
    y: "-6.08",
    width: "209",
    height: "57.53",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "73.09 31.27 84.14 31.27 84.14 33.41 70.68 33.41 70.68 9.72 73.09 9.72 73.09 31.27",
    fill: "none",
    clipPath: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.75,25h10.44L101,12.4Zm-3.52,8.44H89.62L99.86,9.72h2.35l10.14,23.7H109.7l-2.61-6.23H94.84l-2.58,6.23Z",
    fill: "none",
    clipPath: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132,13.54a5.94,5.94,0,0,0-2-1.73,6.05,6.05,0,0,0-2.92-.64,6.26,6.26,0,0,0-1.77.25,5.29,5.29,0,0,0-1.64.83,4.27,4.27,0,0,0-1.18,1.39,4.12,4.12,0,0,0-.46,2,3.67,3.67,0,0,0,.44,1.86,4.15,4.15,0,0,0,1.17,1.26,6.82,6.82,0,0,0,1.65.86l1.91.66c.82.27,1.66.56,2.49.87A9.12,9.12,0,0,1,132,22.31a5.59,5.59,0,0,1,2.27,4.84,6.49,6.49,0,0,1-.68,3.06,6.27,6.27,0,0,1-1.75,2.11,7.44,7.44,0,0,1-2.48,1.25,10.12,10.12,0,0,1-2.79.4,10.24,10.24,0,0,1-2.14-.23,9.12,9.12,0,0,1-2-.64A8.62,8.62,0,0,1,120.57,32a8.2,8.2,0,0,1-1.47-1.53l2.08-1.54A6.32,6.32,0,0,0,123.33,31a6.14,6.14,0,0,0,3.26.85,6.43,6.43,0,0,0,1.85-.28,5.43,5.43,0,0,0,1.69-.87,4.71,4.71,0,0,0,1.17-1.45,3.91,3.91,0,0,0,.5-2,4,4,0,0,0-.5-2.06A4.29,4.29,0,0,0,130,23.88a8,8,0,0,0-1.84-.93L126,22.23c-.79-.25-1.55-.53-2.35-.85a7.51,7.51,0,0,1-2-1.17,5.89,5.89,0,0,1-1.46-1.87,6,6,0,0,1-.55-2.71,5.94,5.94,0,0,1,2.47-5,7.51,7.51,0,0,1,2.45-1.18,9.83,9.83,0,0,1,2.64-.36,9.16,9.16,0,0,1,4.12.85,6.89,6.89,0,0,1,2.57,2L132,13.53",
    fill: "none",
    clipPath: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.57,13.54a5.85,5.85,0,0,0-2-1.73,6,6,0,0,0-2.91-.64,6.33,6.33,0,0,0-1.78.25,5.4,5.4,0,0,0-1.64.83,4.08,4.08,0,0,0-1.62,3.37,3.54,3.54,0,0,0,.43,1.86,4.06,4.06,0,0,0,1.18,1.26,6.69,6.69,0,0,0,1.63.86l1.91.66q1.24.4,2.49.87a9,9,0,0,1,2.26,1.18,6,6,0,0,1,1.63,1.9,6.1,6.1,0,0,1,.63,2.94,6.38,6.38,0,0,1-.68,3.06,6.15,6.15,0,0,1-1.75,2.11,7.34,7.34,0,0,1-2.46,1.25,10,10,0,0,1-4.94.17,9.2,9.2,0,0,1-2-.64A8.1,8.1,0,0,1,144.14,32a7.94,7.94,0,0,1-1.48-1.53l2.07-1.54A6.53,6.53,0,0,0,146.89,31a6.06,6.06,0,0,0,3.27.85,6.3,6.3,0,0,0,1.83-.28,5.32,5.32,0,0,0,1.69-.87,4.84,4.84,0,0,0,1.25-1.45,4,4,0,0,0,.48-2,4.09,4.09,0,0,0-.48-2.06,4.47,4.47,0,0,0-1.3-1.37,8,8,0,0,0-1.84-.93l-2.17-.72c-.79-.25-1.55-.53-2.35-.85a8.12,8.12,0,0,1-2-1.17,6,6,0,0,1-1.46-1.87,6,6,0,0,1-.55-2.71,6,6,0,0,1,.69-2.94,6.26,6.26,0,0,1,1.79-2,7.36,7.36,0,0,1,2.44-1.18,9.9,9.9,0,0,1,2.65-.36,9.09,9.09,0,0,1,4.11.85,6.89,6.89,0,0,1,2.57,2l-1.9,1.54",
    fill: "none",
    clipPath: "url(#a)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "64.81",
    y: "3.85",
    width: "25.2",
    height: "35.44",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "83.75",
    y: "3.85",
    width: "34.5",
    height: "35.44",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "113.2",
    y: "3.25",
    width: "26.9",
    height: "36.63",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "136.75",
    y: "3.25",
    width: "26.9",
    height: "36.63",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.54,2.58h.15a35.84,35.84,0,0,0-11-1.4H31A22.82,22.82,0,0,0,21,4.2c-7.92,4.58-12.63,11-12.13,20.57a3.27,3.27,0,0,1-1,2.81,20.39,20.39,0,0,0-1.47,1.47A18,18,0,0,0,1.59,40.3v2c.32.51.66,1,1.38,1s1.17.2,1.75-.19c1-.64,1-1.75,1.17-2.76a17.17,17.17,0,0,1,5-9.31,32.67,32.67,0,0,0,1.79,3c3.43,4.56,7.48,8,13.56,8.09a10.19,10.19,0,0,0,9.28-5.13A8.33,8.33,0,0,0,36,29.05a12.48,12.48,0,0,0-.88-1.8c-2.7-4.58-8.85-6.87-14.75-5.59A40.4,40.4,0,0,0,13.45,24,14.73,14.73,0,0,1,15,16.23c3.62-7,12.1-11.49,21-10.71,10.92,1,18.79,8.66,18.51,19.3A18.28,18.28,0,0,1,54,29.05,14.1,14.1,0,0,1,43.48,39.3c-.86.23-1.64.56-1.86,1.51a1.85,1.85,0,0,0,1.06,2.27,4.8,4.8,0,0,0,2.44,0,9.92,9.92,0,0,0,4.7-1.62A18.66,18.66,0,0,0,58,29a29.38,29.38,0,0,0,.51-4C59.16,14.84,52.16,5.56,42.54,2.58ZM15.24,27.73a18.63,18.63,0,0,1,8.22-2.29,9.69,9.69,0,0,1,5.42,1.25A8,8,0,0,1,31.49,29a5.4,5.4,0,0,1,.84,5,6.75,6.75,0,0,1-7.76,3.81c-4.9-1.12-7.83-4.52-10-8.78V29C14.13,28.16,14.72,28,15.24,27.73Z",
    fill: "#f5bf3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,9.25a12,12,0,0,0-12.39,11.66c0,.22,0,.44,0,.66a12,12,0,0,0,11.5,12.48h.69c7.05.08,12.27-5.08,12.32-12.29S185.72,9.3,178.63,9.25ZM178.56,32c-5.6,0-9.79-4.35-9.83-10.22s4.28-10.47,9.88-10.39,9.7,4.43,9.69,10.34S184.19,32,178.56,32Z",
    fill: "#ffffff"
  }));
};

/* eslint-disable max-len */
const NexoniaNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 275 84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.23,55.35,161.87,69.6a.55.55,0,0,1-.44.89h-4.36a.53.53,0,0,1-.44-.22l-8.56-11.48-8.49,11.47a.55.55,0,0,1-.44.23h-4.3a.56.56,0,0,1-.56-.55.54.54,0,0,1,.12-.34L145,55.38,134.72,41.93a.55.55,0,0,1,.1-.77.54.54,0,0,1,.34-.12h4.41a.55.55,0,0,1,.44.23L148.16,52l8.22-10.74a.54.54,0,0,1,.44-.22h4.29a.55.55,0,0,1,.55.55.52.52,0,0,1-.12.34Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.94,67.82a.54.54,0,0,1-.27.59A21.8,21.8,0,0,1,119.9,71.1c-9.92,0-16.76-6.26-16.76-15.35,0-8.78,6.32-15.35,15.17-15.35,9.8,0,15.43,7.8,14.1,16.66a.56.56,0,0,1-.55.47H108.24c.82,5.8,5.74,9,11.45,9a20,20,0,0,0,9.81-2.38.56.56,0,0,1,.75.23.88.88,0,0,1,.05.15Zm-3-14.28c-.34-5-3.81-8.6-9.43-8.6s-9.64,3.56-10.1,8.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,40.4c9,0,15.65,6.72,15.65,15.35A15.22,15.22,0,0,1,178.54,71.1c-9,0-15.66-6.73-15.66-15.35S169.57,40.4,178.54,40.4Zm0,26.15a10.81,10.81,0,1,0-10.78-10.83v0a10.57,10.57,0,0,0,10.33,10.8A3.38,3.38,0,0,0,178.54,66.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,41A4.55,4.55,0,0,0,268,45.58v.25c-2.21-3.16-6.08-5.43-11.37-5.43-8.44,0-14.85,6.41-14.85,15.26s6.41,15.44,14.85,15.44c5.28,0,9.15-2.3,11.37-5.47v.31a4.55,4.55,0,0,0,4.55,4.55.32.32,0,0,0,.33-.32h0V41.35a.32.32,0,0,0-.33-.32ZM257.16,66.68c-6.14,0-10.5-4.91-10.5-11s4.36-10.84,10.5-10.84a10.67,10.67,0,0,1,10.93,10.4v.44a10.81,10.81,0,0,1-10.58,11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,40.4a11.44,11.44,0,0,0-9.89,5.09A4.56,4.56,0,0,0,71.52,41a.33.33,0,0,0-.32.33V69.93a.56.56,0,0,0,.55.56h3.78a.56.56,0,0,0,.56-.56V53.85c0-5.38,4.08-8.85,9.11-8.85,5.35,0,8.35,3,8.35,8.75V69.93a.56.56,0,0,0,.56.56h3.75a.56.56,0,0,0,.55-.56V52.56C98.4,45,93.74,40.4,86,40.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,40.4a11.44,11.44,0,0,0-9.89,5.09A4.56,4.56,0,0,0,199,41a.33.33,0,0,0-.32.33V69.93a.56.56,0,0,0,.56.56H203a.56.56,0,0,0,.56-.56V53.85c0-5.38,4.08-8.85,9.11-8.85,5.35,0,8.36,3,8.36,8.75V69.93a.55.55,0,0,0,.55.56h3.75a.56.56,0,0,0,.55-.56V52.56C225.92,45,221.25,40.4,213.48,40.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.44,41h3.78a.55.55,0,0,1,.55.55V69.93a.55.55,0,0,1-.55.56h-3.78a.56.56,0,0,1-.55-.56V41.56A.55.55,0,0,1,232.44,41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,34a2.87,2.87,0,0,1,2.72-3h.29a3,3,0,1,1-3,3Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.46,7.88a7.62,7.62,0,0,0-7.81,7.89c0,4.68,3.52,7.9,8.63,7.9a11.41,11.41,0,0,0,5.54-1.35.38.38,0,0,0,.19-.4l-.34-2.07a.39.39,0,0,0-.45-.32.16.16,0,0,0-.09,0,11.25,11.25,0,0,1-4.85,1.21c-2.94,0-4.87-1.38-5.42-3.86H85.33a.39.39,0,0,0,.39-.32C86.42,11.8,83.27,7.88,78.46,7.88ZM74,14.42c.24-2.2,2.1-3.68,4.6-3.68a3.94,3.94,0,0,1,4.28,3.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,7.88A6.3,6.3,0,0,0,102,10.7a5.76,5.76,0,0,0-5.4-2.82,5.33,5.33,0,0,0-4.72,2.4A2.94,2.94,0,0,0,89,8.19a.21.21,0,0,0-.21.21V23a.39.39,0,0,0,.39.39h2.37A.39.39,0,0,0,92,23V14.81a3.85,3.85,0,0,1,4.11-4c2.23,0,3.57,1.45,3.57,4V23a.39.39,0,0,0,.39.39h2.37a.39.39,0,0,0,.38-.39V14.62a3.8,3.8,0,0,1,4.11-3.77c2.23,0,3.57,1.45,3.57,4V23a.39.39,0,0,0,.39.39h2.37a.4.4,0,0,0,.39-.39V14.15C113.6,10.47,111.42,7.88,107.38,7.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16,7.88a6.41,6.41,0,0,0-5.39,2.36v-8a.22.22,0,0,0-.21-.21,2.93,2.93,0,0,0-2.93,2.93h0V23.1a.21.21,0,0,0,.21.21,2.92,2.92,0,0,0,2.82-2.15,6.42,6.42,0,0,0,5.5,2.51c4.31,0,7.61-3.31,7.61-8A7.45,7.45,0,0,0,125.16,7.88Zm-.38,13a5,5,0,0,1-5-5V15.7a4.9,4.9,0,0,1,4.79-5h.22a4.77,4.77,0,0,1,4.86,5A4.9,4.9,0,0,1,124.78,20.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.16,8.19h-2.35a.39.39,0,0,0-.39.39h0v8.16c0,2.51-1.88,4-4.27,4s-3.69-1.45-3.69-4V8.58a.39.39,0,0,0-.39-.39h-2.35a.4.4,0,0,0-.39.39V17.4c0,3.68,2.2,6.27,6.34,6.27a5.44,5.44,0,0,0,4.87-2.42,2.93,2.93,0,0,0,2.8,2.07.23.23,0,0,0,.21-.22V8.58a.39.39,0,0,0-.39-.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,8.15a6,6,0,0,0-1.78-.27,4.26,4.26,0,0,0-4,2.54A2.93,2.93,0,0,0,153,8.19a.22.22,0,0,0-.21.21h0V23a.4.4,0,0,0,.39.39h2.37a.4.4,0,0,0,.39-.39h0V15.1c0-3.43,2.18-4.32,3.85-4.32a5.16,5.16,0,0,1,1.41.2.39.39,0,0,0,.48-.26.15.15,0,0,0,0-.07l.25-2.09A.39.39,0,0,0,161.62,8.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,14.58l-1.77-.37c-1.92-.39-2.63-.87-2.63-1.81,0-1.13,1.14-1.77,3.43-1.77a12.79,12.79,0,0,1,4.16.7.38.38,0,0,0,.49-.23.29.29,0,0,0,0-.09l.24-1.92a.38.38,0,0,0-.25-.41,14.38,14.38,0,0,0-4.82-.8c-3.79,0-6.32,1.89-6.32,4.47,0,2.34,1.43,3.87,4.1,4.41l2.24.45c2,.4,2.78.95,2.78,2s-1.06,1.74-3.33,1.74a13.66,13.66,0,0,1-4.73-.91.4.4,0,0,0-.5.22.29.29,0,0,0,0,.09l-.28,1.93a.38.38,0,0,0,.21.4,13.57,13.57,0,0,0,5.52,1c3.68,0,6.18-1.47,6.18-4.54C175.65,16.5,174,15.21,170.93,14.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,7.88a7.62,7.62,0,0,0-7.81,7.89c0,4.68,3.53,7.9,8.63,7.9a11.41,11.41,0,0,0,5.54-1.35.38.38,0,0,0,.19-.4l-.34-2.07a.38.38,0,0,0-.44-.32.17.17,0,0,0-.1,0,11.22,11.22,0,0,1-4.85,1.21c-2.94,0-4.87-1.38-5.42-3.86H192.2a.4.4,0,0,0,.39-.32C193.29,11.8,190.15,7.88,185.33,7.88Zm-4.51,6.54c.24-2.2,2.11-3.68,4.6-3.68a3.94,3.94,0,0,1,4.28,3.68Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M54.54,29H14.4A12.4,12.4,0,0,0,2,41.39V81.52a.42.42,0,0,0,.41.42H42.55A12.4,12.4,0,0,0,55,69.54V29.4A.41.41,0,0,0,54.54,29ZM36.33,73.66l-.06-.08L26.22,59.43,20.36,67.6H14l9.3-12.41L14.14,42.78h6.65l5.64,8L36.5,36.71h6.29L29.38,55.05,43,73.66Z",
    fill: "#fff"
  })));
};

/* eslint-disable max-len */
const SpendNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "190",
    viewBox: "0 0 725 84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.12,44.2c-.08,.5-.58,.91-1.08,.91h-33.23c1.58,7.14,7.14,11.13,15.7,11.13,4.74,0,8.81-1.16,14.04-3.49,.58-.25,1.25,0,1.5,.58,0,.08,.08,.17,.08,.25l1,5.98c.08,.5-.17,.91-.58,1.16-4.9,2.66-10.47,3.99-16.03,3.9-14.79,0-25.01-9.3-25.01-22.85s9.47-22.85,22.6-22.85c13.96,0,23.01,11.38,21.02,25.25Zm-8.31-6.31c-.58-6.4-5.15-10.63-12.38-10.63s-12.63,4.32-13.29,10.63h25.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54,37.14v25.59c0,.58-.5,1.08-1.08,1.08h-6.9c-.58,0-1.08-.5-1.08-1.08v-23.68c0-7.31-3.9-11.46-10.3-11.46s-11.63,3.99-11.88,10.97v24.17c0,.58-.5,1.08-1.08,1.08h-6.9c-.58,0-1.08-.5-1.08-1.08h0v-23.68c0-7.31-3.9-11.46-10.3-11.46s-11.88,4.24-11.88,11.46v23.68c0,.58-.5,1.08-1.08,1.08h-6.9c-.58,0-1.08-.5-1.16-1.08V20.53c0-.33,.25-.58,.58-.58,3.74,0,7.06,2.49,8.14,6.15l.33-.58c1.41-2.24,5.57-6.48,13.29-6.48s12.88,3.16,15.62,8.22c2.66-4.32,8.14-8.22,15.7-8.22,11.63-.08,17.94,7.48,17.94,18.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03,41.63c0,13.46-9.55,23.09-22.01,23.09-7.48,0-12.38-2.74-15.62-6.9l-.25-.33c-1,3.74-4.32,6.31-8.14,6.31-.33,0-.58-.25-.58-.58V10.47c0-4.65,3.82-8.47,8.47-8.47h0c.33,0,.58,.25,.58,.58V25.84c3.24-4.15,8.22-6.9,15.62-6.9,12.38,0,21.93,9.22,21.93,22.68Zm-9.06,0c0-8.14-5.65-14.54-14.12-14.54-7.81-.17-14.29,6.06-14.45,13.87v.58c0,8.06,6.06,14.95,14.54,14.95s14.04-6.81,14.04-14.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,21.02V63.23c0,.33-.25,.58-.58,.58-3.74,0-7.06-2.49-8.14-6.06l-.33,.58c-1.5,2.24-5.65,6.48-13.71,6.48-11.96,0-18.36-7.48-18.36-18.19V21.02c0-.58,.5-1.08,1.16-1.16h6.81c.58,0,1.08,.5,1.08,1.16v23.59c0,7.31,3.99,11.46,10.72,11.46s12.38-4.24,12.38-11.46V21.02c0-.58,.5-1.08,1.08-1.16h6.81c.58,0,1.08,.58,1.08,1.16h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.51,20.94l-.66,6.06c-.08,.58-.58,1.08-1.25,1h-.17c-1.33-.42-2.66-.58-4.07-.58-4.82,0-11.13,2.58-11.13,12.46v22.85c0,.58-.5,1.08-1.08,1.08h-6.9c-.58,0-1.08-.5-1.16-1.08V20.53c0-.33,.25-.58,.58-.58,3.9,0,7.31,2.66,8.22,6.48l.25-.5c2.08-4.4,6.56-7.06,11.46-6.9,1.74,0,3.49,.25,5.15,.83,.5,.08,.83,.58,.75,1.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.39,51.6c0,8.89-7.23,13.13-17.86,13.13-6.23,0-12.13-1.08-15.95-2.91-.42-.25-.66-.66-.58-1.16l.83-5.65c.08-.58,.66-1,1.25-.91,.08,0,.17,0,.25,.08,4.4,1.66,8.97,2.58,13.71,2.58,6.56,0,9.64-1.66,9.64-4.98,0-2.99-2.41-4.57-8.06-5.73l-6.48-1.33c-7.73-1.58-11.88-5.98-11.88-12.79,0-7.48,7.31-12.96,18.28-12.96,4.74,0,9.47,.75,13.96,2.33,.5,.17,.75,.66,.66,1.16l-.66,5.57c-.08,.58-.58,1.08-1.25,1-.08,0-.17,0-.25-.08-3.9-1.33-7.98-1.99-12.05-2.08-6.65,0-9.97,1.91-9.97,5.15,0,2.74,2.08,4.15,7.56,5.23l5.15,1.08c8.97,1.91,13.71,5.65,13.71,13.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.15,44.2c-.08,.5-.58,.91-1.08,.91h-33.23c1.58,7.14,7.14,11.13,15.7,11.13,4.74,0,8.81-1.16,14.04-3.49,.58-.25,1.25,0,1.5,.58,0,.08,.08,.17,.08,.25l1,5.98c.08,.5-.17,.91-.58,1.16-4.9,2.66-10.47,3.99-16.03,3.9-14.79,0-25.01-9.3-25.01-22.85s9.47-22.85,22.6-22.85c13.96,0,23.01,11.38,21.02,25.25Zm-8.39-6.31c-.58-6.4-5.15-10.63-12.38-10.63s-12.63,4.32-13.29,10.63h25.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.56,51.51c0,8.56-6.81,13.04-17.36,13.04-5.9,0-11.8-1.08-15.87-2.99-.33-.17-.5-.5-.42-.83l.75-4.82c.08-.42,.5-.75,1-.66q.08,0,.17,.08c4.4,1.91,9.14,2.82,13.96,2.82,6.98,0,10.8-2.16,10.8-6.23s-3.41-5.57-9.55-6.73l-5.65-1.16c-7.23-1.41-11.88-5.23-11.88-11.96,0-7.81,6.9-12.96,17.78-12.96,4.57,0,9.14,.66,13.46,2.16,.33,.17,.58,.5,.5,.91l-.66,4.65c-.08,.42-.5,.75-1,.66h-.08c-3.82-1.25-7.73-1.91-11.71-1.99-7.06,0-11.05,2.33-11.05,6.4,0,3.74,2.99,5.07,9.14,6.31l4.57,.91c8.56,1.66,13.13,5.57,13.13,12.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.81,41.88c0,13.13-9.55,22.68-22.01,22.68-7.81,0-13.54-3.41-16.86-8.14v23.59c0,.25-.25,.5-.5,.5h0c-3.74,0-6.73-2.99-6.73-6.73h0V20.44c0-.25,.25-.5,.5-.5h0c3.74,0,6.73,2.99,6.73,6.73h0v.33c3.32-4.65,8.97-8.06,16.86-8.06,12.46,.08,22.01,9.8,22.01,22.93Zm-7.23,0c0-9.06-6.48-16.28-15.53-16.28-8.81-.08-16.12,6.98-16.2,15.78v.5c-.17,8.72,6.81,15.95,15.53,16.12h.66c9.06,0,15.53-7.06,15.53-16.12h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,43.7c-.08,.42-.42,.66-.83,.66h-35.06c1.25,8.64,8.47,13.37,16.95,13.37,5.07,.08,10.05-1.16,14.54-3.49,.42-.17,.91-.08,1.08,.33,0,.08,.08,.17,.08,.17l.91,4.9c.08,.33-.08,.66-.42,.83-4.9,2.66-10.38,4.07-15.95,3.99-14.7,0-24.84-9.3-24.84-22.76s9.39-22.76,22.51-22.76c14.62,.08,23.01,11.63,21.02,24.76Zm-6.73-5.15c-.5-7.48-5.65-12.71-13.96-12.71s-14.29,5.32-14.95,12.71h28.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.25,37.06v25.75c0,.5-.33,.83-.83,.83h-5.57c-.5,0-.83-.33-.83-.83v-23.93c0-8.47-4.49-12.96-12.38-12.96-7.48,0-13.54,5.15-13.54,13.13v23.84c0,.5-.33,.83-.83,.83h-5.57c-.5,0-.83-.33-.83-.83V20.53c0-.25,.25-.5,.5-.5,3.66,0,6.73,2.99,6.73,6.65,2.49-4.07,7.73-7.56,14.7-7.56,11.55-.08,18.44,6.73,18.44,17.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723,8.98V63.23c0,.25-.25,.5-.5,.5-3.74,0-6.73-2.99-6.73-6.73h0v-.33c-3.32,4.65-8.97,7.98-16.86,7.98-12.54,0-22.01-9.72-22.01-22.85s9.55-22.68,22.01-22.68c7.81,0,13.54,3.41,16.86,8.14V2.66c0-.25,.17-.5,.5-.5h0c3.74,0,6.73,3.07,6.73,6.81h0Zm-7.14,32.73c.17-8.72-6.81-15.95-15.53-16.12h-.66c-9.14,0-15.53,7.06-15.53,16.12s6.48,16.28,15.53,16.28c8.81,.08,16.12-6.98,16.2-15.78v-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.17,2H20.69C10.39,2,2,10.39,2,20.69v60.48c0,.33,.25,.66,.66,.66H63.14c10.3,0,18.69-8.31,18.69-18.61V2.66c0-.33-.25-.66-.66-.66Zm-21.43,51.51c-1.08,5.23-5.65,9.14-10.97,9.3H18.7c-.33-.08-.5-.33-.42-.66,1.08-5.23,5.57-9.14,10.97-9.3h30.07c.33,.08,.5,.33,.42,.66Zm1.33-7.31c-.08,.42-.42,.66-.83,.66H30.33c-5.15,0-8.56-4.15-7.64-9.3,.08-.42,.42-.66,.83-.66h29.91c5.15,0,8.56,4.15,7.64,9.3Zm-6.65-15.29H24.51c-.33,0-.58-.25-.58-.5v-.17c1.08-5.23,5.57-9.14,10.97-9.3h29.91c.33,0,.58,.25,.58,.5,0,.08,0,.17,0,.17-1.08,5.23-5.57,9.14-10.97,9.3Z",
    fill: "#fff"
  }));
};

/* eslint-disable max-len */
const SutiSoftNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 276 84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6,12.77C13.23,21,12.26,36.34,12.26,37l3.89,2.64-3,2.66C15.83,54.09,27.28,58,27.28,58a28.91,28.91,0,0,1-9.71-18.05C16.13,24.87,31.65,12.77,31.65,12.77",
    fill: "#f07049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28,39.94c0,1.93-2.39,3.48-5.34,3.48s-5.32-1.55-5.32-3.48S5,36.47,7.94,36.47s5.34,1.56,5.34,3.47",
    fill: "#f07049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,33.38a31.52,31.52,0,0,0-22.67-21l-3.14,4L38.68,13A22.18,22.18,0,0,0,22.53,25.79a29.65,29.65,0,0,1,19.28-8.37c13.72-.52,25.55,15.92,25.55,15.92",
    fill: "#1c8ecd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.71,13.07c-2,0-3.61-2.48-3.61-5.53S39.72,2,41.71,2s3.62,2.48,3.62,5.54-1.67,5.53-3.62,5.53",
    fill: "#1c8ecd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.61,51A31.45,31.45,0,0,0,38.36,71.84l3.12-4,2.9,3.35a22.18,22.18,0,0,0,16-12.91,29.76,29.76,0,0,1-19.21,8.57C27.5,67.3,15.61,51,15.61,51",
    fill: "#5cbd78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,70.93c2,0,3.62,2.48,3.62,5.53S43.52,82,41.58,82,38,79.52,38,76.46s1.68-5.53,3.62-5.53",
    fill: "#5cbd78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.66,27.68a9.67,9.67,0,0,0-4.14-1.13,4.29,4.29,0,0,0-3.11,1.22A3.83,3.83,0,0,0,35.1,30.7a5.39,5.39,0,0,0,.77,2.59,30.36,30.36,0,0,0,3.48,4.42A42.09,42.09,0,0,1,43.5,43a9.23,9.23,0,0,1,1.43,5.11A7.7,7.7,0,0,1,42.6,53.9a8.52,8.52,0,0,1-6.11,2.25,15.16,15.16,0,0,1-5-1.14V51.16h.16a13.23,13.23,0,0,0,1.68.85,6.55,6.55,0,0,0,2.58.57,4.55,4.55,0,0,0,3.34-1.27,4.25,4.25,0,0,0,1.33-3.23,5.19,5.19,0,0,0-.67-2.55,21.87,21.87,0,0,0-2.51-3.09l-3.07-3.6A19.66,19.66,0,0,1,31.6,35,9.21,9.21,0,0,1,30.68,31a7.69,7.69,0,0,1,2.21-5.73A7.82,7.82,0,0,1,38.63,23a12,12,0,0,1,5,1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,48.88a7.81,7.81,0,0,1-1.67,5.58,7.47,7.47,0,0,1-5.49,1.67,7.69,7.69,0,0,1-5.54-1.67,7.3,7.3,0,0,1-1.68-5.41V33.65h4.42v15.4c0,2.44,1,3.67,2.85,3.67a2.3,2.3,0,0,0,2.11-.94,5.78,5.78,0,0,0,.52-3.12V33.59h4.42V48.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,36.93H78V55.78H73.49V36.93H70.63V33.66h2.86v-6H78v6h2.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,26.91a2.11,2.11,0,0,1,.74-1.67,2.44,2.44,0,0,1,1.67-.69,2.49,2.49,0,0,1,1.68.69,2.13,2.13,0,0,1,.72,1.67,2.05,2.05,0,0,1-.72,1.59,2.45,2.45,0,0,1-1.68.69,2.4,2.4,0,0,1-1.67-.69A2.06,2.06,0,0,1,86.08,26.91Zm.22,6.7h4.44V55.78H86.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.15,55.78V24.87h24.13v3.65h-19.7V38h18.51v3.63H102.68V52.13h20.37v3.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,55.78l8.84-11.64-8.19-10.76h5.13l3.71,5.25c.71,1,1.26,1.85,1.68,2.52.65-.92,1.27-1.68,1.84-2.47l4.07-5.3h4.9l-8.37,10.48,9,11.85h-5l-5-7-1.33-1.89-6.36,8.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.93,64.37v-31h3.74v2.91a9,9,0,0,1,3-2.48,8.78,8.78,0,0,1,4-.85,10.25,10.25,0,0,1,5.46,1.47,9.33,9.33,0,0,1,3.59,4.17,14.41,14.41,0,0,1,1.2,5.89,14.14,14.14,0,0,1-1.34,6.2,9.46,9.46,0,0,1-3.87,4.22,10.44,10.44,0,0,1-5.34,1.47,8.11,8.11,0,0,1-3.66-.8,8.46,8.46,0,0,1-2.68-2v10.9Zm3.72-19.66a9.25,9.25,0,0,0,1.89,6.4,6,6,0,0,0,4.57,2.06A6.11,6.11,0,0,0,166.79,51a9.57,9.57,0,0,0,2-6.69,9.43,9.43,0,0,0-1.91-6.42,5.86,5.86,0,0,0-4.54-2.12,6.06,6.06,0,0,0-4.64,2.26A9.68,9.68,0,0,0,155.65,44.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.41,48.56l4.24.49a9.51,9.51,0,0,1-3.72,5.34,11.73,11.73,0,0,1-6.86,1.91,11.52,11.52,0,0,1-8.37-3,11.29,11.29,0,0,1-3.12-8.49A11.81,11.81,0,0,1,179.7,36a11,11,0,0,1,8.13-3.14,10.72,10.72,0,0,1,7.92,3.07,11.53,11.53,0,0,1,3.08,8.6v1h-18.1A8.3,8.3,0,0,0,183,51.21a7,7,0,0,0,5,2,6.66,6.66,0,0,0,3.85-1.09A7.19,7.19,0,0,0,194.41,48.56ZM181,42.44h13.49A7.18,7.18,0,0,0,193,38.2a6.44,6.44,0,0,0-5-2.19,6.81,6.81,0,0,0-4.74,1.67A6.71,6.71,0,0,0,181,42.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.79,55.78V33.38h3.68v3.2a8.93,8.93,0,0,1,7.7-3.71,10.81,10.81,0,0,1,4,.74,6.31,6.31,0,0,1,2.75,1.88,7.22,7.22,0,0,1,1.27,2.79,20.89,20.89,0,0,1,.22,3.7V55.75h-4.09V42.18a9.56,9.56,0,0,0-.48-3.48,3.76,3.76,0,0,0-1.68-1.82,5.58,5.58,0,0,0-2.86-.69,6.94,6.94,0,0,0-4.52,1.54c-1.26,1-1.89,3-1.89,5.84V55.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08,49.1l4.06-.59A5,5,0,0,0,234,52a6.94,6.94,0,0,0,4.35,1.21,6.7,6.7,0,0,0,4.2-1.07,3.12,3.12,0,0,0,1.36-2.5,2.29,2.29,0,0,0-1.21-2,19.09,19.09,0,0,0-4.18-1.29,40,40,0,0,1-6.25-1.83,5.86,5.86,0,0,1-2.64-2.13,5.32,5.32,0,0,1-.91-3,5.43,5.43,0,0,1,.76-2.78,6.21,6.21,0,0,1,2-2.13,8.48,8.48,0,0,1,2.61-1.1,13.57,13.57,0,0,1,3.53-.46,14.73,14.73,0,0,1,5,.78,6.79,6.79,0,0,1,3.19,2,7.59,7.59,0,0,1,1.4,3.48l-4,.5A3.94,3.94,0,0,0,241.7,37a6.14,6.14,0,0,0-3.7-1,7.18,7.18,0,0,0-4,.85,2.46,2.46,0,0,0-1.2,2,2,2,0,0,0,.5,1.34,3.68,3.68,0,0,0,1.57,1c.4.15,1.68.47,3.62,1a53.35,53.35,0,0,1,6.06,1.68,6.06,6.06,0,0,1,2.69,2,5.23,5.23,0,0,1,1,3.25A6,6,0,0,1,247,52.7a7.63,7.63,0,0,1-3.45,2.59,13.52,13.52,0,0,1-5,.93,12,12,0,0,1-7.18-1.83A8.27,8.27,0,0,1,228.08,49.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.57,48.56l4.24.49a9.52,9.52,0,0,1-3.7,5.34,11.77,11.77,0,0,1-6.92,1.91,11.55,11.55,0,0,1-8.37-3,11.32,11.32,0,0,1-3.13-8.49A11.83,11.83,0,0,1,254.84,36,11,11,0,0,1,263,32.87a10.73,10.73,0,0,1,7.92,3.07,11.57,11.57,0,0,1,3.08,8.6v1H255.89a8.31,8.31,0,0,0,2.26,5.66,7,7,0,0,0,5,2A6.66,6.66,0,0,0,267,52.08,7.24,7.24,0,0,0,269.57,48.56Zm-13.39-6.12h13.49a7.18,7.18,0,0,0-1.55-4.24,6.44,6.44,0,0,0-5-2.19,6.77,6.77,0,0,0-4.73,1.67,6.68,6.68,0,0,0-2.23,4.76Z",
    fill: "#fff"
  })));
};

/* eslint-disable max-len */
const SVBNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 361.5 96"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.06,28.35h4.01c.29,3.37,2.29,5.66,6.95,5.66,4.01,0,5.23-1.72,5.23-4.01,0-3.22-2.44-3.65-7.02-4.8-3.94-1.07-8.24-2.29-8.24-7.09,0-4.37,3.37-6.81,8.74-6.81,5.73,0,9.39,2.94,9.81,7.95h-4.01c-.36-3.01-2.08-4.66-5.8-4.66-3.15,0-4.73,1.15-4.73,3.3,0,2.79,2.65,3.37,5.87,4.23,4.87,1.22,9.39,2.36,9.39,7.67,0,4.3-2.94,7.52-9.17,7.52s-10.75-3.3-11.03-8.96h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,14.02c0-1.07.72-2.01,2.01-2.01s2.01.93,2.01,2.01-.72,2.01-2.01,2.01-2.01-.93-2.01-2.01ZM188.2,36.8v-17.84h3.44v17.84h-3.44Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,36.8V11.73h3.44v25.07h-3.44Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,14.02c0-1.07.72-2.01,2.01-2.01s2.01.93,2.01,2.01-.72,2.01-2.01,2.01-2.01-.93-2.01-2.01ZM203.1,36.8v-17.84h3.44v17.84h-3.44Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,27.92c0-5.59,3.44-9.46,8.74-9.46,4.59,0,7.67,3.01,8.02,7.02h-3.58c-.14-1.86-1.22-4.16-4.51-4.16-3.8,0-5.16,3.22-5.16,6.59s1.43,6.59,5.16,6.59c3.3,0,4.37-2.22,4.51-4.3h3.58c-.21,4.08-3.44,7.16-8.02,7.16-5.3,0-8.74-3.87-8.74-9.46h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,27.92c0-5.59,3.37-9.46,8.96-9.46s8.96,3.87,8.96,9.46-3.37,9.46-8.96,9.46-8.96-3.87-8.96-9.46ZM242.93,27.92c0-3.73-1.72-6.59-5.37-6.59s-5.37,2.87-5.37,6.59,1.72,6.59,5.37,6.59,5.37-2.94,5.37-6.59Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.86,24.41v12.39h-3.44v-11.46c0-2.36-1.07-4.01-3.58-4.01-2.94,0-4.87,1.79-4.87,4.51v10.96h-3.44v-17.84h3.44v2.22h.07c.93-1.36,2.79-2.79,5.87-2.79,3.3.07,5.95,1.93,5.95,6.02h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,36.8l-8.81-25.07h4.3l6.59,20.99h.07l6.59-20.99h4.08l-8.6,25.07h-4.23Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,32.22c0-4.01,3.01-5.16,7.45-6.02,2.79-.5,4.51-.86,4.51-2.65,0-1.29-.79-2.36-3.37-2.36-3.15,0-4.08,1-4.23,3.37h-3.51c.14-3.44,2.44-6.16,7.88-6.16,3.65,0,6.59,1.5,6.59,6.16v8.17c0,1.29.14,1.93.86,1.93h.43v2.08c-.57.14-1.22.21-1.72.21-1.72,0-2.65-.64-2.79-2.72h-.07c-1.22,1.86-3.22,3.01-6.16,3.01-3.58.07-5.87-2.01-5.87-5.01h0ZM304.26,29.85v-2.58c-.57.5-2.08.93-3.94,1.29-3.15.64-4.44,1.5-4.44,3.37,0,1.65.86,2.58,3.01,2.58,3.08,0,5.3-1.58,5.37-4.66h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.78,36.8V11.73h3.44v25.07h-3.44Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.02,36.8V11.73h3.44v25.07h-3.44Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.73,28.78h-13.76c.07,3.01,1.79,5.73,5.37,5.73,3.15,0,4.37-2.01,4.66-3.22h3.44c-.93,3.44-3.51,6.02-8.24,6.02-5.66,0-8.81-4.01-8.81-9.46s3.37-9.46,8.81-9.46,8.45,3.58,8.45,9.1c.14.5.14,1,.07,1.29h0ZM339.15,26.13c0-2.79-1.93-4.94-4.94-4.94s-4.94,1.93-5.16,4.94h10.1Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.53,42.82v-2.79c.57.07.93.14,1.43.14,1.43,0,3.01-.72,3.73-3.51l-7.24-17.7h3.73l5.23,13.68h.07l4.94-13.68h3.58l-7.02,18.27c-1.79,4.44-3.44,5.87-6.23,5.87-.79,0-1.29-.07-2.22-.29h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.49,68.68v-25.07h10.53c5.16,0,8.17,2.29,8.17,6.3,0,3.08-1.79,4.51-3.87,5.23v.07c2.65.43,4.87,2.36,4.87,6.16,0,4.8-3.3,7.31-8.53,7.31h-11.18ZM170.29,54.07h6.59c3.15,0,4.23-1.29,4.23-3.51s-1.36-3.51-3.94-3.51h-6.88c0-.07,0,7.02,0,7.02h0ZM170.29,65.39h7.02c3.73,0,4.73-1.79,4.73-4.16,0-2.65-1.58-4.16-4.23-4.16h-7.59c.07.07.07,8.31.07,8.31h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.56,64.1c0-4.01,3.01-5.16,7.45-6.02,2.79-.5,4.51-.86,4.51-2.65,0-1.29-.79-2.36-3.37-2.36-3.15,0-4.08,1-4.23,3.37h-3.51c.14-3.44,2.44-6.16,7.88-6.16,3.65,0,6.59,1.58,6.59,6.16v8.17c0,1.29.14,1.93.86,1.93.07,0,.21,0,.43-.07v2.08c-.57.14-1.22.21-1.72.21-1.72,0-2.65-.64-2.79-2.72h-.07c-1.22,1.86-3.22,3.01-6.16,3.01-3.58.14-5.87-1.93-5.87-4.94h0ZM200.52,61.73v-2.58c-.57.5-2.08.93-3.94,1.29-3.15.64-4.44,1.5-4.44,3.37,0,1.65.86,2.58,3.01,2.58,3.08.07,5.37-1.5,5.37-4.66h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.45,56.29v12.39h-3.44v-11.46c0-2.36-1.07-4.01-3.58-4.01-2.94,0-4.87,1.79-4.87,4.51v10.96h-3.44v-17.84h3.44v2.22h.07c.93-1.36,2.79-2.79,5.87-2.79,3.3.07,5.95,1.93,5.95,6.02h0Z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.07,68.68l-5.87-9.17-2.58,2.51v6.66h-3.44v-25.07h3.44v14.76l7.81-7.59h3.94l-6.88,6.52,7.67,11.39h-4.08,0Z",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.77,36.01c-4.87-.86-9.1-1.58-9.1-5.01,0-2.79,2.51-4.51,6.73-4.51,4.44,0,6.95,2.29,6.95,6.3h9.39c0-7.95-6.09-12.61-16.33-12.61S2,24.62,2,31.86c0,8.81,7.95,10.1,14.61,11.18,5.01.86,9.53,1.58,9.53,5.66,0,3.22-2.79,5.01-7.74,5.01s-8.02-2.51-8.02-6.81H1c0,8.31,6.38,13.18,17.41,13.18s17.41-4.73,17.41-12.61c0-8.96-8.24-10.32-15.04-11.46",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.45 55.71 55.38 55.71 46.64 21.04 35.82 21.04 46.99 59.37 47.57 59.37 62.11 59.37 63.9 59.37 75.01 21.04 64.26 21.04 55.45 55.71",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,52.2c-4.59,0-7.74-2.65-9.03-7.02-.43-1.43-.64-3.08-.64-4.94,0-1.65.21-3.3.64-4.8,1.22-4.01,4.08-7.16,9.03-7.16,7.38,0,9.67,5.95,9.67,11.96,0,7.09-3.22,11.96-9.67,11.96M100.58,20.32c-5.87,0-10.24,3.3-12.11,7.95h-.14V.55h-10.1v58.82h6.38l3.73-6.73h.14c1.79,4.01,6.3,7.52,12.11,7.59,10.24.14,16.76-8.17,16.76-19.92s-6.09-19.92-16.76-19.99",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "129.03 10.13 121.48 14.76 135.77 40.21 121.48 65.67 129.03 70.37 153.33 40.21 129.03 10.13",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.26,95.06H1l5.23-14.13h2.34l5.3,14.13h-2.4l-1.2-3.4h-5.8l-1.2,3.4h0ZM7.43,82.97l-2.34,6.86h4.66l-2.34-6.86h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.88,95.06v-14.13h5.44c1.28,0,2.4.28,3.4.85s1.7,1.34,2.19,2.4.78,2.34.78,3.82-.28,2.76-.78,3.82c-.49,1.06-1.2,1.83-2.12,2.4s-2.05.85-3.32.85h-5.59ZM24.18,93.23c2.76,0,4.1-1.7,4.1-5.16s-1.41-5.23-4.1-5.23h-3.11v10.39h3.11Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.45,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35-.42,0-.71-.07-.85-.35ZM34.22,95.07h-1.98v-10.04h1.98v10.04Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.21,95.06h-2.19l-3.53-10.04h2.05l2.61,8.06h0l2.61-8.06h2.05l-3.6,10.04Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.16,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35s-.64-.07-.85-.35ZM47.99,95.07h-1.98v-10.04h1.98v10.04Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,94.92c-.71-.28-1.2-.78-1.55-1.28-.35-.57-.57-1.2-.57-1.91h1.98c.07.64.28,1.13.71,1.55.42.35,1.06.57,1.98.57.78,0,1.34-.14,1.7-.42s.49-.64.49-1.06c0-.35-.07-.64-.28-.85s-.42-.35-.71-.42-.71-.21-1.2-.28l-.42-.07c-.78-.21-1.41-.35-1.91-.57s-.99-.49-1.34-.92c-.35-.42-.57-.92-.57-1.55,0-.57.14-1.06.42-1.55.28-.42.78-.78,1.34-.99s1.28-.35,2.05-.35c.85,0,1.63.14,2.26.42s1.06.71,1.41,1.13c.35.49.49,1.06.57,1.63h-1.98c-.07-.49-.28-.92-.64-1.2-.35-.28-.85-.49-1.63-.49-.64,0-1.06.14-1.41.35-.28.21-.42.57-.42.92,0,.28.07.49.28.71.14.14.35.28.64.35s.64.21,1.13.28l.49.14c.78.21,1.48.42,1.98.57s.99.49,1.34.92c.35.42.57.99.57,1.7,0,.64-.14,1.2-.49,1.7s-.78.85-1.41,1.06-1.34.35-2.26.35c-.99.07-1.83-.14-2.54-.42h0Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.94,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35s-.64-.07-.85-.35ZM61.77,95.07h-1.98v-10.04h1.98v10.04Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81,94.71c-.78-.42-1.34-1.06-1.77-1.91-.42-.78-.64-1.77-.64-2.76,0-1.06.21-1.98.64-2.83.42-.78.99-1.41,1.77-1.91s1.63-.71,2.69-.71c.99,0,1.91.21,2.69.71s1.34,1.06,1.77,1.91c.42.78.64,1.77.64,2.76,0,1.06-.21,1.98-.64,2.76-.42.78-.99,1.41-1.77,1.91s-1.63.71-2.69.71-1.98-.14-2.69-.64h0ZM70.12,93.3c.42-.35.78-.78.99-1.34.21-.57.35-1.2.35-1.91s-.14-1.34-.35-1.91c-.21-.57-.57-.99-.99-1.34s-.99-.49-1.7-.49c-.64,0-1.2.14-1.7.49-.42.35-.78.78-.99,1.34s-.35,1.2-.35,1.91.14,1.34.35,1.91.57.99.99,1.34.99.49,1.7.49,1.28-.14,1.7-.49Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,85.09c.49.28.92.64,1.2,1.13s.42,1.13.42,1.91v7h-1.98v-6.43c0-.71-.14-1.28-.49-1.7s-.85-.64-1.55-.64c-.57,0-.99.07-1.41.28s-.71.49-.92.92c-.21.35-.35.85-.35,1.34v6.22h-1.98v-10.11h1.98v1.28h.07c.28-.42.71-.85,1.28-1.13s1.2-.42,2.05-.42c.57,0,1.13.07,1.7.35h-.01Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.88,94.71c-.78-.42-1.34-1.06-1.77-1.91-.42-.78-.64-1.77-.64-2.76,0-1.06.21-1.98.64-2.83.42-.78.99-1.41,1.77-1.91.78-.49,1.63-.71,2.69-.71.99,0,1.91.21,2.69.71s1.34,1.06,1.77,1.91c.42.78.64,1.77.64,2.76,0,1.06-.21,1.98-.64,2.76-.42.78-.99,1.41-1.77,1.91s-1.63.71-2.69.71-1.98-.14-2.69-.64h0ZM96.27,93.3c.42-.35.78-.78.99-1.34.21-.57.35-1.2.35-1.91s-.14-1.34-.35-1.91c-.21-.57-.57-.99-.99-1.34-.42-.35-.99-.49-1.7-.49-.64,0-1.2.14-1.7.49-.42.35-.78.78-.99,1.34-.21.57-.35,1.2-.35,1.91s.14,1.34.35,1.91.57.99.99,1.34.99.49,1.7.49c.64,0,1.2-.14,1.7-.49Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.04,82.55c-.14.07-.28.21-.35.35-.07.21-.07.42-.07.85v1.28h1.91v1.63h-1.91v8.48h-1.91v-8.48h-1.41v-1.63h1.41v-1.2c0-.78.07-1.34.28-1.77s.49-.71.85-.92c.35-.14.85-.28,1.41-.28.35,0,.71.07,1.2.14v1.55c-.35-.07-.64-.07-.85-.07-.21-.07-.42,0-.57.07h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.08,95.06h-2.19v-14.13h9.82v1.91h-7.63v4.24h6.15v1.91h-6.15v6.08h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.28,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35s-.64-.07-.85-.35ZM124.11,95.07h-1.98v-10.04h1.98v10.04Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.88,84.82v1.83c-.21-.07-.49-.07-.64-.07-.57,0-1.13.14-1.55.42s-.85.64-1.06,1.13c-.28.49-.35,1.06-.35,1.7v5.23h-1.98v-10.04h1.98v1.91h.07c.28-.71.64-1.2,1.06-1.55s.99-.57,1.63-.57c.28-.07.64,0,.85,0h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.35,94.92c-.71-.28-1.2-.78-1.55-1.28-.35-.57-.57-1.2-.57-1.91h1.98c.07.64.28,1.13.71,1.55.42.35,1.06.57,1.98.57.78,0,1.34-.14,1.7-.42s.49-.64.49-1.06c0-.35-.07-.64-.28-.85-.21-.21-.42-.35-.71-.42s-.71-.21-1.2-.28l-.42-.07c-.78-.21-1.41-.35-1.91-.57s-.99-.49-1.34-.92c-.35-.42-.57-.92-.57-1.55,0-.57.14-1.06.42-1.55.28-.42.78-.78,1.34-.99s1.28-.35,2.05-.35c.85,0,1.63.14,2.26.42s1.06.71,1.41,1.13c.35.49.49,1.06.57,1.63h-1.98c-.07-.49-.28-.92-.64-1.2-.35-.28-.85-.49-1.63-.49-.64,0-1.06.14-1.41.35-.28.21-.42.57-.42.92,0,.28.07.49.28.71.14.14.35.28.64.35s.64.21,1.13.28l.49.14c.78.21,1.48.42,1.98.57.49.21.99.49,1.34.92.35.42.57.99.57,1.7,0,.64-.14,1.2-.49,1.7s-.78.85-1.41,1.06-1.34.35-2.26.35c-.99.07-1.83-.14-2.54-.42h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.01,93.51v1.55c-.42.07-.85.14-1.2.14-.57,0-1.06-.07-1.48-.28-.35-.14-.71-.49-.92-.92s-.28-1.06-.28-1.77v-5.65h-1.48v-1.55h1.48v-3.25h1.98v3.25h1.91v1.63h-1.91v5.65c0,.35.07.64.14.85.07.21.21.28.35.35s.35.14.64.14c.21-.07.49-.07.78-.14h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.49,94.43c-.99-.64-1.77-1.48-2.34-2.61s-.85-2.4-.85-3.82.28-2.69.85-3.82,1.34-1.98,2.34-2.61c.99-.64,2.19-.92,3.46-.92,1.13,0,2.19.21,3.04.71.85.42,1.55,1.06,2.12,1.83s.85,1.63.92,2.61h-2.26c-.14-.85-.57-1.63-1.13-2.26-.57-.64-1.48-.92-2.69-.92-.99,0-1.83.28-2.47.78s-1.13,1.13-1.41,1.98-.42,1.77-.42,2.76.14,1.91.42,2.76c.28.85.78,1.48,1.41,1.98s1.48.78,2.47.78c.85,0,1.55-.14,2.12-.49s.99-.78,1.2-1.28.42-1.13.49-1.77h2.26c-.14,1.06-.42,1.98-.92,2.83-.49.85-1.2,1.48-2.12,1.91s-1.91.71-3.04.71c-1.28-.14-2.47-.49-3.46-1.13h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.79,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35s-.64-.07-.85-.35ZM168.63,95.07h-1.98v-10.04h1.98v10.04Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,93.51v1.55c-.42.07-.85.14-1.28.14-.57,0-1.06-.07-1.48-.28-.35-.14-.71-.49-.92-.92s-.28-1.06-.28-1.77v-5.65h-1.48v-1.55h1.48v-3.25h1.98v3.25h1.91v1.63h-1.83v5.65c0,.35,0,.64.14.85.07.21.21.28.35.35s.35.14.64.14c.21-.07.49-.07.78-.14h0Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,82.98c-.21-.21-.28-.49-.28-.78,0-.35.07-.57.28-.85s.49-.35.85-.35.64.14.85.35.28.49.28.85c0,.28-.07.57-.28.78-.21.21-.49.35-.85.35s-.64-.07-.85-.35ZM178.89,95.07h-1.91v-10.04h1.98v10.04h-.07,0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M188.7,95.06h-8.34v-1.41l5.51-7v-.07h-5.16v-1.55h7.77v1.28l-5.65,7.21v.07h5.87v1.48h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.23,90.54h-7.77c0,.57.14,1.13.35,1.63.21.49.57.85.99,1.2.42.28.99.42,1.63.42.57,0,.99-.07,1.41-.28.35-.21.64-.42.85-.71.21-.28.35-.57.42-.85h1.98c-.28.99-.78,1.83-1.55,2.47s-1.83.92-3.04.92c-1.06,0-1.91-.21-2.69-.71s-1.34-1.13-1.7-1.91c-.42-.78-.57-1.77-.57-2.76,0-1.06.21-1.98.64-2.76s.99-1.41,1.77-1.91c.78-.42,1.63-.71,2.61-.71s1.83.21,2.61.64,1.28.99,1.63,1.77.57,1.7.57,2.76c-.14.49-.14.71-.14.78h0ZM197.26,89.06c0-.49-.14-.99-.35-1.41s-.57-.78-.99-.99-.92-.35-1.48-.35-.99.14-1.41.35-.78.57-1.06.99-.42.92-.42,1.48h5.72v-.07h0Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,85.09c.49.28.92.64,1.2,1.13.28.49.42,1.13.42,1.91v7h-1.98v-6.43c0-.71-.14-1.28-.49-1.7s-.85-.64-1.55-.64c-.57,0-.99.07-1.41.28s-.71.49-.92.92c-.21.35-.35.85-.35,1.34v6.22h-1.98v-10.11h1.98v1.28h.07c.28-.42.71-.85,1.28-1.13s1.2-.42,2.05-.42c.64,0,1.2.07,1.7.35h-.01Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,94.92c-.71-.28-1.2-.78-1.55-1.28-.35-.57-.57-1.2-.57-1.91h1.98c.07.64.28,1.13.71,1.55.42.35,1.06.57,1.98.57.78,0,1.34-.14,1.7-.42s.49-.64.49-1.06c0-.35-.07-.64-.28-.85-.21-.21-.42-.35-.71-.42s-.71-.21-1.2-.28l-.42-.07c-.78-.21-1.41-.35-1.91-.57s-.99-.49-1.34-.92-.57-.92-.57-1.55c0-.57.14-1.06.42-1.55.28-.42.78-.78,1.34-.99s1.28-.35,2.05-.35c.85,0,1.63.14,2.26.42s1.06.71,1.41,1.13c.35.49.49,1.06.57,1.63h-1.98c-.07-.49-.28-.92-.64-1.2-.35-.28-.85-.49-1.63-.49-.64,0-1.06.14-1.41.35-.28.21-.42.57-.42.92,0,.28.07.49.28.71.14.14.35.28.64.35s.64.21,1.13.28l.49.14c.78.21,1.48.42,1.98.57.49.21.99.49,1.34.92s.57.99.57,1.7c0,.64-.14,1.2-.49,1.7s-.78.85-1.41,1.06-1.34.35-2.26.35c-.99.07-1.83-.14-2.54-.42h0Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.73,95.06v-14.13h5.94c.99,0,1.77.14,2.47.42s1.2.71,1.55,1.2c.35.57.57,1.2.57,1.91,0,1.48-.71,2.47-2.19,2.97v.07c.49.07.99.28,1.41.57s.78.64.99,1.13.35,1.06.35,1.77c0,.85-.21,1.63-.57,2.26-.42.64-.92,1.06-1.7,1.41s-1.55.49-2.54.49h-6.29v-.07h0ZM231.67,86.79c.85,0,1.48-.14,1.83-.49s.57-.85.57-1.48-.21-1.13-.57-1.48-.92-.49-1.7-.49h-3.89v3.95h3.75ZM231.89,93.23c.99,0,1.7-.21,2.05-.64.42-.42.64-.99.64-1.7s-.21-1.28-.64-1.7-.99-.64-1.77-.64h-4.31v4.66h4.03Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.66,95c-.49-.21-.85-.57-1.13-.99-.28-.42-.42-.92-.42-1.48,0-.71.14-1.28.49-1.77s.78-.78,1.41-1.06c.57-.21,1.34-.42,2.34-.64.64-.14,1.13-.21,1.48-.35.35-.07.57-.21.78-.42.21-.21.28-.42.28-.78,0-.92-.64-1.34-1.91-1.34-.57,0-1.06.07-1.34.21-.35.14-.57.35-.71.64s-.28.64-.28,1.13h-1.98c.07-1.06.42-1.83,1.13-2.47s1.83-.92,3.25-.92c1.13,0,2.05.28,2.76.85.71.57.99,1.41.99,2.69v4.66c0,.35,0,.64.07.85s.21.28.35.28h.21v1.2c-.35.07-.71.14-.99.14-.49,0-.85-.14-1.13-.35s-.42-.64-.42-1.2h-.07c-.35.57-.85.99-1.41,1.28-.57.28-1.28.42-2.05.42-.64-.14-1.2-.28-1.7-.57h-.01ZM243.41,93.51c.49-.21.85-.49,1.06-.92.28-.42.35-.92.35-1.48v-1.41c-.14.14-.42.28-.78.35-.35.14-.85.21-1.41.35-.64.14-1.13.28-1.48.42s-.64.35-.78.57-.28.57-.28.92c0,.99.57,1.48,1.7,1.48.64,0,1.13-.07,1.63-.28h0Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.12,85.09c.49.28.92.64,1.2,1.13.28.49.42,1.13.42,1.91v7h-1.98v-6.43c0-.71-.14-1.28-.49-1.7s-.85-.64-1.55-.64c-.57,0-.99.07-1.41.28s-.71.49-.92.92c-.21.35-.35.85-.35,1.34v6.22h-1.98v-10.11h1.98v1.28h.07c.28-.42.71-.85,1.28-1.13s1.2-.42,2.05-.42c.64,0,1.2.07,1.7.35h-.01Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268.85,95.06h-2.26l-3.32-5.16-1.48,1.41v3.75h-1.98v-14.13h1.98v8.34l4.38-4.24h2.26l-3.89,3.68,4.31,6.36h0Z",
    fill: "#f5f5f5"
  }))));
};

/* eslint-disable max-len */
const TallieNavigation = () => {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 195 84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191,67.89a.57.57,0,0,1-.28.59A21.72,21.72,0,0,1,180,71.16c-9.91,0-16.76-6.26-16.76-15.34,0-8.78,6.33-15.35,15.17-15.35,9.8,0,15.42,7.8,14.1,16.66a.56.56,0,0,1-.55.47H168.32c.83,5.8,5.74,9,11.45,9a20,20,0,0,0,9.81-2.38.54.54,0,0,1,.74.23.34.34,0,0,1,.06.15ZM188,53.61c-.33-5-3.8-8.6-9.42-8.6s-9.64,3.56-10.1,8.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.37,31.63h3.78a.55.55,0,0,1,.55.55V70a.55.55,0,0,1-.55.55h-3.78a.55.55,0,0,1-.55-.55V32.18A.55.55,0,0,1,130.37,31.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.21,31.63H146a.55.55,0,0,1,.55.55V70a.55.55,0,0,1-.55.55h-3.78a.55.55,0,0,1-.55-.55V32.18A.55.55,0,0,1,142.21,31.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,41.1a4.56,4.56,0,0,0-4.56,4.55v.25c-2.21-3.16-6.08-5.43-11.36-5.43-8.44,0-14.85,6.42-14.85,15.26s6.41,15.44,14.85,15.44c5.28,0,9.15-2.31,11.36-5.47V66A4.56,4.56,0,0,0,123,70.56a.32.32,0,0,0,.32-.33h0V41.43a.32.32,0,0,0-.32-.33ZM107.56,66.74c-6.14,0-10.5-4.91-10.5-11s4.35-10.84,10.5-10.84a10.66,10.66,0,0,1,10.92,10.4c0,.14,0,.29,0,.44a10.78,10.78,0,0,1-10.57,11A2,2,0,0,1,107.56,66.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63,66.59a.54.54,0,0,0-.62-.46h-.07a17.14,17.14,0,0,1-4.44.64c-3,0-5.09-1.69-5.09-5.56V45.29h8.84a.55.55,0,0,0,.55-.55v-3.1a.56.56,0,0,0-.55-.56H80.38V36.13a4.5,4.5,0,0,0-4.5-4.5h0a.31.31,0,0,0-.31.32v5.19h0v3.94H70.64a.56.56,0,0,0-.55.56v3.1a.55.55,0,0,0,.55.55h4.89V62c0,6,3.77,9.14,9.45,9.14a19.1,19.1,0,0,0,5.77-.84.56.56,0,0,0,.36-.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.19,41.08H158a.55.55,0,0,1,.55.56V70a.55.55,0,0,1-.55.55h-3.78a.55.55,0,0,1-.55-.55V41.64A.56.56,0,0,1,154.19,41.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,34a2.86,2.86,0,0,1,2.72-3h.28a3,3,0,1,1-3,3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.44,8a7.61,7.61,0,0,0-7.8,7.89c0,4.68,3.52,7.9,8.62,7.9A11.52,11.52,0,0,0,84.8,22.4.39.39,0,0,0,85,22l-.34-2.07a.39.39,0,0,0-.45-.31.16.16,0,0,0-.09,0,11.21,11.21,0,0,1-4.85,1.2c-2.94,0-4.87-1.37-5.42-3.85H85.31a.4.4,0,0,0,.39-.33C86.4,11.88,83.26,8,78.44,8Zm-4.5,6.53c.23-2.19,2.1-3.67,4.59-3.67a3.94,3.94,0,0,1,4.28,3.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,8a6.27,6.27,0,0,0-5.41,2.82A5.77,5.77,0,0,0,96.54,8a5.33,5.33,0,0,0-4.72,2.4A2.94,2.94,0,0,0,89,8.27a.21.21,0,0,0-.21.21V23.05a.38.38,0,0,0,.39.38h2.37a.38.38,0,0,0,.38-.38V14.89a3.85,3.85,0,0,1,4.11-4c2.23,0,3.57,1.45,3.57,4v8.16a.38.38,0,0,0,.38.38h2.38a.38.38,0,0,0,.38-.38V14.7a3.8,3.8,0,0,1,4.11-3.77c2.22,0,3.57,1.45,3.57,4v8.16a.38.38,0,0,0,.38.38h2.37a.38.38,0,0,0,.39-.38V14.22C113.58,10.55,111.4,8,107.35,8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13,8a6.41,6.41,0,0,0-5.39,2.36v-8a.21.21,0,0,0-.21-.21A2.93,2.93,0,0,0,116.6,5h0V23.18a.21.21,0,0,0,.21.21,2.91,2.91,0,0,0,2.82-2.15,6.46,6.46,0,0,0,5.5,2.51c4.31,0,7.61-3.32,7.61-8A7.44,7.44,0,0,0,125.13,8Zm-.38,13a5,5,0,0,1-5-5v-.12a4.9,4.9,0,0,1,4.79-5h.22a4.77,4.77,0,0,1,4.86,5A4.9,4.9,0,0,1,124.75,20.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,8.27h-2.35a.39.39,0,0,0-.38.39h0v8.16c0,2.51-1.88,4-4.27,4s-3.69-1.45-3.69-4V8.66a.4.4,0,0,0-.39-.39h-2.35a.39.39,0,0,0-.39.39v8.82c0,3.68,2.2,6.27,6.33,6.27a5.41,5.41,0,0,0,4.87-2.42,2.93,2.93,0,0,0,2.8,2.06.21.21,0,0,0,.21-.21V8.66a.39.39,0,0,0-.38-.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.58,8.23A6,6,0,0,0,159.8,8a4.26,4.26,0,0,0-4,2.54,2.92,2.92,0,0,0-2.84-2.23.21.21,0,0,0-.21.21h0V23.05a.38.38,0,0,0,.38.38h2.37a.38.38,0,0,0,.39-.38h0V15.17c0-3.42,2.18-4.31,3.85-4.31a5.24,5.24,0,0,1,1.42.2.38.38,0,0,0,.47-.26.64.64,0,0,0,0-.07l.24-2.09A.38.38,0,0,0,161.58,8.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,14.65l-1.77-.36c-1.91-.39-2.62-.87-2.62-1.82,0-1.12,1.13-1.76,3.42-1.76a12.79,12.79,0,0,1,4.16.7.38.38,0,0,0,.49-.23.29.29,0,0,0,0-.09l.24-1.92a.38.38,0,0,0-.25-.41,14.38,14.38,0,0,0-4.82-.8c-3.79,0-6.31,1.89-6.31,4.47,0,2.33,1.42,3.87,4.09,4.4l2.24.46c2,.4,2.78.95,2.78,2S171.5,21,169.23,21a13.65,13.65,0,0,1-4.73-.9.38.38,0,0,0-.5.22.29.29,0,0,0,0,.09l-.27,1.93a.38.38,0,0,0,.2.4,13.56,13.56,0,0,0,5.52,1c3.68,0,6.18-1.47,6.18-4.53C175.61,16.58,174,15.28,170.89,14.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.28,8a7.62,7.62,0,0,0-7.8,7.89c0,4.68,3.52,7.9,8.62,7.9a11.47,11.47,0,0,0,5.54-1.35.38.38,0,0,0,.2-.41l-.34-2.07a.39.39,0,0,0-.45-.31.19.19,0,0,0-.1,0,11.17,11.17,0,0,1-4.85,1.2c-2.93,0-4.86-1.37-5.41-3.85h11.47a.39.39,0,0,0,.38-.33C193.24,11.88,190.1,8,185.28,8Zm-4.5,6.53c.24-2.19,2.1-3.67,4.6-3.67a4,4,0,0,1,4.28,3.67Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.52,29.06H14.4A12.4,12.4,0,0,0,2,41.46V81.59a.42.42,0,0,0,.41.41H42.54a12.4,12.4,0,0,0,12.4-12.4V29.48A.42.42,0,0,0,54.52,29.06ZM43.36,44.3a1.23,1.23,0,0,1-1.23,1.31H34.6a1.14,1.14,0,0,0-1,.58c-.42.67-.7,1.76-.7,4.89v14c0,4.92-2.33,7.86-6.22,7.86a8.19,8.19,0,0,1-3.4-.67,3.92,3.92,0,0,1-1.45-1.06,1.31,1.31,0,0,1-.14-1.41l.21-.49a1,1,0,0,1,1.28-.57,4.18,4.18,0,0,0,1.38.28,2.22,2.22,0,0,0,2.27-2.23V51.21a8.68,8.68,0,0,1,1.36-4.87c.15-.23.2-.44.13-.56s-.21-.17-.42-.17H24.61c-3.46,0-5.22,1.23-5.24,3.67,0,1.82,1.37,3.09,3.68,3.4a1.29,1.29,0,0,1,1,.5,1.26,1.26,0,0,1,.07,1l0,.15c-.09.3-.28,1-.36,1.28h0l0,.16c-.18.62-.77.88-1.78.79a11.06,11.06,0,0,1-6.09-2.15,6.75,6.75,0,0,1-2.49-5.63A7.92,7.92,0,0,1,17.05,42c2.42-1.65,5.4-2.35,10-2.35,3.07,0,15.07.95,15.19,1a1.16,1.16,0,0,1,1.17,1.19Z",
    fill: "#fff"
  })));
};

const getNavigationLogo = token => {
  switch (token) {
    case 'A2bNavigation':
      return /*#__PURE__*/React.createElement(BounceNextNavigation, null);
    case 'AbacusNavigation':
      return /*#__PURE__*/React.createElement(BounceNextNavigation$1, null);
    case 'AdvisorConsoleNavigation':
      return null;
    case 'ATOMNavigation':
      return /*#__PURE__*/React.createElement(BounceNextNavigation, null);
    case 'BounceNextNavigation':
      return /*#__PURE__*/React.createElement(BounceNextNavigation, null);
    case 'CertifyNavigation':
      // aka Emburse Professional
      return /*#__PURE__*/React.createElement(CertifyNavigation, null);
    case 'CavaNavigation':
      return /*#__PURE__*/React.createElement(CavaNavigation, null);
    case 'ChromeRiverNavigation':
      // aka Emburse Enterprise
      return /*#__PURE__*/React.createElement(ChromeRiverNavigation, null);
    case 'EANavigation':
      return /*#__PURE__*/React.createElement(EANavigation, null);
    case 'EdenredPayNavigation':
      return /*#__PURE__*/React.createElement(EdenredPayNavigation, null);
    case 'LassoNavigation':
      return /*#__PURE__*/React.createElement(LassoNavigation, null);
    case 'NexoniaNavigation':
      return /*#__PURE__*/React.createElement(NexoniaNavigation, null);
    case 'SpendNavigation':
      return /*#__PURE__*/React.createElement(SpendNavigation, null);
    case 'SutiSoftNavigation':
      return /*#__PURE__*/React.createElement(SutiSoftNavigation, null);
    case 'SVBNavigation':
      return /*#__PURE__*/React.createElement(SVBNavigation, null);
    case 'TallieNavigation':
      return /*#__PURE__*/React.createElement(TallieNavigation, null);
    default:
      return null;
  }
};

/* eslint-disable consistent-return */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const progressBarHeight = '4px';
const backgroundHeight = 14;
const prog = keyframes`
  0% {
    background-position: ${backgroundHeight * 2}px 0;
  }

  100% {
    background-position: 0 0;
  }
`;
const ProgressBarContainer = styled.div`
  /* background: rgba(0, 0, 0, 0.05); */
  height: ${progressBarHeight};
`;
const ProgressBar = styled(animated.div)`
  height: ${progressBarHeight};
  background-color: ${getTokenValue(THEME_TOKENS.base.color.loadingBar)};
  background-size: ${backgroundHeight * 2}px ${backgroundHeight * 2}px;
  animation: ${prog} 1s linear infinite;

  ${_ref => {
  let {
    $progress
  } = _ref;
  return $progress >= 100 && css`
      --stripe-color: rgba(57, 57, 57, 0.07);
      background-image: repeating-linear-gradient(
        -45deg,
        var(--stripe-color),
        var(--stripe-color) 11px,
        transparent 10px,
        transparent 20px
      );
    `;
}};
`;
const LoadingBar = _ref2 => {
  let {
    duration
  } = _ref2;
  const [progress, setProgress] = useState(0);
  const props = useSpring({
    width: `${progress}%`,
    from: {
      width: '0%',
      $progress: 0
    }
  });
  const getDelayInterval = () => {
    const halfTotalDuration = duration / 2;
    if (progress >= 100) {
      return null;
    }
    if (progress <= 80) {
      return halfTotalDuration / 80;
    }
    return halfTotalDuration / 20;
  };
  useInterval(() => {
    setProgress(progress + 1);
  }, getDelayInterval());
  return /*#__PURE__*/React.createElement(ProgressBarContainer, null, /*#__PURE__*/React.createElement(ProgressBar, {
    $progress: progress,
    style: props
  }));
};
LoadingBar.propTypes = {
  /**
   * Time (in milliseconds) for loader to animate to the end.
   */
  duration: PropTypes.number
};
LoadingBar.defaultProps = {
  duration: 10000
};

// import { Flex, Box } from '@rebass/grid';

const TextContainer$3 = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 2.5em;
  height: auto;
`;
const Text$1 = styled(animated.div)`
  position: absolute;
  min-height: 2.5em;
  width: 100%;

  ${media.Large`
    min-height: 1.5em;
  `}
`;
const TextTransitioner = _ref => {
  let {
    items,
    interval
  } = _ref;
  const [messageIndex, setMessageIndex] = useState(1);
  const [text, setText] = useState(items[0]);
  const transitions = useTransition(text, null, {
    initial: {
      opacity: 1,
      transform: 'translate3d(0,0%,0)'
    },
    from: {
      opacity: 0,
      transform: 'translate3d(0,100%,0)'
    },
    enter: {
      opacity: 1,
      transform: 'translate3d(0,0%,0)'
    },
    leave: {
      opacity: 0,
      transform: 'translate3d(0,-100%,0)'
    }
  });
  useInterval(() => {
    setMessageIndex(messageIndex >= items.length - 1 ? 0 : messageIndex + 1);
    setText(items[messageIndex]);
  }, interval);
  return /*#__PURE__*/React.createElement(TextContainer$3, null, transitions.map(_ref2 => {
    let {
      item,
      key,
      props
    } = _ref2;
    return /*#__PURE__*/React.createElement(Text$1, {
      key: key,
      style: props
    }, item);
  }));
};
TextTransitioner.propTypes = {
  /**
   * List of strings to transition.
   */
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Time (in milliseconds) in between transitions.
   */
  interval: PropTypes.number
};
TextTransitioner.defaultProps = {
  interval: 3000
};

const TextRegion = styled(Box)`
  height: 64px;
  font-size: ${getTokenValue(THEME_TOKENS.base.size.header3)};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  text-align: center;

  ${media.Large`
    font-size: ${getTokenValue(THEME_TOKENS.base.size.header2)};
  `};
`;
const Logo = styled(Box)`
  width: 200px;
  margin: 0 auto;
`;
const Card = styled(Box)`
  margin: 0 auto;
  min-width: 330px;
  max-width: 600px;
  text-align: center;
  font-size: 16px;

  ${media.Large`
    min-width: 520px;
    max-width: 900px;
  `};

  ${media.XLargeOnly`
    min-width: 720px;
  `};
`;
const CardWrapper = styled(Flex)`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    justify-content: flex-start;
  }
`;
const LoadingImage = styled(Flex)`
  img {
    border-radius: 50%;
    height: 64px;
    width: 64px;
  }
`;
const InterstitialContent = _ref => {
  let {
    messages,
    messagesInterval,
    delay = 0,
    ...rest
  } = _ref;
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    const showTimeout = setTimeout(() => {
      setIsShown(true);
    }, delay);
    return () => {
      clearTimeout(showTimeout);
    };
  }, [delay]);
  if (!isShown) {
    return null;
  }
  const loaderContent = getConfigValue(THEME_CONFIG.base.flag.isFlagshipSite) ? /*#__PURE__*/React.createElement(LoadingImage, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.amtrav.com/web-a2b/cava-loading.gif",
    alt: "Loading..."
  })) : /*#__PURE__*/React.createElement(Logo, null, /*#__PURE__*/React.createElement(ActivityIndicator, null));
  return /*#__PURE__*/React.createElement(CardWrapper, _extends({
    flex: "1 0 auto",
    justifyContent: "center",
    alignItems: "center"
  }, rest), /*#__PURE__*/React.createElement(Card, {
    px: 3
  }, loaderContent, messages && messages.length === 1 && /*#__PURE__*/React.createElement(TextRegion, {
    pt: 4
  }, messages[0]), messages && messages.length > 1 && /*#__PURE__*/React.createElement(TextRegion, {
    pt: 4
  }, /*#__PURE__*/React.createElement(TextTransitioner, {
    interval: messagesInterval,
    items: messages
  }))));
};
InterstitialContent.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string),
  messagesInterval: PropTypes.number,
  delay: PropTypes.number
};

const Overlay = styled(ModalOverlayStyled)``;
const InterstitialLoaderWrapper = _ref => {
  let {
    duration = 2000,
    delay = 0,
    messages = [],
    messagesInterval = 1000,
    showLoadingBar = true
  } = _ref;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Flex, {
    height: "100%",
    flexDirection: "column",
    justifyContent: "space-between"
  }, showLoadingBar ? /*#__PURE__*/React.createElement(Box, {
    flex: "0 1 auto"
  }, /*#__PURE__*/React.createElement(LoadingBar, {
    duration: duration
  })) : null, /*#__PURE__*/React.createElement(InterstitialContent, {
    messages: messages,
    messagesInterval: messagesInterval,
    delay: delay
  }))), document.getElementsByTagName('body')[0]);
};
const InterstitialLoader = props => /*#__PURE__*/React.createElement(InterstitialLoaderWrapper, props);
InterstitialLoader.propTypes = {
  /**
   * Time (in milliseconds) to animate the loading bar.
   */
  duration: PropTypes.number,
  /**
   * Messages to cycle through.
   */
  messages: PropTypes.arrayOf(PropTypes.string),
  /**
   * Time (in milliseconds) between message transitions.
   */
  messagesInterval: PropTypes.number,
  /**
   * Adds a delay to show just an overlay without the interstitial content for a specified time (in milliseconds).
   */
  delay: PropTypes.number,
  /**
   * Whether to show the loading bar at the top of the interstitial.
   */
  showLoadingBar: PropTypes.bool
};

/* eslint-disable max-len */
const LightBoxStyles = createGlobalStyle`

  body {
    --yarl__thumbnails_thumbnail_active_border_color: ${getThemeProp('global.link--color')};
    --yarl__thumbnails_thumbnail_border: 1px solid hsla(0, 0%, 100%, 0.3);
    --yarl__slide_description_text_align: center;
    --yarl__slide_description_container_bottom: 15px;
  }

  /* the following styles are copied over from  */
  .yarl__fullsize {
    height: 100%;
    width: 100%;
  }
  .yarl__relative {
    position: relative;
  }
  .yarl__portal {
    bottom: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity var(--yarl__fade_animation_duration, 0.25s)
      var(--yarl__fade_animation_timing_function, ease);
    z-index: var(--yarl__portal_zindex, 9999);
  }
  .yarl__portal_open {
    opacity: 1;
  }
  .yarl__container {
    background-color: var(
      --yarl__container_background_color,
      var(--yarl__color_backdrop, #000)
    );
    bottom: 0;
    left: 0;
    outline: 0;
    overflow: hidden;
    overscroll-behavior: var(--yarl__controller_overscroll-behavior, contain);
    position: absolute;
    right: 0;
    top: 0;
    touch-action: var(--yarl__controller_touch_action, none);
    user-select: none;
  }
  .yarl__carousel {
    align-content: center;
    align-items: stretch;
    display: flex;
    flex: 0 0 auto;
    height: 100%;
    justify-content: center;
    opacity: var(--yarl__pull_down_opacity, 1);
    transform: translate(
      var(--yarl__swipe_offset, 0),
      var(--yarl__pull_down_offset, 0)
    );
    width: calc(
      100% + (var(--yarl__carousel_slides_count) - 1) *
        (
          100% + var(--yarl__carousel_spacing_px, 0) * 1px +
            var(--yarl__carousel_spacing_percent, 0) * 1%
        )
    );
  }
  .yarl__carousel_with_slides {
    column-gap: calc(
      var(--yarl__carousel_spacing_px, 0) * 1px + 100 /
        (
          var(--yarl__carousel_slides_count) * 100 +
            (var(--yarl__carousel_slides_count) - 1) *
            var(--yarl__carousel_spacing_percent, 0)
        ) * var(--yarl__carousel_spacing_percent, 0) * 1%
    );
  }
  .yarl__flex_center {
    align-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .yarl__slide {
    flex: 1;
    overflow: hidden;
    padding: calc(
      var(--yarl__carousel_padding_px, 0) * 1px + 100 /
        (
          var(--yarl__carousel_slides_count) * 100 +
            (var(--yarl__carousel_slides_count) - 1) *
            var(--yarl__carousel_spacing_percent, 0)
        ) * var(--yarl__carousel_padding_percent, 0) * 1%
    );
    position: relative;
  }
  [dir="rtl"] .yarl__slide {
    --yarl__direction: -1;
  }
  .yarl__slide_image {
    -webkit-touch-callout: none;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    touch-action: var(--yarl__controller_touch_action, none);
    user-select: none;
  }
  @media screen and (min-width: 800px) {
    .yarl__slide_image {
      -webkit-backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
    }
  }
  .yarl__slide_image_cover {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  .yarl__slide_image_loading {
    opacity: 0;
  }
  .yarl__slide_placeholder {
    left: 50%;
    line-height: 0;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .yarl__slide_loading {
    animation: yarl__delayed_fadein 1s linear;
    color: var(
      --yarl__slide_icon_loading_color,
      var(--yarl__color_button, hsla(0, 0%, 100%, 0.8))
    );
  }
  .yarl__slide_loading line {
    animation: yarl__stroke_opacity 1s linear infinite;
  }
  .yarl__slide_loading line:first-of-type {
    animation-delay: -1.875s;
  }
  .yarl__slide_loading line:nth-of-type(2) {
    animation-delay: -1.75s;
  }
  .yarl__slide_loading line:nth-of-type(3) {
    animation-delay: -1.625s;
  }
  .yarl__slide_loading line:nth-of-type(4) {
    animation-delay: -1.5s;
  }
  .yarl__slide_loading line:nth-of-type(5) {
    animation-delay: -1.375s;
  }
  .yarl__slide_loading line:nth-of-type(6) {
    animation-delay: -1.25s;
  }
  .yarl__slide_loading line:nth-of-type(7) {
    animation-delay: -1.125s;
  }
  .yarl__slide_loading line:nth-of-type(8) {
    animation-delay: -1s;
  }
  .yarl__slide_error {
    color: var(--yarl__slide_icon_error_color, red);
    height: var(--yarl__slide_icon_error_size, 48px);
    width: var(--yarl__slide_icon_error_size, 48px);
  }
  @media (prefers-reduced-motion) {
    .yarl__portal,
    .yarl__slide {
      transition: unset;
    }
    .yarl__slide_loading,
    .yarl__slide_loading line {
      animation: unset;
    }
  }
  .yarl__toolbar {
    bottom: auto;
    display: flex;
    justify-content: flex-end;
    left: auto;
    padding: var(--yarl__toolbar_padding, 8px);
    position: absolute;
    right: 0;
    top: 0;
  }
  [dir="rtl"] .yarl__toolbar {
    bottom: auto;
    left: 0;
    right: auto;
    top: 0;
  }
  .yarl__icon {
    height: var(--yarl__icon_size, 32px);
    width: var(--yarl__icon_size, 32px);
  }
  .yarl__button {
    -webkit-tap-highlight-color: transparent;
    appearance: none;
    background-color: var(--yarl__button_background_color, transparent);
    border: var(--yarl__button_border, 0);
    color: var(--yarl__color_button, hsla(0, 0%, 100%, 0.8));
    cursor: pointer;
    filter: var(
      --yarl__button_filter,
      drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8))
    );
    line-height: 0;
    margin: var(--yarl__button_margin, 0);
    outline: none;
    padding: var(--yarl__button_padding, 8px);
  }
  .yarl__button:focus {
    color: var(--yarl__color_button_active, #fff);
  }
  .yarl__button:focus:not(:focus-visible) {
    color: var(--yarl__color_button, hsla(0, 0%, 100%, 0.8));
  }
  .yarl__button:focus-visible {
    color: var(--yarl__color_button_active, #fff);
  }
  @media (hover: hover) {
    .yarl__button:focus-visible:hover,
    .yarl__button:focus:hover,
    .yarl__button:hover {
      color: var(--yarl__color_button_active, #fff);
    }
  }
  .yarl__button:disabled {
    display: none;
    color: var(--yarl__color_button_disabled, hsla(0, 0%, 100%, 0.4));
    cursor: default;
  }
  .yarl__navigation_next,
  .yarl__navigation_prev {
    padding: var(--yarl__navigation_button_padding, 24px 16px);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .yarl__navigation_prev {
    left: 0;
  }
  [dir="rtl"] .yarl__navigation_prev {
    left: unset;
    right: 0;
    transform: translateY(-50%) rotate(180deg);
  }
  .yarl__navigation_next {
    right: 0;
  }
  [dir="rtl"] .yarl__navigation_next {
    left: 0;
    right: unset;
    transform: translateY(-50%) rotate(180deg);
  }
  .yarl__no_scroll {
    height: 100%;
    overflow: hidden;
    overscroll-behavior: none;
  }
  @-webkit-keyframes yarl__delayed_fadein {
    0% {
      opacity: 0;
    }
    80% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes yarl__delayed_fadein {
    0% {
      opacity: 0;
    }
    80% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes yarl__stroke_opacity {
    0% {
      stroke-opacity: 1;
    }
    to {
      stroke-opacity: 0.125;
    }
  }
  @keyframes yarl__stroke_opacity {
    0% {
      stroke-opacity: 1;
    }
    to {
      stroke-opacity: 0.125;
    }
  }

  /* counter css */
  .yarl__counter {
    bottom: var(--yarl__counter_bottom, unset);
    color: var(
      --yarl__counter_color,
      var(--yarl__color_button, hsla(0, 0%, 100%, 0.8))
    );
    filter: var(
      --yarl__counter_filter,
      drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8))
    );
    left: var(--yarl__counter_left, 0);
    line-height: var(--yarl__counter_line_height, var(--yarl__icon_size, 32px));
    margin: var(--yarl__counter_margin, var(--yarl__toolbar_padding, 8px));
    padding: var(--yarl__counter_padding, var(--yarl__button_padding, 8px));
    position: var(--yarl__counter_position, absolute);
    right: var(--yarl__counter_right, unset);
    top: var(--yarl__counter_top, 0);
    user-select: var(--yarl__counter_user_select, none);
  }

  /* Thumbnails css */
  .yarl__thumbnails {
    display: flex;
    height: 100%;
  }
  .yarl__thumbnails_bottom,
  .yarl__thumbnails_end .yarl__thumbnails_track,
  .yarl__thumbnails_start .yarl__thumbnails_track,
  .yarl__thumbnails_top {
    flex-direction: column;
  }
  .yarl__thumbnails_wrapper {
    flex: 1;
    position: relative;
  }
  .yarl__thumbnails_container {
    -webkit-touch-callout: none;
    background-color: var(
      --yarl__thumbnails_container_background_color,
      var(--yarl__color_backdrop, #000)
    );
    flex: 0 0 auto;
    overflow: hidden;
    padding: var(--yarl__thumbnails_container_padding, 16px);
    position: relative;
    user-select: none;
  }
  .yarl__thumbnails_vignette {
    --yarl__thumbnails_vignette_size: 12%;
    pointer-events: none;
    position: absolute;
  }
  @media (min-width: 1200px) {
    .yarl__thumbnails_vignette {
      --yarl__thumbnails_vignette_size: 8%;
    }
  }
  @media (min-width: 2000px) {
    .yarl__thumbnails_vignette {
      --yarl__thumbnails_vignette_size: 5%;
    }
  }
  .yarl__thumbnails_bottom .yarl__thumbnails_vignette,
  .yarl__thumbnails_top .yarl__thumbnails_vignette {
    background: linear-gradient(
      to right,
      var(--yarl__color_backdrop, #000) 0,
      transparent var(--yarl__thumbnails_vignette_size, 12%)
        calc(100% - var(--yarl__thumbnails_vignette_size, 12%)),
      var(--yarl__color_backdrop, #000) 100%
    );
    height: 100%;
    left: 0;
    right: 0;
  }
  .yarl__thumbnails_end .yarl__thumbnails_vignette,
  .yarl__thumbnails_start .yarl__thumbnails_vignette {
    background: linear-gradient(
      to bottom,
      var(--yarl__color_backdrop, #000) 0,
      transparent var(--yarl__thumbnails_vignette_size, 12%)
        calc(100% - var(--yarl__thumbnails_vignette_size, 12%)),
      var(--yarl__color_backdrop, #000) 100%
    );
    bottom: 0;
    top: 0;
    width: 100%;
  }
  .yarl__thumbnails_track {
    gap: var(--yarl__thumbnails_thumbnail_gap, 16px);
  }
  .yarl__thumbnails_thumbnail {
    -webkit-tap-highlight-color: transparent;
    appearance: none;
    background: var(--yarl__thumbnails_thumbnail_background, #000);
    border: var(
      --yarl__thumbnails_thumbnail_border,
      1px solid var(--yarl__color_button, hsla(0, 0%, 100%, 0.8))
    );
    border-radius: var(--yarl__thumbnails_thumbnail_border_radius, 4px);
    box-sizing: content-box;
    cursor: pointer;
    flex: 0 0 auto;
    height: var(--yarl__thumbnails_thumbnail_height, 80px);
    overflow: hidden;
    padding: var(--yarl__thumbnails_thumbnail_padding, 4px);
    position: relative;
    width: var(--yarl__thumbnails_thumbnail_width, 120px);
  }
  .yarl__thumbnails_thumbnail_active {
    border-color: var(
      --yarl__thumbnails_thumbnail_active_border_color,
      var(--yarl__color_button_active, #fff)
    );
  }
  .yarl__thumbnails_thumbnail_fadein {
    animation: yarl__thumbnails_thumbnail_fadein
      var(--yarl__thumbnails_thumbnail_fadein_duration, 0.5s) ease-in-out
      var(--yarl__thumbnails_thumbnail_fadein_delay, 0s) forwards;
    opacity: 0;
  }
  .yarl__thumbnails_thumbnail_fadeout {
    animation: yarl__thumbnails_thumbnail_fadeout
      var(--yarl__thumbnails_thumbnail_fadeout_duration, 0.5s) ease-in-out
      var(--yarl__thumbnails_thumbnail_fadeout_delay, 0s) forwards;
    cursor: unset;
  }
  .yarl__thumbnails_thumbnail_placeholder {
    cursor: unset;
    visibility: hidden;
  }
  .yarl__thumbnails_thumbnail_icon {
    color: var(
      --yarl__thumbnails_thumbnail_icon_color,
      var(--yarl__color_button, hsla(0, 0%, 100%, 0.8))
    );
    filter: var(
      --yarl__thumbnails_thumbnail_icon_filter,
      drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8))
    );
    height: var(--yarl__thumbnails_thumbnail_icon_size, 32px);
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: var(--yarl__thumbnails_thumbnail_icon_size, 32px);
  }
  .yarl__thumbnails_contain_image {
    -o-object-fit: contain;
    object-fit: contain;
  }
  @-webkit-keyframes yarl__thumbnails_thumbnail_fadein {
    0% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes yarl__thumbnails_thumbnail_fadein {
    0% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes yarl__thumbnails_thumbnail_fadeout {
    0% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  @keyframes yarl__thumbnails_thumbnail_fadeout {
    0% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  /* caption css */
  .yarl__slide_captions_container {
  background: var(
    --yarl__slide_captions_container_background,
    rgba(0, 0, 0, 0.5)
  );
  left: var(--yarl__slide_captions_container_left, 0);
  padding: var(--yarl__slide_captions_container_padding, 16px);
  position: absolute;
  right: var(--yarl__slide_captions_container_right, 0);
  -webkit-transform: translateZ(0);
}
.yarl__slide_title {
  color: var(--yarl__slide_title_color, #fff);
  font-size: var(--yarl__slide_title_font_size, 125%);
  font-weight: var(--yarl__slide_title_font_weight, bolder);
  max-width: calc(100% - var(--yarl__toolbar_width, 0px));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.yarl__slide_title_container {
  top: var(--yarl__slide_title_container_top, 0);
}
.yarl__slide_description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--yarl__slide_description_max_lines, 3);
  color: var(--yarl__slide_description_color, #fff);
  display: -webkit-box;
  hyphens: auto;
  overflow: hidden;
  text-align: var(--yarl__slide_description_text_align, start);
  font-weight: 600;

}
.yarl__slide_description_container {
  bottom: var(--yarl__slide_description_container_bottom, 0);
}

`;

const LightBox = _ref => {
  let {
    slides,
    showThumbnails = true,
    showCounter = true,
    open,
    onClose
  } = _ref;
  const activatedPlugins = [Captions];
  if (showThumbnails) {
    activatedPlugins.push(Thumbnails);
  }
  if (showCounter) {
    activatedPlugins.push(Counter);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, open ? /*#__PURE__*/React.createElement(LightBoxStyles, null) : null, /*#__PURE__*/React.createElement(AnotherReactLightBox, {
    plugins: activatedPlugins,
    carousel: {
      preload: 10,
      finite: true
    },
    open: open,
    close: onClose,
    slides: slides
  }));
};
LightBox.propTypes = {
  /**
   * Controls open state of the LightBox.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Handler called on closing of `LightBox` by either clicking the `x` button or hitting `esc` on the keyboard.
   */
  onClose: PropTypes.func.isRequired,
  /**
   * A collection of slides with optional descriptions for each.
   */
  slides: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    description: PropTypes.string
  })).isRequired,
  /**
   * Adds thumbnails track.
   */
  showThumbnails: PropTypes.bool,
  /**
   * Adds slides counter.
   */
  showCounter: PropTypes.bool
};

const ToggleBackground = styled(Flex)`
  text-align: right;
  background-color: ${getThemeProp('global.border--color')};
  border-radius: 20px;
  padding: 2px;
  display: inline-flex;
  position: relative;
  z-index: 0;
  cursor: pointer;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    min-width: 150px;
  }

  &:after {
    content: '';
    width: calc(50% - 4px);
    position: absolute;
    left: 0%;
    top: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.15);
    transition: left 0.3s, borderRadius 2.3s;
    margin: 0 2px;

    ${_ref => {
  let {
    isActive
  } = _ref;
  return isActive && css`
        left: 50%;
        right: 0;
      `;
}};
  }
`;
const Option$1 = styled(Box)`
  z-index: 2;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  flex: 0 1 50%;
`;
const OptionContent = styled(Box)`
  z-index: 2;
  flex: 0 1 50%;
`;
const ButtonToggle = _ref2 => {
  let {
    isActive,
    activeLabel,
    inactiveLabel,
    activeContent,
    inactiveContent,
    onClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(ToggleBackground, {
    isActive: isActive,
    onClick: onClick
  }, activeLabel ? /*#__PURE__*/React.createElement(Option$1, null, activeLabel) : null, inactiveLabel ? /*#__PURE__*/React.createElement(Option$1, null, inactiveLabel) : null, activeContent ? /*#__PURE__*/React.createElement(OptionContent, null, activeContent) : null, inactiveContent ? /*#__PURE__*/React.createElement(OptionContent, null, inactiveContent) : null);
};
ButtonToggle.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  activeLabel: PropTypes.string,
  inactiveLabel: PropTypes.string,
  activeContent: PropTypes.element,
  inactiveContent: PropTypes.element
};

const Metric = styled(Flex)`
  width: 90px;
  height: 72px;
  border-radius: 8px;
  line-height: 1;
  background: white;
  box-shadow: 0px 0px 0px 1px ${getTokenValue(THEME_TOKENS.base.color.infoBorder)} inset;

  [data-within='tooltip'] & {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: unset;
  }
`;
const MetricValue$1 = styled.div`
  font-size: 16px;
`;
const MetricValueTitle = styled.div`
  font-weight: bold;
  opacity: 0.6;
  font-size: 14px;
`;
const MetricValueCaption = styled.div`
  opacity: 0.7;
  font-weight: 100;
  font-size: 11px;
  padding-bottom: 2px;
  /* text-transform: uppercase; */
`;
const MetricBox = _ref => {
  let {
    title,
    value,
    valueCaption,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Metric, _extends({
    my: 2,
    p: 2,
    justifyContent: "space-between",
    flexDirection: "column"
  }, rest), /*#__PURE__*/React.createElement(MetricValueTitle, null, title), /*#__PURE__*/React.createElement(MetricValue$1, null, valueCaption !== null ? /*#__PURE__*/React.createElement(MetricValueCaption, null, valueCaption) : '', value));
};
MetricBox.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  valueCaption: PropTypes.string
};
MetricBox.defaultProps = {
  valueCaption: null
};

const RootStyled = styled(TabsPrimitive.Root)`
  display: flex;
  flex-direction: column;
  background: transparent;
`;
const ListStyled = styled(TabsPrimitive.List)`
  display: flex;
  color: ${THEME_TOKENS.base.color.secondaryText};
  box-shadow: ${props => props.customTabSwitchingControls ? 'none' : `0px -1px ${getTokenValue(THEME_TOKENS.textInput.color.border)} inset`};
`;
const TriggerStyled = styled(TabsPrimitive.Trigger)`
  all: unset;
  display: flex;
  flex-grow: ${_ref => {
  let {
    grow
  } = _ref;
  return grow;
}};
  align-items: center;
  justify-content: center;
  user-select: none;
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};

  &:hover {
    cursor: pointer;
    color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  }

  &[data-state='active'] {
    color: ${getTokenValue(THEME_TOKENS.base.color.action)};
    box-shadow: 0px -2px ${getTokenValue(THEME_TOKENS.base.color.action)} inset;

    &:hover {
      cursor: default;
    }
  }
`;
const TriggerWithKind = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    kind,
    grow = false,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(TriggerStyled, _extends({
    kind: kind,
    grow: grow ? 1 : 0,
    ref: ref
  }, props));
});

// eslint-disable-next-line react/prop-types
const Tabs = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(RootStyled, rest, children);
};
Tabs.List = props => {
  const {
    children,
    customTabSwitchingControls,
    ...rest
  } = props;
  return customTabSwitchingControls ? /*#__PURE__*/React.createElement(React.Fragment, null, customTabSwitchingControls) : /*#__PURE__*/React.createElement(ListStyled, rest, children);
};
Tabs.Trigger = TriggerWithKind;
Tabs.Content = TabsPrimitive.Content;

// Most of the props below are from Radix-UI.
// kind && grow prop are new.

const PropTypesTabs = {
  asChild: PropTypes.bool,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  onValueChange: PropTypes.func,
  orientation: PropTypes.oneOf(['horizontal', 'vertical', undefined]),
  dir: PropTypes.oneOf(['ltr', 'rtl']),
  activationMode: PropTypes.oneOf(['automatic', 'manual'])
};
const PropTypesTabsList = {
  asChild: PropTypes.bool,
  loop: PropTypes.bool,
  children: PropTypes.node,
  /**
   * Supplying a custom component to this prop will hide the default tabs and render the custom component instead.
   * Tabs must then be controlled using 'value' prop.
   */
  customTabSwitchingControls: PropTypes.node
};
const PropTypesTabContent = {
  asChild: PropTypes.bool,
  value: PropTypes.string.isRequired
};
TriggerWithKind.propTypes = {
  /**
   * Provide theme for text, selected indicator, hover
   */
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'dark']),
  asChild: PropTypes.bool,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  /**
   * Allow the tab to grow.
   */
  grow: PropTypes.bool
};
Tabs.propTypes = PropTypesTabs;
Tabs.List.propTypes = PropTypesTabsList;
Tabs.Trigger.propTypes = TriggerWithKind.propTypes;
Tabs.Content.propTypes = PropTypesTabContent;

const getKindColor$1 = props => {
  if (props.kind) {
    switch (props.kind) {
      case 'primary':
      case 'secondary':
        return getThemeProp(`button.${props.kind}--color`)(props);
      case 'danger':
      case 'warning':
      case 'success':
      case 'info':
        return getThemeProp(`global.${props.kind}--color`)(props);
      case 'vellum':
        return 'rgba(255,255,255,0.3)';
      default:
        return null;
    }
  }
  return null;
};
const kindLinkColorOrDefault = defaultProp => props => {
  return getKindColor$1(props) || getThemeProp(defaultProp);
};
const enlightenedKindColorOrDefault = defaultProp => props => {
  const kindColor = getKindColor$1(props);
  if (kindColor) {
    return tinycolor.mix(kindColor, 'white', 60).toString();
  }
  return getThemeProp(defaultProp)(props);
};
const backgroundKindColorOrWhite = props => {
  const kindColor = getKindColor$1(props);
  if (kindColor) {
    return tinycolor.mix(kindColor, 'white', 90).toString();
  }
  return 'white';
};
const IconContainer = styled(Box)`
  background-color: ${enlightenedKindColorOrDefault('global.light--color')};
  transition: all 150ms ease;
  border-radius: 7px 0 0 7px;
`;
const IconWrapper = styled(Flex)`
  font-size: ${_ref => {
  let {
    iconSize
  } = _ref;
  return iconSize || '32px';
}};
  border: 1px solid;
  border-color: ${getThemeProp('global.accent--color')};
  border-radius: 50%;
  overflow: hidden;
  transition: all 150ms ease;
  background: white;
  padding: 0.2em;

  ${props => props.withLink && css`
      color: ${kindLinkColorOrDefault('global.link--color')};
    `}
`;
const TileWrapper = styled(Flex)`
  background-color: ${backgroundKindColorOrWhite};
  width: 100%;
  border-style: solid;
  border-color: var(${THEME_TOKENS.card.color.border}, ${getThemeProp('global.border--color')});
  border-width: 1px;
  border-radius: 8px;

  ${props => props.withLink && css`
      transition: all 150ms ease;
    `};
`;
const LinkWrapper = styled(Flex)`
  text-decoration: none;
  width: 100%;

  ${props => props.withLink && css`
      color: ${kindLinkColorOrDefault('global.link--color')};
      cursor: pointer;

      &:hover {
        ${TileWrapper} {
          border-color: transparent;
          box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
        }
      }
    `}
`;
const Icon$1 = _ref2 => {
  let {
    withLink,
    children,
    iconSize,
    kind
  } = _ref2;
  return /*#__PURE__*/React.createElement(IconContainer, {
    px: [2],
    py: [3],
    kind: kind
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    iconSize: iconSize,
    withLink: withLink,
    kind: kind
  }, children));
};
Icon$1.propTypes = {
  withLink: PropTypes.bool,
  iconSize: PropTypes.string,
  kind: PropTypes.string
};
const Body = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(Box, _extends({
    alignSelf: "center",
    px: [3]
  }, props), children);
};
const LinkTile = _ref4 => {
  let {
    children,
    icon,
    iconSize,
    href,
    kind,
    ...props
  } = _ref4;
  return /*#__PURE__*/React.createElement(LinkWrapper, _extends({
    as: href ? 'a' : null,
    withLink: href,
    href: href,
    kind: kind
  }, props), /*#__PURE__*/React.createElement(TileWrapper, {
    withLink: href,
    kind: kind
  }, /*#__PURE__*/React.createElement(Icon$1, {
    withLink: href,
    iconSize: iconSize,
    kind: kind
  }, /*#__PURE__*/React.cloneElement(icon, {
    backgroundColor: 'white'
  })), children));
};
LinkTile.Body = Body;
LinkTile.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node.isRequired,
  iconSize: PropTypes.string,
  href: PropTypes.string,
  kind: PropTypes.string
};
Body.propTypes = {
  children: PropTypes.node
};
Icon$1.propTypes = {
  children: PropTypes.node
};

const getKindColor = props => {
  if (props.kind) {
    switch (props.kind) {
      case 'primary':
      case 'secondary':
        return getThemeProp(`button.${props.kind}--color`)(props);
      case 'danger':
      case 'warning':
      case 'success':
      case 'info':
        return getThemeProp(`global.${props.kind}--color`)(props);
      case 'vellum':
        return 'rgba(255,255,255,0.3)';
      default:
        return null;
    }
  }
  return null;
};
const lightKindColorOrDefault = defaultProp => props => {
  return getKindColor(props) ? tinycolor.mix(getKindColor(props), 'white', 40).toString() : getThemeProp(defaultProp)(props);
};
const CountText = styled(Text$2)`
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const LabelText = styled(Text$2)`
  color: ${lightKindColorOrDefault('global.greyPalette.600')};
`;
const StyledAnchor = styled.span`
  text-decoration: inherit;
  color: ${getTokenValue(THEME_TOKENS.base.color.link)};
  font-weight: 600;
  font-size: 14px;
`;
const MetricTile = _ref => {
  let {
    icon,
    iconSize,
    count,
    countLabel,
    anchorText,
    href,
    kind,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(LinkTile, _extends({
    icon: icon,
    iconSize: iconSize,
    href: href,
    kind: kind
  }, props), /*#__PURE__*/React.createElement(LinkTile.Body, {
    py: "12px"
  }, /*#__PURE__*/React.createElement(CountText, {
    kind: kind,
    size: "28px",
    mb: 1
  }, count), /*#__PURE__*/React.createElement(LabelText, {
    kind: kind,
    size: "14px"
  }, countLabel), anchorText && href ? /*#__PURE__*/React.createElement(Box, {
    pt: 3
  }, /*#__PURE__*/React.createElement(StyledAnchor, {
    kind: kind
  }, anchorText)) : null));
};
MetricTile.propTypes = {
  anchorText: PropTypes.string,
  children: PropTypes.node,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  countLabel: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  iconSize: PropTypes.string,
  href: PropTypes.string,
  kind: PropTypes.string
};

const tileHeight = '48px';
const TileContainer = styled.div`
  height: ${tileHeight};
  display: inline-flex;
  align-items: center;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
  overflow: hidden;
  background-color: white;
  border: 1px solid ${getTokenValue(THEME_TOKENS.card.color.border)};
  /* box-shadow: rgb(0 0 0 / 12%) 0px 1px 4px 0px; */
`;
const TileGraphic = styled.div`
  height: ${tileHeight};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getThemeProp('global.light--color')};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  padding: 0 6px;
`;
const MetricValue = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const TileTextColumn = styled.div`
  display: flex;
  flex-direction: ${_ref => {
  let {
    reverseOrder
  } = _ref;
  return reverseOrder ? 'column-reverse' : 'column';
}};
  gap: 4px;
  margin: 0 8px;
`;
const MetricTileCompact = _ref2 => {
  let {
    graphic,
    label,
    metric,
    reverseOrder = false
  } = _ref2;
  return /*#__PURE__*/React.createElement(TileContainer, null, /*#__PURE__*/React.createElement(TileGraphic, null, graphic), /*#__PURE__*/React.createElement(TileTextColumn, {
    reverseOrder: reverseOrder
  }, /*#__PURE__*/React.createElement(MetricValue, null, metric), /*#__PURE__*/React.createElement(Text$2, {
    size: 12
  }, label)));
};
MetricTileCompact.propTypes = {
  label: PropTypes.string.isRequired,
  metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  graphic: PropTypes.node,
  reverseOrder: PropTypes.bool
};

const TileContainerSmall = styled.div`
  display: inline-flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
  border-style: solid;
  border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
  border-width: 1px;
  background-color: white;
`;
const TitleSmall = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getThemeProp('global.light--color')};
  padding: 4px 6px;
  font-size: 10px;
`;
const IconTextSmall = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 6px;
`;
const renderMetric = metric => {
  if (typeof metric === 'string') {
    return /*#__PURE__*/React.createElement(Text$2, {
      size: 14,
      weight: "800"
    }, metric);
  }
  return metric;
};
const MetricTileMini = _ref => {
  let {
    graphic,
    label,
    metric
  } = _ref;
  return /*#__PURE__*/React.createElement(TileContainerSmall, null, label ? /*#__PURE__*/React.createElement(TitleSmall, null, label) : null, /*#__PURE__*/React.createElement(IconTextSmall, null, graphic, renderMetric(metric)));
};
MetricTileMini.propTypes = {
  label: PropTypes.string,
  metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  graphic: PropTypes.node
};

var DropdownHint = styled.div`
  background: ${getTokenValue(THEME_TOKENS.base.color.infoBackground)};
  padding: 8px 16px;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  align-items: center;
  font-size: 14px;
`;

var Options = styled.ol`
  margin: 0;
  padding: 0;
`;

const PrefixIcon = styled(IconFlex)`
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
`;
const OptionItem$1 = styled.li`
  position: relative;
  cursor: pointer;
  list-style: none;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1;
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 12px 16px;
  margin: 0;

  ${_ref => {
  let {
    showBorder
  } = _ref;
  return showBorder && css`
      border-bottom: 1px solid ${GreyPalette[200]};
    `;
}};

  ${_ref2 => {
  let {
    isSelectedItem
  } = _ref2;
  return isSelectedItem && css`
      font-weight: bold;
    `;
}};

  ${_ref3 => {
  let {
    isActive
  } = _ref3;
  return isActive && css`
      background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
      border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
    `;
}};
`;
const TextOverflow$1 = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Subtitle = styled.small`
  font-size: 12px;
  display: block;
  padding-top: 4px;
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};
  font-weight: normal;
`;
const TextContainer$2 = styled(Box)`
  display: grid;
`;
const SpecialBadge = styled.span`
  display: inline-block;
  padding: ${SPACE.size2} ${SPACE.size4};
  border-radius: 2px;
  background-color: #fff;
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  border: 1px solid ${getTokenValue(THEME_TOKENS.card.color.border)};
`;
const Option = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    subtitle = '',
    prefixIcon = null,
    badgeText = null,
    isActive,
    children,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(OptionItem$1, _extends({
    ref: ref,
    isActive: isActive
  }, rest), /*#__PURE__*/React.createElement(Flex, null, prefixIcon ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(PrefixIcon, {
    isActive: isActive,
    size: 20,
    pr: 3
  }, prefixIcon)) : null, /*#__PURE__*/React.createElement(TextContainer$2, null, /*#__PURE__*/React.createElement(TextOverflow$1, null, badgeText ? /*#__PURE__*/React.createElement(SpecialBadge, null, badgeText) : null, " ", children), subtitle ? /*#__PURE__*/React.createElement(Subtitle, {
    isActive: isActive
  }, subtitle) : null)));
});
Option.propTypes = {
  prefixIcon: PropTypes.element,
  subtitle: PropTypes.string,
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired,
  badgeText: PropTypes.string
};

const ItemText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.2;
`;
const OptionPerson = _ref => {
  let {
    imgUrl = '',
    initials = '',
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Option, rest, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, imgUrl || initials ? /*#__PURE__*/React.createElement(Box, {
    pr: 2
  }, /*#__PURE__*/React.createElement(Avatar, {
    bordered: true,
    imgUrl: imgUrl,
    size: "28px",
    initials: initials
  })) : null, /*#__PURE__*/React.createElement(ItemText, null, children)));
};
OptionPerson.propTypes = {
  imgUrl: PropTypes.string,
  /**
   * Initials are only shown if imageUrl is not provided.
   */
  initials: PropTypes.string,
  /**
   * Name of the person.
   */
  children: PropTypes.string.isRequired
};

var Dropdown = styled.div`
  outline: 0;
  transition: opacity 0.1s ease;
  background: #fff;
  margin: 0;
  padding: 0;
  display: ${_ref => {
  let {
    isEmpty
  } = _ref;
  return isEmpty ? 'none' : 'block';
}};
  ${_ref2 => {
  let {
    inline
  } = _ref2;
  return !inline && css`
      z-index: ${ZINDEX.POPOVER};
      box-shadow: ${getTokenValue(THEME_TOKENS.base.shadow.raised)};
      border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusLarge)};
      overflow: hidden;
      margin-top: ${SPACE.size8};
      padding: ${SPACE.size12};
      position: absolute;
      min-width: 100%;
    `;
}};
`;

var SectionTitle = styled.div`
  letter-spacing: 0.08rem;
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
  font-size: 12px;
  background: ${getTokenValue(THEME_TOKENS.base.color.infoBackground)};
  text-transform: uppercase;
  padding: 8px 16px;
`;

const InputWithInnerLabel = styled(TextInput)`
  background: ${getThemeProp('global.light--color')};
  border-radius: ${_ref => {
  let {
    isOpen
  } = _ref;
  return isOpen ? '17px 17px 0 0' : '20px';
}};

  ${TextFieldStyled} {
    border-left: 1px solid ${getThemeProp('global.border--color')};
    border-radius: ${_ref2 => {
  let {
    isOpen
  } = _ref2;
  return isOpen ? '20px 20px 0 20px' : '20px';
}};
    background: white;
    padding-left: 16px;
  }
`;
const AutocompleteLabel$1 = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 0 8px;
`;
const InputWithLabel$1 = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    label,
    isOpen = false,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(InputWithInnerLabel, _extends({
    isOpen: isOpen,
    prefixContent: /*#__PURE__*/React.createElement(AutocompleteLabel$1, null, label),
    ref: ref
  }, props));
});
InputWithLabel$1.propTypes = {
  label: PropTypes.string,
  isOpen: PropTypes.bool
};

const TextInputNoInnerLabel = styled(TextInput)`
  background-color: ${getTokenValue(THEME_TOKENS.textInput.color.background)};

  ${SuffixBoxStyled} {
    position: unset;
  }

  ${media.Small`
    
    ${TextFieldStyled} {
      border-style: solid;
      border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      ${_ref => {
  let {
    showActivityIndicator,
    suffixContent
  } = _ref;
  return !showActivityIndicator && css`
          border-width: ${suffixContent ? '0 1px 0 0' : '0'};
        `;
}};

        ${_ref2 => {
  let {
    suffixContent
  } = _ref2;
  return suffixContent && css`
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          `;
}};

    }
  `};
`;
const TextInputWithInnerLabel = styled(TextInput)`
  border-color: ${_ref3 => {
  let {
    isOpen
  } = _ref3;
  return isOpen ? getTokenValue(THEME_TOKENS.base.color.action) : getTokenValue(THEME_TOKENS.textInput.color.border);
}};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
  background-color: ${getTokenValue(THEME_TOKENS.textInput.color.background)};
  ${SuffixBoxStyled} {
    position: unset;
    background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
  }

  /* ${_ref4 => {
  let {
    isOpen
  } = _ref4;
  return !isOpen && css`
      &:hover input {
        background-color: ${getTokenValue(THEME_TOKENS.textInput.color.backgroundHover)};
      }
    `;
}}; */

  ${PrefixBoxStyled} {
    background: ${getTokenValue(THEME_TOKENS.base.color.neutral0)};
  }

  ${media.Small`
    /* background: ${getThemeProp('global.light--color')}; */
    
    
    ${TextFieldStyled} {
      border-style: solid;
      border-color: ${getTokenValue(THEME_TOKENS.card.color.border)};
      /* background: white; */
      padding-left: 16px;
      height: 35px;
      border-radius: 0;
      
      ${_ref5 => {
  let {
    showActivityIndicator,
    suffixContent
  } = _ref5;
  return !showActivityIndicator && css`
          border-width: ${suffixContent ? '0 1px' : '0 0 0 1px'};
        `;
}};
    }
  `}
`;
const AutocompleteLabel = styled.div`
  font-size: 14px;
  padding: 8px 8px 8px 12px;
`;
const ActivityIndicatorArea = styled(Box)`
  position: absolute;
  right: 0;
`;
const getPrefixContent = _ref6 => {
  let {
    prefixContent,
    textLabel
  } = _ref6;
  if (textLabel) {
    return /*#__PURE__*/React.createElement(MatchMedia.Small, null, /*#__PURE__*/React.createElement(AutocompleteLabel, null, textLabel));
  }
  if (prefixContent) {
    return prefixContent;
  }
  return /*#__PURE__*/React.createElement(IconFlex, {
    pl: 2,
    width: 25
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: "Search"
  }));
};
const InputWithLabel = /*#__PURE__*/forwardRef((_ref7, ref) => {
  let {
    isOpen,
    isFetching = false,
    clearable = false,
    showActivityIndicator = false,
    textLabel,
    prefixContent = null,
    suffixContent = null,
    ...props
  } = _ref7;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, textLabel ? /*#__PURE__*/React.createElement(TextInputWithInnerLabel, _extends({
      removeAffixSpacing: true,
      isOpen: isOpen,
      clearable: !isFetching && clearable,
      showActivityIndicator: showActivityIndicator,
      prefixContent: getPrefixContent({
        prefixContent,
        textLabel
      }),
      suffixContent: showActivityIndicator && isFetching ? /*#__PURE__*/React.createElement(ActivityIndicatorArea, {
        pr: 2
      }, /*#__PURE__*/React.createElement(ActivityIndicator, {
        size: 14
      })) : suffixContent,
      ref: ref
    }, props)) : /*#__PURE__*/React.createElement(TextInputNoInnerLabel, _extends({
      isOpen: isOpen,
      clearable: !isFetching && clearable,
      iconLineName: !prefixContent && !textLabel ? 'Search' : '',
      prefixContent: getPrefixContent({
        prefixContent,
        textLabel
      }),
      showActivityIndicator: showActivityIndicator,
      suffixContent: showActivityIndicator && isFetching ? /*#__PURE__*/React.createElement(ActivityIndicatorArea, {
        pr: 2
      }, /*#__PURE__*/React.createElement(ActivityIndicator, {
        size: 14
      })) : suffixContent,
      ref: ref
    }, props)))
  );
});
InputWithLabel.propTypes = {
  prefixContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  suffixContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  textLabel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool,
  clearable: PropTypes.bool,
  showActivityIndicator: PropTypes.bool
};

const OptionItem = styled.li`
  position: relative;
  cursor: pointer;
  list-style: none;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1;
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  background-color: ${getTokenValue(THEME_TOKENS.card.color.background)};
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 12px 16px;
  margin: 0;
  font-weight: bold;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};

  ${_ref => {
  let {
    isSelectedItem
  } = _ref;
  return isSelectedItem && css`
      font-weight: bold;
    `;
}};

  ${_ref2 => {
  let {
    isActive
  } = _ref2;
  return isActive && css`
      color: ${getTokenValue(THEME_TOKENS.base.color.neutral0)};
      background-color: ${getTokenValue(THEME_TOKENS.base.color.action)};
    `;
}};
`;
const TextOverflow = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const TextContainer$1 = styled(Box)`
  display: grid;
`;
const AddOption = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    isActive,
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(OptionItem, _extends({
    ref: ref,
    isActive: isActive
  }, rest), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(TextContainer$1, {
    pl: SPACE.size6
  }, /*#__PURE__*/React.createElement(TextOverflow, null, children))));
});
AddOption.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired
};

const Autocomplete = styled.div`
  position: relative;
`;
Autocomplete.InputWithLabel = InputWithLabel$1;
Autocomplete.Input = InputWithLabel;
Autocomplete.Dropdown = Dropdown;
Autocomplete.DropdownHint = DropdownHint;
Autocomplete.SectionTitle = SectionTitle;
Autocomplete.Options = Options;
Autocomplete.Option = Option;
Autocomplete.ActionOption = AddOption;
Autocomplete.OptionPerson = OptionPerson;

// Custom locations concept has been removed from this component. It now simply deals with items (locations).
// Custom locations should be merged into items before it gets here.
const reshapeCustomLocation = customLoc => ({
  Display: `${customLoc.display} (${customLoc.city}${customLoc.stateCode ? `, ${customLoc.stateCode}` : ''})`,
  KeyType: 'G',
  LocID: customLoc.locId,
  nearbyAirports: customLoc.airports
});
const KEY_TYPES = {
  AIRPORT: 'A',
  TOWN: 'T',
  CITY: 'C',
  HOTEL: 'H',
  ATTRACTION: 'P',
  RENTAL_AGENCY: 'V',
  RAIL_STATION: 'R',
  ADDRESS: 'G',
  CUSTOM_ACCOUNT: 'G',
  CUSTOM_PERSONAL: 'G'
};
const getPrefixIcon = keyType => {
  switch (keyType) {
    case KEY_TYPES.CITY:
    case KEY_TYPES.TOWN:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "BuildingSkyscraper"
      });
    case KEY_TYPES.AIRPORT:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "Plane"
      });
    case KEY_TYPES.HOTEL:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "Hotel"
      });
    case KEY_TYPES.RAIL_STATION:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "Train"
      });
    case KEY_TYPES.CUSTOM_ACCOUNT:
    case KEY_TYPES.CUSTOM_PERSONAL:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "Star"
      });
    default:
      return /*#__PURE__*/React.createElement(IconLine, {
        size: 20,
        icon: "MapPin"
      });
  }
};
const PoweredByGoogle = () => /*#__PURE__*/React.createElement(Autocomplete.DropdownHint, null, /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "flex-end",
  width: "100%"
}, /*#__PURE__*/React.createElement("img", {
  width: "100px",
  alt: "Powered by Google",
  src: "https://cdn.amtrav.com/web-all/powered-by-google.png"
})));
const CityAutocompleteInput = _ref => {
  let {
    autofocus = false,
    clearable,
    inputValue = '',
    highlightFirstItem = true,
    isInlineDropdown = false,
    isFetching = false,
    items,
    itemToString,
    kind,
    maxWidth,
    onBlur,
    onClear,
    onInputChange,
    onSelectionChange,
    placeholder,
    selectedItem,
    showLocIcon,
    prefixContent,
    suggestionsCount
  } = _ref;
  const inputRef = useRef(null);
  // Used for delayed keyboard tab action
  const postFetchCallback = useRef(null);
  // only show up to suggestionsCount items
  const truncatedItems = items.slice(0, suggestionsCount);
  const changeHandler = selection => {
    onSelectionChange(selection.selectedItem);
    // Apply focus for onClear
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const {
    isOpen,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps,
    selectItem
  } = useCombobox({
    inputValue,
    onInputValueChange: newInputData => onInputChange(newInputData.inputValue),
    items: truncatedItems,
    itemToString,
    onSelectedItemChange: changeHandler,
    highlightFirstItem,
    selectedItem
  });
  const clearHandler = () => {
    selectItem(null);
    onClear();
  };

  // This useEffect will only fire when there is a postFetchCallback and the system is not fetching data.
  // This is to delay action if a user types and hits tab before the the network call or debounce is complete.
  useEffect(() => {
    if (!isFetching && postFetchCallback.current) {
      postFetchCallback.current(truncatedItems[0]);
      postFetchCallback.current = null;
    }
  }, [isFetching]);
  const hasGoogleResults = truncatedItems.some(a => a.KeyType === null);
  const matchedList = truncatedItems.map((item, index) => {
    var _item$LocID, _item$Display;
    const keyTypeLabel = getLocationByKeyTypeValue(item.KeyType);
    const highlighted = highlightedIndex === index;
    // if the item is an airport, get the airport code and truncate the first character
    const airportCode = item.KeyType === KEY_TYPES.AIRPORT ? (_item$LocID = item.LocID) === null || _item$LocID === void 0 ? void 0 : _item$LocID.slice(1) : null;
    // use regex to replace airport codes in the format (***) with a dash " — "
    const optionDisplay = item.KeyType === KEY_TYPES.AIRPORT ? (_item$Display = item.Display) === null || _item$Display === void 0 ? void 0 : _item$Display.replace(/\((\w{3})\)/, ' — ') : item.Display;
    return /*#__PURE__*/React.createElement(Autocomplete.Option, _extends({}, getItemProps({
      key: item.LocID,
      index,
      item,
      isActive: highlighted,
      isSelected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Display) === item.Display
    }), {
      maxWidth: maxWidth,
      subtitle: keyTypeLabel || '',
      showBorder: isInlineDropdown,
      badgeText: airportCode,
      prefixIcon: getPrefixIcon(item.KeyType)
    }), optionDisplay);
  });
  return /*#__PURE__*/React.createElement(Autocomplete, getComboboxProps(), /*#__PURE__*/React.createElement(Autocomplete.Input, _extends({}, getInputProps({
    kind,
    placeholder,
    onFocus: el => {
      el.target.select();
    },
    onBlur: () => {
      onBlur();
    },
    onChange: e => {
      // This allows React to preserve the input's cursor position, which onInputValueChange cannot do because
      // its asynchronous. Read more: https://github.com/downshift-js/downshift/issues/1108
      onInputChange(e.target.value);
    },
    onKeyDown: _ref2 => {
      let {
        key,
        nativeEvent
      } = _ref2;
      if (key === 'Tab') {
        // if input is debounced or fetching locations, save the action for later in postFetchCallback ref.
        if (isFetching) {
          postFetchCallback.current = newItem => onSelectionChange(newItem);
        } else {
          onSelectionChange(truncatedItems[highlightedIndex === -1 ? 0 : highlightedIndex]);
        }
      }
      if (key === 'Home' || key === 'End') {
        // eslint-disable-next-line no-param-reassign
        nativeEvent.preventDownshiftDefault = true;
      }
      if (key === 'Escape') {
        var _nativeEvent$target;
        // eslint-disable-next-line no-param-reassign
        nativeEvent === null || nativeEvent === void 0 || (_nativeEvent$target = nativeEvent.target) === null || _nativeEvent$target === void 0 || _nativeEvent$target.blur();
      }
    },
    ref: inputRef,
    autoComplete: 'off',
    isOpen,
    onClear: clearHandler,
    isFetching,
    clearable,
    autoFocus: autofocus
  }), {
    showActivityIndicator: true,
    iconLineName: showLocIcon ? 'MapPin' : null,
    prefixContent: prefixContent
  })), /*#__PURE__*/React.createElement(Autocomplete.Dropdown, {
    isEmpty: !isOpen || (matchedList === null || matchedList === void 0 ? void 0 : matchedList.length) === 0,
    inline: isInlineDropdown
  }, /*#__PURE__*/React.createElement(Autocomplete.Options, getMenuProps(), isOpen && matchedList), isOpen && hasGoogleResults && /*#__PURE__*/React.createElement(PoweredByGoogle, null)));
};
const CityAutocomplete = _ref3 => {
  let {
    inputValue = '',
    kind = '',
    items = [],
    selectedItem = undefined,
    defaultSelectedItem = undefined,
    placeholder = 'A city, town, or airport',
    debounce = 200,
    suggestionsCount = 10,
    maxWidth = '420px',
    showLocIcon = false,
    prefixContent = null,
    isFetching = false,
    onInputChange = () => console.warn('No onInputChange supplied to CityAutocomplete'),
    onSelectionChange = () => console.warn('No onSelectionChange supplied to CityAutocomplete'),
    clearable = false,
    onClear = () => {},
    itemToString = loc => loc ? loc.Display : '',
    onBlur = () => {}
  } = _ref3;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const smallOnSelectionChange = e => {
    closeModal();
    onSelectionChange(e);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    readOnly: true,
    kind: kind,
    placeholder: placeholder,
    value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Display) || inputValue || '',
    onChange: () => {},
    onClick: openModal,
    iconLineName: showLocIcon ? 'MapPin' : null
  }), isModalOpen && /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    fullscreen: true
  }, /*#__PURE__*/React.createElement(Modal.Header, null, placeholder), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(CityAutocompleteInput, {
    kind: kind,
    inputValue: inputValue,
    items: items,
    selectedItem: selectedItem,
    defaultSelectedItem: defaultSelectedItem,
    placeholder: placeholder,
    debounce: debounce,
    suggestionsCount: suggestionsCount,
    maxWidth: maxWidth,
    showLocIcon: showLocIcon,
    onInputChange: onInputChange,
    onSelectionChange: smallOnSelectionChange,
    clearable: clearable,
    onClear: onClear,
    itemToString: itemToString,
    isFetching: isFetching,
    isInlineDropdown: true,
    autofocus: true,
    highlightFirstItem: false,
    onBlur: onBlur
  }))))), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(CityAutocompleteInput, {
    kind: kind,
    inputValue: inputValue,
    items: items,
    selectedItem: selectedItem,
    defaultSelectedItem: defaultSelectedItem,
    placeholder: placeholder,
    debounce: debounce,
    suggestionsCount: suggestionsCount,
    maxWidth: maxWidth,
    showLocIcon: showLocIcon,
    prefixContent: prefixContent,
    onInputChange: onInputChange,
    onSelectionChange: onSelectionChange,
    clearable: clearable,
    onClear: onClear,
    itemToString: itemToString,
    isInlineDropdown: false,
    isFetching: isFetching,
    onBlur: onBlur
  })));
};
const Location = PropTypes.shape({
  Display: PropTypes.string.isRequired,
  inputValue: PropTypes.string,
  KeyType: PropTypes.string,
  LocID: PropTypes.string.isRequired,
  nearbyAirports: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    distance: PropTypes.number,
    isRail: PropTypes.bool,
    name: PropTypes.string.isRequired
  }))
});
CityAutocomplete.propTypes = {
  items: PropTypes.arrayOf(Location),
  /**
   * Sets the selection on first render. Only used for an uncontrolled implementation as state is managed internally.
   *
   * Do NOT use with `selectedItem` prop.
   */
  defaultSelectedItem: Location,
  /**
   * For use with a controlled implementation. Takes precedence over `defaultSelectedItem`.
   *
   * Do NOT use with `defaultSelectedItem`
   */
  selectedItem: Location,
  placeholder: PropTypes.string,
  debounce: PropTypes.number,
  suggestionsCount: PropTypes.number,
  onInputChange: PropTypes.func,
  onSelectionChange: PropTypes.func,
  onClear: PropTypes.func,
  itemToString: PropTypes.func,
  onBlur: PropTypes.func,
  kind: PropTypes.string,
  maxWidth: PropTypes.string,
  /**
   * Shows 'X' icon to clear the input once user starts typing
   */
  clearable: PropTypes.bool,
  /**
   * Shows IconLocation in prefix
   */
  showLocIcon: PropTypes.bool,
  isFetching: PropTypes.bool
};
CityAutocompleteInput.propTypes = CityAutocomplete.propTypes;

const DayPickerStyles = createGlobalStyle`
  /* DayPicker styles */
  .DayPicker {
    display: inline-block;
    outline: none;
  }

  .DayPicker-wrapper {
    position: relative;
    flex-direction: row;
    padding-bottom: 1em;
    user-select: none;
    outline: 0;
  }

.DayPicker-Months {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.DayPicker-Month {
  display: table;
  margin-top: 1em;
  border-spacing: 0;
  border-collapse: collapse;
  user-select: none;
}


.DayPicker-NavButton {
  position: absolute;
  top: 1em;
  right: 1.5em;
  left: auto;

  display: inline-block;
  margin-top: 2px;
  width: 1.25em;
  height: 1.25em;
  background-position: center;
  background-size: 50%;
  background-repeat: no-repeat;
  color: #8B9898;
  cursor: pointer;
}

.DayPicker-NavButton:hover {
  opacity: 0.8;
}

.DayPicker-NavButton--prev {
  margin-right: 1.5em;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');
}

.DayPicker-NavButton--next {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');
}

.DayPicker-NavButton--interactionDisabled {
  display: none;
}

.DayPicker-Caption {
  display: table-caption;
  margin-bottom: 0.5em;
  padding: 0 0.5em;
  text-align: left;
}

.DayPicker-Caption > div {
  font-weight: 500;
  font-size: 1.15em;
}

.DayPicker-Weekdays {
  display: table-header-group;
  margin-top: 1em;
}

.DayPicker-WeekdaysRow {
  display: table-row;
}

.DayPicker-Weekday {
  display: table-cell;
  padding: 0.5em;
  color: #8B9898;
  text-align: center;
  font-size: 0.875em;
}

.DayPicker-Weekday abbr[title] {
  border-bottom: none;
  text-decoration: none;
}

.DayPicker-Body {
  display: table-row-group;
}

.DayPicker-Week {
  display: table-row;
}

.DayPicker-Day {
  display: table-cell;
  padding: 0.5em;
  border-radius: 50%;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
}

.DayPicker-WeekNumber {
  display: table-cell;
  padding: 0.5em;
  min-width: 1em;
  border-right: 1px solid #EAECEC;
  color: #8B9898;
  vertical-align: middle;
  text-align: right;
  font-size: 0.75em;
  cursor: pointer;
}

.DayPicker--interactionDisabled .DayPicker-Day {
  cursor: default;
}

.DayPicker-Footer {
  padding-top: 0.5em;
}

.DayPicker-TodayButton {
  border: none;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
  color: #4A90E2;
  font-size: 0.875em;
  cursor: pointer;
}

/* Default modifiers */

.DayPicker-Day--today {
  color: #D0021B;
  font-weight: 700;
}

.DayPicker-Day--outside {
  color: #8B9898;
  cursor: default;
}

.DayPicker-Day--disabled {
  color: #DCE0E0;
  cursor: default;
  /* background-color: #eff1f1; */
}

/* Example modifiers */

.DayPicker-Day--sunday {
  background-color: #F7F8F8;
}

.DayPicker-Day--sunday:not(.DayPicker-Day--today) {
  color: #DCE0E0;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
  position: relative;

  background-color: #4A90E2;
  color: #F0F8FF;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  background-color: #51A0FA;
}

.DayPicker:not(.DayPicker--interactionDisabled)
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
  background-color: #F0F8FF;
}

/* DayPickerInput */

.DayPickerInput {
  display: inline-block;
}

.DayPickerInput-OverlayWrapper {
  position: relative;
}

.DayPickerInput-Overlay {
  position: absolute;
  left: 0;
  z-index: 1;

  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background: none;
    border-radius: 0;
    box-shadow: 0 0 0px 1px ${getThemeProp('global.link--color')} inset;
  }

  .DayPicker {
    &-Weekday {
      padding: 0.8rem;
      font-size: 1em;
    }

    &-NavButton {
      outline: none;
    }

    &-Day {
      padding: 0.8rem;
      outline: none;

      &--today {
        color: inherit;
      }

      &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        border-radius: 0;
        background-color: ${getThemeProp('global.link--color')};

        &:hover {
          background-color: ${getThemeProp('global.link--color')};
        }
      }

      &--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
      }

      &--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
      }
    }
  }
`;

const DatePickerInline = _ref => {
  let {
    date,
    disableBeforeDate,
    disableAfterDate,
    numberOfMonths,
    onSelectDate,
    showNavigationButtons
  } = _ref;
  const handleDayClick = day => {
    onSelectDate(day);
  };
  const navBarProp = showNavigationButtons ? {} : {
    navbarElement: () => null
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DayPickerStyles, null), /*#__PURE__*/React.createElement(DayPicker, _extends({
    initialMonth: showNavigationButtons ? date : null,
    selectedDays: [date],
    modifiers: {
      start: date,
      end: date
    },
    numberOfMonths: numberOfMonths,
    onDayClick: day => handleDayClick(day),
    fromMonth: disableBeforeDate,
    disabledDays: {
      before: disableBeforeDate,
      after: disableAfterDate
    }
  }, navBarProp)));
};
DatePickerInline.propTypes = {
  /**
   * The selected date object.
   */
  date: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  /**
   * Number of months to display at a time
   */
  numberOfMonths: PropTypes.number,
  onSelectDate: PropTypes.func.isRequired,
  showNavigationButtons: PropTypes.bool
};
DatePickerInline.defaultProps = {
  date: null,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1,
  showNavigationButtons: true
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
const DatePicker = _ref => {
  let {
    date,
    disableBeforeDate,
    disableAfterDate,
    numberOfMonths,
    onSelectDate,
    children
  } = _ref;
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  const handleDayClick = day => {
    onSelectDate(day);
  };
  const handleDayClickAndClose = day => {
    onSelectDate(day);
    hide();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children), visible && /*#__PURE__*/React.createElement(Modal, {
    noPadding: true,
    drawer: true,
    onClose: hide
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Date"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(DatePickerInline, {
    date: date,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    numberOfMonths: 12,
    onSelectDate: day => handleDayClick(day),
    showNavigationButtons: false
  }))))), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(Popover, {
    open: visible,
    onOpenChange: open => {
      if (!open) hide();
    },
    onClickOutside: hide,
    content: /*#__PURE__*/React.createElement(DatePickerInline, {
      date: date,
      disableBeforeDate: disableBeforeDate,
      disableAfterDate: disableAfterDate,
      numberOfMonths: numberOfMonths,
      onSelectDate: day => handleDayClickAndClose(day)
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children))));
};
DatePicker.propTypes = {
  /**
   * The selected date object.
   */
  date: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  /**
   * Number of months to display at a time
   */
  numberOfMonths: PropTypes.number,
  onSelectDate: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
DatePicker.defaultProps = {
  // startDate: '',
  // endDate: '',
  date: null,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1
};

const DateRangePicker$1 = _ref => {
  let {
    fromDate,
    toDate,
    onSelectFromDate,
    onSelectToDate,
    disableBeforeDate,
    disableAfterDate,
    numberOfMonths,
    showNavigationButtons
  } = _ref;
  const handleDayClick = currentDaySelection => {
    const bothDatesSelected = fromDate && toDate;
    if (fromDate && isBefore(currentDaySelection, fromDate) || bothDatesSelected) {
      onSelectFromDate(currentDaySelection);
      onSelectToDate(null);
    } else if (fromDate && !isBefore(currentDaySelection, fromDate)) {
      onSelectToDate(currentDaySelection);
    } else {
      onSelectFromDate(currentDaySelection);
    }
  };
  const navBarProp = showNavigationButtons ? {} : {
    navbarElement: () => null
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DayPickerStyles, null), /*#__PURE__*/React.createElement(DayPicker, _extends({
    pagedNavigation: false,
    initialMonth: showNavigationButtons ? fromDate : null,
    selectedDays: [fromDate, {
      from: fromDate,
      to: toDate
    }],
    numberOfMonths: numberOfMonths,
    onDayClick: day => handleDayClick(day),
    modifiers: {
      start: fromDate,
      end: toDate
    },
    fromMonth: disableBeforeDate,
    disabledDays: {
      before: disableBeforeDate,
      after: disableAfterDate
    }
  }, navBarProp)));
};
DateRangePicker$1.propTypes = {
  /**
   * The selected date object.
   */
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  /**
   * Number of months to display at a time
   */
  numberOfMonths: PropTypes.number,
  onSelectFromDate: PropTypes.func.isRequired,
  onSelectToDate: PropTypes.func.isRequired,
  showNavigationButtons: PropTypes.bool
};
DateRangePicker$1.defaultProps = {
  fromDate: null,
  toDate: null,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1,
  showNavigationButtons: true
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
const DateRangePicker = _ref => {
  let {
    fromDate,
    toDate,
    onSelectFromDate,
    onSelectToDate,
    disableBeforeDate,
    disableAfterDate,
    numberOfMonths,
    children
  } = _ref;
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children), visible && /*#__PURE__*/React.createElement(Modal, {
    noPadding: true,
    drawer: true,
    onClose: hide
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Date"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(DateRangePicker$1, {
    numberOfMonths: 12,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    fromDate: fromDate,
    toDate: toDate,
    onSelectFromDate: onSelectFromDate,
    onSelectToDate: onSelectToDate,
    showNavigationButtons: false
  }))))), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(Popover, {
    showCloseButton: true,
    open: visible,
    onOpenChange: open => {
      if (!open) hide();
    },
    onClickOutside: hide,
    content: /*#__PURE__*/React.createElement(DateRangePicker$1, {
      numberOfMonths: numberOfMonths,
      disableBeforeDate: disableBeforeDate,
      disableAfterDate: disableAfterDate,
      fromDate: fromDate,
      toDate: toDate,
      onSelectFromDate: onSelectFromDate,
      onSelectToDate: onSelectToDate
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children))));
};
DateRangePicker.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  /**
   * Number of months to display at a time
   */
  numberOfMonths: PropTypes.number,
  onSelectFromDate: PropTypes.func.isRequired,
  onSelectToDate: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
DateRangePicker.defaultProps = {
  fromDate: null,
  toDate: null,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1
};

const datePickerContextDefaultValue = /*#__PURE__*/createContext({
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => false,
  isDateHovered: () => false,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => false,
  isStartDate: () => false,
  isEndDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {}
});

const getDayBackgroundColor = () => props => {
  const {
    isSelected,
    isWithinHoverRange,
    disabledDate,
    singleDateOnly
  } = props;
  if (singleDateOnly) {
    return 'transparent';
  }
  if (isSelected) {
    return getTokenValue(THEME_TOKENS.card.color.backgroundSecondary);
  }
  if (isWithinHoverRange) {
    return getTokenValue(THEME_TOKENS.card.color.backgroundSecondary);
  }
  if (disabledDate) {
    return 'transparent';
  }
  return 'transparent';
};

const getDaySphereColor = () => props => {
  const {
    isSelectedStart,
    isSelectedEnd,
    disabledDate
  } = props;
  if (isSelectedStart) {
    return getTokenValue(THEME_TOKENS.base.color.link);
  }
  if (isSelectedEnd) {
    return getTokenValue(THEME_TOKENS.base.color.link);
  }
  if (disabledDate) {
    return 'transparent';
  }
  return 'transparent';
};

const getDayTextColor = () => props => {
  const {
    isSelected,
    isSelectedStart,
    isSelectedEnd,
    isWithinHoverRange,
    disabledDate
  } = props;
  if (isSelectedStart) {
    return '#FFFFFF';
  }
  if (isSelectedEnd) {
    return '#FFFFFF';
  }
  if (isSelected) {
    return getTokenValue(THEME_TOKENS.base.color.primaryText);
  }
  if (isWithinHoverRange) {
    return getTokenValue(THEME_TOKENS.base.color.primaryText);
  }
  if (disabledDate) {
    return getTokenValue(THEME_TOKENS.base.color.neutral500);
  }
  return getTokenValue(THEME_TOKENS.base.color.primaryText);
};

const getDayCellSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '48px';
    case 'small':
      return '34px';
    default:
      return '34px';
  }
};

const getDayFontSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '16px';
    case 'small':
      return '14px';
    default:
      return '14px';
  }
};

const DayStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${getDayCellSize};
  height: ${getDayCellSize};
  font-size: ${getDayFontSize};
  color: ${getDayTextColor};
  background-color: ${getDayBackgroundColor};
  cursor: ${_ref => {
  let {
    disabledDate
  } = _ref;
  return disabledDate ? 'not-allowed' : 'pointer';
}};
  margin-bottom: 4px;
  z-index: ${ZINDEX.DATE_RANGE};

  &:hover {
    ${_ref2 => {
  let {
    isSelectedStartOrEnd
  } = _ref2;
  return !isSelectedStartOrEnd && css`
        color: ${_ref3 => {
    let {
      disabledDate
    } = _ref3;
    return disabledDate ? 'gainsboro' : 'white';
  }};
        background-color: ${_ref4 => {
    let {
      disabledDate
    } = _ref4;
    return disabledDate ? 'transparent' : 'gray';
  }};
        border-radius: ${getTokenValue(THEME_TOKENS.button.size.borderRadius)};
      `;
}};
  }

  &:before {
    ${props => props.isSelectedStart && !props.singleDateOnly && css`
        width: 50%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        content: '';
        background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
        z-index: ${ZINDEX.DATE_RANGE_MASK};
      `};
  }

  &:after {
    ${props => props.isSelectedEnd && css`
        width: 50%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        content: '';
        background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
        z-index: ${ZINDEX.DATE_RANGE_MASK};
      `};
  }
`;
const Sphere = styled.div`
  &:after {
    height: ${getDayCellSize};
    width: ${getDayCellSize};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${getDaySphereColor};
    border-radius: ${getTokenValue(THEME_TOKENS.button.size.borderRadius)};
    content: '';
    margin: auto;
    z-index: ${ZINDEX.DATE_SELECTED};
  }
`;
const DayLabel = styled.div`
  z-index: ${ZINDEX.DATE_NUMBER};
`;
const Day = _ref5 => {
  let {
    dayLabel,
    date,
    singleDateOnly,
    size
  } = _ref5;
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    isStartDate,
    isEndDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  } = useContext(datePickerContextDefaultValue);
  const {
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    isStartDate,
    isEndDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });
  if (!dayLabel) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(DayStyled, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    role: "gridcell",
    ref: dayRef,
    isSelected: isSelected,
    isSelectedStartOrEnd: isSelectedStartOrEnd,
    isSelectedStart: isStartDate(date),
    isSelectedEnd: isEndDate(date),
    isWithinHoverRange: isWithinHoverRange,
    disabledDate: disabledDate,
    singleDateOnly: singleDateOnly,
    size: size
  }, /*#__PURE__*/React.createElement(DayLabel, null, parseInt(dayLabel, 10)), /*#__PURE__*/React.createElement(Sphere, {
    size: size,
    isSelectedStart: isStartDate(date),
    isSelectedEnd: isEndDate(date),
    disabledDate: disabledDate
  }));
};
Day.propTypes = {
  dayLabel: PropTypes.string,
  date: PropTypes.shape({}),
  singleDateOnly: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
};

const getDayOfWeekFontSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '13px';
    case 'small':
      return '11px';
    default:
      return '11px';
  }
};

const getMonthFontSize = () => props => {
  switch (props.size) {
    case 'medium':
      return '15px';
    case 'small':
      return '13px';
    default:
      return '13px';
  }
};

const getMonthFontSpacing = () => props => {
  switch (props.size) {
    case 'medium':
      return '0.7px';
    case 'small':
      return '0.5px';
    default:
      return '0.5px';
  }
};

const MonthLabel = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: ${getMonthFontSize};
  letter-spacing: ${getMonthFontSpacing};
  font-weight: bold;
  margin-top: 18px;
  margin-bottom: 18px;
  transform: translate(0, -8px);
  position: relative;
  z-index: 0;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};

  ${media.Medium`
    margin-top: 0px;
  `}
`;
const WeekDaysContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-content: center;
  font-size: ${getDayOfWeekFontSize};
  font-weight: bold;
  text-transform: uppercase;
  color: #626262;
  border-bottom: 1px solid gainsboro;
  padding-bottom: 8px;
  margin-bottom: 12px;
`;
const WeekDayLabel = styled.div`
  text-align: center;
`;
const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-content: center;
`;
const Month = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    year,
    month,
    firstDayOfWeek,
    singleDateOnly,
    size
  } = props;
  const {
    days,
    weekdayLabels,
    monthLabel
  } = useMonth({
    year,
    month,
    firstDayOfWeek
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(MonthLabel, {
    size: size
  }, monthLabel), /*#__PURE__*/React.createElement(WeekDaysContainer, {
    size: size
  }, weekdayLabels.map(dayLabel => /*#__PURE__*/React.createElement(WeekDayLabel, {
    key: dayLabel
  }, dayLabel))), /*#__PURE__*/React.createElement(DaysGrid, null, days.map(day => {
    if (typeof day === 'object') {
      return /*#__PURE__*/React.createElement(Day, {
        date: day.date,
        key: day.date.toString(),
        dayLabel: day.dayLabel,
        singleDateOnly: singleDateOnly,
        size: size
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      key: randomString()
    });
  })));
});
Month.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
  firstDayOfWeek: PropTypes.number,
  singleDateOnly: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
};

const DatePickerContainer = styled(Flex)`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
  user-select: none;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};

  ${media.Medium`
       border: ${_ref => {
  let {
    inline
  } = _ref;
  return inline ? `${getTokenValue(THEME_TOKENS.textInput.size.border)} solid ${getTokenValue(THEME_TOKENS.card.color.border)}` : 'none';
}};

      `};
`;
const MonthsContainer = styled(Flex)`
  align-self: center;
  gap: 16px;

  ${media.Medium`
    gap: 32px;
  `};
`;
const PrevNextContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
`;
const PrevNext = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: 24px;
  cursor: pointer;
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};
  @media (hover: hover) {
    &:hover {
      color: ${getTokenValue(THEME_TOKENS.base.color.link)};
    }
  }
`;
const DatePickerCustom = _ref2 => {
  let {
    onSelectDate,
    onSelectFrom,
    onSelectTo,
    fromDate,
    toDate,
    focusedInput,
    disableBeforeDate,
    disableAfterDate,
    numberOfMonths,
    showNavigationButtons = true,
    singleDateOnly = false,
    size = 'small',
    shouldScrollIntoView = false,
    // mobile view only
    navigateToStartDate = false,
    // desktop view only
    withPadding = true,
    inline = false
  } = _ref2;
  const daySelectLimit = singleDateOnly ? 1 : undefined;
  const {
    firstDayOfWeek,
    activeMonths,
    isDateSelected,
    isDateHovered,
    isFirstOrLastSelectedDate,
    isStartDate,
    isEndDate,
    isDateBlocked,
    isDateFocused,
    focusedDate,
    onDateHover,
    onDateSelect,
    onDateFocus,
    goToPreviousMonths,
    goToNextMonths,
    goToDate
  } = useDatepicker({
    startDate: fromDate,
    endDate: toDate,
    focusedInput,
    onDatesChange: onSelectDate,
    onFromChange: onSelectFrom,
    onToChange: onSelectTo,
    firstDayOfWeek: 0,
    minBookingDate: disableBeforeDate,
    maxBookingDate: disableAfterDate,
    numberOfMonths: numberOfMonths || null,
    // default is 2
    exactMinBookingDays: singleDateOnly,
    // set for single date picker
    minBookingDays: daySelectLimit,
    // set for single date picker
    changeActiveMonthOnSelect: false,
    // Less than 4 applies to desktop carousel view. `undefined` for mobile to allow user to see dates before startDate
    initialVisibleMonth: numberOfMonths < 4 ? fromDate || disableBeforeDate : undefined
  });
  const fromDateMonthRef = useRef(null);
  useEffect(() => {
    if (navigateToStartDate && fromDate && numberOfMonths === 1) {
      goToDate(fromDate);
    }
    if (shouldScrollIntoView) {
      var _fromDateMonthRef$cur;
      fromDateMonthRef === null || fromDateMonthRef === void 0 || (_fromDateMonthRef$cur = fromDateMonthRef.current) === null || _fromDateMonthRef$cur === void 0 || _fromDateMonthRef$cur.scrollIntoView({
        behavior: 'instant',
        block: 'start'
      });
    }
  }, [fromDate]);

  // Eslint insists on a useMemo here; not sure how helpful it is.
  const value = useMemo(() => ({
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    isStartDate,
    isEndDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  }), [focusedDate, isDateFocused, isDateSelected, isDateHovered, isDateBlocked, isFirstOrLastSelectedDate, isStartDate, isEndDate, onDateSelect, onDateFocus, onDateHover]);
  return /*#__PURE__*/React.createElement(datePickerContextDefaultValue.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(DatePickerContainer, {
    p: withPadding ? 3 : 0,
    inline: inline
  }, showNavigationButtons ? /*#__PURE__*/React.createElement(PrevNextContainer, null, /*#__PURE__*/React.createElement(PrevNext, {
    onClick: goToPreviousMonths
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: "ArrowNarrowLeft"
  })), /*#__PURE__*/React.createElement(PrevNext, {
    onClick: goToNextMonths
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: "ArrowNarrowRight"
  }))) : null, /*#__PURE__*/React.createElement(MonthsContainer, {
    mt: showNavigationButtons ? '-16px' : '4px',
    flexDirection: ['column', 'column', 'row']
  }, activeMonths.map(month => /*#__PURE__*/React.createElement(Month, {
    ref: isSameMonth(fromDate, month.date) ? fromDateMonthRef : undefined,
    key: `${month.year}-${month.month}`,
    year: month.year,
    month: month.month,
    firstDayOfWeek: firstDayOfWeek,
    singleDateOnly: singleDateOnly,
    size: size
  })))));
};
DatePickerCustom.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  onSelectDate: PropTypes.func,
  onSelectFrom: PropTypes.func,
  onSelectTo: PropTypes.func,
  focusedInput: PropTypes.string,
  showNavigationButtons: PropTypes.bool,
  singleDateOnly: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  shouldScrollIntoView: PropTypes.bool,
  navigateToStartDate: PropTypes.bool,
  withPadding: PropTypes.bool,
  inline: PropTypes.bool
};

const DateText = styled.div`
  font-size: 15px;
`;
const HeaderText = styled.div`
  display: flex;
  align-items: baseline;
`;
const Dot = styled.div`
  font-size: 14px;
  margin-left: 8px;
  margin-right: 8px;
`;

/* eslint-disable jsx-a11y/no-static-element-interactions */
const DateSelect = _ref => {
  let {
    headerText,
    numberOfMonths,
    disabled,
    disableBeforeDate,
    disableAfterDate,
    date,
    onSelectDate,
    focusedInput,
    children
  } = _ref;
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  const handleDayClickAndClose = day => {
    onSelectDate(day);
    hide();
  };
  const visibleAndNotDisabled = !disabled && visible;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: visibleAndNotDisabled ? hide : show
  }, children), visibleAndNotDisabled && /*#__PURE__*/React.createElement(Modal, {
    noPadding: true,
    drawer: true,
    onClose: hide
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(HeaderText, null, "Date", headerText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dot, null, "\u2022"), /*#__PURE__*/React.createElement(DateText, null, headerText)) : null)), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(DatePickerCustom, {
    numberOfMonths: 12,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    fromDate: date,
    onSelectDate: handleDayClickAndClose,
    focusedInput: focusedInput,
    singleDateOnly: true,
    showNavigationButtons: false,
    size: "medium",
    shouldScrollIntoView: true
  }))))), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(Popover, {
    showCloseButton: true,
    open: visibleAndNotDisabled,
    onOpenChange: open => {
      if (!open) hide();
    },
    onClickOutside: hide,
    content: /*#__PURE__*/React.createElement(DatePickerCustom, {
      numberOfMonths: numberOfMonths,
      disableBeforeDate: disableBeforeDate,
      disableAfterDate: disableAfterDate,
      fromDate: date,
      onSelectDate: handleDayClickAndClose,
      focusedInput: focusedInput,
      singleDateOnly: true,
      withPadding: false,
      navigateToStartDate: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: visibleAndNotDisabled ? hide : show
  }, children))));
};
DateSelect.propTypes = {
  headerText: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  onSelectDate: PropTypes.func.isRequired,
  focusedInput: PropTypes.string,
  children: PropTypes.node.isRequired
};
DateSelect.defaultProps = {
  date: null,
  disabled: false,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1
};

const DateSelectInline = _ref => {
  let {
    numberOfMonths,
    disableBeforeDate,
    disableAfterDate,
    date,
    onSelectDate,
    focusedInput
  } = _ref;
  return /*#__PURE__*/React.createElement(DatePickerCustom, {
    numberOfMonths: numberOfMonths,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    fromDate: date,
    onSelectDate: onSelectDate,
    focusedInput: focusedInput,
    singleDateOnly: true,
    navigateToStartDate: true,
    inline: true
  });
};
DateSelectInline.propTypes = {
  date: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  onSelectDate: PropTypes.func.isRequired,
  focusedInput: PropTypes.string
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
const DateRangeSelect = _ref => {
  let {
    headerText,
    numberOfMonths,
    disableBeforeDate,
    disableAfterDate,
    fromDate,
    toDate,
    onSelectFrom,
    onSelectTo,
    focusedInput,
    children
  } = _ref;
  const [visible, setVisible] = useState(false);
  const [openedWithBothDatesSelected, setOpenedWithBothDatesSelected] = useState(false);
  const [scrollIntoView, setScrollIntoView] = useState(true);
  const show = () => {
    setOpenedWithBothDatesSelected(fromDate && toDate);
    setVisible(true);

    // we use a setTimeout to allow the scroll into view to complete before disabling it. We disable it so the calendar
    // does not jump around in mobile when selecting new dates in a different month.
    setTimeout(() => {
      setScrollIntoView(false);
    }, 500);
  };
  const hide = () => {
    setVisible(false);
    setScrollIntoView(true);
  };
  useEffect(() => {
    // Close the date picker after both dates are selected but not in the case when modifying previously selected dates
    if (fromDate !== null && toDate !== null && !openedWithBothDatesSelected) {
      hide();
    }
  }, [fromDate, toDate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.SmallAndLess, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children), visible && /*#__PURE__*/React.createElement(Modal, {
    noPadding: true,
    drawer: true,
    onClose: hide
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(HeaderText, null, "Dates", headerText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dot, null, "\u2022"), /*#__PURE__*/React.createElement(DateText, null, headerText)) : null)), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(DatePickerCustom, {
    numberOfMonths: 12,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    fromDate: fromDate,
    toDate: toDate,
    onSelectFrom: onSelectFrom,
    onSelectTo: onSelectTo,
    focusedInput: focusedInput,
    showNavigationButtons: false,
    size: "medium",
    shouldScrollIntoView: scrollIntoView
  }))))), /*#__PURE__*/React.createElement(MatchMedia.Medium, null, /*#__PURE__*/React.createElement(Popover, {
    showCloseButton: true,
    open: visible,
    onOpenChange: open => {
      if (!open) hide();
    },
    onClickOutside: hide,
    content: /*#__PURE__*/React.createElement(DatePickerCustom, {
      numberOfMonths: numberOfMonths,
      disableBeforeDate: disableBeforeDate,
      disableAfterDate: disableAfterDate,
      fromDate: fromDate,
      toDate: toDate,
      onSelectFrom: onSelectFrom,
      onSelectTo: onSelectTo,
      focusedInput: focusedInput,
      navigateToStartDate: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: visible ? hide : show
  }, children))));
};
DateRangeSelect.propTypes = {
  headerText: PropTypes.string,
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  onSelectFrom: PropTypes.func.isRequired,
  onSelectTo: PropTypes.func.isRequired,
  focusedInput: PropTypes.string,
  children: PropTypes.node.isRequired
};
DateRangeSelect.defaultProps = {
  fromDate: null,
  toDate: null,
  disableBeforeDate: null,
  disableAfterDate: null,
  numberOfMonths: 1
};

const DateRangeSelectInline = _ref => {
  let {
    numberOfMonths,
    disableBeforeDate,
    disableAfterDate,
    fromDate,
    toDate,
    onSelectFrom,
    onSelectTo,
    focusedInput,
    size
  } = _ref;
  return /*#__PURE__*/React.createElement(DatePickerCustom, {
    inline: true,
    numberOfMonths: numberOfMonths,
    disableBeforeDate: disableBeforeDate,
    disableAfterDate: disableAfterDate,
    fromDate: fromDate,
    toDate: toDate,
    onSelectFrom: onSelectFrom,
    onSelectTo: onSelectTo,
    focusedInput: focusedInput,
    size: size,
    navigateToStartDate: true
  });
};
DateRangeSelectInline.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  disableBeforeDate: PropTypes.instanceOf(Date),
  disableAfterDate: PropTypes.instanceOf(Date),
  numberOfMonths: PropTypes.number,
  onSelectFrom: PropTypes.func.isRequired,
  onSelectTo: PropTypes.func.isRequired,
  focusedInput: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium'])
};

// import Button from '../form-controls/Button/index';

const LinkBox = styled(Box)`
  border: 1px solid ${getThemeProp('global.border--color')};
  background: ${getThemeProp('global.light--color')};
  transition: background 0.2s, border 0.2s;
  border-radius: 6px;

  &:hover {
    border: 1px solid ${getThemeProp('global.link--color')};
    background: ${getThemeProp('global.link--color')};
    color: white;
    cursor: pointer;
  }
`;
const IconBox = styled(Box)`
  color: ${getThemeProp('global.link--color')};

  ${LinkBox}:hover & {
    color: white;
  }
`;
const Title = styled(Box)`
  color: ${getThemeProp('global.link--color')};
  font-weight: bold;

  ${LinkBox}:hover & {
    color: white;
  }
`;
const Text = styled(Box)`
  opacity: 0.7;
  font-size: 13px;
`;
const LinkCard = _ref => {
  let {
    title,
    text = '',
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(LinkBox, _extends({
    p: 3
  }, rest, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Title, null, title), text && /*#__PURE__*/React.createElement(Text, {
    pt: 2
  }, text)), /*#__PURE__*/React.createElement(IconBox, {
    pl: "3"
  }, /*#__PURE__*/React.createElement(IconNext, null))));
};
LinkCard.propTypes = {
  /**
   * Primary title/text.
   */
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  /**
   * An optional short sentence or two to add further context to the link card.
   */
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClick: PropTypes.func.isRequired
};

// Copying their css until we come up with our own
const StyledPhoneInput = styled(PhoneInput)`
  display: flex;
  align-items: center;
  & .PhoneInputCountry {
    align-items: center;
    position: absolute;
    width: 60px;
    -webkit-align-self: stretch;
    -ms-flex-item-align: stretch;
    align-self: stretch;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    z-index: 1001;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    padding-right: ${SPACE.size32};
    & select {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      z-index: 1010;
      opacity: 0;
      cursor: pointer;
    }
    & .PhoneInputCountryIcon {
      width: inherit;
      height: 1.2em;
    }
  }
  & .PhoneInputInput {
    flex: 1 1;
    min-width: 0;
  }
`;
const StyledPhoneInputContainer = styled(Box)`
  position: relative;
  & .IconAngleDown {
    position: absolute;
    right: ${SPACE.size8};
    top: 0;
    bottom: 0;
  }
`;
const PhoneNumberInputCountry = _ref => {
  let {
    value,
    onChange,
    defaultCountry = 'US',
    placeholder,
    ...props
  } = _ref;
  const [country, setCountry] = useState(defaultCountry);
  // This prevents undefined value.
  const handleEmptyStateOnChange = val => {
    if (val) {
      onChange(val);
    } else {
      onChange('');
    }
  };
  let defaultPlaceholder = placeholder || null;
  if (!defaultPlaceholder) {
    defaultPlaceholder = country === 'US' ? '(800) 795-8371' : '+34 931227581';
  }
  const onCountryChange = countryChange => {
    setCountry(countryChange);
  };
  return /*#__PURE__*/React.createElement(StyledPhoneInputContainer, null, /*#__PURE__*/React.createElement(StyledPhoneInput, _extends({
    flags: flags,
    value: value,
    onChange: handleEmptyStateOnChange,
    inputComponent: TextInput,
    defaultCountry: defaultCountry,
    placeholder: defaultPlaceholder,
    onCountryChange: onCountryChange
  }, props)), /*#__PURE__*/React.createElement(IconAngleDown, {
    className: "IconAngleDown"
  }));
};

// Format xxx-xxx-xxxx to e164
const dashToE164 = phoneNumber => {
  if (!phoneNumber.includes('-') || phoneNumber.length !== 12) {
    return phoneNumber;
  }
  let newPhoneNumber = phoneNumber.split('-').join('');
  newPhoneNumber = `+1${newPhoneNumber}`;
  return newPhoneNumber;
};

/**
 * if intl, display +xx xxx xxx
 * if US which usually contain dashes, (xxx) xxx-xxxx
 */
const uiFriendlyPhoneNumber = phoneNumber => {
  try {
    if (phoneNumber[0] === '+') {
      return formatPhoneNumberIntl(phoneNumber);
    }
    const e164UsNumber = dashToE164(phoneNumber);
    return formatPhoneNumber(e164UsNumber);
  } catch (error) {
    return phoneNumber;
  }
};
const amtravPhoneFormat = phoneNumber => {
  if (!isPossiblePhoneNumber(phoneNumber)) {
    return phoneNumber;
  }
  const parsed = parsePhoneNumber(phoneNumber);
  if (parsed.country === 'US') {
    const newPhoneNumber = phoneNumber.slice(2).split('');
    newPhoneNumber.splice(6, 0, '-');
    newPhoneNumber.splice(3, 0, '-');
    return newPhoneNumber.join('');
  }
  return `+${parsed.countryCallingCode} ${parsed.nationalNumber}`;
};
PhoneNumberInputCountry.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  /**
   * Passing a country code will change flag and give it a default country code for phone number
   */
  defaultCountry: PropTypes.string,
  /**
   * Placeholder for the input
   */
  placeholder: PropTypes.string
};

const DropDownContainer = styled.div`
  min-width: 340px;
  max-width: 520px;
`;
const ToggleRegion = styled.div`
  padding: 0 8px;
`;
const showAvatar = item => {
  return item.nameNum > 0 ? /*#__PURE__*/React.createElement(Box, {
    pl: 1
  }, /*#__PURE__*/React.createElement(Avatar, {
    bordered: true,
    size: "26px",
    imgUrl: item.profileImageUrl,
    initials: item.initials,
    name: item.name
  })) : null;
};
const TravelerAutocomplete = _ref => {
  let {
    listWidth = '4003px',
    travelers,
    onChange = () => {},
    selectedTraveler,
    suggestionsCount = 8,
    textLabel = '',
    kind = '',
    showIsPersonalToggle = false,
    isPersonal = false,
    onToggleIsPersonal = () => {},
    itemToString = t => t ? t.name : ''
  } = _ref;
  return /*#__PURE__*/React.createElement(DropDownContainer, null, /*#__PURE__*/React.createElement(AutocompleteRenderer, {
    items: travelers,
    selectedItem: selectedTraveler || null,
    onChange: onChange,
    itemToString: itemToString,
    suggestionsCount: suggestionsCount,
    defaultHighlightedIndex: 0,
    labelKey: "name"
  }, (downshiftProps, dropdownProps) => {
    const {
      getInputProps,
      getMenuProps,
      getItemProps,
      isOpen,
      openMenu,
      highlightedIndex,
      setState
    } = downshiftProps;
    const {
      filteredItems,
      selectedItem,
      updateInputFocus
    } = dropdownProps;
    const filteredTotal = filteredItems.length;
    const filteredList = filteredItems.slice(0, suggestionsCount).map((item, index) => {
      const highlighted = highlightedIndex === index;
      return /*#__PURE__*/React.createElement(Autocomplete.OptionPerson, _extends({}, getItemProps({
        key: item.name,
        index,
        item,
        isActive: highlighted,
        isSelectedItem: selectedItem ? item.nameNum === selectedItem.nameNum : false
      }), {
        imgUrl: item.profileImageUrl,
        initials: item.initials
      }), item.name);
    });
    const listHint = filteredTotal > suggestionsCount ? /*#__PURE__*/React.createElement(Autocomplete.DropdownHint, {
      key: "last-item"
    }, filteredTotal - suggestionsCount, " more results. Type to filter.") : null;
    return /*#__PURE__*/React.createElement(Autocomplete, null, /*#__PURE__*/React.createElement(Autocomplete.Input, _extends({
      kind: kind,
      isOpen: isOpen && filteredTotal > 0,
      textLabel: textLabel,
      prefixContent: selectedItem && !isOpen ? showAvatar(selectedItem) : null,
      suffixContent: showIsPersonalToggle ? /*#__PURE__*/React.createElement(ToggleRegion, null, /*#__PURE__*/React.createElement(ToggleGroup, {
        type: "single",
        defaultValue: isPersonal ? 'personal' : 'business',
        onValueChange: onToggleIsPersonal
      }, /*#__PURE__*/React.createElement(ToggleGroup.Item, {
        value: "business"
      }, "Business"), /*#__PURE__*/React.createElement(ToggleGroup.Item, {
        value: "personal"
      }, "Personal"))) : null
    }, getInputProps({
      placeholder: 'Type or select...',
      onFocus: () => {
        setState({
          inputValue: ''
        });
        updateInputFocus(true);
        openMenu();
      },
      onClick: () => {
        setState({
          inputValue: ''
        });
        updateInputFocus(true);
        openMenu();
      },
      onBlur: () => updateInputFocus(false),
      onKeyDown: _ref2 => {
        let {
          key
        } = _ref2;
        if (key === 'Tab') {
          onChange(filteredItems[highlightedIndex || 0]);
        }
      }
    }))), isOpen && filteredTotal ? /*#__PURE__*/React.createElement(Autocomplete.Dropdown, null, /*#__PURE__*/React.createElement(Autocomplete.Options, _extends({
      listWidth: listWidth
    }, getMenuProps()), filteredList), listHint) : null);
  }));
};
const travelerShape = PropTypes.shape({
  initials: PropTypes.string,
  name: PropTypes.string,
  nameNum: PropTypes.number,
  profileImageUrl: PropTypes.string
});
TravelerAutocomplete.propTypes = {
  listWidth: PropTypes.string,
  travelers: PropTypes.arrayOf(travelerShape).isRequired,
  onChange: PropTypes.func,
  selectedTraveler: travelerShape,
  suggestionsCount: PropTypes.number,
  itemToString: PropTypes.func,
  isPersonal: PropTypes.bool,
  showIsPersonalToggle: PropTypes.bool,
  onToggleIsPersonal: PropTypes.func,
  textLabel: PropTypes.string,
  kind: PropTypes.string
};

/*
Legacy image file names:

A4 = AudiA4
CC = CompactTwoFourDoor
EC = EconomyTwoFourDoor
FC = FullsizeTwoFourDoor
FF = FullsizeSUV
FV = FullsizePassengerVan
IC = IntermediateTwoFourDoor
IF = IntermediateSUV
LC = LuxuryTwoFourDoor
MV = MiniPassengerVan
PC = PremiumTwoFourDoor
SC = StandardTwoFourDoor
SF = StandardSUV
ST = StandardConvertible

*/

// TODO: Add more brand specific logic
const sabreImageCodes = ['CCAR', 'CDAR', 'CFAR', 'CFDR', 'ECAR', 'EDAR', 'FCAR', 'FDAR', 'FFAR', 'FFDR', 'FJAR', 'FVAR', 'GFAR', 'GXAR', 'ICAE', 'ICAR', 'IDAR', 'IFAR', 'IFDR', 'LBAR', 'LCAR', 'LDAR', 'LFAR', 'LFDR', 'LTAR', 'MVAR', 'OQAR', 'PCAR', 'PDAR', 'PFAR', 'PFDR', 'PGAR', 'PGDR', 'PPAR', 'RFAR', 'RXAR', 'SCAR', 'SDAR', 'SFAR', 'SGAR', 'SJAR', 'SKAR', 'SPAR', 'SPBR', 'SSAR', 'STAR', 'SVAR', 'UFAR', 'UXAR', 'WCAR', 'XFAR', 'XXAR'];
const legacyImageTokens = ['AudiA4', 'CompactTwoFourDoor', 'EconomyTwoFourDoor', 'FullsizeTwoFourDoor', 'FullsizeFourFiveDoor',
// Dodge Charger
'FullsizeSUV', 'FullsizePassengerVan', 'IntermediateTwoFourDoor', 'IntermediateSUV', 'LuxuryTwoFourDoor', 'MiniPassengerVan', 'PremiumTwoFourDoor', 'StandardTwoFourDoor', 'StandardSUV', 'StandardConvertible', 'TeslaModel3', 'ElectricGeneric' // Polestar 2
];

// Source: https://developer.sabre.com/guides/travel-agency/cars/vehicle-type-codes

// This comes from the 1st character of the carTypeCode
const carCategories = {
  M: 'Mini',
  N: 'Mini',
  E: 'Economy',
  H: 'Economy',
  C: 'Compact',
  D: 'Compact',
  I: 'Intermediate',
  J: 'Intermediate',
  S: 'Standard',
  R: 'Standard',
  F: 'Fullsize',
  G: 'Fullsize',
  P: 'Premium',
  U: 'Premium',
  L: 'Luxury',
  W: 'Luxury',
  O: 'Oversize',
  X: 'Special'
};
const validCarCategories = Object.keys(carCategories);

// This comes from the 2nd character of the carTypeCode
const carTypes = {
  B: 'TwoThreeDoor',
  C: 'TwoFourDoor',
  D: 'FourFiveDoor',
  W: 'WagonEstate',
  V: 'PassengerVan',
  L: 'Limousine',
  S: 'Sport',
  T: 'Convertible',
  F: 'SUV',
  J: 'OpenAirAllTerrain',
  X: 'Special',
  P: 'PickUpRegularCab',
  Q: 'PickUpExtendedCab',
  Z: 'SpecialOfferCar',
  E: 'Coupe',
  M: 'Monospace',
  // European use
  H: 'MotorHome',
  Y: 'TwoWheelVehicle',
  N: 'Roadster'
};
const validCarTypes = Object.keys(carTypes);
const getCarImageToken = (carTypeCode, makeModel, fuelType) => {
  const carTypeShort = carTypeCode === null || carTypeCode === void 0 ? void 0 : carTypeCode.slice(0, -2);
  const char1 = carTypeShort[0];
  const char2 = carTypeShort[1];
  const legacyCdnPath = 'car-types/';
  const sabreCdnPath = 'cars-sabre/';
  const isBmwOrMercedes = makeModel === null || makeModel === void 0 ? void 0 : makeModel.includes('BMW'  );
  const isTesla = makeModel === null || makeModel === void 0 ? void 0 : makeModel.includes('Tesla');
  const isElectric = fuelType === 'Electric';
  if (isTesla) {
    return `${legacyCdnPath}TeslaModel3`;
  }
  if (isElectric || carTypeCode === 'JDAE') {
    return `${legacyCdnPath}ElectricGeneric`;
  }

  // 'X' means Special so we need to be more specific with the brand
  if (isBmwOrMercedes && carTypeCode === 'XCAR') {
    return `${sabreCdnPath}/XCAR-Bmw5Series`;
  }
  if (isBmwOrMercedes && carTypeCode === 'XFAZ') {
    return `${sabreCdnPath}/XFAZ-BmwX7`;
  }
  if (sabreImageCodes.includes(carTypeCode)) {
    return `${sabreCdnPath}${carTypeCode}`;
  }

  // legacy image fallback
  if (validCarCategories.includes(char1) && validCarTypes.includes(char2)) {
    const categoryAndType = `${carCategories[char1]}${carTypes[char2]}`;
    if (legacyImageTokens.includes(categoryAndType)) {
      return `${legacyCdnPath}${categoryAndType}`;
    }
  }
  return `${sabreCdnPath}XXAR`;
};

const imgSize$1 = {
  small: '32px',
  medium: '46px',
  large: '76px'
};
const fallbackSize = {
  small: '28px',
  medium: '46px',
  large: '76px'
};
const iconSize = {
  small: 14,
  medium: 24,
  large: 38
};
const CarImageContainer = styled.div`
  width: ${_ref => {
  let {
    size
  } = _ref;
  return imgSize$1[size];
}};

  img {
    width: ${_ref2 => {
  let {
    size
  } = _ref2;
  return imgSize$1[size];
}};
  }
`;
const ImageFallback$1 = styled(Flex)`
  width: ${_ref3 => {
  let {
    size
  } = _ref3;
  return fallbackSize[size];
}};
  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  return fallbackSize[size];
}};
  align-items: center;
  justify-content: center;
  color: ${getThemeProp('global.greyPalette.600')};
  background-color: whitesmoke;
  border-radius: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'small' ? '0' : '6px';
}};
`;
const CarTypeImage = _ref6 => {
  let {
    code,
    size = 'medium',
    makeModel = '',
    fuelType = ''
  } = _ref6;
  const [imgError, setImgError] = useState(false);
  const onImgError = () => {
    setImgError(true);
  };
  const cdnImage = `https://cdn.amtrav.com/${getCarImageToken(code, makeModel, fuelType)}.png`;
  return /*#__PURE__*/React.createElement(CarImageContainer, {
    size: size
  }, !imgError ? /*#__PURE__*/React.createElement("img", {
    alt: "Car",
    src: cdnImage,
    onError: onImgError
  }) : /*#__PURE__*/React.createElement(ImageFallback$1, {
    size: size
  }, /*#__PURE__*/React.createElement(IconFlex, {
    size: iconSize[size],
    inheritColor: true
  }, /*#__PURE__*/React.createElement(IconCar, null))));
};
CarTypeImage.propTypes = {
  code: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  makeModel: PropTypes.string,
  fuelType: PropTypes.string
};

const imgSize = {
  xsmall: 28,
  small: 42,
  medium: 60,
  large: 88
};
const imgRatio = {
  square: '1 / 1',
  wide: '3 / 2'
};
const getImgSize = props => {
  const {
    size,
    sizeNum
  } = props;
  if (sizeNum) {
    return `${sizeNum}px`;
  }
  return `${imgSize[size]}px`;
};
const getIconSize = (size, sizeNum) => {
  if (sizeNum) {
    return sizeNum * 0.5;
  }
  return imgSize[size] * 0.5;
};
const HotelImageContainer = styled.div`
  img {
    aspect-ratio: ${_ref => {
  let {
    ratio
  } = _ref;
  return imgRatio[ratio];
}};
    height: ${getImgSize};
    border-radius: ${_ref2 => {
  let {
    borderRadius
  } = _ref2;
  return borderRadius;
}}px;
    object-fit: cover;
  }
`;
const ImageFallback = styled(Flex)`
  aspect-ratio: ${_ref3 => {
  let {
    ratio
  } = _ref3;
  return imgRatio[ratio];
}};
  height: ${getImgSize};
  align-items: center;
  justify-content: center;
  color: ${getThemeProp('global.greyPalette.600')};
  background-color: whitesmoke;
  border-radius: ${_ref4 => {
  let {
    borderRadius
  } = _ref4;
  return borderRadius;
}}px;
`;
const HotelThumbnail = _ref5 => {
  let {
    src,
    size = 'medium',
    sizeNum = null,
    ratio = 'square',
    borderRadius = 6
  } = _ref5;
  const [imgError, setImgError] = useState(false);
  const onImgError = () => {
    setImgError(true);
  };
  return /*#__PURE__*/React.createElement(HotelImageContainer, {
    size: size,
    sizeNum: sizeNum,
    ratio: ratio,
    borderRadius: borderRadius
  }, src && !imgError ? /*#__PURE__*/React.createElement("img", {
    alt: "Hotel",
    src: src,
    onError: onImgError
  }) : /*#__PURE__*/React.createElement(ImageFallback, {
    size: size,
    sizeNum: sizeNum,
    ratio: ratio,
    borderRadius: borderRadius
  }, /*#__PURE__*/React.createElement(IconFlex, {
    size: getIconSize(size, sizeNum),
    inheritColor: true
  }, /*#__PURE__*/React.createElement(IconHotel, null))));
};
HotelThumbnail.propTypes = {
  src: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  sizeNum: PropTypes.number,
  ratio: PropTypes.oneOf(['square', 'wide']),
  borderRadius: PropTypes.number
};

const OutOfPolicyIcon = styled(Box)`
  height: 20px;
  font-size: 20px;
  color: ${getThemeProp('global.warning--color')};
`;
const OutOfPolicySpacer = styled(Flex)`
  align-items: center;
  width: 20px;
  height: 20px;
`;
const ViolationsContainer = styled(Flex)`
  flex-direction: column;
  gap: 12px;
`;
const ViolationText = styled(Box)`
  font-size: 13px;
`;
const GatherPolicyText = styled.div`
  font-size: 13px;
  font-style: italic;
  background: rgba(0, 0, 0, 0.15);
  padding: 8px;
`;
const gatherPolicyText = 'You can book this option, however you will provide an explanation on the Purchase page and the meeting arranger may be asked to approve your booking.'; // eslint-disable-line

const OutOfPolicy = _ref => {
  let {
    policyViolations,
    isLoading,
    soldOut,
    iconOnly = false,
    invitationToken,
    ...rest
  } = _ref;
  // hide OOP if no violations & if skeleton loader is active
  const showOutOfPolicy = (policyViolations === null || policyViolations === void 0 ? void 0 : policyViolations.length) > 0 && !isLoading;
  if (showOutOfPolicy && !soldOut) {
    return /*#__PURE__*/React.createElement(OutOfPolicySpacer, rest, iconOnly ? /*#__PURE__*/React.createElement(OutOfPolicyIcon, null, /*#__PURE__*/React.createElement(IconWarningTriangle, null)) : /*#__PURE__*/React.createElement(Tooltip, {
      kind: "warning",
      placement: "top",
      content: /*#__PURE__*/React.createElement(ViolationsContainer, null, policyViolations.map(pv => /*#__PURE__*/React.createElement(ViolationText, {
        key: pv
      }, pv)), invitationToken ? /*#__PURE__*/React.createElement(GatherPolicyText, null, gatherPolicyText) : null)
    }, /*#__PURE__*/React.createElement(OutOfPolicyIcon, null, /*#__PURE__*/React.createElement(IconWarningTriangle, null))));
  }
  return null;
};
OutOfPolicy.propTypes = {
  policyViolations: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  soldOut: PropTypes.bool,
  /**
   * This is for mobile when no popover needs to be shown
   */
  iconOnly: PropTypes.bool,
  /**
   * When an invitationToken is present, an extra message is displayed
   */
  invitationToken: PropTypes.string
};

const formatUSCurrencyNum = num => {
  const formatUSCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(num);
  return formatUSCurrency.slice(1);
};
const formatLocationAddress = function (address, city, state) {
  let zip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return `${address}, ${city}, ${state} ${zip || ''}`;
};

const PriceButtonStyled = styled.button`
  all: unset;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  color: ${getThemeProp('global.link--color')};
  font-weight: bold;
  cursor: pointer;
  min-width: ${_ref2 => {
  let {
    minWidth
  } = _ref2;
  return minWidth;
}};

  ${_ref3 => {
  let {
    bordered
  } = _ref3;
  return bordered && css`
      background: white;
      align-items: center;
      padding: 8px 0;
      border: 1px solid ${getThemeProp('global.border--color')};
      border-radius: 4px;
      box-shadow: 0px 0px 25px 1px rgba(0, 0, 0, 0.05);
      transition: all 0.15s;

      &:hover {
        background-color: ${getThemeProp('global.light--color')};
        border-color: ${getThemeProp('global.link--color')};
      }
    `;
}};
`;
const Dollar = styled.span``;
const PriceAmount = styled.div`
  font-weight: bolder;
`;
const Label = styled.div`
  padding-top: 2px;
  font-size: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size;
}};
  font-weight: normal;
  color: ${getThemeProp('global.textBody--color')};
  white-space: nowrap;
`;
const PaymentType = styled.div`
  background-color: ${getThemeProp('global.border--color')};
  font-size: 12px;
  color: ${getThemeProp('global.textBody--color')};
  padding: 4px 0;
  width: 100%;
  border-radius: 0 0 3px 3px;
  text-align: center;
  margin: 8px 0 -8px;
`;
const PriceButton = _ref5 => {
  let {
    price,
    priceSize = 22,
    labelSize = 12,
    minWidth = 'auto',
    label = 'per night',
    onClick = () => {},
    showFrom = false,
    bordered = false,
    paymentTypeText = ''
  } = _ref5;
  const priceSizeVal = typeof priceSize === 'number' ? `${priceSize}px` : priceSize;
  const labelSizeVal = typeof labelSize === 'number' ? `${labelSize}px` : labelSize;
  return /*#__PURE__*/React.createElement(PriceButtonStyled, {
    bordered: bordered,
    minWidth: minWidth,
    size: priceSizeVal,
    onClick: onClick
  }, showFrom ? /*#__PURE__*/React.createElement(Label, {
    size: labelSizeVal
  }, "from") : null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Dollar, null, "$"), /*#__PURE__*/React.createElement(PriceAmount, null, formatUSCurrencyNum(price))), /*#__PURE__*/React.createElement(Label, {
    size: labelSizeVal
  }, label), paymentTypeText ? /*#__PURE__*/React.createElement(PaymentType, null, paymentTypeText) : null);
};
PriceButton.propTypes = {
  price: PropTypes.number,
  priceSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  onClick: PropTypes.func,
  showFrom: PropTypes.bool,
  bordered: PropTypes.bool,
  minWidth: PropTypes.string,
  paymentTypeText: PropTypes.string
};

const AreaDistanceStyled = styled.div`
  display: inline-flex;
  align-items: center;
  height: 18px;
  font-size: 12px;
  color: ${getThemeProp('global.greyPalette.600')};
  background-color: ${getThemeProp('global.greyPalette.200')};
  padding: 0 4px;
`;
const Icon = styled.div`
  font-size: 14px;
  width: 14px;
  height: 14px;
  margin-left: -2px;
  margin-right: 2px;
`;
const AreaDistance = _ref => {
  let {
    distance = 0.0,
    area
  } = _ref;
  // the back-end always sends 0.0 for distance
  // we don't show the string for area if distance has a number
  const showDistance = distance > 0.0;
  if (showDistance) {
    return /*#__PURE__*/React.createElement(AreaDistanceStyled, null, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(IconLocation, null)), distance, " miles away");
  }
  if (area && !showDistance) {
    return /*#__PURE__*/React.createElement(AreaDistanceStyled, null, area);
  }
  return null;
};
AreaDistance.propTypes = {
  area: PropTypes.string,
  distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const DateSummaryContainer = styled(Flex)`
  height: 48px;
  background-color: ${getThemeProp('global.light--color')};
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};

  ${_ref => {
  let {
    noBorder
  } = _ref;
  return !noBorder && css`
      border-style: solid;
      border-width: 0 0 1px;
      border-color: ${getThemeProp('global.border--color')};
    `;
}};
`;
const PrimaryContent = styled(Flex)`
  align-items: center;
  gap: 8px;
`;
const DatesSummary = _ref2 => {
  let {
    startDate,
    endDate,
    noBorder,
    hideDateDiff = false,
    dateDiffType = 'night',
    secondaryContent = null,
    ...rest
  } = _ref2;
  const datesDisplay = `${dayOfWeekShortFormatter(parseDate(startDate))}, 
  ${monthShortFormatter(parseDate(startDate))} ${dayOfMonthFormatter(parseDate(startDate))} – ${dayOfWeekShortFormatter(parseDate(endDate))}, 
  ${monthShortFormatter(parseDate(endDate))} ${dayOfMonthFormatter(parseDate(endDate))}`;
  const datesDiff = differenceInCalendarDays(parseDate(endDate), parseDate(startDate));
  return /*#__PURE__*/React.createElement(DateSummaryContainer, _extends({
    noBorder: noBorder,
    justifyContent: "space-between",
    alignItems: "center"
  }, rest), /*#__PURE__*/React.createElement(PrimaryContent, null, /*#__PURE__*/React.createElement(IconFlex, {
    defaultColor: true
  }, /*#__PURE__*/React.createElement(IconCalendarLine, null)), datesDisplay, !hideDateDiff && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DotSeparator, null), `${datesDiff} ${dateDiffType}${datesDiff > 1 ? 's' : ''}`)), secondaryContent || null);
};
DatesSummary.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  /**
   * set this to the singular "day" or "night" instead of plural
   */
  hideDateDiff: PropTypes.bool,
  dateDiffType: PropTypes.string,
  secondaryContent: PropTypes.node,
  noBorder: PropTypes.bool
};

const RefundabilityBadge = _ref => {
  let {
    isRefundable
  } = _ref;
  if (isRefundable === null) {
    return null;
  }
  return !isRefundable ? /*#__PURE__*/React.createElement(Badge, {
    kind: "warning",
    iconToken: "CurrencyDollarOff"
  }, "Non-Refundable") : /*#__PURE__*/React.createElement(Badge, {
    iconToken: "Check",
    kind: "neutral"
  }, "Free Cancellation");
};
RefundabilityBadge.propTypes = {
  /**
   * If null, the badge will not render
   *  */
  isRefundable: PropTypes.bool
};

const getBadgeTextColor = () => props => {
  if (props.kind === 'neutral') {
    return 'black';
  }
  if (props.kind === 'warning') {
    return tinycolor.mix(getThemeProp('global.warning--color')(props), 'black', 60).toString();
  }
  if (props.kind === 'primary') {
    return tinycolor.mix(getThemeProp('global.primary--color')(props), 'black', 60).toString();
  }
  return 'black';
};
const getBadgeBackgroundColor = () => props => {
  if (props.kind === 'neutral') {
    return getThemeProp('global.greyPalette.200')(props);
  }
  if (props.kind === 'warning') {
    return tinycolor.mix(getThemeProp('global.warning--color')(props), 'white', 80).toString();
  }
  if (props.kind === 'primary') {
    return tinycolor.mix(getThemeProp('global.primary--color')(props), 'white', 80).toString();
  }
  return getThemeProp('global.greyPalette.200')(props);
};
const BadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 25px;
  padding: 0 8px;
  color: ${getBadgeTextColor};
  text-align: center;
  white-space: nowrap;
  font-weight: ${_ref => {
  let {
    kind
  } = _ref;
  return kind === 'neutral' ? '600' : '700';
}};
  background-color: ${_ref2 => {
  return getBadgeBackgroundColor();
}};
  border-radius: ${_ref3 => {
  let {
    noBorderRadius
  } = _ref3;
  return noBorderRadius ? 'unset' : '6px';
}};
  font-size: 12px;
  letter-spacing: 0.5px;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  cursor: ${_ref4 => {
  let {
    hasTooltip
  } = _ref4;
  return hasTooltip ? 'pointer' : null;
}};
`;
const TextContainer = styled(Box)`
  border-bottom: ${_ref5 => {
  let {
    hasTooltip
  } = _ref5;
  return hasTooltip ? '1px dotted' : null;
}};
`;
const RateInfoBadge = _ref6 => {
  let {
    hasTooltip,
    kind,
    icon,
    noBorderRadius = false,
    children
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BadgeStyled, {
    hasTooltip: hasTooltip,
    kind: kind,
    noBorderRadius: noBorderRadius
  }, icon ? /*#__PURE__*/React.createElement(IconFlex, {
    size: 16,
    inheritColor: true
  }, icon) : null, /*#__PURE__*/React.createElement(TextContainer, {
    hasTooltip: hasTooltip
  }, children)));
};
RateInfoBadge.propTypes = {
  children: PropTypes.node,
  kind: PropTypes.oneOf(['primary', 'neutral', 'warning']),
  icon: PropTypes.node,
  noBorderRadius: PropTypes.bool,
  hasTooltip: PropTypes.bool
};

// for use inside the main option cards
const AddressRegular = styled.span`
  font-size: 12px;
  line-height: 1.2;
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};
`;

// for use inside the option mini cards
const AddressMini = styled.span`
  font-size: 10px;
  color: ${getTokenValue(THEME_TOKENS.base.color.secondaryText)};
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const AddressOverviewContainer = styled.div`
  max-width: 350px;
  display: flex;
  align-items: center;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const AddressOverviewText = styled(Box)`
  line-height: 1.2;

  // this is for long addresses on hotel overview
  ${media.Medium`
    text-align: right;
  `}
`;
const AddressOverview = _ref => {
  let {
    addressDisplay,
    greyPaletteNum = 600
  } = _ref;
  return /*#__PURE__*/React.createElement(AddressOverviewContainer, {
    greyNum: greyPaletteNum
  }, /*#__PURE__*/React.createElement(IconLine, {
    icon: "MapPin",
    size: "small",
    mr: SPACE.size4
  }), /*#__PURE__*/React.createElement(AddressOverviewText, null, addressDisplay));
};
AddressOverview.propTypes = {
  addressDisplay: PropTypes.string,
  /**
   * use 900 here to make the component darker
   */
  greyPaletteNum: PropTypes.number
};

const OptionMiniContainer = styled.div`
  width: 275px;
  display: flex;
  font-family: ${getThemeProp('global.textBody--fontFamily')};
  background-color: white;
  border-radius: 6px;
  padding: 8px;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};

  ${_ref => {
  let {
    isOutOfPolicy
  } = _ref;
  return isOutOfPolicy && css`
      transform: translateY(-8px);
    `;
}};
`;
const OutOfPolicyHeader = styled.div`
  background-color: ${getThemeProp('global.warning--color')};
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 8px 10px;
  border-radius: 6px 6px 0 0;
`;
const OutOfPolicyBanner = () => /*#__PURE__*/React.createElement(OutOfPolicyHeader, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(IconWarningTriangle, null), /*#__PURE__*/React.createElement(Box, {
  pl: 1
}, "Out of Policy")));
const OptionMini = _ref2 => {
  let {
    isOutOfPolicy,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, isOutOfPolicy ? /*#__PURE__*/React.createElement(OutOfPolicyBanner, null) : null, /*#__PURE__*/React.createElement(OptionMiniContainer, {
    isOutOfPolicy: isOutOfPolicy
  }, children));
};
OptionMini.propTypes = {
  isOutOfPolicy: PropTypes.bool,
  children: PropTypes.node
};

const ListHeaderDark = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: white;
  font-size: 14px;
  font-weight: 400;
  background-color: ${getThemeProp('global.dark--color')};

  b {
    font-weight: 800;
  }
`;

const BreadcrumbsContainer = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
`;
const BreadcrumbSeparator = styled.span`
  margin: 0 8px;
  color: #999;
`;
const BreadcrumbItemContainer = styled.span`
  color: ${_ref => {
  let {
    isLast
  } = _ref;
  return isLast ? '#000' : getThemeProp('global.greyPalette.600');
}};
  cursor: ${_ref2 => {
  let {
    isLast
  } = _ref2;
  return isLast ? 'default' : 'pointer';
}};
  text-decoration: none;

  &:hover {
    text-decoration: ${_ref3 => {
  let {
    isLast
  } = _ref3;
  return isLast ? 'none' : 'underline';
}}; /* Underline only on hover */
  }
`;
const BreadcrumbLink = styled.a`
  color: ${_ref4 => {
  let {
    isLast
  } = _ref4;
  return isLast ? '#000' : getThemeProp('global.greyPalette.600');
}};
  cursor: ${_ref5 => {
  let {
    isLast
  } = _ref5;
  return isLast ? 'default' : 'pointer';
}};
  text-decoration: none;

  &:hover {
    text-decoration: ${_ref6 => {
  let {
    isLast
  } = _ref6;
  return isLast ? 'none' : 'underline';
}}; /* Underline only on hover */
  }
`;
const Breadcrumbs = _ref7 => {
  let {
    children
  } = _ref7;
  const childrenArray = React.Children.toArray(children);
  const lastIndex = childrenArray.length - 1;
  return /*#__PURE__*/React.createElement(BreadcrumbsContainer, {
    "aria-label": "breadcrumb"
  }, React.Children.map(childrenArray, (child, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.cloneElement(child, {
    isLast: index === lastIndex
  }), index < lastIndex && /*#__PURE__*/React.createElement(BreadcrumbSeparator, null, "/"))));
};
Breadcrumbs.propTypes = {
  children: PropTypes.node.isRequired
};
const BreadcrumbItem = _ref8 => {
  let {
    children,
    href,
    onClick,
    isLast = false
  } = _ref8;
  if (isLast) {
    return /*#__PURE__*/React.createElement(BreadcrumbItemContainer, {
      isLast: isLast
    }, children);
  }
  if (href) {
    return /*#__PURE__*/React.createElement(BreadcrumbLink, {
      href: href,
      isLast: isLast
    }, children);
  }
  return /*#__PURE__*/React.createElement(BreadcrumbItemContainer, {
    isLast: isLast,
    onClick: onClick
  }, children);
};
BreadcrumbItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  // New prop for href support
  onClick: PropTypes.func,
  isLast: PropTypes.bool
};

/** Deprecated use SoloFilter */
const ActionButtonRegion = styled(Flex)`
  box-shadow: ${_ref => {
  let {
    showBorder
  } = _ref;
  return showBorder ? `0 1px 0 0 ${getTokenValue(THEME_TOKENS.card.color.border)} inset` : 'none';
}};
`;
const ScrollRegion = styled(Box)`
  max-height: 50vh;
  overflow-y: auto;
`;
const CaretRegion = styled(Flex)`
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
`;
const FilterButton = styled(Button)`
  font-size: ${getTokenValue(THEME_TOKENS.textInput.size.text)};
  border-radius: ${getTokenValue(THEME_TOKENS.textInput.size.borderRadius)};
  border-color: ${getTokenValue(THEME_TOKENS.textInput.color.border)};
  box-shadow: none;
  width: 100%;
  min-height: 40px;
  align-items: center;
`;
const FilterButtonRegion = styled.span`
  & ${ButtonStyled} {
    border-color: ${getTokenValue(THEME_TOKENS.textInput.color.border)};
  }
`;
const InputTriggerContainer = styled(TextInputContainer)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  padding-right: 8px;
  padding-left: 12px;
  cursor: pointer;
`;
const FilterChip = _ref2 => {
  let {
    text,
    filterText,
    modalHeader = 'Filter',
    kind,
    onReset,
    onApply,
    onCancel,
    hasChipSiblings = true,
    fullscreenDrawer = false,
    alwaysUsePopover = false,
    children
  } = _ref2;
  console.warn('FilterChip has been deprecated, please use SoloFilter component');
  const [isOpen, setIsOpen] = useState(false);
  const clickHandler = () => setIsOpen(!isOpen);
  const closePopover = () => setIsOpen(false);
  const resetHandler = e => {
    e.stopPropagation();
    closePopover();
    onReset();
  };
  const OpenIcon = isOpen ? /*#__PURE__*/React.createElement(IconCaretUp, null) : /*#__PURE__*/React.createElement(IconCaretDown, null);
  const Icon = filterText ? /*#__PURE__*/React.createElement(IconClose, {
    onClick: resetHandler
  }) : OpenIcon;
  const renderProps = {
    closePopover,
    resetHandler
  };
  const applyHandler = () => {
    onApply();
    closePopover();
  };
  const cancelHandler = () => {
    onCancel();
    closePopover();
  };
  const makeActionButtons = (padding, showBorder) => onApply ? /*#__PURE__*/React.createElement(ActionButtonRegion, {
    width: "100%",
    justifyContent: "center",
    p: padding,
    showBorder: showBorder
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    bordered: true,
    text: "Cancel",
    kind: "danger",
    onClick: cancelHandler
  })), /*#__PURE__*/React.createElement(Box, {
    px: 2,
    flex: "1 0 auto"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    text: "Apply Filter",
    onClick: applyHandler
  }))) : /*#__PURE__*/React.createElement(MatchMedia.LargeAndLess, null, /*#__PURE__*/React.createElement(ActionButtonRegion, {
    width: "100%",
    justifyContent: "center",
    p: padding,
    showBorder: showBorder
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2
  }, /*#__PURE__*/React.createElement(Button, {
    bordered: true,
    text: "Close",
    onClick: cancelHandler
  }))));
  if (alwaysUsePopover === true) {
    return /*#__PURE__*/React.createElement(Popover, {
      content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollRegion, {
        p: 3
      }, children(renderProps)), makeActionButtons(3, true)),
      open: isOpen,
      onOpenChange: open => {
        if (!open) closePopover();
      },
      onClickOutside: closePopover,
      withPadding: false,
      triggerDisplayProperty: "block"
    }, hasChipSiblings ? /*#__PURE__*/React.createElement(FilterButtonRegion, null, /*#__PURE__*/React.createElement(FilterButton, {
      iconSuffix: Icon,
      text: filterText || text,
      onClick: clickHandler,
      borderedLight: !filterText,
      bordered: !!filterText,
      renderAs: "div"
    })) : /*#__PURE__*/React.createElement(InputTriggerContainer, {
      minHeight: `calc(${getTokenValue(THEME_TOKENS.textInput.size.minHeight)} + ${getTokenValue(THEME_TOKENS.textInput.size.border)} * 2)`,
      kind: kind,
      onClick: clickHandler
    }, filterText || text, /*#__PURE__*/React.createElement(CaretRegion, {
      ml: 2
    }, /*#__PURE__*/React.createElement(IconLine, {
      strokeWidth: 1.5,
      icon: "ChevronDown"
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.XLargeOnly, null, /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollRegion, {
      p: 3
    }, children(renderProps)), makeActionButtons(3, true)),
    open: isOpen,
    onOpenChange: open => {
      if (!open) closePopover();
    },
    onClickOutside: closePopover,
    withPadding: false,
    triggerDisplayProperty: "block"
  }, hasChipSiblings ? /*#__PURE__*/React.createElement(FilterButtonRegion, null, /*#__PURE__*/React.createElement(FilterButton, {
    iconSuffix: Icon,
    text: filterText || text,
    onClick: clickHandler,
    borderedLight: !filterText,
    bordered: !!filterText,
    renderAs: "div"
  })) : /*#__PURE__*/React.createElement(InputTriggerContainer, {
    minHeight: `calc(${getTokenValue(THEME_TOKENS.textInput.size.minHeight)} + ${getTokenValue(THEME_TOKENS.textInput.size.border)} * 2)`,
    kind: kind,
    onClick: clickHandler
  }, filterText || text, /*#__PURE__*/React.createElement(CaretRegion, {
    ml: 2
  }, /*#__PURE__*/React.createElement(IconLine, {
    strokeWidth: 1.5,
    icon: "ChevronDown"
  }))))), /*#__PURE__*/React.createElement(MatchMedia.LargeAndLess, null, isOpen && /*#__PURE__*/React.createElement(Modal, {
    drawer: true,
    fullscreen: fullscreenDrawer,
    onClose: closePopover
  }, /*#__PURE__*/React.createElement(Modal.Header, null, modalHeader), /*#__PURE__*/React.createElement(Modal.Body, null, children(renderProps)), /*#__PURE__*/React.createElement(Modal.Footer, null, makeActionButtons(0, false))), hasChipSiblings ? /*#__PURE__*/React.createElement(FilterButtonRegion, null, /*#__PURE__*/React.createElement(FilterButton, {
    iconSuffix: filterText ? /*#__PURE__*/React.createElement(IconClose, {
      onClick: resetHandler
    }) : null,
    text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MatchMedia.MediumAndLess, null, text), /*#__PURE__*/React.createElement(MatchMedia.Large, null, filterText || text)),
    onClick: clickHandler,
    borderedLight: !filterText,
    bordered: !!filterText
  })) : /*#__PURE__*/React.createElement(InputTriggerContainer, {
    minHeight: `calc(${getTokenValue(THEME_TOKENS.textInput.size.minHeight)} + ${getTokenValue(THEME_TOKENS.textInput.size.border)} * 2)`,
    kind: kind,
    onClick: clickHandler
  }, filterText || text, /*#__PURE__*/React.createElement(CaretRegion, {
    ml: 2
  }, /*#__PURE__*/React.createElement(IconLine, {
    strokeWidth: 1.5,
    icon: "ChevronDown"
  })))));
};
FilterChip.propTypes = {
  /**
   * Button text name
   */
  text: PropTypes.string.isRequired,
  /**
   * filterText will override text.
   */
  filterText: PropTypes.string,
  modalHeader: PropTypes.string,
  kind: PropTypes.oneOf(['primary', 'secondary', 'warning', 'danger', 'success', 'info', 'vellum']),
  children: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  hasChipSiblings: PropTypes.bool,
  fullscreenDrawer: PropTypes.bool,
  alwaysUsePopover: PropTypes.bool
};
FilterChip.defaultProps = {
  filterText: undefined,
  onReset: () => {},
  onApply: () => {},
  onCancel: () => {}
};

/** Deprecated */
const TimeSelectorHeading = styled.h5`
  text-align: center;
`;
const sliderValuesPropType = PropTypes.shape({
  value1: PropTypes.number,
  time1: PropTypes.string,
  value2: PropTypes.number,
  time2: PropTypes.string
});
const isValidTimestamp = timestamp => {
  if (timestamp % 1800000 === 0) return true;
  if (timestamp === new Date(timestamp).setHours(23, 59)) return true;
  return false;
};
const DEFAULT_DATE = new Date(2020, 1, 2);
const TimeRangeFilterChip = _ref => {
  let {
    sliderValues,
    onApply,
    onCancel,
    onReset,
    referenceDate,
    showTimesAsLabel
  } = _ref;
  console.warn('TimeRangeFilterChip has been deprecated, please use SoloFilter component');
  if (!isValidTimestamp(sliderValues.value1) || !isValidTimestamp(sliderValues.value2)) {
    console.error('startTime and endTime must be a multiple of 30 minutes (1800000 milliseconds) or be 11:59.');
  }

  // represents a potential onChange value tracked changes separately until applied. Changes when user stops dragging.
  const [potentialChange, setPotentialChange] = useState(sliderValues);
  // represents an onUpdate value; changes as user drags.
  const [times, setTimes] = useState([sliderValues.time1, sliderValues.time2]);
  const updateTimes = newValues => setTimes([newValues.time1, newValues.time2]);

  // Need for reset. useEffect here because sliderValues will have stale data until after onReset's changes render
  useEffect(() => {
    updateTimes(sliderValues);
    setPotentialChange(sliderValues);
  }, [sliderValues]);
  return /*#__PURE__*/React.createElement(FilterChip, {
    text: "Times",
    filterText: showTimesAsLabel ? `${sliderValues.time1} — ${sliderValues.time2}` : null,
    onReset: onReset,
    onApply: () => {
      onApply(potentialChange);
    },
    onCancel: () => {
      setPotentialChange(sliderValues);
      updateTimes(sliderValues);
      onCancel(sliderValues, potentialChange);
    }
  }, () => {
    return /*#__PURE__*/React.createElement(Box, {
      py: 2
    }, /*#__PURE__*/React.createElement(TimeSelectorHeading, null, /*#__PURE__*/React.createElement(ChipHeader, null, "Departure Time")), /*#__PURE__*/React.createElement(TimeSelectorHeading, null, times[0], " \u2014 ", times[1]), /*#__PURE__*/React.createElement(Box, {
      px: 3
    }, /*#__PURE__*/React.createElement(HourlyRangeSlider, {
      onUpdate: updateTimes,
      onChange: setPotentialChange,
      values: [potentialChange.value1, potentialChange.value2],
      referenceDate: referenceDate,
      formatString: "p",
      mode: 3
    })));
  });
};
TimeRangeFilterChip.propTypes = {
  referenceDate: PropTypes.instanceOf(Date).isRequired,
  sliderValues: sliderValuesPropType,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func,
  showTimesAsLabel: PropTypes.bool
};
TimeRangeFilterChip.defaultProps = {
  sliderValues: {
    time1: '12:00 AM',
    value1: DEFAULT_DATE.getTime(),
    // 00:00
    time2: '11:59 PM',
    value2: DEFAULT_DATE.getTime() + (60 * 60 * 24 * 1000 - 60000) // 23:59
  },
  onApply: () => {},
  onCancel: () => {},
  onReset: () => {},
  showTimesAsLabel: false
};

/** Deprecated use SoloFilter */
const labelLookup = {
  0: 'Nonstop',
  1: 'Max 1 Stop',
  '2+': 'Max 2 Stops'
};
const StopsRadioButton = styled(RadioButton)`
  padding: 0;

  ${RadioLabelStyled} {
    display: flex;
    align-items: center;
    height: 30px;

    &:hover {
      ${RadioLabelText} {
        color: ${getThemeProp('global.link--color')};
      }
    }
  }
  ${RadioLabelText} {
    padding-top: 0;
  }
`;
const StopsFilterChip = _ref => {
  let {
    stops,
    selectedStop,
    onChange,
    onReset
  } = _ref;
  console.warn('StopsFilterChip has been deprecated, please use SoloFilter component');
  const filterText = selectedStop !== undefined ? labelLookup[selectedStop] : undefined;
  const options = closePopover => stops.map(_ref2 => {
    let {
      stops: stop
    } = _ref2;
    return /*#__PURE__*/React.createElement(StopsRadioButton, {
      name: "stops",
      label: labelLookup[stop],
      checked: selectedStop.toString() === stop.toString(),
      onChange: _ref3 => {
        let {
          target
        } = _ref3;
        closePopover();
        onChange({
          target
        });
      },
      value: stop,
      id: `stops-${stop}`,
      key: `stops-${stop}`
    });
  });
  return /*#__PURE__*/React.createElement(FilterChip, {
    text: "Stops",
    filterText: filterText,
    onApply: null,
    onReset: onReset
  }, _ref4 => {
    let {
      closePopover
    } = _ref4;
    const changeHandler = () => {
      closePopover();
      onReset();
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StopsRadioButton, {
      name: "stops",
      label: "Any",
      checked: selectedStop.toString() === (-1).toString(),
      onChange: changeHandler,
      value: "any",
      id: "stops-any",
      key: "stops-any"
    }), options(closePopover));
  });
};
StopsFilterChip.propTypes = {
  stops: PropTypes.arrayOf(PropTypes.shape({
    stops: PropTypes.string
  })).isRequired,
  selectedStop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onReset: PropTypes.func
};
StopsFilterChip.defaultProps = {
  selectedStop: -1,
  onChange: () => {},
  onReset: () => {}
};

/** Deprecated use SoloFilter */
const getAirportCodes = airportOptions => airportOptions.reduce((acc, location) => acc.concat(location.airports.map(airport => airport.code)), []);
const AirportsFilterChip = _ref => {
  let {
    airports,
    excludedAirports,
    onApply,
    onCancel,
    onReset
  } = _ref;
  console.warn('AirportsFilterChip has been deprecated, please use SoloFilter component');
  const allAirportCodes = useMemo(() => getAirportCodes(airports), [airports]);
  const [potentialChanges, setPotentialChanges] = useState(excludedAirports);
  const filterText = excludedAirports.length !== 0 ? `Airports (${allAirportCodes.length - excludedAirports.length})` : undefined;
  const changeHandler = _ref2 => {
    let {
      target
    } = _ref2;
    const excluded = potentialChanges.includes(target.id) ? potentialChanges.filter(a => a !== target.id) : [...potentialChanges, target.id];
    setPotentialChanges(excluded);
  };
  const resetHandler = () => {
    setPotentialChanges([]);
    onReset();
  };
  const checkboxGroups = airports.map((location, idx) => {
    return /*#__PURE__*/React.createElement(Box, {
      key: location.locId
    }, /*#__PURE__*/React.createElement(ChipHeader, {
      pt: idx > 0 ? 3 : 1,
      pb: 1
    }, location.locIdName), location.airports.map(airport => {
      var _airport$code;
      return /*#__PURE__*/React.createElement(ChipCheckbox, {
        disabled: location.airports.length === 1,
        key: airport.code,
        label: `${airport.name} (${airport === null || airport === void 0 || (_airport$code = airport.code) === null || _airport$code === void 0 ? void 0 : _airport$code.toUpperCase()})`,
        checked: !potentialChanges.includes(airport.code),
        onChange: changeHandler,
        id: airport.code
      });
    }));
  });
  return /*#__PURE__*/React.createElement(FilterChip, {
    text: "Airports",
    filterText: filterText,
    onReset: resetHandler,
    onApply: () => {
      onApply(potentialChanges);
    },
    onCancel: () => {
      onCancel();
      setPotentialChanges(excludedAirports);
    }
  }, () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, checkboxGroups);
  });
};
AirportsFilterChip.propTypes = {
  airports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  excludedAirports: PropTypes.arrayOf(PropTypes.string).isRequired,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func
};
AirportsFilterChip.defaultProps = {
  onApply: () => {},
  onCancel: () => {},
  onReset: () => {}
};

/** Deprecated use SoloFilter */
const AmenitiesFilterChip = _ref => {
  let {
    amenities,
    selectedAmenities,
    onApply = () => {},
    onCancel = () => {},
    onReset = () => {}
  } = _ref;
  console.warn('AmenitiesFilterChip has been deprecated, please use SoloFilter component');
  const [potentialChanges, setPotentialChanges] = useState(selectedAmenities);
  const checkSelected = amenity => potentialChanges.includes(amenity.value);
  const changeHandler = amenity => {
    const newSelections = checkSelected(amenity) ? potentialChanges.filter(pc => pc !== amenity.value) : [...potentialChanges, amenity.value];
    setPotentialChanges(newSelections);
  };
  const resetHandler = () => {
    setPotentialChanges([]);
    onReset();
  };
  const checkboxes = amenities.map(amenity => {
    const clickHandler = () => changeHandler(amenity);
    return /*#__PURE__*/React.createElement(Box, {
      key: amenity.value
    }, /*#__PURE__*/React.createElement(ChipCheckbox, {
      key: amenity.value,
      label: amenity.display,
      checked: checkSelected(amenity),
      onChange: clickHandler,
      id: amenity.value
    }));
  });
  const applyHandler = () => onApply(potentialChanges);
  const cancelHandler = () => {
    onCancel();
    setPotentialChanges(selectedAmenities);
  };
  const filterText = selectedAmenities.length ? `Amenities (${selectedAmenities.length})` : null;
  return /*#__PURE__*/React.createElement(FilterChip, {
    text: "Amenities",
    filterText: filterText,
    onReset: resetHandler,
    onApply: applyHandler,
    onCancel: cancelHandler
  }, () => checkboxes);
};
AmenitiesFilterChip.propTypes = {
  amenities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedAmenities: PropTypes.arrayOf(PropTypes.string).isRequired,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func
};

/** Deprecated use SoloFilter */
const ID_PREFIX = 'airline-filter-';
const AirlinesFilterChip = _ref => {
  let {
    airlines,
    alliances,
    selectedAirlines,
    selectedAlliances,
    hideLowCostAirlines,
    lowCostAirlineCodes,
    onApply,
    onCancel,
    onReset
  } = _ref;
  console.warn('AirlinesFilterChip has been deprecated, please use SoloFilter component');
  const [potentialAirlineChanges, setPotentialAirlineChanges] = useState(selectedAirlines);
  const [potentialAllianceChanges, setPotentialAllianceChanges] = useState(selectedAlliances);
  const [lowCostChange, setLowCostChange] = useState(hideLowCostAirlines);
  const airlineChangeHandler = airlineCode => {
    const isRemoving = potentialAirlineChanges.includes(airlineCode);
    if (isRemoving) {
      if (potentialAirlineChanges.length > 1) {
        setPotentialAirlineChanges(potentialAirlineChanges.filter(a => a !== airlineCode));
      }
    } else {
      setPotentialAirlineChanges([...potentialAirlineChanges, airlineCode]);
    }
  };
  const allianceChangeHandler = allianceCode => {
    setPotentialAllianceChanges(potentialAllianceChanges.includes(allianceCode) ? potentialAllianceChanges.filter(a => a !== allianceCode) : [...potentialAllianceChanges, allianceCode]);
  };
  const hideLowCostToggleHandler = () => {
    const hideLowCost = !lowCostChange;
    setLowCostChange(hideLowCost);
    // uncheck low cost airlines but do not allow no airlines and no alliances.
    if (hideLowCost) {
      let airlinesWithoutLowCost = potentialAirlineChanges.filter(a => !lowCostAirlineCodes.includes(a));
      if (!airlinesWithoutLowCost.length && !potentialAllianceChanges.length) {
        airlinesWithoutLowCost = selectedAirlines.filter(a => !lowCostAirlineCodes.includes(a));
      }
      setPotentialAirlineChanges(airlinesWithoutLowCost);
    }
  };
  useEffect(() => setPotentialAirlineChanges(selectedAirlines), [selectedAirlines]);
  useEffect(() => setPotentialAllianceChanges(selectedAlliances), [selectedAlliances]);
  useEffect(() => setLowCostChange(hideLowCostAirlines), [hideLowCostAirlines]);
  const selectOnly = code => setPotentialAirlineChanges([code]);
  const disableAirlines = !!potentialAllianceChanges.length;
  const airlineCheckboxes = airlines.map(airline => {
    const disableLowCost = lowCostChange && lowCostAirlineCodes.includes(airline.code);
    const isChecked = potentialAirlineChanges.includes(airline.code) && !disableLowCost;
    const isDisabled = disableAirlines || disableLowCost;
    const toggleAirline = () => airlineChangeHandler(airline.code);
    return /*#__PURE__*/React.createElement(ChipCheckbox, {
      key: airline.code,
      name: "airline-filter",
      label: airline.name,
      isPreferred: airline.isPreferred,
      disabled: isDisabled,
      checked: isChecked,
      onChange: toggleAirline,
      value: airline.code,
      id: ID_PREFIX + airline.code,
      "data-airlinecode": airline.code,
      onlyButton: !isDisabled ? /*#__PURE__*/React.createElement(Button, {
        text: "Only",
        kind: "primary",
        size: "small",
        pill: true,
        bordered: true,
        onClick: () => selectOnly(airline.code)
      }) : null
    });
  });
  const allianceCheckboxes = alliances.map(alliance => {
    const allianceCheckHandler = () => allianceChangeHandler(alliance.code);
    return /*#__PURE__*/React.createElement(ChipCheckbox, {
      key: alliance.code,
      name: "alliance-filter",
      label: alliance.name,
      checked: potentialAllianceChanges.includes(alliance.code),
      onChange: allianceCheckHandler,
      value: alliance.code,
      id: ID_PREFIX + alliance.code
    });
  });
  let filterText = selectedAlliances.length ? `Alliances (${selectedAlliances.length})` : null;
  if (!filterText) {
    filterText = airlines.length !== selectedAirlines.length ? `Airlines (${selectedAirlines.length})` : null;
  }
  return /*#__PURE__*/React.createElement(FilterChip, {
    text: "Airlines",
    filterText: filterText,
    onReset: onReset,
    onApply: () => {
      onApply({
        airlines: potentialAirlineChanges,
        alliances: potentialAllianceChanges,
        hideLowCost: lowCostChange
      });
    },
    onCancel: () => {
      onCancel();
      setPotentialAirlineChanges(selectedAirlines);
    }
  }, () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChipHeader, {
      pt: 1,
      pb: 1
    }, "Airlines"), airlineCheckboxes, /*#__PURE__*/React.createElement(ChipHeader, {
      pt: 3,
      pb: 1
    }, "Alliances"), allianceCheckboxes, /*#__PURE__*/React.createElement(ChipHeader, {
      pt: 3,
      pb: 1
    }, "Ultra Low Cost Carriers"), /*#__PURE__*/React.createElement(ChipCheckbox, {
      id: `${ID_PREFIX}hideLowCostAirlines`,
      label: "Hide Ultra Low Cost Carriers",
      checked: lowCostChange,
      disabled: disableAirlines,
      onChange: hideLowCostToggleHandler
    }));
  });
};
AirlinesFilterChip.propTypes = {
  airlines: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  alliances: PropTypes.arrayOf(PropTypes.shape({})),
  selectedAirlines: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])).isRequired,
  selectedAlliances: PropTypes.arrayOf(PropTypes.string),
  lowCostAirlineCodes: PropTypes.arrayOf(PropTypes.string),
  hideLowCostAirlines: PropTypes.bool,
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func
};
AirlinesFilterChip.defaultProps = {
  alliances: [],
  selectedAlliances: [],
  hideLowCostAirlines: false,
  lowCostAirlineCodes: ['F9', 'NK'],
  onApply: () => {},
  onCancel: () => {},
  onReset: () => {}
};

export { AcceptedCardImages, ActionBadgeCritical, ActionLink, ActivityIndicator, AddressMini, AddressOverview, AddressRegular, AirlineList, AirlineLogo, AirlinesFilterChip, AirportCode, AirportsFilterChip, AmenitiesFilterChip, ACCEPT as ApprovalAccept, REJECT as ApprovalReject, ApprovalTray, AreaDistance, Asterisk, Autocomplete, AutocompleteInput, AutocompleteRenderer, Avatar, Badge, BirthdayInput, BookStatusIndicator, BreadcrumbItem, Breadcrumbs, Button, ButtonTextStyled, ButtonToggle, CalendarHeader, CarTypeImage, CarVendorLogo, Card$2 as Card, CardFlat, CardShell, CardStrip, CardWithIcon, Carousel, CarouselContainer, CharacterCounter, ChasingDots$1 as ChasingDots, Checkbox, CheckboxCard, CheckboxLabel, CheckboxLabelText, CheckboxStyled, ChipCheckbox, ChipHeader, CircleIconBadge, CityAutocomplete, CityAutocomplete as CitySearchInput, ClickableGraphic, ComboBox, ComboBoxInput, ComboBoxInputContainer, ComboBoxLabel, CommonCard, CreditCardLogo, Currency, DatePicker, DatePickerCustom, DatePickerInline, DateRangePicker, DateRangePicker$1 as DateRangePickerInline, DateRangeSelect, DateRangeSelectInline, DateSelect, DateSelectInline, DatesSummary, DayFare, DayTile, DebounceRenderer, Dialog, DismissibleCard, Divider, DotSeparator, DropDownContainer$1 as DropDownContainer, DropdownSelect, ElasticDotsLoader, EmailChip, EmailChipTile, EmptyState, ErrorMessage, Fade, FareCalendar, FareCalendarHeader, FilterButton as FilterButtonStyles, FilterCheckbox, FilterChip, FilterRegionSeparator, FilterSection, FilterTitle, FlexBgButton, FlexButtonGroup, FloatingCard, FloatingList, FullPageLoader$1 as FullPageLoader, FullPageOverlay, GatherBadge, Grouping, Handle, HandleContainer, HandleControl, Heading1, Heading2, Heading3, Heading4, HorizontalScroll, HotelThumbnail, HourlyRangeSlider, IconFlex, Image, Incrementor, InfoTooltip, InlineLoader, InputLabel, InterstitialContent, InterstitialLoader, LabeledValue, LastListItem, LightBox, LinkCard, LinkTile, Linkify, List, ListHeaderDark, ListItem, ListTable, LoadingBar, MetricBox, MetricTile, MetricTileCompact, MetricTileMini, Modal, MonthlyCalendarRenderer, MoreDotsMenu, Multifilter, Multiselect, Notice, NoticeBoard, NoticeItem, Notification, NumberBadge, OptionMini, OutOfPolicy, OverlayPanel, P, PassengerOptions, PassengersFilterChip, PhoneNumberInputCountry, Popover, PopoverMenu, PoweredBy, PreferredBadge, PreferredMark, PreferredSpacer, PreferredStar, PrefixBoxStyled, PriceButton, RadioButton, RadioButtonContainer, RadioCard, RadioCircleStyled, RadioGroup, RadioLabelStyled, RadioLabelText, Rail, RailContainer, RangeSlider, RateInfoBadge, RefundabilityBadge, ScrollArea, SearchButton, SearchNewWindowButton, SliderRail, Solofilter, SolofilterCheckbox, StopsFilterChip, StyledTrack, Switch, TILE_KINDS, Table, Tabs, Text$2 as Text, TextFieldStyled, TextInput, TextInputArea, TextTransitioner, ThreePartDateInput, Tick, TickLabel, TickLine, TileGroup, TimeRangeFilterChip, TitleCase, ToastNotice, ToastProvider, ToastWrapper, ToggleGroup, Tooltip, Track, TravelerAutocomplete as TravelerAutoComplete, TravelerAutocomplete, Tray, UserRoleBadge, WeekDayLabel$1 as WeekdayLabel, WizardTracker, amtravPhoneFormat, creditCardByKey, dashToE164, detectCreditCardType, fadeIn, fadeOut, flipInX, formatDefaults, formatLocationAddress, formatUSCurrencyNum, getBadgeKindColorObj$1 as getBadgeKindColorObj, getButtonKindToken, getKindColorOrString, getNavigationLogo, notify, passengerOptionsSummary, pulse, reshapeCustomLocation, sabreImageCodes, scrollToElement, shake, skeletonLoadingStyles, timeToTimestamp, uiFriendlyPhoneNumber, useToasts };
//# sourceMappingURL=index.esm.js.map
